export const pipesTestProjectData = [
  {
    "id": 18780,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.0758781501990693,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18754,
        "lat": 15.18009921071009,
        "lon": 145.7814831556313
      },
      {
        "id": 18755,
        "lat": 15.18009020007266,
        "lon": 145.781486777185
      }
    ],

  },
  {
    "id": 18781,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 55.02250365156108,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18756,
        "lat": 15.18045584249075,
        "lon": 145.7768645820376
      },
      {
        "id": 18757,
        "lat": 15.18088735676838,
        "lon": 145.7766148193299
      }
    ],

  },
  {
    "id": 18782,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 47.83490123732797,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18758,
        "lat": 15.18045426694797,
        "lon": 145.7768712183417
      },
      {
        "id": 18759,
        "lat": 15.18066682142757,
        "lon": 145.7772581776303
      }
    ],

  },
  {
    "id": 18783,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 35.63156838031649,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18760,
        "lat": 15.18160669220654,
        "lon": 145.776028308911
      },
      {
        "id": 18761,
        "lat": 15.1813886740676,
        "lon": 145.7762711372401
      }
    ],

  },
  {
    "id": 18784,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 35.75371283251376,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18762,
        "lat": 15.17692236575757,
        "lon": 145.7787927022406
      },
      {
        "id": 18763,
        "lat": 15.17704403242822,
        "lon": 145.7791006891336
      }
    ],

  },
  {
    "id": 18785,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 39.08932194033384,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18764,
        "lat": 15.18095944264904,
        "lon": 145.7793946583248
      },
      {
        "id": 18765,
        "lat": 15.18082610910625,
        "lon": 145.7790580660962
      }
    ],

  },
  {
    "id": 18786,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 91.90481829883903,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18766,
        "lat": 15.18291278903119,
        "lon": 145.7803756881712
      },
      {
        "id": 18767,
        "lat": 15.18215200122168,
        "lon": 145.7807079228867
      }
    ],

  },
  {
    "id": 18787,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 68.81712456658202,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18768,
        "lat": 15.17927478994572,
        "lon": 145.7763515489828
      },
      {
        "id": 18769,
        "lat": 15.17873479875091,
        "lon": 145.776663383686
      }
    ],

  },
  {
    "id": 18788,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 7.172031609513528,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18769,
        "lat": 15.17873479875091,
        "lon": 145.776663383686
      },
      {
        "id": 18770,
        "lat": 15.17871906176022,
        "lon": 145.77672811797
      }
    ],

  },
  {
    "id": 18789,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 14.644944033640988,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18771,
        "lat": 15.17962273507344,
        "lon": 145.7787234249803
      },
      {
        "id": 18772,
        "lat": 15.17968516916074,
        "lon": 145.7788434104288
      }
    ],

  },
  {
    "id": 18790,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.5745794053645366,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18772,
        "lat": 15.17968516916074,
        "lon": 145.7788434104288
      },
      {
        "id": 18773,
        "lat": 15.17971187588205,
        "lon": 145.7789082563559
      }
    ],

  },
  {
    "id": 18791,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 34.902891028722614,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18774,
        "lat": 15.18036657804751,
        "lon": 145.7788783092216
      },
      {
        "id": 18775,
        "lat": 15.18065765259813,
        "lon": 145.7787575550881
      }
    ],

  },
  {
    "id": 18792,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.0761099499135427,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18775,
        "lat": 15.18065765259813,
        "lon": 145.7787575550881
      },
      {
        "id": 18776,
        "lat": 15.18066655144276,
        "lon": 145.7787536424815
      }
    ],

  },
  {
    "id": 18793,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 21.212201185844197,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18777,
        "lat": 15.17888684361632,
        "lon": 145.7757160006688
      },
      {
        "id": 18778,
        "lat": 15.17873131375151,
        "lon": 145.7756019269955
      }
    ],

  },
  {
    "id": 18794,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 29.494062500891708,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18778,
        "lat": 15.17873131375151,
        "lon": 145.7756019269955
      },
      {
        "id": 18779,
        "lat": 15.17846835779166,
        "lon": 145.7755683121957
      }
    ],

  },
  {
    "id": 18795,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 31.781938198468893,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18780,
        "lat": 15.18039071119967,
        "lon": 145.7783748800033
      },
      {
        "id": 18781,
        "lat": 15.18012913632061,
        "lon": 145.7784934279731
      }
    ],

  },
  {
    "id": 18796,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 59.93836521380076,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18782,
        "lat": 15.17814537721297,
        "lon": 145.7806635902461
      },
      {
        "id": 18783,
        "lat": 15.1783612580152,
        "lon": 145.7811746820781
      }
    ],

  },
  {
    "id": 18797,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 48.26808087106733,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18784,
        "lat": 15.18214303875523,
        "lon": 145.7807118367647
      },
      {
        "id": 18785,
        "lat": 15.18197284477074,
        "lon": 145.7802986132414
      }
    ],

  },
  {
    "id": 18798,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 84.67341903331354,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18786,
        "lat": 15.18127065362673,
        "lon": 145.7802110589572
      },
      {
        "id": 18787,
        "lat": 15.18057153674934,
        "lon": 145.7805215609211
      }
    ],

  },
  {
    "id": 18799,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 32.59988708528639,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18788,
        "lat": 15.18144750977499,
        "lon": 145.7726634196625
      },
      {
        "id": 18789,
        "lat": 15.18171554188658,
        "lon": 145.7727856681368
      }
    ],

  },
  {
    "id": 18800,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 3.2001094357644764,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18789,
        "lat": 15.18171554188658,
        "lon": 145.7727856681368
      },
      {
        "id": 18790,
        "lat": 15.18174421187209,
        "lon": 145.7727834882309
      }
    ],

  },
  {
    "id": 18801,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 38.43576214477529,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18791,
        "lat": 15.18222244860775,
        "lon": 145.7739003342002
      },
      {
        "id": 18792,
        "lat": 15.18248624066339,
        "lon": 145.7741311645027
      }
    ],

  },
  {
    "id": 18802,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 35.37051653603338,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18793,
        "lat": 15.18254798305254,
        "lon": 145.7730880381137
      },
      {
        "id": 18794,
        "lat": 15.182846904085,
        "lon": 145.7731996565695
      }
    ],

  },
  {
    "id": 18803,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 29.80154190453985,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18794,
        "lat": 15.182846904085,
        "lon": 145.7731996565695
      },
      {
        "id": 18795,
        "lat": 15.18295849832991,
        "lon": 145.7734518018467
      }
    ],

  },
  {
    "id": 18804,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.294696234481951,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18791,
        "lat": 15.18222244860775,
        "lon": 145.7739003342002
      },
      {
        "id": 18796,
        "lat": 15.18219787375358,
        "lon": 145.7739632778805
      }
    ],

  },
  {
    "id": 18805,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 39.12004311914425,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18796,
        "lat": 15.18219787375358,
        "lon": 145.7739632778805
      },
      {
        "id": 18797,
        "lat": 15.18200783684805,
        "lon": 145.7742695741542
      }
    ],

  },
  {
    "id": 18806,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 65.59687890828245,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18798,
        "lat": 15.182005531511,
        "lon": 145.7742808487389
      },
      {
        "id": 18799,
        "lat": 15.18196793155479,
        "lon": 145.7748901810987
      }
    ],

  },
  {
    "id": 18807,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 54.81910000351778,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18800,
        "lat": 15.18235480907187,
        "lon": 145.7735454379585
      },
      {
        "id": 18801,
        "lat": 15.18187072952697,
        "lon": 145.7734517675086
      }
    ],

  },
  {
    "id": 18808,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 17.45276680037909,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18802,
        "lat": 15.18254082587188,
        "lon": 145.7730904889919
      },
      {
        "id": 18803,
        "lat": 15.18248146814093,
        "lon": 145.7732408469784
      }
    ],

  },
  {
    "id": 18809,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 85.63324473937699,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18804,
        "lat": 15.17785487540812,
        "lon": 145.773393086249
      },
      {
        "id": 18805,
        "lat": 15.17794668694475,
        "lon": 145.7726017236064
      }
    ],

  },
  {
    "id": 18810,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 56.34549058342776,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18806,
        "lat": 15.17759549756261,
        "lon": 145.7751954468858
      },
      {
        "id": 18807,
        "lat": 15.17709362292977,
        "lon": 145.7751273451446
      }
    ],

  },
  {
    "id": 18811,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.29601382374204,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18807,
        "lat": 15.17709362292977,
        "lon": 145.7751273451446
      },
      {
        "id": 18808,
        "lat": 15.17692176730226,
        "lon": 145.7751038984751
      }
    ],

  },
  {
    "id": 18812,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 19.31623829701903,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18809,
        "lat": 15.18144829471769,
        "lon": 145.7749512227911
      },
      {
        "id": 18810,
        "lat": 15.18129557845699,
        "lon": 145.7750365861994
      }
    ],

  },
  {
    "id": 18813,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 12.681112600149342,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18810,
        "lat": 15.18129557845699,
        "lon": 145.7750365861994
      },
      {
        "id": 18811,
        "lat": 15.18122739307322,
        "lon": 145.7751311421929
      }
    ],

  },
  {
    "id": 18814,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 8.218397472317319,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18812,
        "lat": 15.17922772387279,
        "lon": 145.775257153602
      },
      {
        "id": 18813,
        "lat": 15.17919027209227,
        "lon": 145.7753230759128
      }
    ],

  },
  {
    "id": 18815,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 53.4792232847207,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18813,
        "lat": 15.17919027209227,
        "lon": 145.7753230759128
      },
      {
        "id": 18814,
        "lat": 15.17888991034295,
        "lon": 145.7757115675289
      }
    ],

  },
  {
    "id": 18816,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 17.957821783427566,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18815,
        "lat": 15.18153943709405,
        "lon": 145.7706956828024
      },
      {
        "id": 18816,
        "lat": 15.18151305360023,
        "lon": 145.7705307822062
      }
    ],

  },
  {
    "id": 18817,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 31.396316797538297,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18816,
        "lat": 15.18151305360023,
        "lon": 145.7705307822062
      },
      {
        "id": 18817,
        "lat": 15.18138642676744,
        "lon": 145.7702696552774
      }
    ],

  },
  {
    "id": 18818,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 31.819097379855123,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18818,
        "lat": 15.18043543111811,
        "lon": 145.7716575884737
      },
      {
        "id": 18819,
        "lat": 15.18061537102727,
        "lon": 145.7714274690943
      }
    ],

  },
  {
    "id": 18819,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 97.0253058048122,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18820,
        "lat": 15.18207822496439,
        "lon": 145.7717928709846
      },
      {
        "id": 18821,
        "lat": 15.18245219896316,
        "lon": 145.7726086281165
      }
    ],

  },
  {
    "id": 18820,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.90887690223292,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18822,
        "lat": 15.17988638315949,
        "lon": 145.7715321285037
      },
      {
        "id": 18823,
        "lat": 15.18003675129921,
        "lon": 145.7715543882354
      }
    ],

  },
  {
    "id": 18821,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 5.45025338930592,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18823,
        "lat": 15.18003675129921,
        "lon": 145.7715543882354
      },
      {
        "id": 18824,
        "lat": 15.18008505721417,
        "lon": 145.7715626557525
      }
    ],

  },
  {
    "id": 18822,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 5.449667614951472,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18824,
        "lat": 15.18008505721417,
        "lon": 145.7715626557525
      },
      {
        "id": 18825,
        "lat": 15.18013293241745,
        "lon": 145.7715732517252
      }
    ],

  },
  {
    "id": 18823,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 5.4946667335724175,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18825,
        "lat": 15.18013293241745,
        "lon": 145.7715732517252
      },
      {
        "id": 18826,
        "lat": 15.18018066653399,
        "lon": 145.7715862680483
      }
    ],

  },
  {
    "id": 18824,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 5.493799776262304,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18826,
        "lat": 15.18018066653399,
        "lon": 145.7715862680483
      },
      {
        "id": 18827,
        "lat": 15.18022774876438,
        "lon": 145.7716015964216
      }
    ],

  },
  {
    "id": 18825,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.765251868150507,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18827,
        "lat": 15.18022774876438,
        "lon": 145.7716015964216
      },
      {
        "id": 18828,
        "lat": 15.18037769135162,
        "lon": 145.7716162143737
      }
    ],

  },
  {
    "id": 18826,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.282135716387844,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18828,
        "lat": 15.18037769135162,
        "lon": 145.7716162143737
      },
      {
        "id": 18829,
        "lat": 15.1804281150658,
        "lon": 145.7716593957421
      }
    ],

  },
  {
    "id": 18827,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 21.48263721843448,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18830,
        "lat": 15.18127265032141,
        "lon": 145.771799057261
      },
      {
        "id": 18831,
        "lat": 15.18145238256055,
        "lon": 145.771871871406
      }
    ],

  },
  {
    "id": 18828,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.48105093977409447,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18832,
        "lat": 15.18007301453061,
        "lon": 145.7749033833553
      },
      {
        "id": 18833,
        "lat": 15.18006994128944,
        "lon": 145.7749065311645
      }
    ],

  },
  {
    "id": 18829,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 80.35357006930938,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18834,
        "lat": 15.17024222991939,
        "lon": 145.7883938303796
      },
      {
        "id": 18835,
        "lat": 15.1695476763782,
        "lon": 145.7885974758645
      }
    ],

  },
  {
    "id": 18830,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 43.57833935852567,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18836,
        "lat": 15.169122918609,
        "lon": 145.7879810395282
      },
      {
        "id": 18837,
        "lat": 15.16873383904541,
        "lon": 145.7880258026769
      }
    ],

  },
  {
    "id": 18831,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 70.42967063259373,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18838,
        "lat": 15.1705271387098,
        "lon": 145.7869896004116
      },
      {
        "id": 18839,
        "lat": 15.17081342123348,
        "lon": 145.787574177259
      }
    ],

  },
  {
    "id": 18832,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 28.74732937174473,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18840,
        "lat": 15.17127528985002,
        "lon": 145.7873131754156
      },
      {
        "id": 18841,
        "lat": 15.17105241345099,
        "lon": 145.7874483266938
      }
    ],

  },
  {
    "id": 18833,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 14.591008972379797,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18841,
        "lat": 15.17105241345099,
        "lon": 145.7874483266938
      },
      {
        "id": 18842,
        "lat": 15.17093809948468,
        "lon": 145.7875147712605
      }
    ],

  },
  {
    "id": 18834,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 14.593800026299878,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18842,
        "lat": 15.17093809948468,
        "lon": 145.7875147712605
      },
      {
        "id": 18843,
        "lat": 15.17082149734036,
        "lon": 145.7875768575552
      }
    ],

  },
  {
    "id": 18835,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 59.77966482593939,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18844,
        "lat": 15.1742940653324,
        "lon": 145.7829901264032
      },
      {
        "id": 18845,
        "lat": 15.1748138488794,
        "lon": 145.7828503273609
      }
    ],

  },
  {
    "id": 18836,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 28.92831855961904,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18846,
        "lat": 15.1748481625669,
        "lon": 145.77615949242
      },
      {
        "id": 18847,
        "lat": 15.17460865117753,
        "lon": 145.7762639586287
      }
    ],

  },
  {
    "id": 18837,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.886044580264414,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18847,
        "lat": 15.17460865117753,
        "lon": 145.7762639586287
      },
      {
        "id": 18848,
        "lat": 15.17448190204255,
        "lon": 145.7763943900084
      }
    ],

  },
  {
    "id": 18838,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 6.548158463191753,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18848,
        "lat": 15.17448190204255,
        "lon": 145.7763943900084
      },
      {
        "id": 18849,
        "lat": 15.17444658078325,
        "lon": 145.7764431272458
      }
    ],

  },
  {
    "id": 18839,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 62.798633125241345,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18850,
        "lat": 15.17743695728477,
        "lon": 145.777879487608
      },
      {
        "id": 18851,
        "lat": 15.17692258937927,
        "lon": 145.7781195233991
      }
    ],

  },
  {
    "id": 18840,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 17.01496203101946,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18852,
        "lat": 15.17554717598832,
        "lon": 145.7796402841962
      },
      {
        "id": 18853,
        "lat": 15.17547539332685,
        "lon": 145.7795004649332
      }
    ],

  },
  {
    "id": 18841,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 37.27420289765484,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18853,
        "lat": 15.17547539332685,
        "lon": 145.7795004649332
      },
      {
        "id": 18854,
        "lat": 15.1753440868733,
        "lon": 145.7791813158176
      }
    ],

  },
  {
    "id": 18842,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.917580837192038,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18855,
        "lat": 15.17635317339567,
        "lon": 145.7793894860349
      },
      {
        "id": 18856,
        "lat": 15.17624400391196,
        "lon": 145.7792426055004
      }
    ],

  },
  {
    "id": 18843,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.40529898595524,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18856,
        "lat": 15.17624400391196,
        "lon": 145.7792426055004
      },
      {
        "id": 18857,
        "lat": 15.17618798071914,
        "lon": 145.7791114917074
      }
    ],

  },
  {
    "id": 18844,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 36.88238042313418,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18858,
        "lat": 15.17454789465209,
        "lon": 145.7789767217779
      },
      {
        "id": 18859,
        "lat": 15.17459948705423,
        "lon": 145.7793158238175
      }
    ],

  },
  {
    "id": 18845,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 27.9474736074079,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18859,
        "lat": 15.17459948705423,
        "lon": 145.7793158238175
      },
      {
        "id": 18860,
        "lat": 15.17466676646942,
        "lon": 145.7795664355686
      }
    ],

  },
  {
    "id": 18846,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 69.17521509204413,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18861,
        "lat": 15.17380779665041,
        "lon": 145.7814859416975
      },
      {
        "id": 18862,
        "lat": 15.17440924114489,
        "lon": 145.7813240381186
      }
    ],

  },
  {
    "id": 18847,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 71.58828917170847,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18863,
        "lat": 15.17499951884119,
        "lon": 145.7834973994915
      },
      {
        "id": 18864,
        "lat": 15.17482897868081,
        "lon": 145.7828549338339
      }
    ],

  },
  {
    "id": 18848,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 50.38252919186923,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18865,
        "lat": 15.16609584490688,
        "lon": 145.7849577162225
      },
      {
        "id": 18866,
        "lat": 15.16613290337299,
        "lon": 145.7854250676562
      }
    ],

  },
  {
    "id": 18849,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.3300836560922809,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18867,
        "lat": 15.17214157966034,
        "lon": 145.7837947793668
      },
      {
        "id": 18868,
        "lat": 15.17215352447083,
        "lon": 145.7837944782774
      }
    ],

  },
  {
    "id": 18850,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 8.941966203945368,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18869,
        "lat": 15.17070452152597,
        "lon": 145.7845913309099
      },
      {
        "id": 18870,
        "lat": 15.17072768056791,
        "lon": 145.784511637477
      }
    ],

  },
  {
    "id": 18851,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 11.98744679368544,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18870,
        "lat": 15.17072768056791,
        "lon": 145.784511637477
      },
      {
        "id": 18871,
        "lat": 15.17075221812588,
        "lon": 145.7844029992739
      }
    ],

  },
  {
    "id": 18852,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 11.985641542085586,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18871,
        "lat": 15.17075221812588,
        "lon": 145.7844029992739
      },
      {
        "id": 18872,
        "lat": 15.17077014556925,
        "lon": 145.784292999965
      }
    ],

  },
  {
    "id": 18853,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 47.76175105252245,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18872,
        "lat": 15.17077014556925,
        "lon": 145.784292999965
      },
      {
        "id": 18873,
        "lat": 15.17083248528957,
        "lon": 145.7838531739484
      }
    ],

  },
  {
    "id": 18854,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.7488462419896158,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18874,
        "lat": 15.16332575505837,
        "lon": 145.7841298118733
      },
      {
        "id": 18875,
        "lat": 15.163325446569,
        "lon": 145.7841228495508
      }
    ],

  },
  {
    "id": 18855,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 10.122261646504498,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18876,
        "lat": 15.16323339016896,
        "lon": 145.7830763752642
      },
      {
        "id": 18877,
        "lat": 15.16314340980508,
        "lon": 145.7830899539989
      }
    ],

  },
  {
    "id": 18856,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 10.120825821990108,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18877,
        "lat": 15.16314340980508,
        "lon": 145.7830899539989
      },
      {
        "id": 18878,
        "lat": 15.16305448344879,
        "lon": 145.7831095571139
      }
    ],

  },
  {
    "id": 18857,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 10.118899097371134,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18878,
        "lat": 15.16305448344879,
        "lon": 145.7831095571139
      },
      {
        "id": 18879,
        "lat": 15.16296699116251,
        "lon": 145.7831351008201
      }
    ],

  },
  {
    "id": 18858,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 10.116514074505114,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18879,
        "lat": 15.16296699116251,
        "lon": 145.7831351008201
      },
      {
        "id": 18880,
        "lat": 15.16288130687949,
        "lon": 145.7831664759393
      }
    ],

  },
  {
    "id": 18859,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 10.113711188290525,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18880,
        "lat": 15.16288130687949,
        "lon": 145.7831664759393
      },
      {
        "id": 18881,
        "lat": 15.16279779680513,
        "lon": 145.7832035483707
      }
    ],

  },
  {
    "id": 18860,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 10.110538000048262,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18881,
        "lat": 15.16279779680513,
        "lon": 145.7832035483707
      },
      {
        "id": 18882,
        "lat": 15.16271681785211,
        "lon": 145.7832461596647
      }
    ],

  },
  {
    "id": 18861,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 10.107048347279772,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18882,
        "lat": 15.16271681785211,
        "lon": 145.7832461596647
      },
      {
        "id": 18883,
        "lat": 15.16263871611519,
        "lon": 145.7832941276996
      }
    ],

  },
  {
    "id": 18862,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 12.665954484483708,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18884,
        "lat": 15.16252218789026,
        "lon": 145.7847516639886
      },
      {
        "id": 18885,
        "lat": 15.16253516461018,
        "lon": 145.7846345491793
      }
    ],

  },
  {
    "id": 18863,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 4.705228486655855,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18886,
        "lat": 15.16693102262969,
        "lon": 145.7866511244463
      },
      {
        "id": 18887,
        "lat": 15.16688919775306,
        "lon": 145.7866448012888
      }
    ],

  },
  {
    "id": 18864,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 16.78917752250271,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18887,
        "lat": 15.16688919775306,
        "lon": 145.7866448012888
      },
      {
        "id": 18888,
        "lat": 15.16674108382928,
        "lon": 145.7866153344064
      }
    ],

  },
  {
    "id": 18865,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 16.787228433456043,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18888,
        "lat": 15.16674108382928,
        "lon": 145.7866153344064
      },
      {
        "id": 18889,
        "lat": 15.16659441012173,
        "lon": 145.7865790248943
      }
    ],

  },
  {
    "id": 18866,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 16.784901055390616,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18889,
        "lat": 15.16659441012173,
        "lon": 145.7865790248943
      },
      {
        "id": 18890,
        "lat": 15.16644947466223,
        "lon": 145.7865359465458
      }
    ],

  },
  {
    "id": 18867,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 16.782214068406052,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18890,
        "lat": 15.16644947466223,
        "lon": 145.7865359465458
      },
      {
        "id": 18891,
        "lat": 15.16630657195065,
        "lon": 145.7864861869074
      }
    ],

  },
  {
    "id": 18868,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 2.0744274297283427,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18892,
        "lat": 15.16524910389124,
        "lon": 145.7854580655437
      },
      {
        "id": 18893,
        "lat": 15.16524794648195,
        "lon": 145.7854773355353
      }
    ],

  },
  {
    "id": 18869,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.134376065019861,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18893,
        "lat": 15.16524794648195,
        "lon": 145.7854773355353
      },
      {
        "id": 18894,
        "lat": 15.16523494943157,
        "lon": 145.7856081970442
      }
    ],

  },
  {
    "id": 18870,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.13523950245107,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18894,
        "lat": 15.16523494943157,
        "lon": 145.7856081970442
      },
      {
        "id": 18895,
        "lat": 15.16521686207,
        "lon": 145.7857384160634
      }
    ],

  },
  {
    "id": 18871,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.427389294539596,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18895,
        "lat": 15.16521686207,
        "lon": 145.7857384160634
      },
      {
        "id": 18896,
        "lat": 15.16519810131021,
        "lon": 145.785880681256
      }
    ],

  },
  {
    "id": 18872,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 67.41154143958164,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18897,
        "lat": 15.16478411752564,
        "lon": 145.7847645427169
      },
      {
        "id": 18898,
        "lat": 15.16417981551899,
        "lon": 145.7847239910995
      }
    ],

  },
  {
    "id": 18873,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 65.51799527790887,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18899,
        "lat": 15.16682940588117,
        "lon": 145.7844844824263
      },
      {
        "id": 18900,
        "lat": 15.16684506877526,
        "lon": 145.7850940650711
      }
    ],

  },
  {
    "id": 18874,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 38.79872051774441,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18901,
        "lat": 15.16772253401658,
        "lon": 145.7860538814461
      },
      {
        "id": 18902,
        "lat": 15.16806987782062,
        "lon": 145.7860240531967
      }
    ],

  },
  {
    "id": 18875,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 42.510651307369606,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18903,
        "lat": 15.16976392603644,
        "lon": 145.7848523928519
      },
      {
        "id": 18904,
        "lat": 15.16948109195756,
        "lon": 145.7845865422213
      }
    ],

  },
  {
    "id": 18876,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 70.42212164611438,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18905,
        "lat": 15.17145464371956,
        "lon": 145.7824952541685
      },
      {
        "id": 18906,
        "lat": 15.17145443572997,
        "lon": 145.7831507114694
      }
    ],

  },
  {
    "id": 18877,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 40.81516696564216,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18907,
        "lat": 15.17308377747832,
        "lon": 145.7849909384326
      },
      {
        "id": 18908,
        "lat": 15.17272297665918,
        "lon": 145.7849233586089
      }
    ],

  },
  {
    "id": 18878,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 29.654705986868034,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18909,
        "lat": 15.17224168264873,
        "lon": 145.7820200391991
      },
      {
        "id": 18910,
        "lat": 15.17250807539135,
        "lon": 145.7820201277851
      }
    ],

  },
  {
    "id": 18879,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 84.00300246852768,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18911,
        "lat": 15.17080659816666,
        "lon": 145.7831878486204
      },
      {
        "id": 18912,
        "lat": 15.17005313865304,
        "lon": 145.7832310400445
      }
    ],

  },
  {
    "id": 18880,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.1927910804603126,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18913,
        "lat": 15.1700456699816,
        "lon": 145.7832311420102
      },
      {
        "id": 18914,
        "lat": 15.17004552702674,
        "lon": 145.7832200411111
      }
    ],

  },
  {
    "id": 18881,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 70.51429452081588,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18915,
        "lat": 15.16872753199359,
        "lon": 145.7866183075818
      },
      {
        "id": 18916,
        "lat": 15.16809594221736,
        "lon": 145.786668442845
      }
    ],

  },
  {
    "id": 18882,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 53.13900421790679,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18917,
        "lat": 15.17020651579846,
        "lon": 145.7812440626816
      },
      {
        "id": 18918,
        "lat": 15.17068375128153,
        "lon": 145.7812329589069
      }
    ],

  },
  {
    "id": 18883,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.6537133210665504,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18919,
        "lat": 15.16870038564842,
        "lon": 145.7782575751461
      },
      {
        "id": 18920,
        "lat": 15.16870233946105,
        "lon": 145.7782821912937
      }
    ],

  },
  {
    "id": 18884,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 80.14949948724275,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18920,
        "lat": 15.16870233946105,
        "lon": 145.7782821912937
      },
      {
        "id": 18921,
        "lat": 15.16876547319155,
        "lon": 145.7790253036344
      }
    ],

  },
  {
    "id": 18885,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 15.669013089904901,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18921,
        "lat": 15.16876547319155,
        "lon": 145.7790253036344
      },
      {
        "id": 18922,
        "lat": 15.16884550646841,
        "lon": 145.7791452731469
      }
    ],

  },
  {
    "id": 18886,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 16.126743189384563,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18922,
        "lat": 15.16884550646841,
        "lon": 145.7791452731469
      },
      {
        "id": 18923,
        "lat": 15.16898983010716,
        "lon": 145.7791322613691
      }
    ],

  },
  {
    "id": 18887,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 15.61010452952114,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18923,
        "lat": 15.16898983010716,
        "lon": 145.7791322613691
      },
      {
        "id": 18924,
        "lat": 15.16904884855591,
        "lon": 145.779000465982
      }
    ],

  },
  {
    "id": 18888,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 64.16403390629436,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18924,
        "lat": 15.16904884855591,
        "lon": 145.779000465982
      },
      {
        "id": 18925,
        "lat": 15.16899949490073,
        "lon": 145.7784054562205
      }
    ],

  },
  {
    "id": 18889,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 1.1465642716247446,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18925,
        "lat": 15.16899949490073,
        "lon": 145.7784054562205
      },
      {
        "id": 18926,
        "lat": 15.16899832768331,
        "lon": 145.7783948533878
      }
    ],

  },
  {
    "id": 18890,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 20.930999726327617,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18926,
        "lat": 15.16899832768331,
        "lon": 145.7783948533878
      },
      {
        "id": 18927,
        "lat": 15.16888132785514,
        "lon": 145.7782423497262
      }
    ],

  },
  {
    "id": 18891,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 20.208711093797,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18927,
        "lat": 15.16888132785514,
        "lon": 145.7782423497262
      },
      {
        "id": 18919,
        "lat": 15.16870038564842,
        "lon": 145.7782575751461
      }
    ],

  },
  {
    "id": 18892,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 73.06503669521541,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18928,
        "lat": 15.17052933445935,
        "lon": 145.779186264895
      },
      {
        "id": 18929,
        "lat": 15.17059309022652,
        "lon": 145.7798631025112
      }
    ],

  },
  {
    "id": 18893,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 4.040716075177047,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18930,
        "lat": 15.16865349238035,
        "lon": 145.7775277097173
      },
      {
        "id": 18931,
        "lat": 15.1686880223936,
        "lon": 145.7775161142186
      }
    ],

  },
  {
    "id": 18894,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 99.41177113971987,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18931,
        "lat": 15.1686880223936,
        "lon": 145.7775161142186
      },
      {
        "id": 18932,
        "lat": 15.16957778115727,
        "lon": 145.777436976579
      }
    ],

  },
  {
    "id": 18895,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 4.1731470733407035,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18932,
        "lat": 15.16957778115727,
        "lon": 145.777436976579
      },
      {
        "id": 18933,
        "lat": 15.16961525724311,
        "lon": 145.7774379564947
      }
    ],

  },
  {
    "id": 18896,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 24.847150129308556,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18934,
        "lat": 15.17147186028129,
        "lon": 145.7790268565888
      },
      {
        "id": 18935,
        "lat": 15.17124870512968,
        "lon": 145.7790317804532
      }
    ],

  },
  {
    "id": 18897,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 69.07609005907902,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18935,
        "lat": 15.17124870512968,
        "lon": 145.7790317804532
      },
      {
        "id": 18936,
        "lat": 15.17103774093476,
        "lon": 145.7784271496239
      }
    ],

  },
  {
    "id": 18898,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 43.93696655641017,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18937,
        "lat": 15.16797106888511,
        "lon": 145.7775864434462
      },
      {
        "id": 18938,
        "lat": 15.16800216181282,
        "lon": 145.7779941113037
      }
    ],

  },
  {
    "id": 18899,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 29.297099942197253,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18939,
        "lat": 15.16938224359122,
        "lon": 145.7758851250012
      },
      {
        "id": 18940,
        "lat": 15.16912003379588,
        "lon": 145.7759085213301
      }
    ],

  },
  {
    "id": 18900,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 69.76554200577525,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18941,
        "lat": 15.1699008335846,
        "lon": 145.7812939921305
      },
      {
        "id": 18942,
        "lat": 15.16986422616756,
        "lon": 145.7806457594683
      }
    ],

  },
  {
    "id": 18901,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 95.86345828914607,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18943,
        "lat": 15.16832247156375,
        "lon": 145.7818311292722
      },
      {
        "id": 18944,
        "lat": 15.16826210806103,
        "lon": 145.7809410834857
      }
    ],

  },
  {
    "id": 18902,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 87.99297982742269,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18945,
        "lat": 15.1691268412849,
        "lon": 145.7818172364219
      },
      {
        "id": 18946,
        "lat": 15.16916598765154,
        "lon": 145.7826352214833
      }
    ],

  },
  {
    "id": 18903,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 86.87552163361025,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18947,
        "lat": 15.16907075337847,
        "lon": 145.7806453567132
      },
      {
        "id": 18948,
        "lat": 15.1698511284086,
        "lon": 145.7806370624409
      }
    ],

  },
  {
    "id": 18904,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 43.882495084673,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18949,
        "lat": 15.17336634170736,
        "lon": 145.7843373518404
      },
      {
        "id": 18950,
        "lat": 15.1737578353493,
        "lon": 145.7843851580616
      }
    ],

  },
  {
    "id": 18905,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.27906767582182,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18951,
        "lat": 15.17272682380968,
        "lon": 145.7836492136252
      },
      {
        "id": 18952,
        "lat": 15.17278221389509,
        "lon": 145.7836381725015
      }
    ],

  },
  {
    "id": 18906,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 53.23378606165003,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18952,
        "lat": 15.17278221389509,
        "lon": 145.7836381725015
      },
      {
        "id": 18953,
        "lat": 15.17324508139348,
        "lon": 145.7835136835615
      }
    ],

  },
  {
    "id": 18907,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 12.956533629874375,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18954,
        "lat": 15.17209394453005,
        "lon": 145.7846804138058
      },
      {
        "id": 18955,
        "lat": 15.17211350185333,
        "lon": 145.7845615345242
      }
    ],

  },
  {
    "id": 18908,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.3553560347122,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18955,
        "lat": 15.17211350185333,
        "lon": 145.7845615345242
      },
      {
        "id": 18956,
        "lat": 15.17213111283163,
        "lon": 145.7844104033186
      }
    ],

  },
  {
    "id": 18909,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.354412296011645,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18956,
        "lat": 15.17213111283163,
        "lon": 145.7844104033186
      },
      {
        "id": 18957,
        "lat": 15.17214160372413,
        "lon": 145.7842585719282
      }
    ],

  },
  {
    "id": 18910,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 49.06996889458731,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18957,
        "lat": 15.17214160372413,
        "lon": 145.7842585719282
      },
      {
        "id": 18958,
        "lat": 15.17214175109836,
        "lon": 145.7838018493366
      }
    ],

  },
  {
    "id": 18911,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 2.2490794593963392,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18959,
        "lat": 15.17057436591408,
        "lon": 145.7860165992892
      },
      {
        "id": 18960,
        "lat": 15.17059017789989,
        "lon": 145.7860035683857
      }
    ],

  },
  {
    "id": 18912,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.631943988150477,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18960,
        "lat": 15.17059017789989,
        "lon": 145.7860035683857
      },
      {
        "id": 18961,
        "lat": 15.17068162675495,
        "lon": 145.7859191842538
      }
    ],

  },
  {
    "id": 18913,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.627201381754428,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18961,
        "lat": 15.17068162675495,
        "lon": 145.7859191842538
      },
      {
        "id": 18962,
        "lat": 15.17076836927913,
        "lon": 145.7858296869264
      }
    ],

  },
  {
    "id": 18914,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.62245823281405,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18962,
        "lat": 15.17076836927913,
        "lon": 145.7858296869264
      },
      {
        "id": 18963,
        "lat": 15.17085013620181,
        "lon": 145.7857353542206
      }
    ],

  },
  {
    "id": 18915,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.540773587174349,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18964,
        "lat": 15.16810500459643,
        "lon": 145.7874853918269
      },
      {
        "id": 18965,
        "lat": 15.1681050220203,
        "lon": 145.7874338216267
      }
    ],

  },
  {
    "id": 18916,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 51.54604610877142,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18965,
        "lat": 15.1681050220203,
        "lon": 145.7874338216267
      },
      {
        "id": 18966,
        "lat": 15.16810518354999,
        "lon": 145.7869540619186
      }
    ],

  },
  {
    "id": 18917,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.743723994686507,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18966,
        "lat": 15.16810518354999,
        "lon": 145.7869540619186
      },
      {
        "id": 18967,
        "lat": 15.16810277786742,
        "lon": 145.7868354771578
      }
    ],

  },
  {
    "id": 18918,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 17.22307189784256,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18967,
        "lat": 15.16810277786742,
        "lon": 145.7868354771578
      },
      {
        "id": 18968,
        "lat": 15.1680964099328,
        "lon": 145.7866753109549
      }
    ],

  },
  {
    "id": 18919,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 80.0373290876914,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18969,
        "lat": 15.16872510566464,
        "lon": 145.7873627202953
      },
      {
        "id": 18970,
        "lat": 15.16873734075304,
        "lon": 145.7866178864151
      }
    ],

  },
  {
    "id": 18920,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 59.17458114349034,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18971,
        "lat": 15.16030853827835,
        "lon": 145.7838652858246
      },
      {
        "id": 18972,
        "lat": 15.15991693792706,
        "lon": 145.7842377193664
      }
    ],

  },
  {
    "id": 18921,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 53.20448629913308,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18973,
        "lat": 15.16085988366889,
        "lon": 145.7844118814602
      },
      {
        "id": 18974,
        "lat": 15.16051663194817,
        "lon": 145.7847564528105
      }
    ],

  },
  {
    "id": 18922,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 85.40908686974899,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18975,
        "lat": 15.16071180591826,
        "lon": 145.7824129605864
      },
      {
        "id": 18976,
        "lat": 15.16121770303253,
        "lon": 145.7830105883959
      }
    ],

  },
  {
    "id": 18923,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 35.43900443844293,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18977,
        "lat": 15.15959728859315,
        "lon": 145.7834232500982
      },
      {
        "id": 18978,
        "lat": 15.1593624710217,
        "lon": 145.783645965264
      }
    ],

  },
  {
    "id": 18924,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.225906874902052,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18979,
        "lat": 15.16136039829074,
        "lon": 145.7849071256721
      },
      {
        "id": 18980,
        "lat": 15.16134517524823,
        "lon": 145.7849326731788
      }
    ],

  },
  {
    "id": 18925,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 8.87193864449573,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18980,
        "lat": 15.16134517524823,
        "lon": 145.7849326731788
      },
      {
        "id": 18981,
        "lat": 15.16130885790014,
        "lon": 145.7850061738585
      }
    ],

  },
  {
    "id": 18926,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 8.868571828469037,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18981,
        "lat": 15.16130885790014,
        "lon": 145.7850061738585
      },
      {
        "id": 18982,
        "lat": 15.16127833815551,
        "lon": 145.7850824176829
      }
    ],

  },
  {
    "id": 18927,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6485697910734698,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18983,
        "lat": 15.16051386215853,
        "lon": 145.7847619146038
      },
      {
        "id": 18984,
        "lat": 15.16051879840328,
        "lon": 145.7847651210505
      }
    ],

  },
  {
    "id": 18928,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 62.56192592203415,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18985,
        "lat": 15.17525188131608,
        "lon": 145.7750853003925
      },
      {
        "id": 18986,
        "lat": 15.17504161187597,
        "lon": 145.7745452844215
      }
    ],

  },
  {
    "id": 18929,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.615776987950965,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18987,
        "lat": 15.16944690863858,
        "lon": 145.7733617371732
      },
      {
        "id": 18988,
        "lat": 15.16948354280967,
        "lon": 145.7733416138483
      }
    ],

  },
  {
    "id": 18930,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 77.58434948138398,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18988,
        "lat": 15.16948354280967,
        "lon": 145.7733416138483
      },
      {
        "id": 18989,
        "lat": 15.17007056815122,
        "lon": 145.772952359539
      }
    ],

  },
  {
    "id": 18931,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 34.689965743350626,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18987,
        "lat": 15.16944690863858,
        "lon": 145.7733617371732
      },
      {
        "id": 18990,
        "lat": 15.16959446242607,
        "lon": 145.7736461244334
      }
    ],

  },
  {
    "id": 18932,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 32.083717988028255,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18991,
        "lat": 15.16864251852856,
        "lon": 145.7775285209883
      },
      {
        "id": 18992,
        "lat": 15.16861773017484,
        "lon": 145.7772310107243
      }
    ],

  },
  {
    "id": 18933,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 69.85950882589728,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18993,
        "lat": 15.16763341855212,
        "lon": 145.7736865659719
      },
      {
        "id": 18994,
        "lat": 15.16768937658091,
        "lon": 145.7743341850594
      }
    ],

  },
  {
    "id": 18934,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 17.199200021495287,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18995,
        "lat": 15.17583520919731,
        "lon": 145.7735641521255
      },
      {
        "id": 18996,
        "lat": 15.17585444744161,
        "lon": 145.7737229919765
      }
    ],

  },
  {
    "id": 18935,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 44.71488672554225,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18996,
        "lat": 15.17585444744161,
        "lon": 145.7737229919765
      },
      {
        "id": 18997,
        "lat": 15.17594102644549,
        "lon": 145.7741294038964
      }
    ],

  },
  {
    "id": 18936,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 29.840084383353684,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18998,
        "lat": 15.17677652337259,
        "lon": 145.776250439588
      },
      {
        "id": 18999,
        "lat": 15.17702335287411,
        "lon": 145.7761421132765
      }
    ],

  },
  {
    "id": 18937,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 44.398365314346194,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19000,
        "lat": 15.16832416821306,
        "lon": 145.7736863619894
      },
      {
        "id": 19001,
        "lat": 15.16829056889139,
        "lon": 145.7732745971433
      }
    ],

  },
  {
    "id": 18938,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 37.515826698736184,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19002,
        "lat": 15.17903708902532,
        "lon": 145.7714488502195
      },
      {
        "id": 19003,
        "lat": 15.17898719315675,
        "lon": 145.7717941947236
      }
    ],

  },
  {
    "id": 18939,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 90.01331267858562,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19003,
        "lat": 15.17898719315675,
        "lon": 145.7717941947236
      },
      {
        "id": 19004,
        "lat": 15.17887673500088,
        "lon": 145.7726241736576
      }
    ],

  },
  {
    "id": 18940,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 221.5393340466532,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19005,
        "lat": 15.17366339027428,
        "lon": 145.7674629518498
      },
      {
        "id": 19006,
        "lat": 15.17463551010927,
        "lon": 145.7692622229069
      }
    ],

  },
  {
    "id": 18941,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 4.911912421331595,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19006,
        "lat": 15.17463551010927,
        "lon": 145.7692622229069
      },
      {
        "id": 19007,
        "lat": 15.17465713775278,
        "lon": 145.7693020729187
      }
    ],

  },
  {
    "id": 18942,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 11.615307983494723,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19007,
        "lat": 15.17465713775278,
        "lon": 145.7693020729187
      },
      {
        "id": 19008,
        "lat": 15.17471077840382,
        "lon": 145.7693948045971
      }
    ],

  },
  {
    "id": 18943,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 11.618987170206772,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19008,
        "lat": 15.17471077840382,
        "lon": 145.7693948045971
      },
      {
        "id": 19009,
        "lat": 15.17476936057267,
        "lon": 145.7694843100732
      }
    ],

  },
  {
    "id": 18944,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 11.622835447996932,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19009,
        "lat": 15.17476936057267,
        "lon": 145.7694843100732
      },
      {
        "id": 19010,
        "lat": 15.17483270173493,
        "lon": 145.7695703104714
      }
    ],

  },
  {
    "id": 18945,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 11.626804768327233,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19010,
        "lat": 15.17483270173493,
        "lon": 145.7695703104714
      },
      {
        "id": 19011,
        "lat": 15.17490060453871,
        "lon": 145.7696525378361
      }
    ],

  },
  {
    "id": 18946,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 13.233055532576032,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19011,
        "lat": 15.17490060453871,
        "lon": 145.7696525378361
      },
      {
        "id": 19012,
        "lat": 15.17498314032675,
        "lon": 145.7697411798714
      }
    ],

  },
  {
    "id": 18947,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.372549061852768,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19012,
        "lat": 15.17498314032675,
        "lon": 145.7697411798714
      },
      {
        "id": 19013,
        "lat": 15.1750515269834,
        "lon": 145.769806754981
      }
    ],

  },
  {
    "id": 18948,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.37575280418018,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19013,
        "lat": 15.1750515269834,
        "lon": 145.769806754981
      },
      {
        "id": 19014,
        "lat": 15.1751229970713,
        "lon": 145.7698687460626
      }
    ],

  },
  {
    "id": 18949,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.378901045951428,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19014,
        "lat": 15.1751229970713,
        "lon": 145.7698687460626
      },
      {
        "id": 19015,
        "lat": 15.17519737361963,
        "lon": 145.7699269996126
      }
    ],

  },
  {
    "id": 18950,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.381962656230936,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19015,
        "lat": 15.17519737361963,
        "lon": 145.7699269996126
      },
      {
        "id": 19016,
        "lat": 15.17527447246019,
        "lon": 145.7699813713816
      }
    ],

  },
  {
    "id": 18951,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.695929063919053,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19016,
        "lat": 15.17527447246019,
        "lon": 145.7699813713816
      },
      {
        "id": 19017,
        "lat": 15.1753565247385,
        "lon": 145.7700331716737
      }
    ],

  },
  {
    "id": 18952,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.698892980070621,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19017,
        "lat": 15.1753565247385,
        "lon": 145.7700331716737
      },
      {
        "id": 19018,
        "lat": 15.17544104675022,
        "lon": 145.7700805753316
      }
    ],

  },
  {
    "id": 18953,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.701666057651165,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19018,
        "lat": 15.17544104675022,
        "lon": 145.7700805753316
      },
      {
        "id": 19019,
        "lat": 15.17552781648211,
        "lon": 145.7701234578349
      }
    ],

  },
  {
    "id": 18954,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.704219403908924,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19019,
        "lat": 15.17552781648211,
        "lon": 145.7701234578349
      },
      {
        "id": 19020,
        "lat": 15.175616606017,
        "lon": 145.7701617065389
      }
    ],

  },
  {
    "id": 18955,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.008465911998172428,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19020,
        "lat": 15.175616606017,
        "lon": 145.7701617065389
      },
      {
        "id": 19021,
        "lat": 15.17561656567641,
        "lon": 145.7701617733379
      }
    ],

  },
  {
    "id": 18956,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 30.05114849145216,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19021,
        "lat": 15.17561656567641,
        "lon": 145.7701617733379
      },
      {
        "id": 19022,
        "lat": 15.17586924984625,
        "lon": 145.7702602108716
      }
    ],

  },
  {
    "id": 18957,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.076026886843524,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19022,
        "lat": 15.17586924984625,
        "lon": 145.7702602108716
      },
      {
        "id": 19023,
        "lat": 15.17595263561147,
        "lon": 145.77029669229
      }
    ],

  },
  {
    "id": 18958,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.072220327780967,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19023,
        "lat": 15.17595263561147,
        "lon": 145.77029669229
      },
      {
        "id": 19024,
        "lat": 15.17603298224016,
        "lon": 145.7703398022198
      }
    ],

  },
  {
    "id": 18959,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.067968578048445,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19024,
        "lat": 15.17603298224016,
        "lon": 145.7703398022198
      },
      {
        "id": 19025,
        "lat": 15.17610979368549,
        "lon": 145.7703892745149
      }
    ],

  },
  {
    "id": 18960,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.063375976495784,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19025,
        "lat": 15.17610979368549,
        "lon": 145.7703892745149
      },
      {
        "id": 19026,
        "lat": 15.17618259572555,
        "lon": 145.7704448037482
      }
    ],

  },
  {
    "id": 18961,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.058555380360453,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19026,
        "lat": 15.17618259572555,
        "lon": 145.7704448037482
      },
      {
        "id": 19027,
        "lat": 15.17625093889129,
        "lon": 145.770506047097
      }
    ],

  },
  {
    "id": 18962,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.053625435407374,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19027,
        "lat": 15.17625093889129,
        "lon": 145.770506047097
      },
      {
        "id": 19028,
        "lat": 15.17631440124193,
        "lon": 145.7705726264593
      }
    ],

  },
  {
    "id": 18963,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.048707611339568,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19028,
        "lat": 15.17631440124193,
        "lon": 145.7705726264593
      },
      {
        "id": 19029,
        "lat": 15.17637259096919,
        "lon": 145.7706441307885
      }
    ],

  },
  {
    "id": 18964,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.4704855976583426,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19029,
        "lat": 15.17637259096919,
        "lon": 145.7706441307885
      },
      {
        "id": 19030,
        "lat": 15.17638136658259,
        "lon": 145.7706543608678
      }
    ],

  },
  {
    "id": 18965,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 12.736857229236719,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19030,
        "lat": 15.17638136658259,
        "lon": 145.7706543608678
      },
      {
        "id": 19031,
        "lat": 15.17645421377522,
        "lon": 145.770745779344
      }
    ],

  },
  {
    "id": 18966,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 9.149179193287457,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19031,
        "lat": 15.17645421377522,
        "lon": 145.770745779344
      },
      {
        "id": 19032,
        "lat": 15.17650914139159,
        "lon": 145.7708091270434
      }
    ],

  },
  {
    "id": 18967,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 9.153709458281726,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19032,
        "lat": 15.17650914139159,
        "lon": 145.7708091270434
      },
      {
        "id": 19033,
        "lat": 15.17656876507718,
        "lon": 145.7708678006723
      }
    ],

  },
  {
    "id": 18968,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 9.158204985598614,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19033,
        "lat": 15.17656876507718,
        "lon": 145.7708678006723
      },
      {
        "id": 19034,
        "lat": 15.17663271090089,
        "lon": 145.7709214322533
      }
    ],

  },
  {
    "id": 18969,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 9.162553337678057,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19034,
        "lat": 15.17663271090089,
        "lon": 145.7709214322533
      },
      {
        "id": 19035,
        "lat": 15.17670057782479,
        "lon": 145.7709696854298
      }
    ],

  },
  {
    "id": 18970,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 9.166645913371394,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19035,
        "lat": 15.17670057782479,
        "lon": 145.7709696854298
      },
      {
        "id": 19036,
        "lat": 15.1767719402198,
        "lon": 145.7710122575748
      }
    ],

  },
  {
    "id": 18971,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 9.170380544416858,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19036,
        "lat": 15.1767719402198,
        "lon": 145.7710122575748
      },
      {
        "id": 19037,
        "lat": 15.17684635053362,
        "lon": 145.7710488816891
      }
    ],

  },
  {
    "id": 18972,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 9.173664235932343,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19037,
        "lat": 15.17684635053362,
        "lon": 145.7710488816891
      },
      {
        "id": 19038,
        "lat": 15.17692334209866,
        "lon": 145.7710793280765
      }
    ],

  },
  {
    "id": 18973,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 9.17641529496078,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19038,
        "lat": 15.17692334209866,
        "lon": 145.7710793280765
      },
      {
        "id": 19039,
        "lat": 15.17700243205865,
        "lon": 145.771103405784
      }
    ],

  },
  {
    "id": 18974,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 9.178565225407372,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19039,
        "lat": 15.17700243205865,
        "lon": 145.771103405784
      },
      {
        "id": 19040,
        "lat": 15.17708312439573,
        "lon": 145.7711209637993
      }
    ],

  },
  {
    "id": 18975,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.05529769080026118,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19040,
        "lat": 15.17708312439573,
        "lon": 145.7711209637993
      },
      {
        "id": 19041,
        "lat": 15.17708276074213,
        "lon": 145.7711213144283
      }
    ],

  },
  {
    "id": 18976,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 143.1211874129147,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19041,
        "lat": 15.17708276074213,
        "lon": 145.7711213144283
      },
      {
        "id": 19042,
        "lat": 15.17835821311437,
        "lon": 145.7712890063941
      }
    ],

  },
  {
    "id": 18977,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 14.81537156643013,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19043,
        "lat": 15.16897828035489,
        "lon": 145.7708463424681
      },
      {
        "id": 19044,
        "lat": 15.16886378251106,
        "lon": 145.7709166359627
      }
    ],

  },
  {
    "id": 18978,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.449505985093514,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19044,
        "lat": 15.16886378251106,
        "lon": 145.7709166359627
      },
      {
        "id": 19045,
        "lat": 15.16880806169896,
        "lon": 145.7709001924764
      }
    ],

  },
  {
    "id": 18979,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.4512494515318695,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19045,
        "lat": 15.16880806169896,
        "lon": 145.7709001924764
      },
      {
        "id": 19046,
        "lat": 15.16875104656626,
        "lon": 145.7708894363052
      }
    ],

  },
  {
    "id": 18980,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 5.614234426026668,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19046,
        "lat": 15.16875104656626,
        "lon": 145.7708894363052
      },
      {
        "id": 19047,
        "lat": 15.1687008131308,
        "lon": 145.7708847862553
      }
    ],

  },
  {
    "id": 18981,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 5.614513719045158,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19047,
        "lat": 15.1687008131308,
        "lon": 145.7708847862553
      },
      {
        "id": 19048,
        "lat": 15.16865037759459,
        "lon": 145.7708845538819
      }
    ],

  },
  {
    "id": 18982,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 5.614287454713617,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19048,
        "lat": 15.16865037759459,
        "lon": 145.7708845538819
      },
      {
        "id": 19049,
        "lat": 15.16860010575342,
        "lon": 145.7708887408672
      }
    ],

  },
  {
    "id": 18983,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 5.613562085556504,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19049,
        "lat": 15.16860010575342,
        "lon": 145.7708887408672
      },
      {
        "id": 19050,
        "lat": 15.16855036221596,
        "lon": 145.7708973168411
      }
    ],

  },
  {
    "id": 18984,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 27.46050531913721,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19051,
        "lat": 15.17062382215105,
        "lon": 145.7757743605998
      },
      {
        "id": 19052,
        "lat": 15.17060257572335,
        "lon": 145.77551972139
      }
    ],

  },
  {
    "id": 18985,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6868886742021718,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19053,
        "lat": 15.18154902339041,
        "lon": 145.77111465094
      },
      {
        "id": 19054,
        "lat": 15.18154507690366,
        "lon": 145.771119565818
      }
    ],

  },
  {
    "id": 18986,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5437369266744488,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19054,
        "lat": 15.18154507690366,
        "lon": 145.771119565818
      },
      {
        "id": 19055,
        "lat": 15.18154885084208,
        "lon": 145.7711227788289
      }
    ],

  },
  {
    "id": 18987,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 20.4112344998715,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19055,
        "lat": 15.18154885084208,
        "lon": 145.7711227788289
      },
      {
        "id": 19056,
        "lat": 15.18171483717391,
        "lon": 145.7712034958433
      }
    ],

  },
  {
    "id": 18988,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5845416324583609,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19057,
        "lat": 15.18207554067642,
        "lon": 145.7717881946961
      },
      {
        "id": 18820,
        "lat": 15.18207822496439,
        "lon": 145.7717928709846
      }
    ],

  },
  {
    "id": 18989,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.5776796100361313,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19058,
        "lat": 15.18207106610217,
        "lon": 145.7717909180319
      },
      {
        "id": 19057,
        "lat": 15.18207554067642,
        "lon": 145.7717881946961
      }
    ],

  },
  {
    "id": 18990,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6103698360651769,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19059,
        "lat": 15.18245432163759,
        "lon": 145.7726130038545
      },
      {
        "id": 19060,
        "lat": 15.18245678409029,
        "lon": 145.7726180800205
      }
    ],

  },
  {
    "id": 18991,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.5826872285273332,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19061,
        "lat": 15.18244963313198,
        "lon": 145.7726154153677
      },
      {
        "id": 19059,
        "lat": 15.18245432163759,
        "lon": 145.7726130038545
      }
    ],

  },
  {
    "id": 18992,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 19.404011377447166,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19060,
        "lat": 15.18245678409029,
        "lon": 145.7726180800205
      },
      {
        "id": 19062,
        "lat": 15.18253574218512,
        "lon": 145.7727791007015
      }
    ],

  },
  {
    "id": 18993,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 30.492942231700614,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19062,
        "lat": 15.18253574218512,
        "lon": 145.7727791007015
      },
      {
        "id": 19063,
        "lat": 15.18255152974841,
        "lon": 145.7730624583463
      }
    ],

  },
  {
    "id": 18994,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 2.0317481235197574,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19063,
        "lat": 15.18255152974841,
        "lon": 145.7730624583463
      },
      {
        "id": 19064,
        "lat": 15.18254468512812,
        "lon": 145.7730799897293
      }
    ],

  },
  {
    "id": 18995,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5269467019436094,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19065,
        "lat": 15.18254251069944,
        "lon": 145.7730859053503
      },
      {
        "id": 18802,
        "lat": 15.18254082587188,
        "lon": 145.7730904889919
      }
    ],

  },
  {
    "id": 18996,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6508463118568044,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18793,
        "lat": 15.18254798305254,
        "lon": 145.7730880381137
      },
      {
        "id": 19065,
        "lat": 15.18254251069944,
        "lon": 145.7730859053503
      }
    ],

  },
  {
    "id": 18997,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5377429328188501,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19066,
        "lat": 15.1823602045886,
        "lon": 145.7735478017618
      },
      {
        "id": 19067,
        "lat": 15.18236210584181,
        "lon": 145.7735432004195
      }
    ],

  },
  {
    "id": 18998,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6521073542332719,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18800,
        "lat": 15.18235480907187,
        "lon": 145.7735454379585
      },
      {
        "id": 19066,
        "lat": 15.1823602045886,
        "lon": 145.7735478017618
      }
    ],

  },
  {
    "id": 18999,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 25.13945505512966,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19068,
        "lat": 15.18073600148674,
        "lon": 145.7763199567728
      },
      {
        "id": 19069,
        "lat": 15.18062683892473,
        "lon": 145.7761151134319
      }
    ],

  },
  {
    "id": 19000,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6359920307715706,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19070,
        "lat": 15.18200665269508,
        "lon": 145.7742753654261
      },
      {
        "id": 18797,
        "lat": 15.18200783684805,
        "lon": 145.7742695741542
      }
    ],

  },
  {
    "id": 19001,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6387166972870634,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19071,
        "lat": 15.18200103661852,
        "lon": 145.7742741478714
      },
      {
        "id": 19070,
        "lat": 15.18200665269508,
        "lon": 145.7742753654261
      }
    ],

  },
  {
    "id": 19002,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6004386376861099,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19072,
        "lat": 15.18196773093003,
        "lon": 145.7748957661214
      },
      {
        "id": 18799,
        "lat": 15.18196793155479,
        "lon": 145.7748901810987
      }
    ],

  },
  {
    "id": 19003,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.462582643170924,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19073,
        "lat": 15.18196357828395,
        "lon": 145.7748956079576
      },
      {
        "id": 19072,
        "lat": 15.18196773093003,
        "lon": 145.7748957661214
      }
    ],

  },
  {
    "id": 19004,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 21.31034631363558,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19074,
        "lat": 15.18196753957449,
        "lon": 145.7749010931038
      },
      {
        "id": 19075,
        "lat": 15.18195745359879,
        "lon": 145.7750991745638
      }
    ],

  },
  {
    "id": 19005,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 47.28006567732407,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19075,
        "lat": 15.18195745359879,
        "lon": 145.7750991745638
      },
      {
        "id": 19076,
        "lat": 15.18185714777992,
        "lon": 145.7755268089945
      }
    ],

  },
  {
    "id": 19006,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5683500021543078,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19077,
        "lat": 15.18089188412703,
        "lon": 145.7766119482643
      },
      {
        "id": 19078,
        "lat": 15.18089623884104,
        "lon": 145.7766091866826
      }
    ],

  },
  {
    "id": 19007,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5401712322269536,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19079,
        "lat": 15.1808893279669,
        "lon": 145.7766076745399
      },
      {
        "id": 19077,
        "lat": 15.18089188412703,
        "lon": 145.7766119482643
      }
    ],

  },
  {
    "id": 19008,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5855676790877725,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19080,
        "lat": 15.18045176896872,
        "lon": 145.7768674297456
      },
      {
        "id": 19081,
        "lat": 15.18044880164106,
        "lon": 145.7768629293057
      }
    ],

  },
  {
    "id": 19009,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.547018961046932,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18756,
        "lat": 15.18045584249075,
        "lon": 145.7768645820376
      },
      {
        "id": 19080,
        "lat": 15.18045176896872,
        "lon": 145.7768674297456
      }
    ],

  },
  {
    "id": 19010,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 24.84431340026525,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18833,
        "lat": 15.18006994128944,
        "lon": 145.7749065311645
      },
      {
        "id": 19082,
        "lat": 15.17991122089187,
        "lon": 145.7750691025071
      }
    ],

  },
  {
    "id": 19011,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 51.22453897442069,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19082,
        "lat": 15.17991122089187,
        "lon": 145.7750691025071
      },
      {
        "id": 19083,
        "lat": 15.17974469078492,
        "lon": 145.7755135781654
      }
    ],

  },
  {
    "id": 19012,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 11.432280424732397,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19083,
        "lat": 15.17974469078492,
        "lon": 145.7755135781654
      },
      {
        "id": 19084,
        "lat": 15.17976491015318,
        "lon": 145.7756179060997
      }
    ],

  },
  {
    "id": 19013,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.54198064796769,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19084,
        "lat": 15.17976491015318,
        "lon": 145.7756179060997
      },
      {
        "id": 19085,
        "lat": 15.17980286689486,
        "lon": 145.7756870057379
      }
    ],

  },
  {
    "id": 19014,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5774319142751587,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19086,
        "lat": 15.17862123739478,
        "lon": 145.7744299486174
      },
      {
        "id": 19087,
        "lat": 15.17861607969129,
        "lon": 145.7744293766544
      }
    ],

  },
  {
    "id": 19015,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5523762641787121,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19088,
        "lat": 15.18006950410277,
        "lon": 145.7748997495505
      },
      {
        "id": 18832,
        "lat": 15.18007301453061,
        "lon": 145.7749033833553
      }
    ],

  },
  {
    "id": 19016,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6306645200496337,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19089,
        "lat": 15.17962773574265,
        "lon": 145.7787206660986
      },
      {
        "id": 18771,
        "lat": 15.17962273507344,
        "lon": 145.7787234249803
      }
    ],

  },
  {
    "id": 19017,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.5859912650961315,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18814,
        "lat": 15.17888991034295,
        "lon": 145.7757115675289
      },
      {
        "id": 18777,
        "lat": 15.17888684361632,
        "lon": 145.7757160006688
      }
    ],

  },
  {
    "id": 19018,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6535554826716489,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18768,
        "lat": 15.17927478994572,
        "lon": 145.7763515489828
      },
      {
        "id": 19090,
        "lat": 15.17927990793605,
        "lon": 145.7763485684196
      }
    ],

  },
  {
    "id": 19019,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 37.47303180931195,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19091,
        "lat": 15.17443863980749,
        "lon": 145.7813166343188
      },
      {
        "id": 19092,
        "lat": 15.17476444934959,
        "lon": 145.7812289288285
      }
    ],

  },
  {
    "id": 19020,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.6839641833981969,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19093,
        "lat": 15.17442394047624,
        "lon": 145.781320336219
      },
      {
        "id": 18862,
        "lat": 15.17440924114489,
        "lon": 145.7813240381186
      }
    ],

  },
  {
    "id": 19021,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 57.78122532089573,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19093,
        "lat": 15.17442394047624,
        "lon": 145.781320336219
      },
      {
        "id": 19094,
        "lat": 15.17429674653874,
        "lon": 145.7807989245098
      }
    ],

  },
  {
    "id": 19022,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.136218398645287,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19094,
        "lat": 15.17429674653874,
        "lon": 145.7807989245098
      },
      {
        "id": 19095,
        "lat": 15.17432549954584,
        "lon": 145.7806612274809
      }
    ],

  },
  {
    "id": 19023,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 39.719409994023046,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19096,
        "lat": 15.1745926376938,
        "lon": 145.7819787650111
      },
      {
        "id": 19097,
        "lat": 15.17424729354904,
        "lon": 145.7820717142952
      }
    ],

  },
  {
    "id": 19024,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 38.8738456575434,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19096,
        "lat": 15.1745926376938,
        "lon": 145.7819787650111
      },
      {
        "id": 19098,
        "lat": 15.17450303745716,
        "lon": 145.7816290523341
      }
    ],

  },
  {
    "id": 19025,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 35.61425788823672,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19096,
        "lat": 15.1745926376938,
        "lon": 145.7819787650111
      },
      {
        "id": 19099,
        "lat": 15.17490228917534,
        "lon": 145.7818954221312
      }
    ],

  },
  {
    "id": 19026,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 55.761611425520535,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19100,
        "lat": 15.1748267424532,
        "lon": 145.7828466435699
      },
      {
        "id": 19101,
        "lat": 15.17530963529204,
        "lon": 145.7827086771182
      }
    ],

  },
  {
    "id": 19027,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 39.02793248081756,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19102,
        "lat": 15.17695983576546,
        "lon": 145.7821062037875
      },
      {
        "id": 19103,
        "lat": 15.17728290978211,
        "lon": 145.7819651241719
      }
    ],

  },
  {
    "id": 19028,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 35.95108566188832,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19103,
        "lat": 15.17728290978211,
        "lon": 145.7819651241719
      },
      {
        "id": 19104,
        "lat": 15.1774096716944,
        "lon": 145.7822728958645
      }
    ],

  },
  {
    "id": 19029,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 6.608109573567106,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19105,
        "lat": 15.1760878686549,
        "lon": 145.7824949629049
      },
      {
        "id": 19106,
        "lat": 15.17611116845295,
        "lon": 145.7825515336205
      }
    ],

  },
  {
    "id": 19030,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 36.902882442800475,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19106,
        "lat": 15.17611116845295,
        "lon": 145.7825515336205
      },
      {
        "id": 19107,
        "lat": 15.17604949670038,
        "lon": 145.7828890203101
      }
    ],

  },
  {
    "id": 19031,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 68.57211963317962,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19107,
        "lat": 15.17604949670038,
        "lon": 145.7828890203101
      },
      {
        "id": 19108,
        "lat": 15.17561794778992,
        "lon": 145.7833444640772
      }
    ],

  },
  {
    "id": 19032,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 9.285265291247688,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19108,
        "lat": 15.17561794778992,
        "lon": 145.7833444640772
      },
      {
        "id": 19109,
        "lat": 15.17553720724602,
        "lon": 145.7833661574304
      }
    ],

  },
  {
    "id": 19033,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.9998133832796541,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19110,
        "lat": 15.17608562448142,
        "lon": 145.7824868910317
      },
      {
        "id": 19111,
        "lat": 15.17607698578223,
        "lon": 145.7824894374348
      }
    ],

  },
  {
    "id": 19034,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.9024862199822221,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19105,
        "lat": 15.1760878686549,
        "lon": 145.7824949629049
      },
      {
        "id": 19110,
        "lat": 15.17608562448142,
        "lon": 145.7824868910317
      }
    ],

  },
  {
    "id": 19035,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 42.72986192868797,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19112,
        "lat": 15.17753868271079,
        "lon": 145.7825453243346
      },
      {
        "id": 19113,
        "lat": 15.17721402080374,
        "lon": 145.78275750461
      }
    ],

  },
  {
    "id": 19036,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.9724915609996645,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19114,
        "lat": 15.178749476266,
        "lon": 145.7820876997611
      },
      {
        "id": 19115,
        "lat": 15.17874145822671,
        "lon": 145.782091293482
      }
    ],

  },
  {
    "id": 19037,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.084454871891291,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19116,
        "lat": 15.18010277223199,
        "lon": 145.7814925509085
      },
      {
        "id": 18754,
        "lat": 15.18009921071009,
        "lon": 145.7814831556313
      }
    ],

  },
  {
    "id": 19038,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.8670205781834242,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19117,
        "lat": 15.17874274718707,
        "lon": 145.7820717818104
      },
      {
        "id": 19114,
        "lat": 15.178749476266,
        "lon": 145.7820876997611
      }
    ],

  },
  {
    "id": 19039,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.2559783002438774,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19118,
        "lat": 15.17813136030458,
        "lon": 145.780659914762
      },
      {
        "id": 19119,
        "lat": 15.17814164830919,
        "lon": 145.7806551153842
      }
    ],

  },
  {
    "id": 19040,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.0006656515432921,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18782,
        "lat": 15.17814537721297,
        "lon": 145.7806635902461
      },
      {
        "id": 19119,
        "lat": 15.17814164830919,
        "lon": 145.7806551153842
      }
    ],

  },
  {
    "id": 19041,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.4266403126440848,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19119,
        "lat": 15.17814164830919,
        "lon": 145.7806551153842
      },
      {
        "id": 19120,
        "lat": 15.17815333424512,
        "lon": 145.7806496638676
      }
    ],

  },
  {
    "id": 19042,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 26.897748055478573,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19121,
        "lat": 15.17500267053864,
        "lon": 145.783509784551
      },
      {
        "id": 19122,
        "lat": 15.17476884112379,
        "lon": 145.7835728711581
      }
    ],

  },
  {
    "id": 19043,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.376100927667368,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18863,
        "lat": 15.17499951884119,
        "lon": 145.7834973994915
      },
      {
        "id": 19121,
        "lat": 15.17500267053864,
        "lon": 145.783509784551
      }
    ],

  },
  {
    "id": 19044,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.5017549562227663,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19123,
        "lat": 15.17439616752434,
        "lon": 145.7803227994208
      },
      {
        "id": 19124,
        "lat": 15.1743990646561,
        "lon": 145.780309147696
      }
    ],

  },
  {
    "id": 19045,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 91.65542804860634,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19125,
        "lat": 15.17378253879622,
        "lon": 145.7790983354869
      },
      {
        "id": 19126,
        "lat": 15.17366210607782,
        "lon": 145.7782544143578
      }
    ],

  },
  {
    "id": 19046,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 39.90996265459371,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19127,
        "lat": 15.17366123103549,
        "lon": 145.7782491841147
      },
      {
        "id": 19128,
        "lat": 15.17359999578857,
        "lon": 145.7778831749025
      }
    ],

  },
  {
    "id": 19047,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 62.05497522243177,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19128,
        "lat": 15.17359999578857,
        "lon": 145.7778831749025
      },
      {
        "id": 19129,
        "lat": 15.17352676832461,
        "lon": 145.7773105944847
      }
    ],

  },
  {
    "id": 19048,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6201443784461861,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19130,
        "lat": 15.17366672200738,
        "lon": 145.7782482101504
      },
      {
        "id": 19127,
        "lat": 15.17366123103549,
        "lon": 145.7782491841147
      }
    ],

  },
  {
    "id": 19049,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 78.4473090811172,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19131,
        "lat": 15.17352593836871,
        "lon": 145.777305118488
      },
      {
        "id": 19132,
        "lat": 15.17341661220248,
        "lon": 145.7765837994975
      }
    ],

  },
  {
    "id": 19050,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6058938708186705,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19133,
        "lat": 15.17353131478068,
        "lon": 145.7773042401209
      },
      {
        "id": 19131,
        "lat": 15.17352593836871,
        "lon": 145.777305118488
      }
    ],

  },
  {
    "id": 19051,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.4099439279396846,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19132,
        "lat": 15.17341661220248,
        "lon": 145.7765837994975
      },
      {
        "id": 19134,
        "lat": 15.17341429837955,
        "lon": 145.7765708970948
      }
    ],

  },
  {
    "id": 19052,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.891255372643672,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19134,
        "lat": 15.17341429837955,
        "lon": 145.7765708970948
      },
      {
        "id": 19135,
        "lat": 15.17340482152214,
        "lon": 145.7765075118532
      }
    ],

  },
  {
    "id": 19053,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.000698448475378,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19135,
        "lat": 15.17340482152214,
        "lon": 145.7765075118532
      },
      {
        "id": 19136,
        "lat": 15.17339784018111,
        "lon": 145.7764333964271
      }
    ],

  },
  {
    "id": 19054,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.000229015736993,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19136,
        "lat": 15.17339784018111,
        "lon": 145.7764333964271
      },
      {
        "id": 19137,
        "lat": 15.17339800805529,
        "lon": 145.7763589334231
      }
    ],

  },
  {
    "id": 19055,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.000744043787234,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19137,
        "lat": 15.17339800805529,
        "lon": 145.7763589334231
      },
      {
        "id": 19138,
        "lat": 15.17340532350017,
        "lon": 145.7762848521725
      }
    ],

  },
  {
    "id": 19056,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.002223248942435,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19138,
        "lat": 15.17340532350017,
        "lon": 145.7762848521725
      },
      {
        "id": 19139,
        "lat": 15.17341971486361,
        "lon": 145.7762118782672
      }
    ],

  },
  {
    "id": 19057,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.004608225180561,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19139,
        "lat": 15.17341971486361,
        "lon": 145.7762118782672
      },
      {
        "id": 19140,
        "lat": 15.17344104118819,
        "lon": 145.7761407264541
      }
    ],

  },
  {
    "id": 19058,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.00780506199198,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19140,
        "lat": 15.17344104118819,
        "lon": 145.7761407264541
      },
      {
        "id": 19141,
        "lat": 15.17346909359159,
        "lon": 145.7760720936333
      }
    ],

  },
  {
    "id": 19059,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.011687934630617,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19141,
        "lat": 15.17346909359159,
        "lon": 145.7760720936333
      },
      {
        "id": 19142,
        "lat": 15.17350359731281,
        "lon": 145.7760066520332
      }
    ],

  },
  {
    "id": 19060,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.01610417990541,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19142,
        "lat": 15.17350359731281,
        "lon": 145.7760066520332
      },
      {
        "id": 19143,
        "lat": 15.17354421440265,
        "lon": 145.7759450426265
      }
    ],

  },
  {
    "id": 19061,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.020880434471694,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19143,
        "lat": 15.17354421440265,
        "lon": 145.7759450426265
      },
      {
        "id": 19144,
        "lat": 15.17359054703423,
        "lon": 145.7758878688526
      }
    ],

  },
  {
    "id": 19062,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.025829634271684,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19144,
        "lat": 15.17359054703423,
        "lon": 145.7758878688526
      },
      {
        "id": 19145,
        "lat": 15.17364214139935,
        "lon": 145.7758356907061
      }
    ],

  },
  {
    "id": 19063,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.030758127695428,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19145,
        "lat": 15.17364214139935,
        "lon": 145.7758356907061
      },
      {
        "id": 19146,
        "lat": 15.17369849215284,
        "lon": 145.7757890192532
      }
    ],

  },
  {
    "id": 19064,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 86.72096085876454,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19147,
        "lat": 15.17453368567776,
        "lon": 145.7754144074323
      },
      {
        "id": 19148,
        "lat": 15.17524813034377,
        "lon": 145.7750926184086
      }
    ],

  },
  {
    "id": 19065,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.557728453857531,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19149,
        "lat": 15.17452862096766,
        "lon": 145.7754167838991
      },
      {
        "id": 19150,
        "lat": 15.17452405699325,
        "lon": 145.7754189254103
      }
    ],

  },
  {
    "id": 19066,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6478511546540846,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19151,
        "lat": 15.17452619513532,
        "lon": 145.7754113027224
      },
      {
        "id": 19149,
        "lat": 15.17452862096766,
        "lon": 145.7754167838991
      }
    ],

  },
  {
    "id": 19067,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 35.68403503350393,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19152,
        "lat": 15.17525862611439,
        "lon": 145.7750889450406
      },
      {
        "id": 19153,
        "lat": 15.17555385041887,
        "lon": 145.7749595397551
      }
    ],

  },
  {
    "id": 19068,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.0929937329433703,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19153,
        "lat": 15.17555385041887,
        "lon": 145.7749595397551
      },
      {
        "id": 19154,
        "lat": 15.17556304952148,
        "lon": 145.7749559835376
      }
    ],

  },
  {
    "id": 19069,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6495368238552542,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19155,
        "lat": 15.17525365838412,
        "lon": 145.7750906836745
      },
      {
        "id": 19148,
        "lat": 15.17524813034377,
        "lon": 145.7750926184086
      }
    ],

  },
  {
    "id": 19070,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6112632934385668,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18985,
        "lat": 15.17525188131608,
        "lon": 145.7750853003925
      },
      {
        "id": 19155,
        "lat": 15.17525365838412,
        "lon": 145.7750906836745
      }
    ],

  },
  {
    "id": 19071,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 18.497802927818583,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19156,
        "lat": 15.17677419598897,
        "lon": 145.7744574822434
      },
      {
        "id": 19157,
        "lat": 15.17692743734194,
        "lon": 145.7743909021016
      }
    ],

  },
  {
    "id": 19072,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 23.307884029938464,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19157,
        "lat": 15.17692743734194,
        "lon": 145.7743909021016
      },
      {
        "id": 19158,
        "lat": 15.1771352128409,
        "lon": 145.7743641101827
      }
    ],

  },
  {
    "id": 19073,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6203228033636139,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19159,
        "lat": 15.17744193406808,
        "lon": 145.7778773679748
      },
      {
        "id": 19160,
        "lat": 15.17744407538486,
        "lon": 145.777882698516
      }
    ],

  },
  {
    "id": 19074,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 73.44165342403103,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19161,
        "lat": 15.17770828304437,
        "lon": 145.7742936708415
      },
      {
        "id": 19162,
        "lat": 15.17782273960224,
        "lon": 145.7736204544969
      }
    ],

  },
  {
    "id": 19075,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.9042635624232068,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19163,
        "lat": 15.17770637492032,
        "lon": 145.7743032242437
      },
      {
        "id": 19164,
        "lat": 15.17770472870984,
        "lon": 145.7743114663212
      }
    ],

  },
  {
    "id": 19076,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 29.8088950537133,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19165,
        "lat": 15.17760098272082,
        "lon": 145.7751906532259
      },
      {
        "id": 19166,
        "lat": 15.17764393439469,
        "lon": 145.7749167898682
      }
    ],

  },
  {
    "id": 19077,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.5697708294506059,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19167,
        "lat": 15.1776004989138,
        "lon": 145.7751959328047
      },
      {
        "id": 19165,
        "lat": 15.17760098272082,
        "lon": 145.7751906532259
      }
    ],

  },
  {
    "id": 19078,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.5591901262376711,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18806,
        "lat": 15.17759549756261,
        "lon": 145.7751954468858
      },
      {
        "id": 19167,
        "lat": 15.1776004989138,
        "lon": 145.7751959328047
      }
    ],

  },
  {
    "id": 19079,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.650813998945623,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19168,
        "lat": 15.17783119671283,
        "lon": 145.7733895502892
      },
      {
        "id": 19169,
        "lat": 15.17773593207679,
        "lon": 145.7733803462299
      }
    ],

  },
  {
    "id": 19080,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 61.32882480589817,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19169,
        "lat": 15.17773593207679,
        "lon": 145.7733803462299
      },
      {
        "id": 19170,
        "lat": 15.17718501346444,
        "lon": 145.7733773489497
      }
    ],

  },
  {
    "id": 19081,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 43.622248756093846,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19170,
        "lat": 15.17718501346444,
        "lon": 145.7733773489497
      },
      {
        "id": 19171,
        "lat": 15.17679660042541,
        "lon": 145.7734311259112
      }
    ],

  },
  {
    "id": 19082,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 18.70570818064282,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19171,
        "lat": 15.17679660042541,
        "lon": 145.7734311259112
      },
      {
        "id": 19172,
        "lat": 15.17663004280042,
        "lon": 145.7734541723187
      }
    ],

  },
  {
    "id": 19083,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 3.8492394442587776,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18805,
        "lat": 15.17794668694475,
        "lon": 145.7726017236064
      },
      {
        "id": 19173,
        "lat": 15.17794739245196,
        "lon": 145.7725659029794
      }
    ],

  },
  {
    "id": 19084,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.7338135852791183,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19174,
        "lat": 15.17846445325094,
        "lon": 145.7755678617164
      },
      {
        "id": 19175,
        "lat": 15.1784637146833,
        "lon": 145.7755746489431
      }
    ],

  },
  {
    "id": 19085,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 62.21729383144976,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19087,
        "lat": 15.17861607969129,
        "lon": 145.7744293766544
      },
      {
        "id": 19176,
        "lat": 15.17806536382904,
        "lon": 145.7743305912494
      }
    ],

  },
  {
    "id": 19086,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6670109853089228,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19086,
        "lat": 15.17862123739478,
        "lon": 145.7744299486174
      },
      {
        "id": 19177,
        "lat": 15.17862042387208,
        "lon": 145.7744360995764
      }
    ],

  },
  {
    "id": 19087,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 44.39028644186426,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19178,
        "lat": 15.17711785154332,
        "lon": 145.7770844284925
      },
      {
        "id": 19179,
        "lat": 15.17675049045256,
        "lon": 145.7772451440144
      }
    ],

  },
  {
    "id": 19088,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.4373376892584667,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18779,
        "lat": 15.17846835779166,
        "lon": 145.7755683121957
      },
      {
        "id": 19174,
        "lat": 15.17846445325094,
        "lon": 145.7755678617164
      }
    ],

  },
  {
    "id": 19089,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 41.22422782886423,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19004,
        "lat": 15.17887673500088,
        "lon": 145.7726241736576
      },
      {
        "id": 19180,
        "lat": 15.17882300834417,
        "lon": 145.7730038239073
      }
    ],

  },
  {
    "id": 19090,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6321659066101663,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19181,
        "lat": 15.17887166305498,
        "lon": 145.77261812649
      },
      {
        "id": 19182,
        "lat": 15.17887730877981,
        "lon": 145.7726187610395
      }
    ],

  },
  {
    "id": 19091,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 4.379966123455522,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19002,
        "lat": 15.17903708902532,
        "lon": 145.7714488502195
      },
      {
        "id": 19183,
        "lat": 15.17904266638609,
        "lon": 145.7714084936762
      }
    ],

  },
  {
    "id": 19092,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6410180234060505,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19184,
        "lat": 15.18043264238855,
        "lon": 145.7716622607842
      },
      {
        "id": 19185,
        "lat": 15.18043755668111,
        "lon": 145.7716653707138
      }
    ],

  },
  {
    "id": 19093,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5902093028310275,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18818,
        "lat": 15.18043543111811,
        "lon": 145.7716575884737
      },
      {
        "id": 19184,
        "lat": 15.18043264238855,
        "lon": 145.7716622607842
      }
    ],

  },
  {
    "id": 19094,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 87.50362374670198,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19186,
        "lat": 15.17212338550107,
        "lon": 145.7790124806775
      },
      {
        "id": 19187,
        "lat": 15.17212414570476,
        "lon": 145.7798269271275
      }
    ],

  },
  {
    "id": 19095,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 0.8926982789855821,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19188,
        "lat": 15.17115889994817,
        "lon": 145.7775872336302
      },
      {
        "id": 19189,
        "lat": 15.17115373744495,
        "lon": 145.7775935917386
      }
    ],

  },
  {
    "id": 19096,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 36.91521618193279,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19190,
        "lat": 15.17138432798863,
        "lon": 145.777335241952
      },
      {
        "id": 19188,
        "lat": 15.17115889994817,
        "lon": 145.7775872336302
      }
    ],

  },
  {
    "id": 19097,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 41.48445585233229,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19191,
        "lat": 15.16899279645248,
        "lon": 145.7708378951476
      },
      {
        "id": 19192,
        "lat": 15.16880856470094,
        "lon": 145.7705022645497
      }
    ],

  },
  {
    "id": 19098,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.819893426813057,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18989,
        "lat": 15.17007056815122,
        "lon": 145.772952359539
      },
      {
        "id": 19193,
        "lat": 15.17007691273117,
        "lon": 145.7729484837745
      }
    ],

  },
  {
    "id": 19099,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.853355924275634,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19043,
        "lat": 15.16897828035489,
        "lon": 145.7708463424681
      },
      {
        "id": 19191,
        "lat": 15.16899279645248,
        "lon": 145.7708378951476
      }
    ],

  },
  {
    "id": 19100,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.8890785106107679,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18937,
        "lat": 15.16797106888511,
        "lon": 145.7775864434462
      },
      {
        "id": 19194,
        "lat": 15.16797007085819,
        "lon": 145.777578233303
      }
    ],

  },
  {
    "id": 19101,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.287722811268919,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19194,
        "lat": 15.16797007085819,
        "lon": 145.777578233303
      },
      {
        "id": 19195,
        "lat": 15.16796862533656,
        "lon": 145.7775663419025
      }
    ],

  },
  {
    "id": 19102,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.93094311077942,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19196,
        "lat": 15.17075745142745,
        "lon": 145.777375992568
      },
      {
        "id": 19197,
        "lat": 15.17082612248239,
        "lon": 145.7773956545716
      }
    ],

  },
  {
    "id": 19103,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.928488298073045,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19197,
        "lat": 15.17082612248239,
        "lon": 145.7773956545716
      },
      {
        "id": 19198,
        "lat": 15.17089292918115,
        "lon": 145.7774212352409
      }
    ],

  },
  {
    "id": 19104,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.925496053321122,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19198,
        "lat": 15.17089292918115,
        "lon": 145.7774212352409
      },
      {
        "id": 19199,
        "lat": 15.1709573913088,
        "lon": 145.7774525507045
      }
    ],

  },
  {
    "id": 19105,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.922051755676825,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19199,
        "lat": 15.1709573913088,
        "lon": 145.7774525507045
      },
      {
        "id": 19200,
        "lat": 15.17101904550354,
        "lon": 145.7774893758681
      }
    ],

  },
  {
    "id": 19106,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.918253671269549,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19200,
        "lat": 15.17101904550354,
        "lon": 145.7774893758681
      },
      {
        "id": 19201,
        "lat": 15.1710774485861,
        "lon": 145.7775314460324
      }
    ],

  },
  {
    "id": 19107,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 11.152277646608855,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19201,
        "lat": 15.1710774485861,
        "lon": 145.7775314460324
      },
      {
        "id": 19202,
        "lat": 15.17115620465474,
        "lon": 145.7775956015544
      }
    ],

  },
  {
    "id": 19108,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 52.99871752361638,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19202,
        "lat": 15.17115620465474,
        "lon": 145.7775956015544
      },
      {
        "id": 19203,
        "lat": 15.17152240488208,
        "lon": 145.7779108320905
      }
    ],

  },
  {
    "id": 19109,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 21.862134986996256,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19203,
        "lat": 15.17152240488208,
        "lon": 145.7779108320905
      },
      {
        "id": 19204,
        "lat": 15.17166976434759,
        "lon": 145.7780453455399
      }
    ],

  },
  {
    "id": 19110,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 65.48538249169513,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19204,
        "lat": 15.17166976434759,
        "lon": 145.7780453455399
      },
      {
        "id": 19205,
        "lat": 15.17212279572394,
        "lon": 145.7784341554504
      }
    ],

  },
  {
    "id": 19111,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.2623517889170788,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19205,
        "lat": 15.17212279572394,
        "lon": 145.7784341554504
      },
      {
        "id": 19206,
        "lat": 15.17212285492426,
        "lon": 145.7784459047284
      }
    ],

  },
  {
    "id": 19112,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.7656136291175536,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19207,
        "lat": 15.17059319529004,
        "lon": 145.7798699512341
      },
      {
        "id": 19208,
        "lat": 15.17060007206716,
        "lon": 145.7798698393933
      }
    ],

  },
  {
    "id": 19113,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.3659176377798363,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19209,
        "lat": 15.16980765147055,
        "lon": 145.7798831332894
      },
      {
        "id": 19210,
        "lat": 15.16979539515746,
        "lon": 145.7798837389879
      }
    ],

  },
  {
    "id": 19114,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 74.41843830395108,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19211,
        "lat": 15.17123734935429,
        "lon": 145.7805941009647
      },
      {
        "id": 19212,
        "lat": 15.17190556937824,
        "lon": 145.7805736244815
      }
    ],

  },
  {
    "id": 19115,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 1.0108922673881595,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18942,
        "lat": 15.16986422616756,
        "lon": 145.7806457594683
      },
      {
        "id": 19213,
        "lat": 15.16986323563233,
        "lon": 145.7806364067506
      }
    ],

  },
  {
    "id": 19116,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 0.9225438573963023,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19213,
        "lat": 15.16986323563233,
        "lon": 145.7806364067506
      },
      {
        "id": 19214,
        "lat": 15.16986233166617,
        "lon": 145.7806278714274
      }
    ],

  },
  {
    "id": 19117,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 80.21924268059948,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19214,
        "lat": 15.16986233166617,
        "lon": 145.7806278714274
      },
      {
        "id": 19215,
        "lat": 15.16981990778363,
        "lon": 145.7798825275907
      }
    ],

  },
  {
    "id": 19118,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.34351520299572,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19216,
        "lat": 15.16986421334406,
        "lon": 145.7806457466562
      },
      {
        "id": 19217,
        "lat": 15.16987171115711,
        "lon": 145.780635947742
      }
    ],

  },
  {
    "id": 19119,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.5012664674704711,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18946,
        "lat": 15.16916598765154,
        "lon": 145.7826352214833
      },
      {
        "id": 19218,
        "lat": 15.16916710721033,
        "lon": 145.7826397404938
      }
    ],

  },
  {
    "id": 19120,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.8314808754041811,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18912,
        "lat": 15.17005313865304,
        "lon": 145.7832310400445
      },
      {
        "id": 18913,
        "lat": 15.1700456699816,
        "lon": 145.7832311420102
      }
    ],

  },
  {
    "id": 19121,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.6471769968897103,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18903,
        "lat": 15.16976392603644,
        "lon": 145.7848523928519
      },
      {
        "id": 19219,
        "lat": 15.16978130718376,
        "lon": 145.7848692078838
      }
    ],

  },
  {
    "id": 19122,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 3.834664176104378,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19220,
        "lat": 15.17139247781971,
        "lon": 145.783849887742
      },
      {
        "id": 19221,
        "lat": 15.17139075470312,
        "lon": 145.7838142411094
      }
    ],

  },
  {
    "id": 19123,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 41.8660425779214,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19222,
        "lat": 15.16873418341721,
        "lon": 145.7855529337744
      },
      {
        "id": 19223,
        "lat": 15.16873302689924,
        "lon": 145.7851632703983
      }
    ],

  },
  {
    "id": 19124,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.0928433260315802,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19224,
        "lat": 15.16874714951238,
        "lon": 145.7866174652485
      },
      {
        "id": 18970,
        "lat": 15.16873734075304,
        "lon": 145.7866178864151
      }
    ],

  },
  {
    "id": 19125,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 1.0928433390714376,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18970,
        "lat": 15.16873734075304,
        "lon": 145.7866178864151
      },
      {
        "id": 18915,
        "lat": 15.16872753199359,
        "lon": 145.7866183075818
      }
    ],

  },
  {
    "id": 19126,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.7249719499331061,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19225,
        "lat": 15.16874172915539,
        "lon": 145.7859012310568
      },
      {
        "id": 19226,
        "lat": 15.16873521665154,
        "lon": 145.7859012515316
      }
    ],

  },
  {
    "id": 19127,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 69.9813782366571,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19227,
        "lat": 15.16872835482729,
        "lon": 145.7880258333987
      },
      {
        "id": 19228,
        "lat": 15.16872491220213,
        "lon": 145.787374496478
      }
    ],

  },
  {
    "id": 19128,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6105092915523425,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18837,
        "lat": 15.16873383904541,
        "lon": 145.7880258026769
      },
      {
        "id": 19227,
        "lat": 15.16872835482729,
        "lon": 145.7880258333987
      }
    ],

  },
  {
    "id": 19129,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 35.72190743478889,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19229,
        "lat": 15.17183378686237,
        "lon": 145.7855907020438
      },
      {
        "id": 19230,
        "lat": 15.17212350104627,
        "lon": 145.7857336689799
      }
    ],

  },
  {
    "id": 19130,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.5716231216844418,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19231,
        "lat": 15.17277402933315,
        "lon": 145.7842658503261
      },
      {
        "id": 19232,
        "lat": 15.17277427332028,
        "lon": 145.784260535892
      }
    ],

  },
  {
    "id": 19131,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 28.368081623141766,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19232,
        "lat": 15.17277427332028,
        "lon": 145.784260535892
      },
      {
        "id": 19233,
        "lat": 15.17277203881562,
        "lon": 145.7839965070897
      }
    ],

  },
  {
    "id": 19132,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 24.78522325627173,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19233,
        "lat": 15.17277203881562,
        "lon": 145.7839965070897
      },
      {
        "id": 19234,
        "lat": 15.17274898030144,
        "lon": 145.7837670564671
      }
    ],

  },
  {
    "id": 19133,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 8.498831545252067,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19234,
        "lat": 15.17274898030144,
        "lon": 145.7837670564671
      },
      {
        "id": 19235,
        "lat": 15.17273438185939,
        "lon": 145.7836894122809
      }
    ],

  },
  {
    "id": 19134,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 1.2322522093013564,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18908,
        "lat": 15.17272297665918,
        "lon": 145.7849233586089
      },
      {
        "id": 19236,
        "lat": 15.17271205381164,
        "lon": 145.7849214977887
      }
    ],

  },
  {
    "id": 19135,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 1.261981524504526,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19237,
        "lat": 15.1727853532054,
        "lon": 145.784266406175
      },
      {
        "id": 19231,
        "lat": 15.17277402933315,
        "lon": 145.7842658503261
      }
    ],

  },
  {
    "id": 19136,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.400092982329924,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19235,
        "lat": 15.17273438185939,
        "lon": 145.7836894122809
      },
      {
        "id": 18951,
        "lat": 15.17272682380968,
        "lon": 145.7836492136252
      }
    ],

  },
  {
    "id": 19137,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 6.157971941787875,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19238,
        "lat": 15.17279247648514,
        "lon": 145.7829933584587
      },
      {
        "id": 19239,
        "lat": 15.1728469169737,
        "lon": 145.7829831899895
      }
    ],

  },
  {
    "id": 19138,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 72.66174445819684,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19240,
        "lat": 15.17214141556484,
        "lon": 145.7837880121994
      },
      {
        "id": 19241,
        "lat": 15.17212637668256,
        "lon": 145.7831118868179
      }
    ],

  },
  {
    "id": 19139,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.7598324786300832,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18867,
        "lat": 15.17214157966034,
        "lon": 145.7837947793668
      },
      {
        "id": 18958,
        "lat": 15.17214175109836,
        "lon": 145.7838018493366
      }
    ],

  },
  {
    "id": 19140,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 55.5246632180312,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18868,
        "lat": 15.17215352447083,
        "lon": 145.7837944782774
      },
      {
        "id": 19242,
        "lat": 15.17263803327996,
        "lon": 145.7836717117425
      }
    ],

  },
  {
    "id": 19141,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.001982719423617246,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19229,
        "lat": 15.17183378686237,
        "lon": 145.7855907020438
      },
      {
        "id": 19243,
        "lat": 15.17183377404072,
        "lon": 145.7855906892345
      }
    ],

  },
  {
    "id": 19142,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.1151596645562665,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19244,
        "lat": 15.17211639492541,
        "lon": 145.7831127646646
      },
      {
        "id": 19241,
        "lat": 15.17212637668256,
        "lon": 145.7831118868179
      }
    ],

  },
  {
    "id": 19143,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.9594778656364941,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19241,
        "lat": 15.17212637668256,
        "lon": 145.7831118868179
      },
      {
        "id": 19245,
        "lat": 15.17213496493711,
        "lon": 145.7831111315231
      }
    ],

  },
  {
    "id": 19144,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 2.82257436107099,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19246,
        "lat": 15.17278792328791,
        "lon": 145.7829675140974
      },
      {
        "id": 19238,
        "lat": 15.17279247648514,
        "lon": 145.7829933584587
      }
    ],

  },
  {
    "id": 19145,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.0338022009978625,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18910,
        "lat": 15.17250807539135,
        "lon": 145.7820201277851
      },
      {
        "id": 19247,
        "lat": 15.17252633916553,
        "lon": 145.782019635389
      }
    ],

  },
  {
    "id": 19146,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 169.72173457155375,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19208,
        "lat": 15.17060007206716,
        "lon": 145.7798698393933
      },
      {
        "id": 19187,
        "lat": 15.17212414570476,
        "lon": 145.7798269271275
      }
    ],

  },
  {
    "id": 19147,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.7359204886769446,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18929,
        "lat": 15.17059309022652,
        "lon": 145.7798631025112
      },
      {
        "id": 19207,
        "lat": 15.17059319529004,
        "lon": 145.7798699512341
      }
    ],

  },
  {
    "id": 19148,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.9279758814631172,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19248,
        "lat": 15.17035898274414,
        "lon": 145.7773779010878
      },
      {
        "id": 19249,
        "lat": 15.1703582281657,
        "lon": 145.7773692994094
      }
    ],

  },
  {
    "id": 19149,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 2.801187266385793,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19250,
        "lat": 15.17059874986468,
        "lon": 145.7757765784153
      },
      {
        "id": 19051,
        "lat": 15.17062382215105,
        "lon": 145.7757743605998
      }
    ],

  },
  {
    "id": 19150,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.1077413386903043,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18873,
        "lat": 15.17083248528957,
        "lon": 145.7838531739484
      },
      {
        "id": 19251,
        "lat": 15.1708319875237,
        "lon": 145.7838428765293
      }
    ],

  },
  {
    "id": 19151,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 24.00255692721487,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19252,
        "lat": 15.16520136576468,
        "lon": 145.7858894510986
      },
      {
        "id": 19253,
        "lat": 15.16539337237023,
        "lon": 145.7859910972871
      }
    ],

  },
  {
    "id": 19152,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 24.00020198252159,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19253,
        "lat": 15.16539337237023,
        "lon": 145.7859910972871
      },
      {
        "id": 19254,
        "lat": 15.16558345927745,
        "lon": 145.786096499214
      }
    ],

  },
  {
    "id": 19153,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 23.997786831506694,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19254,
        "lat": 15.16558345927745,
        "lon": 145.786096499214
      },
      {
        "id": 19255,
        "lat": 15.1657715571982,
        "lon": 145.7862056184703
      }
    ],

  },
  {
    "id": 19154,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.157430983224787,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19255,
        "lat": 15.1657715571982,
        "lon": 145.7862056184703
      },
      {
        "id": 19256,
        "lat": 15.16583444978125,
        "lon": 145.7862445840508
      }
    ],

  },
  {
    "id": 19155,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 5.555931993054429,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19256,
        "lat": 15.16583444978125,
        "lon": 145.7862445840508
      },
      {
        "id": 19257,
        "lat": 15.16587613204662,
        "lon": 145.7862730259386
      }
    ],

  },
  {
    "id": 19156,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.3593528866618311,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19257,
        "lat": 15.16587613204662,
        "lon": 145.7862730259386
      },
      {
        "id": 19258,
        "lat": 15.16587455837886,
        "lon": 145.7862759462153
      }
    ],

  },
  {
    "id": 19157,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.35908568102651306,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19258,
        "lat": 15.16587455837886,
        "lon": 145.7862759462153
      },
      {
        "id": 19259,
        "lat": 15.16587344884513,
        "lon": 145.7862790844073
      }
    ],

  },
  {
    "id": 19158,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.3589033711116129,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19259,
        "lat": 15.16587344884513,
        "lon": 145.7862790844073
      },
      {
        "id": 19260,
        "lat": 15.16587283088748,
        "lon": 145.7862823628969
      }
    ],

  },
  {
    "id": 19159,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.35882402360294813,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19260,
        "lat": 15.16587283088748,
        "lon": 145.7862823628969
      },
      {
        "id": 19261,
        "lat": 15.16587271979027,
        "lon": 145.7862857005966
      }
    ],

  },
  {
    "id": 19160,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.35885546151363995,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19261,
        "lat": 15.16587271979027,
        "lon": 145.7862857005966
      },
      {
        "id": 19262,
        "lat": 15.16587311830126,
        "lon": 145.7862890149539
      }
    ],

  },
  {
    "id": 19161,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.35899462809779925,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19262,
        "lat": 15.16587311830126,
        "lon": 145.7862890149539
      },
      {
        "id": 19263,
        "lat": 15.165874016564,
        "lon": 145.7862922239942
      }
    ],

  },
  {
    "id": 19162,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.3592277025585729,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19263,
        "lat": 15.165874016564,
        "lon": 145.7862922239942
      },
      {
        "id": 19264,
        "lat": 15.16587539236138,
        "lon": 145.7862952483476
      }
    ],

  },
  {
    "id": 19163,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.3595316056681292,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19264,
        "lat": 15.16587539236138,
        "lon": 145.7862952483476
      },
      {
        "id": 19265,
        "lat": 15.16587721166568,
        "lon": 145.7862980132119
      }
    ],

  },
  {
    "id": 19164,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.3598763344916021,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19265,
        "lat": 15.16587721166568,
        "lon": 145.7862980132119
      },
      {
        "id": 19266,
        "lat": 15.16587942947954,
        "lon": 145.7863004502031
      }
    ],

  },
  {
    "id": 19165,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.36022789195340477,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19266,
        "lat": 15.16587942947954,
        "lon": 145.7863004502031
      },
      {
        "id": 19267,
        "lat": 15.16588199094904,
        "lon": 145.7863024990463
      }
    ],

  },
  {
    "id": 19166,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.39875190839490443,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19267,
        "lat": 15.16588199094904,
        "lon": 145.7863024990463
      },
      {
        "id": 19268,
        "lat": 15.1658851480069,
        "lon": 145.786304252468
      }
    ],

  },
  {
    "id": 19167,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.39906543864284844,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19268,
        "lat": 15.1658851480069,
        "lon": 145.786304252468
      },
      {
        "id": 19269,
        "lat": 15.16588855238068,
        "lon": 145.7863054161628
      }
    ],

  },
  {
    "id": 19168,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.3992592089155069,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19269,
        "lat": 15.16588855238068,
        "lon": 145.7863054161628
      },
      {
        "id": 19270,
        "lat": 15.16589210109073,
        "lon": 145.7863059549298
      }
    ],

  },
  {
    "id": 19169,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.3993101485224652,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19270,
        "lat": 15.16589210109073,
        "lon": 145.7863059549298
      },
      {
        "id": 19271,
        "lat": 15.16589568679145,
        "lon": 145.7863058524717
      }
    ],

  },
  {
    "id": 19170,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.3992121951810847,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19271,
        "lat": 15.16589568679145,
        "lon": 145.7863058524717
      },
      {
        "id": 19272,
        "lat": 15.16589920101832,
        "lon": 145.7863051118878
      }
    ],

  },
  {
    "id": 19171,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.3989770057329354,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19272,
        "lat": 15.16589920101832,
        "lon": 145.7863051118878
      },
      {
        "id": 19273,
        "lat": 15.16590253746877,
        "lon": 145.78630375558
      }
    ],

  },
  {
    "id": 19172,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.3986325797384884,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19273,
        "lat": 15.16590253746877,
        "lon": 145.78630375558
      },
      {
        "id": 19274,
        "lat": 15.1659055952175,
        "lon": 145.7863018245756
      }
    ],

  },
  {
    "id": 19173,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.3982201092047342,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19274,
        "lat": 15.1659055952175,
        "lon": 145.7863018245756
      },
      {
        "id": 19275,
        "lat": 15.16590828177043,
        "lon": 145.7862993772861
      }
    ],

  },
  {
    "id": 19174,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.39778896093124994,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19275,
        "lat": 15.16590828177043,
        "lon": 145.7862993772861
      },
      {
        "id": 19276,
        "lat": 15.16591051586108,
        "lon": 145.7862964877398
      }
    ],

  },
  {
    "id": 19175,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 4.989227652825508,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19276,
        "lat": 15.16591051586108,
        "lon": 145.7862964877398
      },
      {
        "id": 19277,
        "lat": 15.16594794653521,
        "lon": 145.7863220285765
      }
    ],

  },
  {
    "id": 19176,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6975123606037134,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18896,
        "lat": 15.16519810131021,
        "lon": 145.785880681256
      },
      {
        "id": 19278,
        "lat": 15.16519540703983,
        "lon": 145.7858865423897
      }
    ],

  },
  {
    "id": 19177,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.7332565047248856,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19278,
        "lat": 15.16519540703983,
        "lon": 145.7858865423897
      },
      {
        "id": 19252,
        "lat": 15.16520136576468,
        "lon": 145.7858894510986
      }
    ],

  },
  {
    "id": 19178,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.9861328237452733,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18982,
        "lat": 15.16127833815551,
        "lon": 145.7850824176829
      },
      {
        "id": 19279,
        "lat": 15.16126945932156,
        "lon": 145.7851183584535
      }
    ],

  },
  {
    "id": 19179,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.7721767770149427,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19280,
        "lat": 15.16317157439443,
        "lon": 145.7853349759078
      },
      {
        "id": 19281,
        "lat": 15.1631784928065,
        "lon": 145.7853354957475
      }
    ],

  },
  {
    "id": 19180,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 35.861652328997444,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19282,
        "lat": 15.1629970445161,
        "lon": 145.784132586497
      },
      {
        "id": 19283,
        "lat": 15.16331918736404,
        "lon": 145.7841302555413
      }
    ],

  },
  {
    "id": 19181,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 81.29287241587933,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18976,
        "lat": 15.16121770303253,
        "lon": 145.7830105883959
      },
      {
        "id": 19284,
        "lat": 15.16170518635576,
        "lon": 145.783573932973
      }
    ],

  },
  {
    "id": 19182,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 2.28671856583793,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18972,
        "lat": 15.15991693792706,
        "lon": 145.7842377193664
      },
      {
        "id": 19285,
        "lat": 15.15990174791824,
        "lon": 145.7842520467384
      }
    ],

  },
  {
    "id": 19183,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 3.700514132706842,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18975,
        "lat": 15.16071180591826,
        "lon": 145.7824129605864
      },
      {
        "id": 19286,
        "lat": 15.16068925489221,
        "lon": 145.7823876565439
      }
    ],

  },
  {
    "id": 19184,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 0.15257080227746647,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19287,
        "lat": 15.1697335548818,
        "lon": 145.7832431282902
      },
      {
        "id": 19288,
        "lat": 15.16973489217359,
        "lon": 145.7832428172795
      }
    ],

  },
  {
    "id": 19185,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 14.46496271491561,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19288,
        "lat": 15.16973489217359,
        "lon": 145.7832428172795
      },
      {
        "id": 19289,
        "lat": 15.16986288095972,
        "lon": 145.783219567742
      }
    ],

  },
  {
    "id": 19186,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 14.466232808116324,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19289,
        "lat": 15.16986288095972,
        "lon": 145.783219567742
      },
      {
        "id": 19290,
        "lat": 15.16999179784333,
        "lon": 145.7832026041426
      }
    ],

  },
  {
    "id": 19187,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 82.96197371862377,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19290,
        "lat": 15.16999179784333,
        "lon": 145.7832026041426
      },
      {
        "id": 19291,
        "lat": 15.16996503524596,
        "lon": 145.7824309349525
      }
    ],

  },
  {
    "id": 19188,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 0.31425799921871916,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19291,
        "lat": 15.16996503524596,
        "lon": 145.7824309349525
      },
      {
        "id": 19292,
        "lat": 15.16996487036724,
        "lon": 145.7824280149944
      }
    ],

  },
  {
    "id": 19189,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.015718379632629,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19293,
        "lat": 15.1661046470433,
        "lon": 145.7860877614076
      },
      {
        "id": 19294,
        "lat": 15.16608194970195,
        "lon": 145.7861385736026
      }
    ],

  },
  {
    "id": 19190,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.83750223510253,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19294,
        "lat": 15.16608194970195,
        "lon": 145.7861385736026
      },
      {
        "id": 19295,
        "lat": 15.16604623614322,
        "lon": 145.7862014382221
      }
    ],

  },
  {
    "id": 19191,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.584134951231763,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19295,
        "lat": 15.16604623614322,
        "lon": 145.7862014382221
      },
      {
        "id": 19296,
        "lat": 15.16601342041204,
        "lon": 145.7862524217267
      }
    ],

  },
  {
    "id": 19192,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.800820533592097,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19296,
        "lat": 15.16601342041204,
        "lon": 145.7862524217267
      },
      {
        "id": 19297,
        "lat": 15.16597952469467,
        "lon": 145.786305083095
      }
    ],

  },
  {
    "id": 19193,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 3.1082882756015247,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19297,
        "lat": 15.16597952469467,
        "lon": 145.786305083095
      },
      {
        "id": 19298,
        "lat": 15.16595283520633,
        "lon": 145.7863135841724
      }
    ],

  },
  {
    "id": 19194,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6648563561750648,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19299,
        "lat": 15.16613833434797,
        "lon": 145.7854174461484
      },
      {
        "id": 19300,
        "lat": 15.16613237857357,
        "lon": 145.7854179090159
      }
    ],

  },
  {
    "id": 19195,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.4754787774737212,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19301,
        "lat": 15.1699516379836,
        "lon": 145.782428807126
      },
      {
        "id": 19292,
        "lat": 15.16996487036724,
        "lon": 145.7824280149944
      }
    ],

  },
  {
    "id": 19196,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 74.5801268957314,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19042,
        "lat": 15.17835821311437,
        "lon": 145.7712890063941
      },
      {
        "id": 19302,
        "lat": 15.17901876019791,
        "lon": 145.7714049911138
      }
    ],

  },
  {
    "id": 19197,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 2.687697726013736,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19302,
        "lat": 15.17901876019791,
        "lon": 145.7714049911138
      },
      {
        "id": 19183,
        "lat": 15.17904266638609,
        "lon": 145.7714084936762
      }
    ],

  },
  {
    "id": 19198,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.020970233825733,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19303,
        "lat": 15.18067017215652,
        "lon": 145.7787623737503
      },
      {
        "id": 18776,
        "lat": 15.18066655144276,
        "lon": 145.7787536424815
      }
    ],

  },
  {
    "id": 19199,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 45.16049991072985,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18776,
        "lat": 15.18066655144276,
        "lon": 145.7787536424815
      },
      {
        "id": 19304,
        "lat": 15.18104000417999,
        "lon": 145.7785894440264
      }
    ],

  },
  {
    "id": 19200,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 24.03369116457089,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18773,
        "lat": 15.17971187588205,
        "lon": 145.7789082563559
      },
      {
        "id": 19305,
        "lat": 15.17979499238774,
        "lon": 145.779114717942
      }
    ],

  },
  {
    "id": 19201,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 53.73796389500132,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19306,
        "lat": 15.17805967816095,
        "lon": 145.77940523706
      },
      {
        "id": 19307,
        "lat": 15.17761841146057,
        "lon": 145.7796080620706
      }
    ],

  },
  {
    "id": 19202,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 13.28807809764301,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19124,
        "lat": 15.1743990646561,
        "lon": 145.780309147696
      },
      {
        "id": 19308,
        "lat": 15.17428241438564,
        "lon": 145.7802829021269
      }
    ],

  },
  {
    "id": 19203,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.2527611419219955,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19308,
        "lat": 15.17428241438564,
        "lon": 145.7802829021269
      },
      {
        "id": 19309,
        "lat": 15.17422732590564,
        "lon": 145.7802715390337
      }
    ],

  },
  {
    "id": 19204,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 48.144790034824126,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19309,
        "lat": 15.17422732590564,
        "lon": 145.7802715390337
      },
      {
        "id": 19310,
        "lat": 15.17387778614155,
        "lon": 145.7800076397926
      }
    ],

  },
  {
    "id": 19205,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 26.925779623584543,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19310,
        "lat": 15.17387778614155,
        "lon": 145.7800076397926
      },
      {
        "id": 19311,
        "lat": 15.17385125118795,
        "lon": 145.7797585365586
      }
    ],

  },
  {
    "id": 19206,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.9982503363554144,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18858,
        "lat": 15.17454789465209,
        "lon": 145.7789767217779
      },
      {
        "id": 19312,
        "lat": 15.17454641421778,
        "lon": 145.7789675578701
      }
    ],

  },
  {
    "id": 19207,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 85.5907148277528,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19312,
        "lat": 15.17454641421778,
        "lon": 145.7789675578701
      },
      {
        "id": 19313,
        "lat": 15.17378783422756,
        "lon": 145.7790974846018
      }
    ],

  },
  {
    "id": 19208,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6229152417183957,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19314,
        "lat": 15.17520806979804,
        "lon": 145.7788493430829
      },
      {
        "id": 19315,
        "lat": 15.17521340403893,
        "lon": 145.7788475913759
      }
    ],

  },
  {
    "id": 19209,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6280403824792443,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19316,
        "lat": 15.17520979380672,
        "lon": 145.7788549090887
      },
      {
        "id": 19314,
        "lat": 15.17520806979804,
        "lon": 145.7788493430829
      }
    ],

  },
  {
    "id": 19210,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 32.9724571736273,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19317,
        "lat": 15.1759469480082,
        "lon": 145.7785592667008
      },
      {
        "id": 19318,
        "lat": 15.17566846677778,
        "lon": 145.7786638116596
      }
    ],

  },
  {
    "id": 19211,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 54.369355753502084,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19318,
        "lat": 15.17566846677778,
        "lon": 145.7786638116596
      },
      {
        "id": 19315,
        "lat": 15.17521340403893,
        "lon": 145.7788475913759
      }
    ],

  },
  {
    "id": 19212,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6017928928713634,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19319,
        "lat": 15.17595154571967,
        "lon": 145.778557447966
      },
      {
        "id": 19320,
        "lat": 15.17595659616808,
        "lon": 145.7785554501401
      }
    ],

  },
  {
    "id": 19213,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6414543380690437,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19321,
        "lat": 15.17595362348693,
        "lon": 145.7785630168139
      },
      {
        "id": 19319,
        "lat": 15.17595154571967,
        "lon": 145.778557447966
      }
    ],

  },
  {
    "id": 19214,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 89.2522464201522,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19322,
        "lat": 15.1766927301167,
        "lon": 145.7782262647542
      },
      {
        "id": 19320,
        "lat": 15.17595659616808,
        "lon": 145.7785554501401
      }
    ],

  },
  {
    "id": 19215,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5394728166346525,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19323,
        "lat": 15.17669781020356,
        "lon": 145.7782241722426
      },
      {
        "id": 19324,
        "lat": 15.1767023135684,
        "lon": 145.7782223172855
      }
    ],

  },
  {
    "id": 19216,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6573350760188397,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19325,
        "lat": 15.1767000152582,
        "lon": 145.7782298479743
      },
      {
        "id": 19323,
        "lat": 15.17669781020356,
        "lon": 145.7782241722426
      }
    ],

  },
  {
    "id": 19217,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 23.75023824928882,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19326,
        "lat": 15.17768574377244,
        "lon": 145.7784643194926
      },
      {
        "id": 19327,
        "lat": 15.17777022347335,
        "lon": 145.7786673142068
      }
    ],

  },
  {
    "id": 19218,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 85.570793850526,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19327,
        "lat": 15.17777022347335,
        "lon": 145.7786673142068
      },
      {
        "id": 19328,
        "lat": 15.17807238650288,
        "lon": 145.7793996779411
      }
    ],

  },
  {
    "id": 19219,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.5355930232009896,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19328,
        "lat": 15.17807238650288,
        "lon": 145.7793996779411
      },
      {
        "id": 19306,
        "lat": 15.17805967816095,
        "lon": 145.77940523706
      }
    ],

  },
  {
    "id": 19220,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5989905080919844,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18850,
        "lat": 15.17743695728477,
        "lon": 145.777879487608
      },
      {
        "id": 19159,
        "lat": 15.17744193406808,
        "lon": 145.7778773679748
      }
    ],

  },
  {
    "id": 19221,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 41.39575815513141,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19311,
        "lat": 15.17385125118795,
        "lon": 145.7797585365586
      },
      {
        "id": 19329,
        "lat": 15.17381440874492,
        "lon": 145.7793751348535
      }
    ],

  },
  {
    "id": 19222,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.4933640974118316,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19329,
        "lat": 15.17381440874492,
        "lon": 145.7793751348535
      },
      {
        "id": 19330,
        "lat": 15.17381282682919,
        "lon": 145.7793613321166
      }
    ],

  },
  {
    "id": 19223,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.3170070478795388,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18786,
        "lat": 15.18127065362673,
        "lon": 145.7802110589572
      },
      {
        "id": 19331,
        "lat": 15.1812813403861,
        "lon": 145.7802057997148
      }
    ],

  },
  {
    "id": 19224,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.0248691700097017,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19332,
        "lat": 15.18127735012481,
        "lon": 145.780197202804
      },
      {
        "id": 19331,
        "lat": 15.1812813403861,
        "lon": 145.7802057997148
      }
    ],

  },
  {
    "id": 19225,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.490712497312061,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19331,
        "lat": 15.1812813403861,
        "lon": 145.7802057997148
      },
      {
        "id": 19333,
        "lat": 15.1812934366657,
        "lon": 145.7801998468086
      }
    ],

  },
  {
    "id": 19226,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.0826850453380221,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18767,
        "lat": 15.18215200122168,
        "lon": 145.7807079228867
      },
      {
        "id": 18784,
        "lat": 15.18214303875523,
        "lon": 145.7807118367647
      }
    ],

  },
  {
    "id": 19227,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 9.744924186520295,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18838,
        "lat": 15.1705271387098,
        "lon": 145.7869896004116
      },
      {
        "id": 19334,
        "lat": 15.17048690360153,
        "lon": 145.7869090474255
      }
    ],

  },
  {
    "id": 19228,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 32.945153266956304,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19335,
        "lat": 15.16805101693675,
        "lon": 145.785554325068
      },
      {
        "id": 19336,
        "lat": 15.1680387148605,
        "lon": 145.7852479564218
      }
    ],

  },
  {
    "id": 19229,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.0205490657407255,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19337,
        "lat": 15.165943230839,
        "lon": 145.7863301741927
      },
      {
        "id": 19277,
        "lat": 15.16594794653521,
        "lon": 145.7863220285765
      }
    ],

  },
  {
    "id": 19230,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.0579835874996066,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19277,
        "lat": 15.16594794653521,
        "lon": 145.7863220285765
      },
      {
        "id": 19298,
        "lat": 15.16595283520633,
        "lon": 145.7863135841724
      }
    ],

  },
  {
    "id": 19231,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.28067179201616,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19338,
        "lat": 15.16313094910675,
        "lon": 145.7818118309925
      },
      {
        "id": 19339,
        "lat": 15.16311613233725,
        "lon": 145.7817363056218
      }
    ],

  },
  {
    "id": 19232,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 23.10417099332402,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19339,
        "lat": 15.16311613233725,
        "lon": 145.7817363056218
      },
      {
        "id": 19340,
        "lat": 15.16305565417747,
        "lon": 145.7815306027164
      }
    ],

  },
  {
    "id": 19233,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 9.896236920229562,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19340,
        "lat": 15.16305565417747,
        "lon": 145.7815306027164
      },
      {
        "id": 19341,
        "lat": 15.16302481630256,
        "lon": 145.7814442157549
      }
    ],

  },
  {
    "id": 19234,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 0.7732708110150096,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19342,
        "lat": 15.1668121186643,
        "lon": 145.7838255826116
      },
      {
        "id": 19343,
        "lat": 15.1668190405664,
        "lon": 145.7838249785784
      }
    ],

  },
  {
    "id": 19235,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 76.51462551377868,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19344,
        "lat": 15.16171714929233,
        "lon": 145.7824285687044
      },
      {
        "id": 19345,
        "lat": 15.16213914848203,
        "lon": 145.7829906818946
      }
    ],

  },
  {
    "id": 19236,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.517792122430523,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19345,
        "lat": 15.16213914848203,
        "lon": 145.7829906818946
      },
      {
        "id": 19346,
        "lat": 15.16221294866481,
        "lon": 145.7829295578759
      }
    ],

  },
  {
    "id": 19237,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.52086359997511,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19346,
        "lat": 15.16221294866481,
        "lon": 145.7829295578759
      },
      {
        "id": 19347,
        "lat": 15.16228953647835,
        "lon": 145.7828721842381
      }
    ],

  },
  {
    "id": 19238,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.523839359972547,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19347,
        "lat": 15.16228953647835,
        "lon": 145.7828721842381
      },
      {
        "id": 19348,
        "lat": 15.16236873230299,
        "lon": 145.7828186955424
      }
    ],

  },
  {
    "id": 19239,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.526691663742856,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19348,
        "lat": 15.16236873230299,
        "lon": 145.7828186955424
      },
      {
        "id": 19349,
        "lat": 15.16245035040257,
        "lon": 145.7827692172382
      }
    ],

  },
  {
    "id": 19240,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.7783295881578454,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19350,
        "lat": 15.16312409399507,
        "lon": 145.781813256658
      },
      {
        "id": 19338,
        "lat": 15.16313094910675,
        "lon": 145.7818118309925
      }
    ],

  },
  {
    "id": 19241,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 1.3673766779994112,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18876,
        "lat": 15.16323339016896,
        "lon": 145.7830763752642
      },
      {
        "id": 19351,
        "lat": 15.16324563636176,
        "lon": 145.7830753860793
      }
    ],

  },
  {
    "id": 19242,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.9431547198392234,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19352,
        "lat": 15.16319182660022,
        "lon": 145.7825266213708
      },
      {
        "id": 19353,
        "lat": 15.16320026879733,
        "lon": 145.7825258795735
      }
    ],

  },
  {
    "id": 19243,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.6882478077595735,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19354,
        "lat": 15.16685177181793,
        "lon": 145.7853549597821
      },
      {
        "id": 19355,
        "lat": 15.16680980625097,
        "lon": 145.7853586353705
      }
    ],

  },
  {
    "id": 19244,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 75.01451073707152,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19355,
        "lat": 15.16680980625097,
        "lon": 145.7853586353705
      },
      {
        "id": 19299,
        "lat": 15.16613833434797,
        "lon": 145.7854174461484
      }
    ],

  },
  {
    "id": 19245,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 77.82418158292343,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19223,
        "lat": 15.16873302689924,
        "lon": 145.7851632703983
      },
      {
        "id": 19336,
        "lat": 15.1680387148605,
        "lon": 145.7852479564218
      }
    ],

  },
  {
    "id": 19246,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 39.153054498669576,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19356,
        "lat": 15.16720223958831,
        "lon": 145.7853242627633
      },
      {
        "id": 19354,
        "lat": 15.16685177181793,
        "lon": 145.7853549597821
      }
    ],

  },
  {
    "id": 19247,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6085602370885078,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19322,
        "lat": 15.1766927301167,
        "lon": 145.7782262647542
      },
      {
        "id": 19323,
        "lat": 15.17669781020356,
        "lon": 145.7782241722426
      }
    ],

  },
  {
    "id": 19248,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5478464167071018,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19317,
        "lat": 15.1759469480082,
        "lon": 145.7785592667008
      },
      {
        "id": 19319,
        "lat": 15.17595154571967,
        "lon": 145.778557447966
      }
    ],

  },
  {
    "id": 19249,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5536529791287789,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19357,
        "lat": 15.17520332867409,
        "lon": 145.7788509000166
      },
      {
        "id": 19314,
        "lat": 15.17520806979804,
        "lon": 145.7788493430829
      }
    ],

  },
  {
    "id": 19250,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6594094355461401,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19358,
        "lat": 15.16601209334991,
        "lon": 145.7839015545895
      },
      {
        "id": 19359,
        "lat": 15.16601165157729,
        "lon": 145.7838954343537
      }
    ],

  },
  {
    "id": 19251,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.8235138103981511,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19360,
        "lat": 15.16681267038132,
        "lon": 145.7838332259928
      },
      {
        "id": 19342,
        "lat": 15.1668121186643,
        "lon": 145.7838255826116
      }
    ],

  },
  {
    "id": 19252,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.7356622815618135,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19361,
        "lat": 15.16519195756576,
        "lon": 145.7839738346185
      },
      {
        "id": 19362,
        "lat": 15.16519140186259,
        "lon": 145.7839670118588
      }
    ],

  },
  {
    "id": 19253,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6629131389275215,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18974,
        "lat": 15.16051663194817,
        "lon": 145.7847564528105
      },
      {
        "id": 18983,
        "lat": 15.16051386215853,
        "lon": 145.7847619146038
      }
    ],

  },
  {
    "id": 19254,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.7272893228679103,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19240,
        "lat": 15.17214141556484,
        "lon": 145.7837880121994
      },
      {
        "id": 18867,
        "lat": 15.17214157966034,
        "lon": 145.7837947793668
      }
    ],

  },
  {
    "id": 19255,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.7556831117419764,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19363,
        "lat": 15.1687318940286,
        "lon": 145.7873627480707
      },
      {
        "id": 18969,
        "lat": 15.16872510566464,
        "lon": 145.7873627202953
      }
    ],

  },
  {
    "id": 19256,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.7298163579712789,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18948,
        "lat": 15.1698511284086,
        "lon": 145.7806370624409
      },
      {
        "id": 19216,
        "lat": 15.16986421334406,
        "lon": 145.7806457466562
      }
    ],

  },
  {
    "id": 19257,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.3659176370902972,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19215,
        "lat": 15.16981990778363,
        "lon": 145.7798825275907
      },
      {
        "id": 19209,
        "lat": 15.16980765147055,
        "lon": 145.7798831332894
      }
    ],

  },
  {
    "id": 19258,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5905418678344724,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18829,
        "lat": 15.1804281150658,
        "lon": 145.7716593957421
      },
      {
        "id": 19184,
        "lat": 15.18043264238855,
        "lon": 145.7716622607842
      }
    ],

  },
  {
    "id": 19259,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6407435753641965,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19364,
        "lat": 15.17862201888006,
        "lon": 145.7744240398879
      },
      {
        "id": 19086,
        "lat": 15.17862123739478,
        "lon": 145.7744299486174
      }
    ],

  },
  {
    "id": 19260,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 2.6631348969603628,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19168,
        "lat": 15.17783119671283,
        "lon": 145.7733895502892
      },
      {
        "id": 18804,
        "lat": 15.17785487540812,
        "lon": 145.773393086249
      }
    ],

  },
  {
    "id": 19261,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.5651424133956354,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19365,
        "lat": 15.17760001903651,
        "lon": 145.7752011694959
      },
      {
        "id": 19167,
        "lat": 15.1776004989138,
        "lon": 145.7751959328047
      }
    ],

  },
  {
    "id": 19262,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.0481329928537824,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19161,
        "lat": 15.17770828304437,
        "lon": 145.7742936708415
      },
      {
        "id": 19163,
        "lat": 15.17770637492032,
        "lon": 145.7743032242437
      }
    ],

  },
  {
    "id": 19263,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5837011981627859,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19152,
        "lat": 15.17525862611439,
        "lon": 145.7750889450406
      },
      {
        "id": 19155,
        "lat": 15.17525365838412,
        "lon": 145.7750906836745
      }
    ],

  },
  {
    "id": 19264,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6189195376964016,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19147,
        "lat": 15.17453368567776,
        "lon": 145.7754144074323
      },
      {
        "id": 19149,
        "lat": 15.17452862096766,
        "lon": 145.7754167838991
      }
    ],

  },
  {
    "id": 19265,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5965311821897087,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19313,
        "lat": 15.17378783422756,
        "lon": 145.7790974846018
      },
      {
        "id": 19125,
        "lat": 15.17378253879622,
        "lon": 145.7790983354869
      }
    ],

  },
  {
    "id": 19266,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.8643620968355376,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19366,
        "lat": 15.17609309283932,
        "lon": 145.7824846896066
      },
      {
        "id": 19110,
        "lat": 15.17608562448142,
        "lon": 145.7824868910317
      }
    ],

  },
  {
    "id": 19267,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.6839641812470445,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19091,
        "lat": 15.17443863980749,
        "lon": 145.7813166343188
      },
      {
        "id": 19093,
        "lat": 15.17442394047624,
        "lon": 145.781320336219
      }
    ],

  },
  {
    "id": 19268,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.49294722836976523,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18758,
        "lat": 15.18045426694797,
        "lon": 145.7768712183417
      },
      {
        "id": 19080,
        "lat": 15.18045176896872,
        "lon": 145.7768674297456
      }
    ],

  },
  {
    "id": 19269,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5908824868423567,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18757,
        "lat": 15.18088735676838,
        "lon": 145.7766148193299
      },
      {
        "id": 19077,
        "lat": 15.18089188412703,
        "lon": 145.7766119482643
      }
    ],

  },
  {
    "id": 19270,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5726970561907493,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19074,
        "lat": 15.18196753957449,
        "lon": 145.7749010931038
      },
      {
        "id": 19072,
        "lat": 15.18196773093003,
        "lon": 145.7748957661214
      }
    ],

  },
  {
    "id": 19271,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.602172259761661,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18798,
        "lat": 15.182005531511,
        "lon": 145.7742808487389
      },
      {
        "id": 19070,
        "lat": 15.18200665269508,
        "lon": 145.7742753654261
      }
    ],

  },
  {
    "id": 19272,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6084414000286944,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19367,
        "lat": 15.18235805337266,
        "lon": 145.7735530080545
      },
      {
        "id": 19066,
        "lat": 15.1823602045886,
        "lon": 145.7735478017618
      }
    ],

  },
  {
    "id": 19273,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6800743293046371,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19064,
        "lat": 15.18254468512812,
        "lon": 145.7730799897293
      },
      {
        "id": 19065,
        "lat": 15.18254251069944,
        "lon": 145.7730859053503
      }
    ],

  },
  {
    "id": 19274,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5261487723227847,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18821,
        "lat": 15.18245219896316,
        "lon": 145.7726086281165
      },
      {
        "id": 19059,
        "lat": 15.18245432163759,
        "lon": 145.7726130038545
      }
    ],

  },
  {
    "id": 19275,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.607219173494807,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19368,
        "lat": 15.18207275224979,
        "lon": 145.7717833369894
      },
      {
        "id": 19057,
        "lat": 15.18207554067642,
        "lon": 145.7717881946961
      }
    ],

  },
  {
    "id": 19276,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6099643361056674,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19369,
        "lat": 15.18154084329767,
        "lon": 145.7711159614611
      },
      {
        "id": 19054,
        "lat": 15.18154507690366,
        "lon": 145.771119565818
      }
    ],

  },
  {
    "id": 19277,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.7709965774355768,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19370,
        "lat": 15.17008005184042,
        "lon": 145.7729548804272
      },
      {
        "id": 19193,
        "lat": 15.17007691273117,
        "lon": 145.7729484837745
      }
    ],

  },
  {
    "id": 19278,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 38.434407801571275,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19193,
        "lat": 15.17007691273117,
        "lon": 145.7729484837745
      },
      {
        "id": 19371,
        "lat": 15.16992042697877,
        "lon": 145.772629608983
      }
    ],

  },
  {
    "id": 19279,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 84.66395493066327,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19196,
        "lat": 15.17075745142745,
        "lon": 145.777375992568
      },
      {
        "id": 19372,
        "lat": 15.17069195085668,
        "lon": 145.7765909092217
      }
    ],

  },
  {
    "id": 19280,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 88.05724883490987,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19372,
        "lat": 15.17069195085668,
        "lon": 145.7765909092217
      },
      {
        "id": 19051,
        "lat": 15.17062382215105,
        "lon": 145.7757743605998
      }
    ],

  },
  {
    "id": 19281,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 71.66139367317356,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19175,
        "lat": 15.1784637146833,
        "lon": 145.7755746489431
      },
      {
        "id": 19373,
        "lat": 15.17827024501716,
        "lon": 145.7762108266184
      }
    ],

  },
  {
    "id": 19282,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.588327117809374,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19373,
        "lat": 15.17827024501716,
        "lon": 145.7762108266184
      },
      {
        "id": 19374,
        "lat": 15.17819925176281,
        "lon": 145.7762764164534
      }
    ],

  },
  {
    "id": 19283,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 39.785384242999534,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19177,
        "lat": 15.17862042387208,
        "lon": 145.7744360995764
      },
      {
        "id": 19375,
        "lat": 15.17854814300886,
        "lon": 145.7747987641095
      }
    ],

  },
  {
    "id": 19284,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 2.7836144913722434,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19375,
        "lat": 15.17854814300886,
        "lon": 145.7747987641095
      },
      {
        "id": 19376,
        "lat": 15.17854534144747,
        "lon": 145.7748245104813
      }
    ],

  },
  {
    "id": 19285,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 17.04051124090556,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19377,
        "lat": 15.17430812664673,
        "lon": 145.7772055199174
      },
      {
        "id": 19378,
        "lat": 15.17445963615089,
        "lon": 145.7771828764435
      }
    ],

  },
  {
    "id": 19286,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.1866387922444,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19378,
        "lat": 15.17445963615089,
        "lon": 145.7771828764435
      },
      {
        "id": 19379,
        "lat": 15.17456760397362,
        "lon": 145.7771641227803
      }
    ],

  },
  {
    "id": 19287,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.185165982296354,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19379,
        "lat": 15.17456760397362,
        "lon": 145.7771641227803
      },
      {
        "id": 19380,
        "lat": 15.1746744880242,
        "lon": 145.777139657103
      }
    ],

  },
  {
    "id": 19288,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.183327109044424,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19380,
        "lat": 15.1746744880242,
        "lon": 145.777139657103
      },
      {
        "id": 19381,
        "lat": 15.17478000346779,
        "lon": 145.7771095446018
      }
    ],

  },
  {
    "id": 19289,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.181141573400298,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19381,
        "lat": 15.17478000346779,
        "lon": 145.7771095446018
      },
      {
        "id": 19382,
        "lat": 15.17488386911614,
        "lon": 145.7770738655156
      }
    ],

  },
  {
    "id": 19290,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.178632490906747,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19382,
        "lat": 15.17488386911614,
        "lon": 145.7770738655156
      },
      {
        "id": 19383,
        "lat": 15.17498580817718,
        "lon": 145.7770327149176
      }
    ],

  },
  {
    "id": 19291,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 21.963379771505533,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19383,
        "lat": 15.17498580817718,
        "lon": 145.7770327149176
      },
      {
        "id": 19384,
        "lat": 15.17516763475879,
        "lon": 145.7769533543004
      }
    ],

  },
  {
    "id": 19292,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.5221111107242353,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19384,
        "lat": 15.17516763475879,
        "lon": 145.7769533543004
      },
      {
        "id": 19385,
        "lat": 15.17518023022309,
        "lon": 145.7769478408663
      }
    ],

  },
  {
    "id": 19293,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6041861102205798,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19386,
        "lat": 15.17614171735569,
        "lon": 145.7747322796708
      },
      {
        "id": 19387,
        "lat": 15.176146722618,
        "lon": 145.7747301050062
      }
    ],

  },
  {
    "id": 19294,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5955437001330981,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19129,
        "lat": 15.17352676832461,
        "lon": 145.7773105944847
      },
      {
        "id": 19131,
        "lat": 15.17352593836871,
        "lon": 145.777305118488
      }
    ],

  },
  {
    "id": 19295,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5703100846761691,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19126,
        "lat": 15.17366210607782,
        "lon": 145.7782544143578
      },
      {
        "id": 19127,
        "lat": 15.17366123103549,
        "lon": 145.7782491841147
      }
    ],

  },
  {
    "id": 19296,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5649103890534407,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19388,
        "lat": 15.17378328106309,
        "lon": 145.7791035369256
      },
      {
        "id": 19125,
        "lat": 15.17378253879622,
        "lon": 145.7790983354869
      }
    ],

  },
  {
    "id": 19297,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 75.02133670650282,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19307,
        "lat": 15.17761841146057,
        "lon": 145.7796080620706
      },
      {
        "id": 19389,
        "lat": 15.17699031246276,
        "lon": 145.7798611663064
      }
    ],

  },
  {
    "id": 19298,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 3.8854922343193783,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19389,
        "lat": 15.17699031246276,
        "lon": 145.7798611663064
      },
      {
        "id": 19390,
        "lat": 15.17695812510623,
        "lon": 145.7798751546099
      }
    ],

  },
  {
    "id": 19299,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5865450631946157,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19391,
        "lat": 15.1761446273104,
        "lon": 145.7747250958232
      },
      {
        "id": 19387,
        "lat": 15.176146722618,
        "lon": 145.7747301050062
      }
    ],

  },
  {
    "id": 19300,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 70.73449033091954,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19387,
        "lat": 15.176146722618,
        "lon": 145.7747301050062
      },
      {
        "id": 19392,
        "lat": 15.17639940572504,
        "lon": 145.7753341889235
      }
    ],

  },
  {
    "id": 19301,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.7426112299625889,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19392,
        "lat": 15.17639940572504,
        "lon": 145.7753341889235
      },
      {
        "id": 19393,
        "lat": 15.17640524667977,
        "lon": 145.7753492373636
      }
    ],

  },
  {
    "id": 19302,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 92.23890426309603,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19394,
        "lat": 15.17644895217386,
        "lon": 145.7754618388461
      },
      {
        "id": 18998,
        "lat": 15.17677652337259,
        "lon": 145.776250439588
      }
    ],

  },
  {
    "id": 19303,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 97.32472023831822,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18998,
        "lat": 15.17677652337259,
        "lon": 145.776250439588
      },
      {
        "id": 19178,
        "lat": 15.17711785154332,
        "lon": 145.7770844284925
      }
    ],

  },
  {
    "id": 19304,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 32.923622113461946,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19178,
        "lat": 15.17711785154332,
        "lon": 145.7770844284925
      },
      {
        "id": 19395,
        "lat": 15.17723621707481,
        "lon": 145.7773652631603
      }
    ],

  },
  {
    "id": 19305,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.3391492445240708,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19395,
        "lat": 15.17723621707481,
        "lon": 145.7773652631603
      },
      {
        "id": 19396,
        "lat": 15.17723738780422,
        "lon": 145.7773681775227
      }
    ],

  },
  {
    "id": 19306,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 47.21221412634021,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19181,
        "lat": 15.17887166305498,
        "lon": 145.77261812649
      },
      {
        "id": 19397,
        "lat": 15.17844959310901,
        "lon": 145.7725750285075
      }
    ],

  },
  {
    "id": 19307,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.561379988263376,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19397,
        "lat": 15.17844959310901,
        "lon": 145.7725750285075
      },
      {
        "id": 19398,
        "lat": 15.17830084565503,
        "lon": 145.7725721492583
      }
    ],

  },
  {
    "id": 19308,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.9979598372055372,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19398,
        "lat": 15.17830084565503,
        "lon": 145.7725721492583
      },
      {
        "id": 19399,
        "lat": 15.17829188210032,
        "lon": 145.7725719928463
      }
    ],

  },
  {
    "id": 19309,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 12.784961434704536,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19173,
        "lat": 15.17794739245196,
        "lon": 145.7725659029794
      },
      {
        "id": 19400,
        "lat": 15.17783256650622,
        "lon": 145.7725635051836
      }
    ],

  },
  {
    "id": 19310,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 69.33354579121692,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19400,
        "lat": 15.17783256650622,
        "lon": 145.7725635051836
      },
      {
        "id": 19401,
        "lat": 15.17721002219319,
        "lon": 145.7725831801178
      }
    ],

  },
  {
    "id": 19311,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 21.90735527687012,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19401,
        "lat": 15.17721002219319,
        "lon": 145.7725831801178
      },
      {
        "id": 19402,
        "lat": 15.17701399821226,
        "lon": 145.7726012370765
      }
    ],

  },
  {
    "id": 19312,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.7886663392372503,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19403,
        "lat": 15.17428414336611,
        "lon": 145.7748441784016
      },
      {
        "id": 19404,
        "lat": 15.17428050130464,
        "lon": 145.7748378819883
      }
    ],

  },
  {
    "id": 19313,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.75051522866985,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19404,
        "lat": 15.17428050130464,
        "lon": 145.7748378819883
      },
      {
        "id": 19405,
        "lat": 15.17425329921149,
        "lon": 145.7748038130261
      }
    ],

  },
  {
    "id": 19314,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.75498376672372,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19405,
        "lat": 15.17425329921149,
        "lon": 145.7748038130261
      },
      {
        "id": 19406,
        "lat": 15.17422143181707,
        "lon": 145.7747743422527
      }
    ],

  },
  {
    "id": 19315,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.759304387057411,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19406,
        "lat": 15.17422143181707,
        "lon": 145.7747743422527
      },
      {
        "id": 19407,
        "lat": 15.17418562353947,
        "lon": 145.7747501396031
      }
    ],

  },
  {
    "id": 19316,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.7630873864383885,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19407,
        "lat": 15.17418562353947,
        "lon": 145.7747501396031
      },
      {
        "id": 19408,
        "lat": 15.17414668838125,
        "lon": 145.774731755255
      }
    ],

  },
  {
    "id": 19317,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.7659923749043,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19408,
        "lat": 15.17414668838125,
        "lon": 145.774731755255
      },
      {
        "id": 19409,
        "lat": 15.17410551142545,
        "lon": 145.7747196071224
      }
    ],

  },
  {
    "id": 19318,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.767758465040351,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19409,
        "lat": 15.17410551142545,
        "lon": 145.7747196071224
      },
      {
        "id": 19410,
        "lat": 15.17406302871598,
        "lon": 145.7747139713553
      }
    ],

  },
  {
    "id": 19319,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.768227324807423,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19410,
        "lat": 15.17406302871598,
        "lon": 145.7747139713553
      },
      {
        "id": 19411,
        "lat": 15.17402020597845,
        "lon": 145.7747149760634
      }
    ],

  },
  {
    "id": 19320,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.767356934232413,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19411,
        "lat": 15.17402020597845,
        "lon": 145.7747149760634
      },
      {
        "id": 19412,
        "lat": 15.17397801666761,
        "lon": 145.7747225984035
      }
    ],

  },
  {
    "id": 19321,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.7652252804894415,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19412,
        "lat": 15.17397801666761,
        "lon": 145.7747225984035
      },
      {
        "id": 19413,
        "lat": 15.17393741983862,
        "lon": 145.7747366650994
      }
    ],

  },
  {
    "id": 19322,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 48.49982594659085,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19413,
        "lat": 15.17393741983862,
        "lon": 145.7747366650994
      },
      {
        "id": 19414,
        "lat": 15.17353594228796,
        "lon": 145.7749119935299
      }
    ],

  },
  {
    "id": 19323,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.745384827624429,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19414,
        "lat": 15.17353594228796,
        "lon": 145.7749119935299
      },
      {
        "id": 19415,
        "lat": 15.17357383268288,
        "lon": 145.7750039802868
      }
    ],

  },
  {
    "id": 19324,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 54.50472707081238,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19416,
        "lat": 15.16766138021175,
        "lon": 145.7736841287412
      },
      {
        "id": 19417,
        "lat": 15.16815083015762,
        "lon": 145.7736976655255
      }
    ],

  },
  {
    "id": 19325,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.33408500886963,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19417,
        "lat": 15.16815083015762,
        "lon": 145.7736976655255
      },
      {
        "id": 19000,
        "lat": 15.16832416821306,
        "lon": 145.7736863619894
      }
    ],

  },
  {
    "id": 19326,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.634436553883078,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19000,
        "lat": 15.16832416821306,
        "lon": 145.7736863619894
      },
      {
        "id": 19418,
        "lat": 15.16836571785031,
        "lon": 145.7736836524961
      }
    ],

  },
  {
    "id": 19327,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 46.23201384935338,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19418,
        "lat": 15.16836571785031,
        "lon": 145.7736836524961
      },
      {
        "id": 19419,
        "lat": 15.16877950537078,
        "lon": 145.7736468504922
      }
    ],

  },
  {
    "id": 19328,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 8.04402192342564,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19419,
        "lat": 15.16877950537078,
        "lon": 145.7736468504922
      },
      {
        "id": 19420,
        "lat": 15.16885118378807,
        "lon": 145.773637365229
      }
    ],

  },
  {
    "id": 19329,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 8.042637182004892,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19420,
        "lat": 15.16885118378807,
        "lon": 145.773637365229
      },
      {
        "id": 19421,
        "lat": 15.16892184700137,
        "lon": 145.773621771394
      }
    ],

  },
  {
    "id": 19330,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 17.257841265090438,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19422,
        "lat": 15.16471554597385,
        "lon": 145.7856836421142
      },
      {
        "id": 19423,
        "lat": 15.16486119723874,
        "lon": 145.7857386612794
      }
    ],

  },
  {
    "id": 19331,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 20.232364290312418,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19423,
        "lat": 15.16486119723874,
        "lon": 145.7857386612794
      },
      {
        "id": 19424,
        "lat": 15.16502960104428,
        "lon": 145.7858094898399
      }
    ],

  },
  {
    "id": 19332,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 20.229056868308437,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19424,
        "lat": 15.16502960104428,
        "lon": 145.7858094898399
      },
      {
        "id": 19278,
        "lat": 15.16519540703983,
        "lon": 145.7858865423897
      }
    ],

  },
  {
    "id": 19333,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 34.76834172742129,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19425,
        "lat": 15.1621024491058,
        "lon": 145.7852407227361
      },
      {
        "id": 19426,
        "lat": 15.16241270408679,
        "lon": 145.7852779556824
      }
    ],

  },
  {
    "id": 19334,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 5.663812223612315,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19426,
        "lat": 15.16241270408679,
        "lon": 145.7852779556824
      },
      {
        "id": 19427,
        "lat": 15.1624634497046,
        "lon": 145.7852817686088
      }
    ],

  },
  {
    "id": 19335,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 50.5706254380039,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19428,
        "lat": 15.16271848069986,
        "lon": 145.7853009311892
      },
      {
        "id": 19280,
        "lat": 15.16317157439443,
        "lon": 145.7853349759078
      }
    ],

  },
  {
    "id": 19336,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 46.96509360510168,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18978,
        "lat": 15.1593624710217,
        "lon": 145.783645965264
      },
      {
        "id": 19429,
        "lat": 15.15964842938308,
        "lon": 145.7839673469783
      }
    ],

  },
  {
    "id": 19337,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.87612008357322,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19285,
        "lat": 15.15990174791824,
        "lon": 145.7842520467384
      },
      {
        "id": 19430,
        "lat": 15.1599436147446,
        "lon": 145.7842991001531
      }
    ],

  },
  {
    "id": 19338,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.14717274299028,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19430,
        "lat": 15.1599436147446,
        "lon": 145.7842991001531
      },
      {
        "id": 19431,
        "lat": 15.16004999109253,
        "lon": 145.7844012675459
      }
    ],

  },
  {
    "id": 19339,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.1513433877241,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19431,
        "lat": 15.16004999109253,
        "lon": 145.7844012675459
      },
      {
        "id": 19432,
        "lat": 15.16016039790544,
        "lon": 145.7844987969031
      }
    ],

  },
  {
    "id": 19340,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.155459966378004,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19432,
        "lat": 15.16016039790544,
        "lon": 145.7844987969031
      },
      {
        "id": 19433,
        "lat": 15.16027464456696,
        "lon": 145.7845915198324
      }
    ],

  },
  {
    "id": 19341,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.159494071977896,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19433,
        "lat": 15.16027464456696,
        "lon": 145.7845915198324
      },
      {
        "id": 19434,
        "lat": 15.16039253382985,
        "lon": 145.7846792762395
      }
    ],

  },
  {
    "id": 19342,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.163417993979866,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19434,
        "lat": 15.16039253382985,
        "lon": 145.7846792762395
      },
      {
        "id": 18983,
        "lat": 15.16051386215853,
        "lon": 145.7847619146038
      }
    ],

  },
  {
    "id": 19343,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 62.88316454476215,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19435,
        "lat": 15.16110666432138,
        "lon": 145.7819933149069
      },
      {
        "id": 19286,
        "lat": 15.16068925489221,
        "lon": 145.7823876565439
      }
    ],

  },
  {
    "id": 19344,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 131.06715835875522,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19343,
        "lat": 15.1668190405664,
        "lon": 145.7838249785784
      },
      {
        "id": 19436,
        "lat": 15.1679891836754,
        "lon": 145.7836897807568
      }
    ],

  },
  {
    "id": 19345,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 9.070150389703128,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19436,
        "lat": 15.1679891836754,
        "lon": 145.7836897807568
      },
      {
        "id": 19437,
        "lat": 15.16807038646431,
        "lon": 145.7836828411848
      }
    ],

  },
  {
    "id": 19346,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 0.7326647898217131,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19283,
        "lat": 15.16331918736404,
        "lon": 145.7841302555413
      },
      {
        "id": 18874,
        "lat": 15.16332575505837,
        "lon": 145.7841298118733
      }
    ],

  },
  {
    "id": 19347,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 106.03624236200503,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19438,
        "lat": 15.16424222271667,
        "lon": 145.7840498396232
      },
      {
        "id": 19362,
        "lat": 15.16519140186259,
        "lon": 145.7839670118588
      }
    ],

  },
  {
    "id": 19348,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 83.48350477955029,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19362,
        "lat": 15.16519140186259,
        "lon": 145.7839670118588
      },
      {
        "id": 19439,
        "lat": 15.16593870107783,
        "lon": 145.7839018002603
      }
    ],

  },
  {
    "id": 19349,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 8.149564897495845,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19439,
        "lat": 15.16593870107783,
        "lon": 145.7839018002603
      },
      {
        "id": 19359,
        "lat": 15.16601165157729,
        "lon": 145.7838954343537
      }
    ],

  },
  {
    "id": 19350,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 89.42308297246107,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19359,
        "lat": 15.16601165157729,
        "lon": 145.7838954343537
      },
      {
        "id": 19342,
        "lat": 15.1668121186643,
        "lon": 145.7838255826116
      }
    ],

  },
  {
    "id": 19351,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.346784358850003,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19440,
        "lat": 15.16365827896023,
        "lon": 145.786179088092
      },
      {
        "id": 19441,
        "lat": 15.16361983532106,
        "lon": 145.7861719987838
      }
    ],

  },
  {
    "id": 19352,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 23.001337285751433,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19441,
        "lat": 15.16361983532106,
        "lon": 145.7861719987838
      },
      {
        "id": 19442,
        "lat": 15.16341617261217,
        "lon": 145.7861358816295
      }
    ],

  },
  {
    "id": 19353,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.4636401084431006,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19442,
        "lat": 15.16341617261217,
        "lon": 145.7861358816295
      },
      {
        "id": 19443,
        "lat": 15.16336895436293,
        "lon": 145.7861220062514
      }
    ],

  },
  {
    "id": 19354,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.460829640635917,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19443,
        "lat": 15.16336895436293,
        "lon": 145.7861220062514
      },
      {
        "id": 19444,
        "lat": 15.16332389452809,
        "lon": 145.7861019147329
      }
    ],

  },
  {
    "id": 19355,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.457226713132405,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19444,
        "lat": 15.16332389452809,
        "lon": 145.7861019147329
      },
      {
        "id": 19445,
        "lat": 15.16328176134527,
        "lon": 145.7860759496242
      }
    ],

  },
  {
    "id": 19356,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.453074679386588,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19445,
        "lat": 15.16328176134527,
        "lon": 145.7860759496242
      },
      {
        "id": 19446,
        "lat": 15.16324327315454,
        "lon": 145.7860445536148
      }
    ],

  },
  {
    "id": 19357,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.448654615303064,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19446,
        "lat": 15.16324327315454,
        "lon": 145.7860445536148
      },
      {
        "id": 19447,
        "lat": 15.16320908615071,
        "lon": 145.7860082619862
      }
    ],

  },
  {
    "id": 19358,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.4442663514295795,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19447,
        "lat": 15.16320908615071,
        "lon": 145.7860082619862
      },
      {
        "id": 19448,
        "lat": 15.1631797831966,
        "lon": 145.7859676934858
      }
    ],

  },
  {
    "id": 19359,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.440208302681588,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19448,
        "lat": 15.1631797831966,
        "lon": 145.7859676934858
      },
      {
        "id": 19449,
        "lat": 15.16315586388486,
        "lon": 145.7859235397778
      }
    ],

  },
  {
    "id": 19360,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.436757105829296,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19449,
        "lat": 15.16315586388486,
        "lon": 145.7859235397778
      },
      {
        "id": 19450,
        "lat": 15.16313773602144,
        "lon": 145.7858765536498
      }
    ],

  },
  {
    "id": 19361,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.434148401569615,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19450,
        "lat": 15.16313773602144,
        "lon": 145.7858765536498
      },
      {
        "id": 19451,
        "lat": 15.16312570867204,
        "lon": 145.7858275361801
      }
    ],

  },
  {
    "id": 19362,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.4325606715163,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19451,
        "lat": 15.16312570867204,
        "lon": 145.7858275361801
      },
      {
        "id": 19452,
        "lat": 15.16311998689334,
        "lon": 145.7857773230788
      }
    ],

  },
  {
    "id": 19363,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.432102683006041,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19452,
        "lat": 15.16311998689334,
        "lon": 145.7857773230788
      },
      {
        "id": 19453,
        "lat": 15.16312066823691,
        "lon": 145.7857267704399
      }
    ],

  },
  {
    "id": 19364,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.432805717432976,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19453,
        "lat": 15.16312066823691,
        "lon": 145.7857267704399
      },
      {
        "id": 19454,
        "lat": 15.16312774108598,
        "lon": 145.785676740147
      }
    ],

  },
  {
    "id": 19365,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 35.796727289302204,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19454,
        "lat": 15.16312774108598,
        "lon": 145.785676740147
      },
      {
        "id": 19455,
        "lat": 15.16317011849032,
        "lon": 145.785346479174
      }
    ],

  },
  {
    "id": 19366,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 76.99637077349828,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18970,
        "lat": 15.16873734075304,
        "lon": 145.7866178864151
      },
      {
        "id": 19226,
        "lat": 15.16873521665154,
        "lon": 145.7859012515316
      }
    ],

  },
  {
    "id": 19367,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.2654288307032306,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19228,
        "lat": 15.16872491220213,
        "lon": 145.787374496478
      },
      {
        "id": 18969,
        "lat": 15.16872510566464,
        "lon": 145.7873627202953
      }
    ],

  },
  {
    "id": 19368,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 33.44361883822253,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19456,
        "lat": 15.16809547450166,
        "lon": 145.7866615747352
      },
      {
        "id": 19457,
        "lat": 15.16808298781634,
        "lon": 145.7863505705502
      }
    ],

  },
  {
    "id": 19369,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.005679257959903,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19458,
        "lat": 15.16546310570181,
        "lon": 145.7869519475951
      },
      {
        "id": 19459,
        "lat": 15.16551304603081,
        "lon": 145.7868745193401
      }
    ],

  },
  {
    "id": 19370,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 73.9192716985104,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19459,
        "lat": 15.16551304603081,
        "lon": 145.7868745193401
      },
      {
        "id": 19267,
        "lat": 15.16588199094904,
        "lon": 145.7863024990463
      }
    ],

  },
  {
    "id": 19371,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.260784249785909,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19267,
        "lat": 15.16588199094904,
        "lon": 145.7863024990463
      },
      {
        "id": 19460,
        "lat": 15.16593317217607,
        "lon": 145.7862230741115
      }
    ],

  },
  {
    "id": 19372,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.501935887138014,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19461,
        "lat": 15.16997076587246,
        "lon": 145.7871236570347
      },
      {
        "id": 19462,
        "lat": 15.17010323256452,
        "lon": 145.7870791541838
      }
    ],

  },
  {
    "id": 19373,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.499180424462217,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19462,
        "lat": 15.17010323256452,
        "lon": 145.7870791541838
      },
      {
        "id": 19463,
        "lat": 15.1702335909907,
        "lon": 145.7870284792795
      }
    ],

  },
  {
    "id": 19374,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.496123150984962,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19463,
        "lat": 15.1702335909907,
        "lon": 145.7870284792795
      },
      {
        "id": 19464,
        "lat": 15.17036157005294,
        "lon": 145.7869717376962
      }
    ],

  },
  {
    "id": 19375,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.492789365920512,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19464,
        "lat": 15.17036157005294,
        "lon": 145.7869717376962
      },
      {
        "id": 19334,
        "lat": 15.17048690360153,
        "lon": 145.7869090474255
      }
    ],

  },
  {
    "id": 19376,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.854531932493411,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19465,
        "lat": 15.17143705082886,
        "lon": 145.7861236292495
      },
      {
        "id": 19466,
        "lat": 15.17148238424391,
        "lon": 145.786067608486
      }
    ],

  },
  {
    "id": 19377,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.98568928937443,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19466,
        "lat": 15.17148238424391,
        "lon": 145.786067608486
      },
      {
        "id": 19467,
        "lat": 15.17156934656342,
        "lon": 145.7859492055139
      }
    ],

  },
  {
    "id": 19378,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.981205209191922,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19467,
        "lat": 15.17156934656342,
        "lon": 145.7859492055139
      },
      {
        "id": 19468,
        "lat": 15.17165078758692,
        "lon": 145.7858267104964
      }
    ],

  },
  {
    "id": 19379,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.976881306525094,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19468,
        "lat": 15.17165078758692,
        "lon": 145.7858267104964
      },
      {
        "id": 19469,
        "lat": 15.17172652598912,
        "lon": 145.7857003961606
      }
    ],

  },
  {
    "id": 19380,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.776916653819924,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19469,
        "lat": 15.17172652598912,
        "lon": 145.7857003961606
      },
      {
        "id": 19243,
        "lat": 15.17183377404072,
        "lon": 145.7855906892345
      }
    ],

  },
  {
    "id": 19381,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 43.13876573540046,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19301,
        "lat": 15.1699516379836,
        "lon": 145.782428807126
      },
      {
        "id": 19470,
        "lat": 15.16957601254994,
        "lon": 145.7825275306012
      }
    ],

  },
  {
    "id": 19382,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 43.137193879183215,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19470,
        "lat": 15.16957601254994,
        "lon": 145.7825275306012
      },
      {
        "id": 19471,
        "lat": 15.16920156217387,
        "lon": 145.7826308781281
      }
    ],

  },
  {
    "id": 19383,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 3.9519331758755767,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19471,
        "lat": 15.16920156217387,
        "lon": 145.7826308781281
      },
      {
        "id": 19218,
        "lat": 15.16916710721033,
        "lon": 145.7826397404938
      }
    ],

  },
  {
    "id": 19384,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 49.275494449031534,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19250,
        "lat": 15.17059874986468,
        "lon": 145.7757765784153
      },
      {
        "id": 19472,
        "lat": 15.17015773294347,
        "lon": 145.7758159296759
      }
    ],

  },
  {
    "id": 19385,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 36.077053961608115,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19215,
        "lat": 15.16981990778363,
        "lon": 145.7798825275907
      },
      {
        "id": 19473,
        "lat": 15.17014395355544,
        "lon": 145.7798772574844
      }
    ],

  },
  {
    "id": 19386,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 60.87257054030315,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19206,
        "lat": 15.17212285492426,
        "lon": 145.7784459047284
      },
      {
        "id": 19186,
        "lat": 15.17212338550107,
        "lon": 145.7790124806775
      }
    ],

  },
  {
    "id": 19387,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 40.73366700331687,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19474,
        "lat": 15.16961524441818,
        "lon": 145.7774379436812
      },
      {
        "id": 19475,
        "lat": 15.16997973473466,
        "lon": 145.7774045001315
      }
    ],

  },
  {
    "id": 19388,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 14.797533769897985,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19249,
        "lat": 15.1703582281657,
        "lon": 145.7773692994094
      },
      {
        "id": 19476,
        "lat": 15.17049062437734,
        "lon": 145.7773569862407
      }
    ],

  },
  {
    "id": 19389,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.473159425655137,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19476,
        "lat": 15.17049062437734,
        "lon": 145.7773569862407
      },
      {
        "id": 19477,
        "lat": 15.170557671572,
        "lon": 145.7773534801673
      }
    ],

  },
  {
    "id": 19390,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.473239490780385,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19477,
        "lat": 15.170557671572,
        "lon": 145.7773534801673
      },
      {
        "id": 19478,
        "lat": 15.17062477669322,
        "lon": 145.7773554936057
      }
    ],

  },
  {
    "id": 19391,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.472728769565918,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19478,
        "lat": 15.17062477669322,
        "lon": 145.7773554936057
      },
      {
        "id": 19479,
        "lat": 15.17069151182941,
        "lon": 145.7773630137221
      }
    ],

  },
  {
    "id": 19392,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.471640106919783,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19479,
        "lat": 15.17069151182941,
        "lon": 145.7773630137221
      },
      {
        "id": 19196,
        "lat": 15.17075745142745,
        "lon": 145.777375992568
      }
    ],

  },
  {
    "id": 19393,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 75.04684104462633,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19194,
        "lat": 15.16797007085819,
        "lon": 145.777578233303
      },
      {
        "id": 18991,
        "lat": 15.16864251852856,
        "lon": 145.7775285209883
      }
    ],

  },
  {
    "id": 19394,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 62.417014511080204,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18991,
        "lat": 15.16864251852856,
        "lon": 145.7775285209883
      },
      {
        "id": 19480,
        "lat": 15.16868847459511,
        "lon": 145.7781075081404
      }
    ],

  },
  {
    "id": 19395,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 37.02971939255336,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18939,
        "lat": 15.16938224359122,
        "lon": 145.7758851250012
      },
      {
        "id": 19481,
        "lat": 15.16941114128187,
        "lon": 145.7762284745764
      }
    ],

  },
  {
    "id": 19396,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 8.864212586826824,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19460,
        "lat": 15.16593317217607,
        "lon": 145.7862230741115
      },
      {
        "id": 19482,
        "lat": 15.16597735194197,
        "lon": 145.7861544350997
      }
    ],

  },
  {
    "id": 19397,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 7.2638026462409755,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19482,
        "lat": 15.16597735194197,
        "lon": 145.7861544350997
      },
      {
        "id": 19483,
        "lat": 15.16601090648425,
        "lon": 145.7860964523219
      }
    ],

  },
  {
    "id": 19398,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 7.260181370345925,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19483,
        "lat": 15.16601090648425,
        "lon": 145.7860964523219
      },
      {
        "id": 19484,
        "lat": 15.16603891932597,
        "lon": 145.7860354301688
      }
    ],

  },
  {
    "id": 19399,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 7.257088663619621,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19484,
        "lat": 15.16603891932597,
        "lon": 145.7860354301688
      },
      {
        "id": 19485,
        "lat": 15.16606113346858,
        "lon": 145.7859719284773
      }
    ],

  },
  {
    "id": 19400,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 7.25463847179052,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19485,
        "lat": 15.16606113346858,
        "lon": 145.7859719284773
      },
      {
        "id": 19486,
        "lat": 15.16607734511212,
        "lon": 145.785906529833
      }
    ],

  },
  {
    "id": 19401,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 7.252921204272381,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19486,
        "lat": 15.16607734511212,
        "lon": 145.785906529833
      },
      {
        "id": 19487,
        "lat": 15.16608740552609,
        "lon": 145.7858398342252
      }
    ],

  },
  {
    "id": 19402,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 7.252000264507238,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19487,
        "lat": 15.16608740552609,
        "lon": 145.7858398342252
      },
      {
        "id": 19488,
        "lat": 15.16609122241312,
        "lon": 145.7857724535421
      }
    ],

  },
  {
    "id": 19403,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 7.251909645963317,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19488,
        "lat": 15.16609122241312,
        "lon": 145.7857724535421
      },
      {
        "id": 19489,
        "lat": 15.16608876075615,
        "lon": 145.7857050059575
      }
    ],

  },
  {
    "id": 19404,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 190.03027826211712,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19489,
        "lat": 15.16608876075615,
        "lon": 145.7857050059575
      },
      {
        "id": 19490,
        "lat": 15.16594211925778,
        "lon": 145.783942873172
      }
    ],

  },
  {
    "id": 19405,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 53.30688240351693,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19223,
        "lat": 15.16873302689924,
        "lon": 145.7851632703983
      },
      {
        "id": 19491,
        "lat": 15.16921019381869,
        "lon": 145.7851215381064
      }
    ],

  },
  {
    "id": 19406,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.146423918555668,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19491,
        "lat": 15.16921019381869,
        "lon": 145.7851215381064
      },
      {
        "id": 19492,
        "lat": 15.1692743514146,
        "lon": 145.7851191956462
      }
    ],

  },
  {
    "id": 19407,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.145863166892064,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19492,
        "lat": 15.1692743514146,
        "lon": 145.7851191956462
      },
      {
        "id": 19493,
        "lat": 15.1693381025441,
        "lon": 145.7851114107226
      }
    ],

  },
  {
    "id": 19408,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.1447138450147705,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19493,
        "lat": 15.1693381025441,
        "lon": 145.7851114107226
      },
      {
        "id": 19494,
        "lat": 15.16940101246699,
        "lon": 145.7850982364186
      }
    ],

  },
  {
    "id": 19409,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.8676995880201065,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19495,
        "lat": 15.16995264741853,
        "lon": 145.7845720168706
      },
      {
        "id": 19496,
        "lat": 15.1699553602179,
        "lon": 145.7845644456687
      }
    ],

  },
  {
    "id": 19410,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.6610047197109825,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19496,
        "lat": 15.1699553602179,
        "lon": 145.7845644456687
      },
      {
        "id": 19497,
        "lat": 15.16997344758428,
        "lon": 145.7844956477484
      }
    ],

  },
  {
    "id": 19411,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.659179194415929,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19497,
        "lat": 15.16997344758428,
        "lon": 145.7844956477484
      },
      {
        "id": 19498,
        "lat": 15.16998551956466,
        "lon": 145.7844254659243
      }
    ],

  },
  {
    "id": 19412,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.658070052056168,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19498,
        "lat": 15.16998551956466,
        "lon": 145.7844254659243
      },
      {
        "id": 19499,
        "lat": 15.16999148044631,
        "lon": 145.7843544566375
      }
    ],

  },
  {
    "id": 19413,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 54.158353063188414,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19499,
        "lat": 15.16999148044631,
        "lon": 145.7843544566375
      },
      {
        "id": 19500,
        "lat": 15.16999138466327,
        "lon": 145.7838503786215
      }
    ],

  },
  {
    "id": 19414,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 19.1253000157957,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19500,
        "lat": 15.16999138466327,
        "lon": 145.7838503786215
      },
      {
        "id": 19501,
        "lat": 15.16999216966138,
        "lon": 145.783672372048
      }
    ],

  },
  {
    "id": 19415,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 30.85551005689675,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19501,
        "lat": 15.16999216966138,
        "lon": 145.783672372048
      },
      {
        "id": 19502,
        "lat": 15.1699919424711,
        "lon": 145.7833851849654
      }
    ],

  },
  {
    "id": 19416,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.78322828213904,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19502,
        "lat": 15.1699919424711,
        "lon": 145.7833851849654
      },
      {
        "id": 19503,
        "lat": 15.17004689829302,
        "lon": 145.7833265260872
      }
    ],

  },
  {
    "id": 19417,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.249014454833857,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19503,
        "lat": 15.17004689829302,
        "lon": 145.7833265260872
      },
      {
        "id": 18913,
        "lat": 15.1700456699816,
        "lon": 145.7832311420102
      }
    ],

  },
  {
    "id": 19418,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 73.80165799497894,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19244,
        "lat": 15.17211639492541,
        "lon": 145.7831127646646
      },
      {
        "id": 18906,
        "lat": 15.17145443572997,
        "lon": 145.7831507114694
      }
    ],

  },
  {
    "id": 19419,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 45.205266226100036,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19245,
        "lat": 15.17213496493711,
        "lon": 145.7831111315231
      },
      {
        "id": 19504,
        "lat": 15.17253543012124,
        "lon": 145.7830413698605
      }
    ],

  },
  {
    "id": 19420,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.0379694467983986,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19504,
        "lat": 15.17253543012124,
        "lon": 145.7830413698605
      },
      {
        "id": 19505,
        "lat": 15.17254460644857,
        "lon": 145.7830396558981
      }
    ],

  },
  {
    "id": 19421,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 18.78792444393712,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19506,
        "lat": 15.1727110252974,
        "lon": 145.7849278638506
      },
      {
        "id": 19507,
        "lat": 15.17273380926909,
        "lon": 145.7847545940241
      }
    ],

  },
  {
    "id": 19422,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 18.78717527390359,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19507,
        "lat": 15.17273380926909,
        "lon": 145.7847545940241
      },
      {
        "id": 19508,
        "lat": 15.17275216028951,
        "lon": 145.7845807672155
      }
    ],

  },
  {
    "id": 19423,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 28.04088744348579,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19509,
        "lat": 15.17145487514178,
        "lon": 145.7817587854604
      },
      {
        "id": 19510,
        "lat": 15.17145479340467,
        "lon": 145.7820197773763
      }
    ],

  },
  {
    "id": 19424,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 35.31733674032246,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19511,
        "lat": 15.17068337651094,
        "lon": 145.7824306187732
      },
      {
        "id": 19512,
        "lat": 15.17068348000611,
        "lon": 145.7821019021538
      }
    ],

  },
  {
    "id": 19425,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 54.66898035077084,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18918,
        "lat": 15.17068375128153,
        "lon": 145.7812329589069
      },
      {
        "id": 19513,
        "lat": 15.17117472730988,
        "lon": 145.7812215354021
      }
    ],

  },
  {
    "id": 19426,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 49.6192996474638,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19514,
        "lat": 15.17250525487579,
        "lon": 145.78119057786
      },
      {
        "id": 19515,
        "lat": 15.1725169964315,
        "lon": 145.7816522539638
      }
    ],

  },
  {
    "id": 19427,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 34.85989034235568,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19516,
        "lat": 15.17261681539328,
        "lon": 145.7825834260663
      },
      {
        "id": 19517,
        "lat": 15.17274805432503,
        "lon": 145.7828780195499
      }
    ],

  },
  {
    "id": 19428,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.59007664580554,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19517,
        "lat": 15.17274805432503,
        "lon": 145.7828780195499
      },
      {
        "id": 19246,
        "lat": 15.17278792328791,
        "lon": 145.7829675140974
      }
    ],

  },
  {
    "id": 19429,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 33.22645162609699,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19518,
        "lat": 15.16522088133972,
        "lon": 145.7844719561525
      },
      {
        "id": 19519,
        "lat": 15.16523880506419,
        "lon": 145.7847806457813
      }
    ],

  },
  {
    "id": 19430,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 9.739844677380203,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18891,
        "lat": 15.16630657195065,
        "lon": 145.7864861869074
      },
      {
        "id": 19520,
        "lat": 15.16622938635091,
        "lon": 145.7864434972268
      }
    ],

  },
  {
    "id": 19431,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 9.73586755046211,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19520,
        "lat": 15.16622938635091,
        "lon": 145.7864434972268
      },
      {
        "id": 19521,
        "lat": 15.16615552745718,
        "lon": 145.7863949678803
      }
    ],

  },
  {
    "id": 19432,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 9.731600707644267,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19521,
        "lat": 15.16615552745718,
        "lon": 145.7863949678803
      },
      {
        "id": 19522,
        "lat": 15.16608541124024,
        "lon": 145.7863408721898
      }
    ],

  },
  {
    "id": 19433,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 9.727139813894055,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19522,
        "lat": 15.16608541124024,
        "lon": 145.7863408721898
      },
      {
        "id": 19523,
        "lat": 15.16601943259171,
        "lon": 145.7862815148259
      }
    ],

  },
  {
    "id": 19434,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.39342849283352527,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19523,
        "lat": 15.16601943259171,
        "lon": 145.7862815148259
      },
      {
        "id": 19524,
        "lat": 15.1660210727512,
        "lon": 145.78627827126
      }
    ],

  },
  {
    "id": 19435,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.39312790098367406,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19524,
        "lat": 15.1660210727512,
        "lon": 145.78627827126
      },
      {
        "id": 19525,
        "lat": 15.16602214811712,
        "lon": 145.7862747860577
      }
    ],

  },
  {
    "id": 19436,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.39294606620757067,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19525,
        "lat": 15.16602214811712,
        "lon": 145.7862747860577
      },
      {
        "id": 19526,
        "lat": 15.16602262679983,
        "lon": 145.7862711625709
      }
    ],

  },
  {
    "id": 19437,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.3929045674157707,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19526,
        "lat": 15.16602262679983,
        "lon": 145.7862711625709
      },
      {
        "id": 19527,
        "lat": 15.16602249460452,
        "lon": 145.7862675082523
      }
    ],

  },
  {
    "id": 19438,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.39300828326343146,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19527,
        "lat": 15.16602249460452,
        "lon": 145.7862675082523
      },
      {
        "id": 19528,
        "lat": 15.16602175545123,
        "lon": 145.7862639314694
      }
    ],

  },
  {
    "id": 19439,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.3932449452237467,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19528,
        "lat": 15.16602175545123,
        "lon": 145.7862639314694
      },
      {
        "id": 19529,
        "lat": 15.16602043125917,
        "lon": 145.7862605382899
      }
    ],

  },
  {
    "id": 19440,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.3935864862834365,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19529,
        "lat": 15.16602043125917,
        "lon": 145.7862605382899
      },
      {
        "id": 19530,
        "lat": 15.16601856129653,
        "lon": 145.7862574293369
      }
    ],

  },
  {
    "id": 19441,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.3939924123218913,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19530,
        "lat": 15.16601856129653,
        "lon": 145.7862574293369
      },
      {
        "id": 19531,
        "lat": 15.16601620101662,
        "lon": 145.7862546968053
      }
    ],

  },
  {
    "id": 19442,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.3944149166725542,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19531,
        "lat": 15.16601620101662,
        "lon": 145.7862546968053
      },
      {
        "id": 19296,
        "lat": 15.16601342041204,
        "lon": 145.7862524217267
      }
    ],

  },
  {
    "id": 19443,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.36229672111364547,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19296,
        "lat": 15.16601342041204,
        "lon": 145.7862524217267
      },
      {
        "id": 19532,
        "lat": 15.16601056976706,
        "lon": 145.7862507947011
      }
    ],

  },
  {
    "id": 19444,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.36256508025905904,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19532,
        "lat": 15.16601056976706,
        "lon": 145.7862507947011
      },
      {
        "id": 19533,
        "lat": 15.16600750577392,
        "lon": 145.7862496503789
      }
    ],

  },
  {
    "id": 19445,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.3627472535714036,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19533,
        "lat": 15.16600750577392,
        "lon": 145.7862496503789
      },
      {
        "id": 19534,
        "lat": 15.1660043049532,
        "lon": 145.7862490173386
      }
    ],

  },
  {
    "id": 19446,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.3628253133394605,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19534,
        "lat": 15.1660043049532,
        "lon": 145.7862490173386
      },
      {
        "id": 19535,
        "lat": 15.16600104724251,
        "lon": 145.7862489113895
      }
    ],

  },
  {
    "id": 19447,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.362791560149932,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19535,
        "lat": 15.16600104724251,
        "lon": 145.7862489113895
      },
      {
        "id": 19536,
        "lat": 15.16599781400032,
        "lon": 145.7862493351778
      }
    ],

  },
  {
    "id": 19448,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.3626493625366678,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19536,
        "lat": 15.16599781400032,
        "lon": 145.7862493351778
      },
      {
        "id": 19537,
        "lat": 15.1659946859736,
        "lon": 145.7862502781197
      }
    ],

  },
  {
    "id": 19449,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.3624126637748625,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19537,
        "lat": 15.1659946859736,
        "lon": 145.7862502781197
      },
      {
        "id": 19538,
        "lat": 15.16599174128218,
        "lon": 145.786251716666
      }
    ],

  },
  {
    "id": 19450,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.36210483325556486,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19538,
        "lat": 15.16599174128218,
        "lon": 145.786251716666
      },
      {
        "id": 19539,
        "lat": 15.16598905346707,
        "lon": 145.7862536148904
      }
    ],

  },
  {
    "id": 19451,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.3617562830993518,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19539,
        "lat": 15.16598905346707,
        "lon": 145.7862536148904
      },
      {
        "id": 19540,
        "lat": 15.16598668965394,
        "lon": 145.7862559253863
      }
    ],

  },
  {
    "id": 19452,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.3614015628120682,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19540,
        "lat": 15.16598668965394,
        "lon": 145.7862559253863
      },
      {
        "id": 19541,
        "lat": 15.16598470887682,
        "lon": 145.7862585904513
      }
    ],

  },
  {
    "id": 19453,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 6.885920374269157,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19541,
        "lat": 15.16598470887682,
        "lon": 145.7862585904513
      },
      {
        "id": 19542,
        "lat": 15.16593320411771,
        "lon": 145.7862230966909
      }
    ],

  },
  {
    "id": 19454,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 0.00430448684267037,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19542,
        "lat": 15.16593320411771,
        "lon": 145.7862230966909
      },
      {
        "id": 19460,
        "lat": 15.16593317217607,
        "lon": 145.7862230741115
      }
    ],

  },
  {
    "id": 19455,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 112.89361588922257,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18875,
        "lat": 15.163325446569,
        "lon": 145.7841228495508
      },
      {
        "id": 19351,
        "lat": 15.16324563636176,
        "lon": 145.7830753860793
      }
    ],

  },
  {
    "id": 19456,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 2.8797756758650177,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19351,
        "lat": 15.16324563636176,
        "lon": 145.7830753860793
      },
      {
        "id": 19543,
        "lat": 15.16324360043916,
        "lon": 145.7830486665998
      }
    ],

  },
  {
    "id": 19457,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 29.56419180304524,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19543,
        "lat": 15.16324360043916,
        "lon": 145.7830486665998
      },
      {
        "id": 19544,
        "lat": 15.16322087740254,
        "lon": 145.7827745161532
      }
    ],

  },
  {
    "id": 19458,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.533523827794458,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19353,
        "lat": 15.16320026879733,
        "lon": 145.7825258795735
      },
      {
        "id": 19545,
        "lat": 15.16319370978203,
        "lon": 145.782446747744
      }
    ],

  },
  {
    "id": 19459,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 65.6521740647788,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19545,
        "lat": 15.16319370978203,
        "lon": 145.782446747744
      },
      {
        "id": 19546,
        "lat": 15.16313620511785,
        "lon": 145.7818386224393
      }
    ],

  },
  {
    "id": 19460,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 2.9374388288516946,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19546,
        "lat": 15.16313620511785,
        "lon": 145.7818386224393
      },
      {
        "id": 19338,
        "lat": 15.16313094910675,
        "lon": 145.7818118309925
      }
    ],

  },
  {
    "id": 19461,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.246536432195223,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19455,
        "lat": 15.16317011849032,
        "lon": 145.785346479174
      },
      {
        "id": 19280,
        "lat": 15.16317157439443,
        "lon": 145.7853349759078
      }
    ],

  },
  {
    "id": 19462,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.763928381710608,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19547,
        "lat": 15.16332693995913,
        "lon": 145.7847177390792
      },
      {
        "id": 19548,
        "lat": 15.16333604229398,
        "lon": 145.7846180020085
      }
    ],

  },
  {
    "id": 19463,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.76344151062098,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19548,
        "lat": 15.16333604229398,
        "lon": 145.7846180020085
      },
      {
        "id": 19549,
        "lat": 15.16333990353585,
        "lon": 145.7845179045092
      }
    ],

  },
  {
    "id": 19464,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.763348217848067,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19549,
        "lat": 15.16333990353585,
        "lon": 145.7845179045092
      },
      {
        "id": 19550,
        "lat": 15.1633385124309,
        "lon": 145.7844177383352
      }
    ],

  },
  {
    "id": 19465,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 30.96849305931783,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19550,
        "lat": 15.1633385124309,
        "lon": 145.7844177383352
      },
      {
        "id": 18874,
        "lat": 15.16332575505837,
        "lon": 145.7841298118733
      }
    ],

  },
  {
    "id": 19466,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 81.34148177840808,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19551,
        "lat": 15.16999237320319,
        "lon": 145.7838859308899
      },
      {
        "id": 19552,
        "lat": 15.17072218273774,
        "lon": 145.7838485037326
      }
    ],

  },
  {
    "id": 19467,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.238355574330887,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19552,
        "lat": 15.17072218273774,
        "lon": 145.7838485037326
      },
      {
        "id": 19251,
        "lat": 15.1708319875237,
        "lon": 145.7838428765293
      }
    ],

  },
  {
    "id": 19468,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 62.27771758668346,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19251,
        "lat": 15.1708319875237,
        "lon": 145.7838428765293
      },
      {
        "id": 19221,
        "lat": 15.17139075470312,
        "lon": 145.7838142411094
      }
    ],

  },
  {
    "id": 19469,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 2.2939924907933675,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19221,
        "lat": 15.17139075470312,
        "lon": 145.7838142411094
      },
      {
        "id": 19553,
        "lat": 15.17141133682718,
        "lon": 145.7838131863242
      }
    ],

  },
  {
    "id": 19470,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.564974880974978,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19553,
        "lat": 15.17141133682718,
        "lon": 145.7838131863242
      },
      {
        "id": 19554,
        "lat": 15.17154213752099,
        "lon": 145.7838098892889
      }
    ],

  },
  {
    "id": 19471,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.9248221109524288,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18864,
        "lat": 15.17482897868081,
        "lon": 145.7828549338339
      },
      {
        "id": 19100,
        "lat": 15.1748267424532,
        "lon": 145.7828466435699
      }
    ],

  },
  {
    "id": 19472,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 96.81648079260256,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19100,
        "lat": 15.1748267424532,
        "lon": 145.7828466435699
      },
      {
        "id": 19096,
        "lat": 15.1745926376938,
        "lon": 145.7819787650111
      }
    ],

  },
  {
    "id": 19473,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 55.49425773924187,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19357,
        "lat": 15.17520332867409,
        "lon": 145.7788509000166
      },
      {
        "id": 19555,
        "lat": 15.17471253822599,
        "lon": 145.7789414670671
      }
    ],

  },
  {
    "id": 19474,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 18.298486315670008,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19555,
        "lat": 15.17471253822599,
        "lon": 145.7789414670671
      },
      {
        "id": 19556,
        "lat": 15.17455000930852,
        "lon": 145.7789669421144
      }
    ],

  },
  {
    "id": 19475,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.40563474214783773,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19556,
        "lat": 15.17455000930852,
        "lon": 145.7789669421144
      },
      {
        "id": 19312,
        "lat": 15.17454641421778,
        "lon": 145.7789675578701
      }
    ],

  },
  {
    "id": 19476,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 40.337143177524325,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19133,
        "lat": 15.17353131478068,
        "lon": 145.7773042401209
      },
      {
        "id": 19557,
        "lat": 15.17389143032707,
        "lon": 145.7772625661126
      }
    ],

  },
  {
    "id": 19477,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.4888735761691922,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18845,
        "lat": 15.1748138488794,
        "lon": 145.7828503273609
      },
      {
        "id": 19100,
        "lat": 15.1748267424532,
        "lon": 145.7828466435699
      }
    ],

  },
  {
    "id": 19478,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.8564574260172694,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19558,
        "lat": 15.17501011595493,
        "lon": 145.7835077757935
      },
      {
        "id": 19121,
        "lat": 15.17500267053864,
        "lon": 145.783509784551
      }
    ],

  },
  {
    "id": 19479,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.6709745138492672,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18843,
        "lat": 15.17082149734036,
        "lon": 145.7875768575552
      },
      {
        "id": 19559,
        "lat": 15.17081593998499,
        "lon": 145.7875792755214
      }
    ],

  },
  {
    "id": 19480,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.581282953090038,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19560,
        "lat": 15.16872838341474,
        "lon": 145.7880312435673
      },
      {
        "id": 19227,
        "lat": 15.16872835482729,
        "lon": 145.7880258333987
      }
    ],

  },
  {
    "id": 19481,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.61534904666991,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18839,
        "lat": 15.17081342123348,
        "lon": 145.787574177259
      },
      {
        "id": 19559,
        "lat": 15.17081593998499,
        "lon": 145.7875792755214
      }
    ],

  },
  {
    "id": 19482,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 105.46851119274032,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19561,
        "lat": 15.18098672825395,
        "lon": 145.7728552864049
      },
      {
        "id": 19562,
        "lat": 15.18112430204434,
        "lon": 145.7738265797852
      }
    ],

  },
  {
    "id": 19483,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 164.55723765538013,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19562,
        "lat": 15.18112430204434,
        "lon": 145.7738265797852
      },
      {
        "id": 18832,
        "lat": 15.18007301453061,
        "lon": 145.7749033833553
      }
    ],

  },
  {
    "id": 19484,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 94.05291455074469,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19120,
        "lat": 15.17815333424512,
        "lon": 145.7806496638676
      },
      {
        "id": 19563,
        "lat": 15.1789289614719,
        "lon": 145.7803025248366
      }
    ],

  },
  {
    "id": 19485,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5498620274247735,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19564,
        "lat": 15.17771130268794,
        "lon": 145.774303576705
      },
      {
        "id": 19163,
        "lat": 15.17770637492032,
        "lon": 145.7743032242437
      }
    ],

  },
  {
    "id": 19486,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 5.003932267724569,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19088,
        "lat": 15.18006950410277,
        "lon": 145.7748997495505
      },
      {
        "id": 19565,
        "lat": 15.18003770341597,
        "lon": 145.7748668312098
      }
    ],

  },
  {
    "id": 19487,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 36.32734012274323,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19565,
        "lat": 15.18003770341597,
        "lon": 145.7748668312098
      },
      {
        "id": 19566,
        "lat": 15.17976570820917,
        "lon": 145.7746800000931
      }
    ],

  },
  {
    "id": 19488,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 49.16633636333531,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19566,
        "lat": 15.17976570820917,
        "lon": 145.7746800000931
      },
      {
        "id": 19567,
        "lat": 15.17935256415445,
        "lon": 145.7745182036642
      }
    ],

  },
  {
    "id": 19489,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.827514772083825,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19567,
        "lat": 15.17935256415445,
        "lon": 145.7745182036642
      },
      {
        "id": 19568,
        "lat": 15.17921208609681,
        "lon": 145.7744954709108
      }
    ],

  },
  {
    "id": 19490,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 12.385100088933616,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19568,
        "lat": 15.17921208609681,
        "lon": 145.7744954709108
      },
      {
        "id": 19569,
        "lat": 15.1791014606352,
        "lon": 145.7744832030481
      }
    ],

  },
  {
    "id": 19491,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 40.252441323799516,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19367,
        "lat": 15.18235805337266,
        "lon": 145.7735530080545
      },
      {
        "id": 18791,
        "lat": 15.18222244860775,
        "lon": 145.7739003342002
      }
    ],

  },
  {
    "id": 19492,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 64.9740051360909,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19116,
        "lat": 15.18010277223199,
        "lon": 145.7814925509085
      },
      {
        "id": 19570,
        "lat": 15.18034744281291,
        "lon": 145.7820416235359
      }
    ],

  },
  {
    "id": 19493,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 48.05831251706583,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19571,
        "lat": 15.18107591556803,
        "lon": 145.7780755556607
      },
      {
        "id": 19572,
        "lat": 15.18067810897156,
        "lon": 145.7782493335581
      }
    ],

  },
  {
    "id": 19494,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 14.424890614605978,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18780,
        "lat": 15.18039071119967,
        "lon": 145.7783748800033
      },
      {
        "id": 19573,
        "lat": 15.18032820652575,
        "lon": 145.7782572665635
      }
    ],

  },
  {
    "id": 19495,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 49.835108883955435,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19573,
        "lat": 15.18032820652575,
        "lon": 145.7782572665635
      },
      {
        "id": 19574,
        "lat": 15.18010679825183,
        "lon": 145.777854107171
      }
    ],

  },
  {
    "id": 19496,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.7644012994571497,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19090,
        "lat": 15.17927990793605,
        "lon": 145.7763485684196
      },
      {
        "id": 19575,
        "lat": 15.17927651142777,
        "lon": 145.776342384786
      }
    ],

  },
  {
    "id": 19497,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 43.19252162327409,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19575,
        "lat": 15.17927651142777,
        "lon": 145.776342384786
      },
      {
        "id": 19576,
        "lat": 15.17908379009142,
        "lon": 145.7759934524881
      }
    ],

  },
  {
    "id": 19498,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 12.5680494516963,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19576,
        "lat": 15.17908379009142,
        "lon": 145.7759934524881
      },
      {
        "id": 19577,
        "lat": 15.17902872744929,
        "lon": 145.7758913264901
      }
    ],

  },
  {
    "id": 19499,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.181005382586106,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19577,
        "lat": 15.17902872744929,
        "lon": 145.7758913264901
      },
      {
        "id": 19578,
        "lat": 15.17895989745843,
        "lon": 145.7757693417999
      }
    ],

  },
  {
    "id": 19500,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.999789625173324,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19578,
        "lat": 15.17895989745843,
        "lon": 145.7757693417999
      },
      {
        "id": 19579,
        "lat": 15.17889380092922,
        "lon": 145.7757211035281
      }
    ],

  },
  {
    "id": 19501,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.9488849642773952,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19579,
        "lat": 15.17889380092922,
        "lon": 145.7757211035281
      },
      {
        "id": 18777,
        "lat": 15.17888684361632,
        "lon": 145.7757160006688
      }
    ],

  },
  {
    "id": 19502,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 93.20135635960996,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19332,
        "lat": 15.18127735012481,
        "lon": 145.780197202804
      },
      {
        "id": 18764,
        "lat": 15.18095944264904,
        "lon": 145.7793946583248
      }
    ],

  },
  {
    "id": 19503,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.433739192642953,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19115,
        "lat": 15.17874145822671,
        "lon": 145.782091293482
      },
      {
        "id": 19580,
        "lat": 15.17870392662053,
        "lon": 145.7821051067021
      }
    ],

  },
  {
    "id": 19504,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 39.83222481324404,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19580,
        "lat": 15.17870392662053,
        "lon": 145.7821051067021
      },
      {
        "id": 19581,
        "lat": 15.17837419454554,
        "lon": 145.7822490943992
      }
    ],

  },
  {
    "id": 19505,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 17.131078713204605,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19581,
        "lat": 15.17837419454554,
        "lon": 145.7822490943992
      },
      {
        "id": 19582,
        "lat": 15.17822053295954,
        "lon": 145.7822577996934
      }
    ],

  },
  {
    "id": 19506,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 72.82313580758205,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18755,
        "lat": 15.18009020007266,
        "lon": 145.781486777185
      },
      {
        "id": 19583,
        "lat": 15.17948978537743,
        "lon": 145.7817558886352
      }
    ],

  },
  {
    "id": 19507,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 31.721210853115196,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19584,
        "lat": 15.18046309959595,
        "lon": 145.7813369012071
      },
      {
        "id": 19585,
        "lat": 15.18019742984206,
        "lon": 145.7814436793964
      }
    ],

  },
  {
    "id": 19508,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 3.123673028768214,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19416,
        "lat": 15.16766138021175,
        "lon": 145.7736841287412
      },
      {
        "id": 18993,
        "lat": 15.16763341855212,
        "lon": 145.7736865659719
      }
    ],

  },
  {
    "id": 19509,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.2061355912913487,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19586,
        "lat": 15.18094920474967,
        "lon": 145.7793983334718
      },
      {
        "id": 18764,
        "lat": 15.18095944264904,
        "lon": 145.7793946583248
      }
    ],

  },
  {
    "id": 19510,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 71.92946819658324,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19587,
        "lat": 15.17848125158902,
        "lon": 145.7814595477405
      },
      {
        "id": 19117,
        "lat": 15.17874274718707,
        "lon": 145.7820717818104
      }
    ],

  },
  {
    "id": 19511,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.1984890653231595,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18760,
        "lat": 15.18160669220654,
        "lon": 145.776028308911
      },
      {
        "id": 19588,
        "lat": 15.18161356093636,
        "lon": 145.7760197186493
      }
    ],

  },
  {
    "id": 19512,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.4751139042963975,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19589,
        "lat": 15.18160697307632,
        "lon": 145.7760210260669
      },
      {
        "id": 19590,
        "lat": 15.18161027630405,
        "lon": 145.7760238265197
      }
    ],

  },
  {
    "id": 19513,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.8231355067360805,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19591,
        "lat": 15.1612075759924,
        "lon": 145.7830102435061
      },
      {
        "id": 19592,
        "lat": 15.16121316532991,
        "lon": 145.7830052278829
      }
    ],

  },
  {
    "id": 19514,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.7616497894133594,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19593,
        "lat": 15.16169535511829,
        "lon": 145.7835731907916
      },
      {
        "id": 19594,
        "lat": 15.1617004777962,
        "lon": 145.7835684916558
      }
    ],

  },
  {
    "id": 19515,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.2247093025479399,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18991,
        "lat": 15.16864251852856,
        "lon": 145.7775285209883
      },
      {
        "id": 18930,
        "lat": 15.16865349238035,
        "lon": 145.7775277097173
      }
    ],

  },
  {
    "id": 19516,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.526742810899163,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19595,
        "lat": 15.18133390649544,
        "lon": 145.7702966587991
      },
      {
        "id": 18817,
        "lat": 15.18138642676744,
        "lon": 145.7702696552774
      }
    ],

  },
  {
    "id": 19517,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 18.72056084391217,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18817,
        "lat": 15.18138642676744,
        "lon": 145.7702696552774
      },
      {
        "id": 19596,
        "lat": 15.18131092332973,
        "lon": 145.7701139542792
      }
    ],

  },
  {
    "id": 19518,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 7.087217155875536,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19597,
        "lat": 15.18168751040313,
        "lon": 145.7712630778576
      },
      {
        "id": 19056,
        "lat": 15.18171483717391,
        "lon": 145.7712034958433
      }
    ],

  },
  {
    "id": 19519,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 11.88123945486476,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19056,
        "lat": 15.18171483717391,
        "lon": 145.7712034958433
      },
      {
        "id": 19598,
        "lat": 15.18181145666457,
        "lon": 145.771250480722
      }
    ],

  },
  {
    "id": 19520,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 64.21289946061927,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19598,
        "lat": 15.18181145666457,
        "lon": 145.771250480722
      },
      {
        "id": 19368,
        "lat": 15.18207275224979,
        "lon": 145.7717833369894
      }
    ],

  },
  {
    "id": 19521,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 1.0394095142611477,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19599,
        "lat": 15.18145581967982,
        "lon": 145.7718628759417
      },
      {
        "id": 18831,
        "lat": 15.18145238256055,
        "lon": 145.771871871406
      }
    ],

  },
  {
    "id": 19522,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 11.516730599439546,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19600,
        "lat": 15.18176265146203,
        "lon": 145.771891979422
      },
      {
        "id": 19601,
        "lat": 15.18186554878638,
        "lon": 145.7718808485764
      }
    ],

  },
  {
    "id": 19523,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 24.83452680961778,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19601,
        "lat": 15.18186554878638,
        "lon": 145.7718808485764
      },
      {
        "id": 19058,
        "lat": 15.18207106610217,
        "lon": 145.7717909180319
      }
    ],

  },
  {
    "id": 19524,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 9.964691844201655,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19602,
        "lat": 15.18173757877123,
        "lon": 145.7726909918555
      },
      {
        "id": 18790,
        "lat": 15.18174421187209,
        "lon": 145.7727834882309
      }
    ],

  },
  {
    "id": 19525,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.057439707855139,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19603,
        "lat": 15.18193821978061,
        "lon": 145.7727653025769
      },
      {
        "id": 19604,
        "lat": 15.18204580338372,
        "lon": 145.7727522925261
      }
    ],

  },
  {
    "id": 19526,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 9.440427828270707,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19604,
        "lat": 15.18204580338372,
        "lon": 145.7727522925261
      },
      {
        "id": 19605,
        "lat": 15.18212838328202,
        "lon": 145.7727322965648
      }
    ],

  },
  {
    "id": 19527,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 18.02218729402291,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19606,
        "lat": 15.18163591457991,
        "lon": 145.7733333996496
      },
      {
        "id": 19607,
        "lat": 15.1816748528619,
        "lon": 145.7734962259326
      }
    ],

  },
  {
    "id": 19528,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.41910976667482,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19607,
        "lat": 15.1816748528619,
        "lon": 145.7734962259326
      },
      {
        "id": 19608,
        "lat": 15.18150540753235,
        "lon": 145.7735391895264
      }
    ],

  },
  {
    "id": 19529,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 1.9988103849816987,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19609,
        "lat": 15.18246481963602,
        "lon": 145.7732338783084
      },
      {
        "id": 18803,
        "lat": 15.18248146814093,
        "lon": 145.7732408469784
      }
    ],

  },
  {
    "id": 19530,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 35.095632063624166,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18803,
        "lat": 15.18248146814093,
        "lon": 145.7732408469784
      },
      {
        "id": 19067,
        "lat": 15.18236210584181,
        "lon": 145.7735432004195
      }
    ],

  },
  {
    "id": 19531,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 4.6613834922624875,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19610,
        "lat": 15.18304662814024,
        "lon": 145.7737550172838
      },
      {
        "id": 19611,
        "lat": 15.18308477264093,
        "lon": 145.7737371175725
      }
    ],

  },
  {
    "id": 19532,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 34.7308597343319,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19611,
        "lat": 15.18308477264093,
        "lon": 145.7737371175725
      },
      {
        "id": 19612,
        "lat": 15.18321482438002,
        "lon": 145.7740309695769
      }
    ],

  },
  {
    "id": 19533,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 38.049622294621585,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19613,
        "lat": 15.18269253468938,
        "lon": 145.7744270910675
      },
      {
        "id": 19614,
        "lat": 15.18286357328396,
        "lon": 145.7747337280089
      }
    ],

  },
  {
    "id": 19534,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.4135738424762025,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19615,
        "lat": 15.18104613617083,
        "lon": 145.7743235014891
      },
      {
        "id": 19616,
        "lat": 15.18105610526798,
        "lon": 145.7743434513692
      }
    ],

  },
  {
    "id": 19535,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 37.55368614945711,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19616,
        "lat": 15.18105610526798,
        "lon": 145.7743434513692
      },
      {
        "id": 19617,
        "lat": 15.18135646639526,
        "lon": 145.7741843121398
      }
    ],

  },
  {
    "id": 19536,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 14.122105529514352,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19617,
        "lat": 15.18135646639526,
        "lon": 145.7741843121398
      },
      {
        "id": 19618,
        "lat": 15.18148219514483,
        "lon": 145.7742018352977
      }
    ],

  },
  {
    "id": 19537,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 7.176033426331511,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19619,
        "lat": 15.18116680968446,
        "lon": 145.7753267462985
      },
      {
        "id": 19620,
        "lat": 15.18111493914454,
        "lon": 145.7752870872807
      }
    ],

  },
  {
    "id": 19538,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 7.137048599865334,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19621,
        "lat": 15.18134146120424,
        "lon": 145.7762261931087
      },
      {
        "id": 18761,
        "lat": 15.1813886740676,
        "lon": 145.7762711372401
      }
    ],

  },
  {
    "id": 19539,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 18.197836293133413,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18761,
        "lat": 15.1813886740676,
        "lon": 145.7762711372401
      },
      {
        "id": 19622,
        "lat": 15.18127732724312,
        "lon": 145.7763951548872
      }
    ],

  },
  {
    "id": 19540,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 48.25369677592821,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19622,
        "lat": 15.18127732724312,
        "lon": 145.7763951548872
      },
      {
        "id": 19078,
        "lat": 15.18089623884104,
        "lon": 145.7766091866826
      }
    ],

  },
  {
    "id": 19541,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 5.306092353561015,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19623,
        "lat": 15.18058499108599,
        "lon": 145.7761387585236
      },
      {
        "id": 19069,
        "lat": 15.18062683892473,
        "lon": 145.7761151134319
      }
    ],

  },
  {
    "id": 19542,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 24.82107364347076,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19069,
        "lat": 15.18062683892473,
        "lon": 145.7761151134319
      },
      {
        "id": 19624,
        "lat": 15.18051905867593,
        "lon": 145.7759128645637
      }
    ],

  },
  {
    "id": 19543,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.224510099773591,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19625,
        "lat": 15.18046653631454,
        "lon": 145.7749950811449
      },
      {
        "id": 19626,
        "lat": 15.18048870931637,
        "lon": 145.7750143937842
      }
    ],

  },
  {
    "id": 19544,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 47.6390810285749,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19627,
        "lat": 15.18063657034187,
        "lon": 145.774834402266
      },
      {
        "id": 19628,
        "lat": 15.1809139557435,
        "lon": 145.774496739262
      }
    ],

  },
  {
    "id": 19545,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 1.4693318844668317,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19629,
        "lat": 15.17923485785865,
        "lon": 145.7752456469273
      },
      {
        "id": 18812,
        "lat": 15.17922772387279,
        "lon": 145.775257153602
      }
    ],

  },
  {
    "id": 19546,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.336559686129444,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19630,
        "lat": 15.17909532762653,
        "lon": 145.7745418396821
      },
      {
        "id": 19569,
        "lat": 15.1791014606352,
        "lon": 145.7744832030481
      }
    ],

  },
  {
    "id": 19547,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 53.76350718233054,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19569,
        "lat": 15.1791014606352,
        "lon": 145.7744832030481
      },
      {
        "id": 19086,
        "lat": 15.17862123739478,
        "lon": 145.7744299486174
      }
    ],

  },
  {
    "id": 19548,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 4.989483972186129,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19631,
        "lat": 15.17858988746118,
        "lon": 145.7748296497405
      },
      {
        "id": 19376,
        "lat": 15.17854534144747,
        "lon": 145.7748245104813
      }
    ],

  },
  {
    "id": 19549,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 47.77710953006287,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19632,
        "lat": 15.17851253944728,
        "lon": 145.7751259590939
      },
      {
        "id": 19174,
        "lat": 15.17846445325094,
        "lon": 145.7755678617164
      }
    ],

  },
  {
    "id": 19550,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.908828110885857,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19633,
        "lat": 15.17884886905354,
        "lon": 145.7730077041387
      },
      {
        "id": 19180,
        "lat": 15.17882300834417,
        "lon": 145.7730038239073
      }
    ],

  },
  {
    "id": 19551,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 71.83011827813814,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19634,
        "lat": 15.17871563730722,
        "lon": 145.7737625290044
      },
      {
        "id": 19364,
        "lat": 15.17862201888006,
        "lon": 145.7744240398879
      }
    ],

  },
  {
    "id": 19552,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 5.443911273403378,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19635,
        "lat": 15.17829104826113,
        "lon": 145.77262265659
      },
      {
        "id": 19399,
        "lat": 15.17829188210032,
        "lon": 145.7725719928463
      }
    ],

  },
  {
    "id": 19553,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 35.803924087779905,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19399,
        "lat": 15.17829188210032,
        "lon": 145.7725719928463
      },
      {
        "id": 19636,
        "lat": 15.17797029557897,
        "lon": 145.7725663812429
      }
    ],

  },
  {
    "id": 19554,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 2.550082158693365,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19636,
        "lat": 15.17797029557897,
        "lon": 145.7725663812429
      },
      {
        "id": 19173,
        "lat": 15.17794739245196,
        "lon": 145.7725659029794
      }
    ],

  },
  {
    "id": 19555,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 5.2652748632024435,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19637,
        "lat": 15.17805719693814,
        "lon": 145.7743788635007
      },
      {
        "id": 19176,
        "lat": 15.17806536382904,
        "lon": 145.7743305912494
      }
    ],

  },
  {
    "id": 19556,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.7703976088338953,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19176,
        "lat": 15.17806536382904,
        "lon": 145.7743305912494
      },
      {
        "id": 19638,
        "lat": 15.1780496931686,
        "lon": 145.7743277803111
      }
    ],

  },
  {
    "id": 19557,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 37.75910124645167,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19638,
        "lat": 15.1780496931686,
        "lon": 145.7743277803111
      },
      {
        "id": 19564,
        "lat": 15.17771130268794,
        "lon": 145.774303576705
      }
    ],

  },
  {
    "id": 19558,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 5.673697773074427,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19639,
        "lat": 15.17777252608657,
        "lon": 145.7736114032875
      },
      {
        "id": 19162,
        "lat": 15.17782273960224,
        "lon": 145.7736204544969
      }
    ],

  },
  {
    "id": 19559,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.8183663151444065,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19162,
        "lat": 15.17782273960224,
        "lon": 145.7736204544969
      },
      {
        "id": 19640,
        "lat": 15.17782401498967,
        "lon": 145.7736129527883
      }
    ],

  },
  {
    "id": 19560,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 23.403645340389517,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19640,
        "lat": 15.17782401498967,
        "lon": 145.7736129527883
      },
      {
        "id": 19641,
        "lat": 15.17785437505441,
        "lon": 145.7733973989425
      }
    ],

  },
  {
    "id": 19561,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.46667618699468344,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19641,
        "lat": 15.17785437505441,
        "lon": 145.7733973989425
      },
      {
        "id": 18804,
        "lat": 15.17785487540812,
        "lon": 145.773393086249
      }
    ],

  },
  {
    "id": 19562,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 4.801972509739557,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19642,
        "lat": 15.177601342526,
        "lon": 145.7749097075671
      },
      {
        "id": 19166,
        "lat": 15.17764393439469,
        "lon": 145.7749167898682
      }
    ],

  },
  {
    "id": 19563,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 2.379266247201236,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19166,
        "lat": 15.17764393439469,
        "lon": 145.7749167898682
      },
      {
        "id": 19643,
        "lat": 15.177647362668,
        "lon": 145.7748949308229
      }
    ],

  },
  {
    "id": 19564,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 63.00982821855675,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19643,
        "lat": 15.177647362668,
        "lon": 145.7748949308229
      },
      {
        "id": 19164,
        "lat": 15.17770472870984,
        "lon": 145.7743114663212
      }
    ],

  },
  {
    "id": 19565,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 1.9858168796630058,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19644,
        "lat": 15.17713298248501,
        "lon": 145.7743457716342
      },
      {
        "id": 19158,
        "lat": 15.1771352128409,
        "lon": 145.7743641101827
      }
    ],

  },
  {
    "id": 19566,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 56.92979680685549,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19158,
        "lat": 15.1771352128409,
        "lon": 145.7743641101827
      },
      {
        "id": 19645,
        "lat": 15.17764270706972,
        "lon": 145.7742986703672
      }
    ],

  },
  {
    "id": 19567,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.104339342865146,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19645,
        "lat": 15.17764270706972,
        "lon": 145.7742986703672
      },
      {
        "id": 19163,
        "lat": 15.17770637492032,
        "lon": 145.7743032242437
      }
    ],

  },
  {
    "id": 19568,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.3406768280498897,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19646,
        "lat": 15.17690095231235,
        "lon": 145.7751008149355
      },
      {
        "id": 18808,
        "lat": 15.17692176730226,
        "lon": 145.7751038984751
      }
    ],

  },
  {
    "id": 19569,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 4.484979811907874,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19647,
        "lat": 15.17700747191312,
        "lon": 145.7761037478722
      },
      {
        "id": 18999,
        "lat": 15.17702335287411,
        "lon": 145.7761421132765
      }
    ],

  },
  {
    "id": 19570,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 17.786783142780134,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18999,
        "lat": 15.17702335287411,
        "lon": 145.7761421132765
      },
      {
        "id": 19648,
        "lat": 15.17717048054384,
        "lon": 145.7760775430767
      }
    ],

  },
  {
    "id": 19571,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 16.61391632685685,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19648,
        "lat": 15.17717048054384,
        "lon": 145.7760775430767
      },
      {
        "id": 19649,
        "lat": 15.17730822750462,
        "lon": 145.7760180218253
      }
    ],

  },
  {
    "id": 19572,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 41.90279643709655,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19649,
        "lat": 15.17730822750462,
        "lon": 145.7760180218253
      },
      {
        "id": 19650,
        "lat": 15.17753419383122,
        "lon": 145.7757060923942
      }
    ],

  },
  {
    "id": 19573,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.733528762397476,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19650,
        "lat": 15.17753419383122,
        "lon": 145.7757060923942
      },
      {
        "id": 19651,
        "lat": 15.17755627189913,
        "lon": 145.7755614453384
      }
    ],

  },
  {
    "id": 19574,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 39.01194837005854,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19651,
        "lat": 15.17755627189913,
        "lon": 145.7755614453384
      },
      {
        "id": 19365,
        "lat": 15.17760001903651,
        "lon": 145.7752011694959
      }
    ],

  },
  {
    "id": 19575,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.145401552417947,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19652,
        "lat": 15.17677219276789,
        "lon": 145.7772977386962
      },
      {
        "id": 19179,
        "lat": 15.17675049045256,
        "lon": 145.7772451440144
      }
    ],

  },
  {
    "id": 19576,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 26.84943491185633,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19179,
        "lat": 15.17675049045256,
        "lon": 145.7772451440144
      },
      {
        "id": 19653,
        "lat": 15.17652829228852,
        "lon": 145.7773423524185
      }
    ],

  },
  {
    "id": 19577,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 49.3541188271158,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19653,
        "lat": 15.17652829228852,
        "lon": 145.7773423524185
      },
      {
        "id": 19654,
        "lat": 15.1761197178067,
        "lon": 145.7775207094537
      }
    ],

  },
  {
    "id": 19578,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.6533360420909613,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19655,
        "lat": 15.17726774194872,
        "lon": 145.7773552494892
      },
      {
        "id": 19396,
        "lat": 15.17723738780422,
        "lon": 145.7773681775227
      }
    ],

  },
  {
    "id": 19579,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 59.25528936285097,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19396,
        "lat": 15.17723738780422,
        "lon": 145.7773681775227
      },
      {
        "id": 19159,
        "lat": 15.17744193406808,
        "lon": 145.7778773679748
      }
    ],

  },
  {
    "id": 19580,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 4.391792093942755,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19656,
        "lat": 15.17693895972502,
        "lon": 145.7781567160519
      },
      {
        "id": 18851,
        "lat": 15.17692258937927,
        "lon": 145.7781195233991
      }
    ],

  },
  {
    "id": 19581,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 26.893231106519195,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18851,
        "lat": 15.17692258937927,
        "lon": 145.7781195233991
      },
      {
        "id": 19324,
        "lat": 15.1767023135684,
        "lon": 145.7782223172855
      }
    ],

  },
  {
    "id": 19582,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 1.1217858735129385,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19657,
        "lat": 15.17704839247817,
        "lon": 145.7791101025806
      },
      {
        "id": 18763,
        "lat": 15.17704403242822,
        "lon": 145.7791006891336
      }
    ],

  },
  {
    "id": 19583,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.025375213431377,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19658,
        "lat": 15.17636294775733,
        "lon": 145.7794053863381
      },
      {
        "id": 18855,
        "lat": 15.17635317339567,
        "lon": 145.7793894860349
      }
    ],

  },
  {
    "id": 19584,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.890424970642732,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19659,
        "lat": 15.1769479748648,
        "lon": 145.7798503919704
      },
      {
        "id": 19390,
        "lat": 15.17695812510623,
        "lon": 145.7798751546099
      }
    ],

  },
  {
    "id": 19585,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 46.6164364254581,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19660,
        "lat": 15.1762221531556,
        "lon": 145.7801949994656
      },
      {
        "id": 19661,
        "lat": 15.17583598300404,
        "lon": 145.7803628234572
      }
    ],

  },
  {
    "id": 19586,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 17.01505687509908,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19661,
        "lat": 15.17583598300404,
        "lon": 145.7803628234572
      },
      {
        "id": 19662,
        "lat": 15.17569547941549,
        "lon": 145.7804251769109
      }
    ],

  },
  {
    "id": 19587,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.6519724441837969,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19662,
        "lat": 15.17569547941549,
        "lon": 145.7804251769109
      },
      {
        "id": 19663,
        "lat": 15.17568187578903,
        "lon": 145.7804313211497
      }
    ],

  },
  {
    "id": 19588,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 4.898368291706794,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19664,
        "lat": 15.17638482873777,
        "lon": 145.7814494874858
      },
      {
        "id": 19665,
        "lat": 15.17636798863307,
        "lon": 145.7814073655861
      }
    ],

  },
  {
    "id": 19589,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 77.47082207798591,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19665,
        "lat": 15.17636798863307,
        "lon": 145.7814073655861
      },
      {
        "id": 19666,
        "lat": 15.17701210677667,
        "lon": 145.7811343409696
      }
    ],

  },
  {
    "id": 19590,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 7.665867112977968,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19667,
        "lat": 15.17615782918791,
        "lon": 145.7807793648982
      },
      {
        "id": 19668,
        "lat": 15.1761308011385,
        "lon": 145.7807137383244
      }
    ],

  },
  {
    "id": 19591,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.377510653847093,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19668,
        "lat": 15.1761308011385,
        "lon": 145.7807137383244
      },
      {
        "id": 19669,
        "lat": 15.17616703861408,
        "lon": 145.780697915279
      }
    ],

  },
  {
    "id": 19592,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 4.997929619972939,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19670,
        "lat": 15.1756637457553,
        "lon": 145.7803887632555
      },
      {
        "id": 19663,
        "lat": 15.17568187578903,
        "lon": 145.7804313211497
      }
    ],

  },
  {
    "id": 19593,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 58.89442149052623,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19671,
        "lat": 15.17497698722466,
        "lon": 145.7804369980799
      },
      {
        "id": 19672,
        "lat": 15.17445956675115,
        "lon": 145.7803226573411
      }
    ],

  },
  {
    "id": 19594,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 7.913842062682648,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19673,
        "lat": 15.17443427016008,
        "lon": 145.7816477320887
      },
      {
        "id": 19098,
        "lat": 15.17450303745716,
        "lon": 145.7816290523341
      }
    ],

  },
  {
    "id": 19595,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 34.31672059844638,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19098,
        "lat": 15.17450303745716,
        "lon": 145.7816290523341
      },
      {
        "id": 19093,
        "lat": 15.17442394047624,
        "lon": 145.781320336219
      }
    ],

  },
  {
    "id": 19596,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.331610461448844,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19674,
        "lat": 15.17446398820341,
        "lon": 145.7803014444991
      },
      {
        "id": 19672,
        "lat": 15.17445956675115,
        "lon": 145.7803226573411
      }
    ],

  },
  {
    "id": 19597,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 2.920692224345409,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19672,
        "lat": 15.17445956675115,
        "lon": 145.7803226573411
      },
      {
        "id": 19675,
        "lat": 15.17443390683282,
        "lon": 145.7803169869699
      }
    ],

  },
  {
    "id": 19598,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 3.9690055685666494,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19675,
        "lat": 15.17443390683282,
        "lon": 145.7803169869699
      },
      {
        "id": 19124,
        "lat": 15.1743990646561,
        "lon": 145.780309147696
      }
    ],

  },
  {
    "id": 19599,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 1.5968538361995204,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19676,
        "lat": 15.17467114395846,
        "lon": 145.7795805896282
      },
      {
        "id": 18860,
        "lat": 15.17466676646942,
        "lon": 145.7795664355686
      }
    ],

  },
  {
    "id": 19600,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.299406938983815,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19677,
        "lat": 15.17447610753416,
        "lon": 145.7781561139709
      },
      {
        "id": 19678,
        "lat": 15.17446755920116,
        "lon": 145.7780981539427
      }
    ],

  },
  {
    "id": 19601,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 40.76294922842673,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19679,
        "lat": 15.1740270441835,
        "lon": 145.778180618864
      },
      {
        "id": 19130,
        "lat": 15.17366672200738,
        "lon": 145.7782482101504
      }
    ],

  },
  {
    "id": 19602,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.138947605559868,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19680,
        "lat": 15.17384083255574,
        "lon": 145.7793579291929
      },
      {
        "id": 19330,
        "lat": 15.17381282682919,
        "lon": 145.7793613321166
      }
    ],

  },
  {
    "id": 19603,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 27.8917248002805,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19330,
        "lat": 15.17381282682919,
        "lon": 145.7793613321166
      },
      {
        "id": 19388,
        "lat": 15.17378328106309,
        "lon": 145.7791035369256
      }
    ],

  },
  {
    "id": 19604,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.742127820540355,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19681,
        "lat": 15.17388866207815,
        "lon": 145.7772372050086
      },
      {
        "id": 19557,
        "lat": 15.17389143032707,
        "lon": 145.7772625661126
      }
    ],

  },
  {
    "id": 19605,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 25.075532518424566,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19557,
        "lat": 15.17389143032707,
        "lon": 145.7772625661126
      },
      {
        "id": 19682,
        "lat": 15.17411529568366,
        "lon": 145.7772366594487
      }
    ],

  },
  {
    "id": 19606,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 21.724994205861282,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19682,
        "lat": 15.17411529568366,
        "lon": 145.7772366594487
      },
      {
        "id": 19377,
        "lat": 15.17430812664673,
        "lon": 145.7772055199174
      }
    ],

  },
  {
    "id": 19607,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.2727019272413043,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19683,
        "lat": 15.17344586998648,
        "lon": 145.7765867834468
      },
      {
        "id": 19132,
        "lat": 15.17341661220248,
        "lon": 145.7765837994975
      }
    ],

  },
  {
    "id": 19608,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 9.611644831126696,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19684,
        "lat": 15.17437722688456,
        "lon": 145.7763898384361
      },
      {
        "id": 18849,
        "lat": 15.17444658078325,
        "lon": 145.7764431272458
      }
    ],

  },
  {
    "id": 19609,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 38.40881431693685,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18849,
        "lat": 15.17444658078325,
        "lon": 145.7764431272458
      },
      {
        "id": 19685,
        "lat": 15.17423940053732,
        "lon": 145.7767289995802
      }
    ],

  },
  {
    "id": 19610,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 16.034583850521155,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19685,
        "lat": 15.17423940053732,
        "lon": 145.7767289995802
      },
      {
        "id": 19686,
        "lat": 15.17426139445443,
        "lon": 145.77687649416
      }
    ],

  },
  {
    "id": 19611,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 35.730681718379884,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19686,
        "lat": 15.17426139445443,
        "lon": 145.77687649416
      },
      {
        "id": 19377,
        "lat": 15.17430812664673,
        "lon": 145.7772055199174
      }
    ],

  },
  {
    "id": 19612,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 1.6902154968906793,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19687,
        "lat": 15.17357237861474,
        "lon": 145.7750196399011
      },
      {
        "id": 19415,
        "lat": 15.17357383268288,
        "lon": 145.7750039802868
      }
    ],

  },
  {
    "id": 19613,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.750607179569873,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19688,
        "lat": 15.17516697866884,
        "lon": 145.7769157448171
      },
      {
        "id": 19385,
        "lat": 15.17518023022309,
        "lon": 145.7769478408663
      }
    ],

  },
  {
    "id": 19614,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 121.32701837644372,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19385,
        "lat": 15.17518023022309,
        "lon": 145.7769478408663
      },
      {
        "id": 19689,
        "lat": 15.17618421045468,
        "lon": 145.7765083645701
      }
    ],

  },
  {
    "id": 19615,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.725472247585637,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19689,
        "lat": 15.17618421045468,
        "lon": 145.7765083645701
      },
      {
        "id": 19690,
        "lat": 15.17619849998486,
        "lon": 145.7765021421568
      }
    ],

  },
  {
    "id": 19616,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.418205617683564,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19691,
        "lat": 15.1761864761317,
        "lon": 145.7764728669638
      },
      {
        "id": 19690,
        "lat": 15.17619849998486,
        "lon": 145.7765021421568
      }
    ],

  },
  {
    "id": 19617,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 69.7968058339957,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19690,
        "lat": 15.17619849998486,
        "lon": 145.7765021421568
      },
      {
        "id": 18998,
        "lat": 15.17677652337259,
        "lon": 145.776250439588
      }
    ],

  },
  {
    "id": 19618,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.8735415880029205,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19692,
        "lat": 15.17642923724005,
        "lon": 145.775339364782
      },
      {
        "id": 19393,
        "lat": 15.17640524667977,
        "lon": 145.7753492373636
      }
    ],

  },
  {
    "id": 19619,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 13.03926251895894,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19393,
        "lat": 15.17640524667977,
        "lon": 145.7753492373636
      },
      {
        "id": 19394,
        "lat": 15.17644895217386,
        "lon": 145.7754618388461
      }
    ],

  },
  {
    "id": 19620,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.180714873348894,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19693,
        "lat": 15.17558267219603,
        "lon": 145.7750097993607
      },
      {
        "id": 19154,
        "lat": 15.17556304952148,
        "lon": 145.7749559835376
      }
    ],

  },
  {
    "id": 19621,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 68.75458039769437,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19154,
        "lat": 15.17556304952148,
        "lon": 145.7749559835376
      },
      {
        "id": 19386,
        "lat": 15.17614171735569,
        "lon": 145.7747322796708
      }
    ],

  },
  {
    "id": 19622,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.4849143745490854,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19694,
        "lat": 15.17597161369078,
        "lon": 145.7741224954475
      },
      {
        "id": 18997,
        "lat": 15.17594102644549,
        "lon": 145.7741294038964
      }
    ],

  },
  {
    "id": 19623,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 9.275344337579309,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18997,
        "lat": 15.17594102644549,
        "lon": 145.7741294038964
      },
      {
        "id": 19695,
        "lat": 15.17595898569866,
        "lon": 145.7742137071933
      }
    ],

  },
  {
    "id": 19624,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 39.15866842208339,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19695,
        "lat": 15.17595898569866,
        "lon": 145.7742137071933
      },
      {
        "id": 19696,
        "lat": 15.17607733731722,
        "lon": 145.7745569379455
      }
    ],

  },
  {
    "id": 19625,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 19.55776737870882,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19696,
        "lat": 15.17607733731722,
        "lon": 145.7745569379455
      },
      {
        "id": 19391,
        "lat": 15.1761446273104,
        "lon": 145.7747250958232
      }
    ],

  },
  {
    "id": 19626,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.4844828213795838,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19697,
        "lat": 15.17579741637735,
        "lon": 145.7730315210033
      },
      {
        "id": 19698,
        "lat": 15.1757663891192,
        "lon": 145.773035805889
      }
    ],

  },
  {
    "id": 19627,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 57.27881959499224,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19698,
        "lat": 15.1757663891192,
        "lon": 145.773035805889
      },
      {
        "id": 18995,
        "lat": 15.17583520919731,
        "lon": 145.7735641521255
      }
    ],

  },
  {
    "id": 19628,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.1331371836503745,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19699,
        "lat": 15.17662627115936,
        "lon": 145.7734252728056
      },
      {
        "id": 19172,
        "lat": 15.17663004280042,
        "lon": 145.7734541723187
      }
    ],

  },
  {
    "id": 19629,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 89.26595126072826,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19172,
        "lat": 15.17663004280042,
        "lon": 145.7734541723187
      },
      {
        "id": 18995,
        "lat": 15.17583520919731,
        "lon": 145.7735641521255
      }
    ],

  },
  {
    "id": 19630,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 5.58274327286438,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19700,
        "lat": 15.17701849472559,
        "lon": 145.7726529908148
      },
      {
        "id": 19402,
        "lat": 15.17701399821226,
        "lon": 145.7726012370765
      }
    ],

  },
  {
    "id": 19631,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 2.1055299422942695,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19402,
        "lat": 15.17701399821226,
        "lon": 145.7726012370765
      },
      {
        "id": 19701,
        "lat": 15.17699515822188,
        "lon": 145.7726029725407
      }
    ],

  },
  {
    "id": 19632,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 47.082939528636594,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19701,
        "lat": 15.17699515822188,
        "lon": 145.7726029725407
      },
      {
        "id": 19702,
        "lat": 15.17657369482565,
        "lon": 145.7726397233188
      }
    ],

  },
  {
    "id": 19633,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 27.639868283944633,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19702,
        "lat": 15.17657369482565,
        "lon": 145.7726397233188
      },
      {
        "id": 19703,
        "lat": 15.17632691148176,
        "lon": 145.7726680512708
      }
    ],

  },
  {
    "id": 19634,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 9.35816150395543,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19704,
        "lat": 15.1784384245317,
        "lon": 145.7811401240706
      },
      {
        "id": 18783,
        "lat": 15.1783612580152,
        "lon": 145.7811746820781
      }
    ],

  },
  {
    "id": 19635,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 31.49905269572486,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18783,
        "lat": 15.1783612580152,
        "lon": 145.7811746820781
      },
      {
        "id": 19705,
        "lat": 15.17847470810453,
        "lon": 145.7814432735501
      }
    ],

  },
  {
    "id": 19636,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.89027256444202,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19706,
        "lat": 15.17735263384726,
        "lon": 145.7822978030311
      },
      {
        "id": 19104,
        "lat": 15.1774096716944,
        "lon": 145.7822728958645
      }
    ],

  },
  {
    "id": 19637,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 22.224877653018492,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19104,
        "lat": 15.1774096716944,
        "lon": 145.7822728958645
      },
      {
        "id": 19707,
        "lat": 15.17748803540382,
        "lon": 145.7824631597954
      }
    ],

  },
  {
    "id": 19638,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.474339010708842,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19707,
        "lat": 15.17748803540382,
        "lon": 145.7824631597954
      },
      {
        "id": 19112,
        "lat": 15.17753868271079,
        "lon": 145.7825453243346
      }
    ],

  },
  {
    "id": 19639,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 7.409493344795244,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19708,
        "lat": 15.17934095263258,
        "lon": 145.7793868472176
      },
      {
        "id": 19709,
        "lat": 15.17931482811165,
        "lon": 145.7793234146433
      }
    ],

  },
  {
    "id": 19640,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 56.57727981620764,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19709,
        "lat": 15.17931482811165,
        "lon": 145.7793234146433
      },
      {
        "id": 19710,
        "lat": 15.17978317921374,
        "lon": 145.7791189025931
      }
    ],

  },
  {
    "id": 19641,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 4.468093253603711,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19711,
        "lat": 15.17960862054965,
        "lon": 145.7800436370161
      },
      {
        "id": 19712,
        "lat": 15.17959253610998,
        "lon": 145.7800055337505
      }
    ],

  },
  {
    "id": 19642,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 87.0962186883481,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19713,
        "lat": 15.18023094872101,
        "lon": 145.7797198024227
      },
      {
        "id": 19586,
        "lat": 15.18094920474967,
        "lon": 145.7793983334718
      }
    ],

  },
  {
    "id": 19643,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 8.13724934811484,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19714,
        "lat": 15.17987449648809,
        "lon": 145.7807487337461
      },
      {
        "id": 19715,
        "lat": 15.1799036002829,
        "lon": 145.7808182124913
      }
    ],

  },
  {
    "id": 19644,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 79.96795340661245,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19715,
        "lat": 15.1799036002829,
        "lon": 145.7808182124913
      },
      {
        "id": 19716,
        "lat": 15.17924333390877,
        "lon": 145.7811114555195
      }
    ],

  },
  {
    "id": 19645,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 11.924591477708637,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19717,
        "lat": 15.18015826754781,
        "lon": 145.781340369552
      },
      {
        "id": 19585,
        "lat": 15.18019742984206,
        "lon": 145.7814436793964
      }
    ],

  },
  {
    "id": 19646,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 11.72745238967841,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19585,
        "lat": 15.18019742984206,
        "lon": 145.7814436793964
      },
      {
        "id": 18754,
        "lat": 15.18009921071009,
        "lon": 145.7814831556313
      }
    ],

  },
  {
    "id": 19647,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 5.299437449807089,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19718,
        "lat": 15.18078199017769,
        "lon": 145.7790765961923
      },
      {
        "id": 18765,
        "lat": 15.18082610910625,
        "lon": 145.7790580660962
      }
    ],

  },
  {
    "id": 19648,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 21.930135882775645,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18765,
        "lat": 15.18082610910625,
        "lon": 145.7790580660962
      },
      {
        "id": 19719,
        "lat": 15.18075130526789,
        "lon": 145.7788692292056
      }
    ],

  },
  {
    "id": 19649,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 14.60692375005852,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19719,
        "lat": 15.18075130526789,
        "lon": 145.7788692292056
      },
      {
        "id": 19303,
        "lat": 15.18067017215652,
        "lon": 145.7787623737503
      }
    ],

  },
  {
    "id": 19650,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 11.39028905579436,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19720,
        "lat": 15.16998899664502,
        "lon": 145.7775100798509
      },
      {
        "id": 19475,
        "lat": 15.16997973473466,
        "lon": 145.7774045001315
      }
    ],

  },
  {
    "id": 19651,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 42.30309315125422,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19475,
        "lat": 15.16997973473466,
        "lon": 145.7774045001315
      },
      {
        "id": 19249,
        "lat": 15.1703582281657,
        "lon": 145.7773692994094
      }
    ],

  },
  {
    "id": 19652,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 10.416378208496976,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19721,
        "lat": 15.17014246644613,
        "lon": 145.7797803193817
      },
      {
        "id": 19473,
        "lat": 15.17014395355544,
        "lon": 145.7798772574844
      }
    ],

  },
  {
    "id": 19653,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 50.01552162310348,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19473,
        "lat": 15.17014395355544,
        "lon": 145.7798772574844
      },
      {
        "id": 19207,
        "lat": 15.17059319529004,
        "lon": 145.7798699512341
      }
    ],

  },
  {
    "id": 19654,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 11.986495605142423,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19722,
        "lat": 15.16967675259406,
        "lon": 145.7794634839398
      },
      {
        "id": 19723,
        "lat": 15.16978410678657,
        "lon": 145.7794548580621
      }
    ],

  },
  {
    "id": 19655,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.9232574730237735,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19724,
        "lat": 15.16820006459929,
        "lon": 145.7809455445135
      },
      {
        "id": 18944,
        "lat": 15.16826210806103,
        "lon": 145.7809410834857
      }
    ],

  },
  {
    "id": 19656,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 92.18913727157295,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19725,
        "lat": 15.16824264783799,
        "lon": 145.7806541582349
      },
      {
        "id": 18947,
        "lat": 15.16907075337847,
        "lon": 145.7806453567132
      }
    ],

  },
  {
    "id": 19657,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 8.558355454255885,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19726,
        "lat": 15.16876510331387,
        "lon": 145.7781010601501
      },
      {
        "id": 19480,
        "lat": 15.16868847459511,
        "lon": 145.7781075081404
      }
    ],

  },
  {
    "id": 19658,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 16.17778885984929,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19480,
        "lat": 15.16868847459511,
        "lon": 145.7781075081404
      },
      {
        "id": 18919,
        "lat": 15.16870038564842,
        "lon": 145.7782575751461
      }
    ],

  },
  {
    "id": 19659,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 7.221539639868112,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19727,
        "lat": 15.16976601166078,
        "lon": 145.7766754908163
      },
      {
        "id": 19728,
        "lat": 15.16976047390147,
        "lon": 145.7766085218657
      }
    ],

  },
  {
    "id": 19660,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 57.461156895968614,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19728,
        "lat": 15.16976047390147,
        "lon": 145.7766085218657
      },
      {
        "id": 19729,
        "lat": 15.17027481841865,
        "lon": 145.7765634311827
      }
    ],

  },
  {
    "id": 19661,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 7.462997542571194,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19729,
        "lat": 15.17027481841865,
        "lon": 145.7765634311827
      },
      {
        "id": 19730,
        "lat": 15.17033348835255,
        "lon": 145.7765970426856
      }
    ],

  },
  {
    "id": 19662,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 5.068954068301116,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19731,
        "lat": 15.16974685945043,
        "lon": 145.7745591048068
      },
      {
        "id": 19732,
        "lat": 15.16979224659706,
        "lon": 145.7745553035117
      }
    ],

  },
  {
    "id": 19663,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 40.68289177155165,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19732,
        "lat": 15.16979224659706,
        "lon": 145.7745553035117
      },
      {
        "id": 19733,
        "lat": 15.16982206040949,
        "lon": 145.7749326964669
      }
    ],

  },
  {
    "id": 19664,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.499573969031648,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19733,
        "lat": 15.16982206040949,
        "lon": 145.7749326964669
      },
      {
        "id": 19734,
        "lat": 15.16975793738043,
        "lon": 145.7750043628008
      }
    ],

  },
  {
    "id": 19665,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 0.5349182054488826,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19735,
        "lat": 15.16918232373354,
        "lon": 145.7748710854165
      },
      {
        "id": 19736,
        "lat": 15.16918711287468,
        "lon": 145.7748706780644
      }
    ],

  },
  {
    "id": 19666,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 55.17972028883091,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19736,
        "lat": 15.16918711287468,
        "lon": 145.7748706780644
      },
      {
        "id": 19737,
        "lat": 15.16914604850264,
        "lon": 145.7743588610751
      }
    ],

  },
  {
    "id": 19667,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 6.68911682497757,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19737,
        "lat": 15.16914604850264,
        "lon": 145.7743588610751
      },
      {
        "id": 19738,
        "lat": 15.1691854827162,
        "lon": 145.7743118847612
      }
    ],

  },
  {
    "id": 19668,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 10.62376048791392,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19739,
        "lat": 15.16857554026642,
        "lon": 145.7755713384454
      },
      {
        "id": 19740,
        "lat": 15.16848044394394,
        "lon": 145.7755796597163
      }
    ],

  },
  {
    "id": 19669,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 88.31115666238843,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19740,
        "lat": 15.16848044394394,
        "lon": 145.7755796597163
      },
      {
        "id": 19741,
        "lat": 15.16841284611166,
        "lon": 145.7747607003985
      }
    ],

  },
  {
    "id": 19670,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 10.503992536464326,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19742,
        "lat": 15.16844413127522,
        "lon": 145.7739924109335
      },
      {
        "id": 19743,
        "lat": 15.16835010708687,
        "lon": 145.7740006390867
      }
    ],

  },
  {
    "id": 19671,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 33.784683751493326,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19743,
        "lat": 15.16835010708687,
        "lon": 145.7740006390867
      },
      {
        "id": 19744,
        "lat": 15.16832424473535,
        "lon": 145.7736873349262
      }
    ],

  },
  {
    "id": 19672,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.10488006667172804,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19744,
        "lat": 15.16832424473535,
        "lon": 145.7736873349262
      },
      {
        "id": 19000,
        "lat": 15.16832416821306,
        "lon": 145.7736863619894
      }
    ],

  },
  {
    "id": 19673,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.8435787577760445,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19745,
        "lat": 15.16885679012837,
        "lon": 145.772290719383
      },
      {
        "id": 19746,
        "lat": 15.16887930238451,
        "lon": 145.7722782126039
      }
    ],

  },
  {
    "id": 19674,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 37.31230004905018,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19746,
        "lat": 15.16887930238451,
        "lon": 145.7722782126039
      },
      {
        "id": 19747,
        "lat": 15.16903923629887,
        "lon": 145.7725834105796
      }
    ],

  },
  {
    "id": 19675,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 10.001257008160012,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19748,
        "lat": 15.16784208839168,
        "lon": 145.7750576553423
      },
      {
        "id": 19749,
        "lat": 15.16775259461585,
        "lon": 145.7750658526996
      }
    ],

  },
  {
    "id": 19676,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 269.7304951956405,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19749,
        "lat": 15.16775259461585,
        "lon": 145.7750658526996
      },
      {
        "id": 19195,
        "lat": 15.16796862533656,
        "lon": 145.7775663419025
      }
    ],

  },
  {
    "id": 19677,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 9.73536454815384,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19750,
        "lat": 15.16984227245659,
        "lon": 145.7726702702143
      },
      {
        "id": 19371,
        "lat": 15.16992042697877,
        "lon": 145.772629608983
      }
    ],

  },
  {
    "id": 19678,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 92.27281710458222,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19371,
        "lat": 15.16992042697877,
        "lon": 145.772629608983
      },
      {
        "id": 19751,
        "lat": 15.16954473621365,
        "lon": 145.771864060543
      }
    ],

  },
  {
    "id": 19679,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 7.111462683495454,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19752,
        "lat": 15.17053892392341,
        "lon": 145.7755253519028
      },
      {
        "id": 19052,
        "lat": 15.17060257572335,
        "lon": 145.77551972139
      }
    ],

  },
  {
    "id": 19680,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 84.95123282935909,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19052,
        "lat": 15.17060257572335,
        "lon": 145.77551972139
      },
      {
        "id": 19753,
        "lat": 15.17053684640716,
        "lon": 145.7747319752937
      }
    ],

  },
  {
    "id": 19681,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.241871542319812,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19754,
        "lat": 15.17083470326168,
        "lon": 145.7857219484532
      },
      {
        "id": 18963,
        "lat": 15.17085013620181,
        "lon": 145.7857353542206
      }
    ],

  },
  {
    "id": 19682,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.77255423073138,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19755,
        "lat": 15.17135087636088,
        "lon": 145.7845608679109
      },
      {
        "id": 19756,
        "lat": 15.17135668369943,
        "lon": 145.7845168565591
      }
    ],

  },
  {
    "id": 19683,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.136216869580776,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19756,
        "lat": 15.17135668369943,
        "lon": 145.7845168565591
      },
      {
        "id": 19757,
        "lat": 15.17136630952412,
        "lon": 145.7843949980858
      }
    ],

  },
  {
    "id": 19684,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.135734197779145,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19757,
        "lat": 15.17136630952412,
        "lon": 145.7843949980858
      },
      {
        "id": 19758,
        "lat": 15.17136954764161,
        "lon": 145.784272782691
      }
    ],

  },
  {
    "id": 19685,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 45.50735598966391,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19758,
        "lat": 15.17136954764161,
        "lon": 145.784272782691
      },
      {
        "id": 19220,
        "lat": 15.17139247781971,
        "lon": 145.783849887742
      }
    ],

  },
  {
    "id": 19686,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.2770980690213265,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19759,
        "lat": 15.17154163376179,
        "lon": 145.7837887015067
      },
      {
        "id": 19554,
        "lat": 15.17154213752099,
        "lon": 145.7838098892889
      }
    ],

  },
  {
    "id": 19687,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 66.74933790997693,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19554,
        "lat": 15.17154213752099,
        "lon": 145.7838098892889
      },
      {
        "id": 18867,
        "lat": 15.17214157966034,
        "lon": 145.7837947793668
      }
    ],

  },
  {
    "id": 19688,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 4.755754761330659,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19760,
        "lat": 15.17214205913378,
        "lon": 145.7856937988975
      },
      {
        "id": 19230,
        "lat": 15.17212350104627,
        "lon": 145.7857336689799
      }
    ],

  },
  {
    "id": 19689,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 6.75580920377438,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19761,
        "lat": 15.17245461884422,
        "lon": 145.7858080823462
      },
      {
        "id": 19762,
        "lat": 15.17247938164423,
        "lon": 145.7857506746279
      }
    ],

  },
  {
    "id": 19690,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.387212935791165,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19762,
        "lat": 15.17247938164423,
        "lon": 145.7857506746279
      },
      {
        "id": 19763,
        "lat": 15.17253082168884,
        "lon": 145.785617743385
      }
    ],

  },
  {
    "id": 19691,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.384738618964942,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19763,
        "lat": 15.17253082168884,
        "lon": 145.785617743385
      },
      {
        "id": 19764,
        "lat": 15.17257721403118,
        "lon": 145.7854828572419
      }
    ],

  },
  {
    "id": 19692,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.38249025985997,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19764,
        "lat": 15.17257721403118,
        "lon": 145.7854828572419
      },
      {
        "id": 19765,
        "lat": 15.17261848880958,
        "lon": 145.7853462193223
      }
    ],

  },
  {
    "id": 19693,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.380481535600605,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19765,
        "lat": 15.17261848880958,
        "lon": 145.7853462193223
      },
      {
        "id": 19766,
        "lat": 15.17265458386966,
        "lon": 145.785208035388
      }
    ],

  },
  {
    "id": 19694,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.378724638194319,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19766,
        "lat": 15.17265458386966,
        "lon": 145.785208035388
      },
      {
        "id": 19767,
        "lat": 15.17268544485646,
        "lon": 145.785068513529
      }
    ],

  },
  {
    "id": 19695,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.377230216697187,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19767,
        "lat": 15.17268544485646,
        "lon": 145.785068513529
      },
      {
        "id": 19506,
        "lat": 15.1727110252974,
        "lon": 145.7849278638506
      }
    ],

  },
  {
    "id": 19696,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 4.146991841206618,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19768,
        "lat": 15.17271507357343,
        "lon": 145.784577123661
      },
      {
        "id": 19508,
        "lat": 15.17275216028951,
        "lon": 145.7845807672155
      }
    ],

  },
  {
    "id": 19697,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 16.96230452173541,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19508,
        "lat": 15.17275216028951,
        "lon": 145.7845807672155
      },
      {
        "id": 19769,
        "lat": 15.17276491048522,
        "lon": 145.7844234424468
      }
    ],

  },
  {
    "id": 19698,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 16.961942768866763,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19769,
        "lat": 15.17276491048522,
        "lon": 145.7844234424468
      },
      {
        "id": 19231,
        "lat": 15.17277402933315,
        "lon": 145.7842658503261
      }
    ],

  },
  {
    "id": 19699,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 0.928408615368706,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19770,
        "lat": 15.17263602857483,
        "lon": 145.7836633238384
      },
      {
        "id": 19242,
        "lat": 15.17263803327996,
        "lon": 145.7836717117425
      }
    ],

  },
  {
    "id": 19700,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.175387039376954,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19242,
        "lat": 15.17263803327996,
        "lon": 145.7836717117425
      },
      {
        "id": 18951,
        "lat": 15.17272682380968,
        "lon": 145.7836492136252
      }
    ],

  },
  {
    "id": 19701,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 4.484612015540298,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19771,
        "lat": 15.17255184072477,
        "lon": 145.7830807183444
      },
      {
        "id": 19505,
        "lat": 15.17254460644857,
        "lon": 145.7830396558981
      }
    ],

  },
  {
    "id": 19702,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 28.03752751496522,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19505,
        "lat": 15.17254460644857,
        "lon": 145.7830396558981
      },
      {
        "id": 19238,
        "lat": 15.17279247648514,
        "lon": 145.7829933584587
      }
    ],

  },
  {
    "id": 19703,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 4.098845402388627,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19772,
        "lat": 15.17248018833701,
        "lon": 145.781653246383
      },
      {
        "id": 19515,
        "lat": 15.1725169964315,
        "lon": 145.7816522539638
      }
    ],

  },
  {
    "id": 19704,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 39.484840227456345,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19515,
        "lat": 15.1725169964315,
        "lon": 145.7816522539638
      },
      {
        "id": 19247,
        "lat": 15.17252633916553,
        "lon": 145.782019635389
      }
    ],

  },
  {
    "id": 19705,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 9.134868512611733,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19773,
        "lat": 15.17190311296504,
        "lon": 145.7804886391676
      },
      {
        "id": 19212,
        "lat": 15.17190556937824,
        "lon": 145.7805736244815
      }
    ],

  },
  {
    "id": 19706,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 37.080147554923514,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19212,
        "lat": 15.17190556937824,
        "lon": 145.7805736244815
      },
      {
        "id": 19774,
        "lat": 15.17223852042895,
        "lon": 145.7805634217953
      }
    ],

  },
  {
    "id": 19707,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 107.55434923023108,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19774,
        "lat": 15.17223852042895,
        "lon": 145.7805634217953
      },
      {
        "id": 19775,
        "lat": 15.17320446289406,
        "lon": 145.7805413582148
      }
    ],

  },
  {
    "id": 19708,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 0.637638701386763,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19776,
        "lat": 15.17117491257565,
        "lon": 145.7812156036617
      },
      {
        "id": 19513,
        "lat": 15.17117472730988,
        "lon": 145.7812215354021
      }
    ],

  },
  {
    "id": 19709,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 1.5506153958598587,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19777,
        "lat": 15.17066955059173,
        "lon": 145.7821018975146
      },
      {
        "id": 19512,
        "lat": 15.17068348000611,
        "lon": 145.7821019021538
      }
    ],

  },
  {
    "id": 19710,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 93.35932348761469,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19512,
        "lat": 15.17068348000611,
        "lon": 145.7821019021538
      },
      {
        "id": 18918,
        "lat": 15.17068375128153,
        "lon": 145.7812329589069
      }
    ],

  },
  {
    "id": 19711,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.82777235961058,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19778,
        "lat": 15.16939489012326,
        "lon": 145.7850726929054
      },
      {
        "id": 19494,
        "lat": 15.16940101246699,
        "lon": 145.7850982364186
      }
    ],

  },
  {
    "id": 19712,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.280162072488453,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19494,
        "lat": 15.16940101246699,
        "lon": 145.7850982364186
      },
      {
        "id": 19779,
        "lat": 15.16947232828753,
        "lon": 145.7850763373869
      }
    ],

  },
  {
    "id": 19713,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.277079522910533,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19779,
        "lat": 15.16947232828753,
        "lon": 145.7850763373869
      },
      {
        "id": 19780,
        "lat": 15.16954128367258,
        "lon": 145.7850475174974
      }
    ],

  },
  {
    "id": 19714,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.273319354765603,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19780,
        "lat": 15.16954128367258,
        "lon": 145.7850475174974
      },
      {
        "id": 19781,
        "lat": 15.16960724672625,
        "lon": 145.7850120408448
      }
    ],

  },
  {
    "id": 19715,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.269018252834101,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19781,
        "lat": 15.16960724672625,
        "lon": 145.7850120408448
      },
      {
        "id": 19782,
        "lat": 15.16966961297318,
        "lon": 145.7849702325259
      }
    ],

  },
  {
    "id": 19716,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.264332772595886,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19782,
        "lat": 15.16966961297318,
        "lon": 145.7849702325259
      },
      {
        "id": 19783,
        "lat": 15.16972781089826,
        "lon": 145.7849224756614
      }
    ],

  },
  {
    "id": 19717,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.259433812249991,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19783,
        "lat": 15.16972781089826,
        "lon": 145.7849224756614
      },
      {
        "id": 19219,
        "lat": 15.16978130718376,
        "lon": 145.7848692078838
      }
    ],

  },
  {
    "id": 19718,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 10.230390566997691,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19784,
        "lat": 15.16799116410861,
        "lon": 145.7863544790169
      },
      {
        "id": 19457,
        "lat": 15.16808298781634,
        "lon": 145.7863505705502
      }
    ],

  },
  {
    "id": 19719,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 35.11182089571203,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19457,
        "lat": 15.16808298781634,
        "lon": 145.7863505705502
      },
      {
        "id": 18902,
        "lat": 15.16806987782062,
        "lon": 145.7860240531967
      }
    ],

  },
  {
    "id": 19720,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.56315606340713,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19785,
        "lat": 15.16681307145488,
        "lon": 145.7850949366132
      },
      {
        "id": 18900,
        "lat": 15.16684506877526,
        "lon": 145.7850940650711
      }
    ],

  },
  {
    "id": 19721,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 28.040983079979547,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18900,
        "lat": 15.16684506877526,
        "lon": 145.7850940650711
      },
      {
        "id": 19354,
        "lat": 15.16685177181793,
        "lon": 145.7853549597821
      }
    ],

  },
  {
    "id": 19722,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 4.927268556826244,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19786,
        "lat": 15.16317677331706,
        "lon": 145.7827783914299
      },
      {
        "id": 19544,
        "lat": 15.16322087740254,
        "lon": 145.7827745161532
      }
    ],

  },
  {
    "id": 19723,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 26.812799814103194,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19544,
        "lat": 15.16322087740254,
        "lon": 145.7827745161532
      },
      {
        "id": 19353,
        "lat": 15.16320026879733,
        "lon": 145.7825258795735
      }
    ],

  },
  {
    "id": 19724,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.327623214570727,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19787,
        "lat": 15.16246495843211,
        "lon": 145.7827962379479
      },
      {
        "id": 19349,
        "lat": 15.16245035040257,
        "lon": 145.7827692172382
      }
    ],

  },
  {
    "id": 19725,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.437455156226287,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19349,
        "lat": 15.16245035040257,
        "lon": 145.7827692172382
      },
      {
        "id": 19788,
        "lat": 15.16254961903107,
        "lon": 145.782716096286
      }
    ],

  },
  {
    "id": 19726,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.440932339112488,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19788,
        "lat": 15.16254961903107,
        "lon": 145.782716096286
      },
      {
        "id": 19789,
        "lat": 15.16265167533472,
        "lon": 145.7826689063706
      }
    ],

  },
  {
    "id": 19727,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.444071792958123,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19789,
        "lat": 15.16265167533472,
        "lon": 145.7826689063706
      },
      {
        "id": 19790,
        "lat": 15.16275618537046,
        "lon": 145.7826278019127
      }
    ],

  },
  {
    "id": 19728,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.446832790175268,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19790,
        "lat": 15.16275618537046,
        "lon": 145.7826278019127
      },
      {
        "id": 19791,
        "lat": 15.16286280716615,
        "lon": 145.7825929174205
      }
    ],

  },
  {
    "id": 19729,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.449179426198342,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19791,
        "lat": 15.16286280716615,
        "lon": 145.7825929174205
      },
      {
        "id": 19792,
        "lat": 15.16297119183891,
        "lon": 145.7825643670508
      }
    ],

  },
  {
    "id": 19730,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.451081263160706,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19792,
        "lat": 15.16297119183891,
        "lon": 145.7825643670508
      },
      {
        "id": 19793,
        "lat": 15.16308098473697,
        "lon": 145.7825422442345
      }
    ],

  },
  {
    "id": 19731,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.452513647668626,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19793,
        "lat": 15.16308098473697,
        "lon": 145.7825422442345
      },
      {
        "id": 19352,
        "lat": 15.16319182660022,
        "lon": 145.7825266213708
      }
    ],

  },
  {
    "id": 19732,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 8.594009511928075,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19794,
        "lat": 15.15970551682611,
        "lon": 145.7839135014264
      },
      {
        "id": 19429,
        "lat": 15.15964842938308,
        "lon": 145.7839673469783
      }
    ],

  },
  {
    "id": 19733,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 41.604472303889935,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19429,
        "lat": 15.15964842938308,
        "lon": 145.7839673469783
      },
      {
        "id": 19285,
        "lat": 15.15990174791824,
        "lon": 145.7842520467384
      }
    ],

  },
  {
    "id": 19734,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 1.958442413487012,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19795,
        "lat": 15.1630082911073,
        "lon": 145.7814504692891
      },
      {
        "id": 19341,
        "lat": 15.16302481630256,
        "lon": 145.7814442157549
      }
    ],

  },
  {
    "id": 19735,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 47.75019136112335,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19341,
        "lat": 15.16302481630256,
        "lon": 145.7814442157549
      },
      {
        "id": 19796,
        "lat": 15.16287602044711,
        "lon": 145.7810273916169
      }
    ],

  },
  {
    "id": 19736,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 18.09389507803606,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19797,
        "lat": 15.16959245030931,
        "lon": 145.7887593687056
      },
      {
        "id": 18835,
        "lat": 15.1695476763782,
        "lon": 145.7885974758645
      }
    ],

  },
  {
    "id": 19737,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 95.77080402182078,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19798,
        "lat": 15.16871725275211,
        "lon": 145.7889225488746
      },
      {
        "id": 19560,
        "lat": 15.16872838341474,
        "lon": 145.7880312435673
      }
    ],

  },
  {
    "id": 19738,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 15.322900955535136,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19799,
        "lat": 15.17797495485278,
        "lon": 145.7766747233318
      },
      {
        "id": 19800,
        "lat": 15.17788271045435,
        "lon": 145.7765688645041
      }
    ],

  },
  {
    "id": 19739,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 24.560878961996337,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19801,
        "lat": 15.17767648700737,
        "lon": 145.7767593907901
      },
      {
        "id": 19802,
        "lat": 15.17751180934065,
        "lon": 145.7769115332508
      }
    ],

  },
  {
    "id": 19740,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 47.62686679378877,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19802,
        "lat": 15.17751180934065,
        "lon": 145.7769115332508
      },
      {
        "id": 19178,
        "lat": 15.17711785154332,
        "lon": 145.7770844284925
      }
    ],

  },
  {
    "id": 19741,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 12.552237275333223,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19803,
        "lat": 15.18052732713443,
        "lon": 145.7713544749177
      },
      {
        "id": 18819,
        "lat": 15.18061537102727,
        "lon": 145.7714274690943
      }
    ],

  },
  {
    "id": 19742,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 3.5084655691930635,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18819,
        "lat": 15.18061537102727,
        "lon": 145.7714274690943
      },
      {
        "id": 19804,
        "lat": 15.18063521170696,
        "lon": 145.7714020954429
      }
    ],

  },
  {
    "id": 19743,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 32.38581398397349,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19804,
        "lat": 15.18063521170696,
        "lon": 145.7714020954429
      },
      {
        "id": 19805,
        "lat": 15.18084596559198,
        "lon": 145.771194291926
      }
    ],

  },
  {
    "id": 19744,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 11.384543758668487,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19805,
        "lat": 15.18084596559198,
        "lon": 145.771194291926
      },
      {
        "id": 19806,
        "lat": 15.180944571773,
        "lon": 145.7711661856928
      }
    ],

  },
  {
    "id": 19745,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.861470175458863,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19807,
        "lat": 15.18125159035472,
        "lon": 145.7701312552365
      },
      {
        "id": 19596,
        "lat": 15.18131092332973,
        "lon": 145.7701139542792
      }
    ],

  },
  {
    "id": 19746,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.427529499608071,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19808,
        "lat": 15.1809600654138,
        "lon": 145.7712238187693
      },
      {
        "id": 19806,
        "lat": 15.180944571773,
        "lon": 145.7711661856928
      }
    ],

  },
  {
    "id": 19747,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 22.26052525755902,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19806,
        "lat": 15.180944571773,
        "lon": 145.7711661856928
      },
      {
        "id": 19809,
        "lat": 15.18113737925964,
        "lon": 145.7711112286923
      }
    ],

  },
  {
    "id": 19748,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 44.916289323499456,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19809,
        "lat": 15.18113737925964,
        "lon": 145.7711112286923
      },
      {
        "id": 19369,
        "lat": 15.18154084329767,
        "lon": 145.7711159614611
      }
    ],

  },
  {
    "id": 19749,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.79372777600823,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19810,
        "lat": 15.18117568912892,
        "lon": 145.7717993843444
      },
      {
        "id": 18830,
        "lat": 15.18127265032141,
        "lon": 145.771799057261
      }
    ],

  },
  {
    "id": 19750,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.888191422621151,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19811,
        "lat": 15.18143203432021,
        "lon": 145.7726208396553
      },
      {
        "id": 18788,
        "lat": 15.18144750977499,
        "lon": 145.7726634196625
      }
    ],

  },
  {
    "id": 19751,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 19.530562242799355,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19812,
        "lat": 15.18151304422636,
        "lon": 145.7733575715053
      },
      {
        "id": 19608,
        "lat": 15.18150540753235,
        "lon": 145.7735391895264
      }
    ],

  },
  {
    "id": 19752,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 5.824747375921383,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19813,
        "lat": 15.18148925669078,
        "lon": 145.7741481146027
      },
      {
        "id": 19618,
        "lat": 15.18148219514483,
        "lon": 145.7742018352977
      }
    ],

  },
  {
    "id": 19753,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 58.277317458870456,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19618,
        "lat": 15.18148219514483,
        "lon": 145.7742018352977
      },
      {
        "id": 19071,
        "lat": 15.18200103661852,
        "lon": 145.7742741478714
      }
    ],

  },
  {
    "id": 19754,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.4252804317509145,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19814,
        "lat": 15.18089040211916,
        "lon": 145.7744762241601
      },
      {
        "id": 19628,
        "lat": 15.1809139557435,
        "lon": 145.774496739262
      }
    ],

  },
  {
    "id": 19755,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 19.478886591731914,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19628,
        "lat": 15.1809139557435,
        "lon": 145.774496739262
      },
      {
        "id": 19815,
        "lat": 15.18102737422099,
        "lon": 145.7743586738071
      }
    ],

  },
  {
    "id": 19756,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 3.592197534573679,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19815,
        "lat": 15.18102737422099,
        "lon": 145.7743586738071
      },
      {
        "id": 19616,
        "lat": 15.18105610526798,
        "lon": 145.7743434513692
      }
    ],

  },
  {
    "id": 19757,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.13102447174337,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19816,
        "lat": 15.18129339491282,
        "lon": 145.775181605633
      },
      {
        "id": 18811,
        "lat": 15.18122739307322,
        "lon": 145.7751311421929
      }
    ],

  },
  {
    "id": 19758,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 47.24093142620564,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19817,
        "lat": 15.18127692657627,
        "lon": 145.7757446190231
      },
      {
        "id": 19589,
        "lat": 15.18160697307632,
        "lon": 145.7760210260669
      }
    ],

  },
  {
    "id": 19759,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.344844628672314,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19818,
        "lat": 15.18179299009858,
        "lon": 145.7755108529638
      },
      {
        "id": 19076,
        "lat": 15.18185714777992,
        "lon": 145.7755268089945
      }
    ],

  },
  {
    "id": 19760,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 33.041931311565996,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19076,
        "lat": 15.18185714777992,
        "lon": 145.7755268089945
      },
      {
        "id": 19819,
        "lat": 15.1817870480309,
        "lon": 145.7758256634028
      }
    ],

  },
  {
    "id": 19761,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 28.41866951738133,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19819,
        "lat": 15.1817870480309,
        "lon": 145.7758256634028
      },
      {
        "id": 19588,
        "lat": 15.18161356093636,
        "lon": 145.7760197186493
      }
    ],

  },
  {
    "id": 19762,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.069399852947571,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19820,
        "lat": 15.18295773586377,
        "lon": 145.7746780386508
      },
      {
        "id": 19614,
        "lat": 15.18286357328396,
        "lon": 145.7747337280089
      }
    ],

  },
  {
    "id": 19763,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 18.83634101932267,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19614,
        "lat": 15.18286357328396,
        "lon": 145.7747337280089
      },
      {
        "id": 19821,
        "lat": 15.18294824522584,
        "lon": 145.774885527808
      }
    ],

  },
  {
    "id": 19764,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.126568959239478,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19822,
        "lat": 15.18328598505763,
        "lon": 145.7739887813439
      },
      {
        "id": 19612,
        "lat": 15.18321482438002,
        "lon": 145.7740309695769
      }
    ],

  },
  {
    "id": 19765,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.737936990770949,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19823,
        "lat": 15.18291972740819,
        "lon": 145.7734699955647
      },
      {
        "id": 18795,
        "lat": 15.18295849832991,
        "lon": 145.7734518018467
      }
    ],

  },
  {
    "id": 19766,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 33.72198377688578,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18795,
        "lat": 15.18295849832991,
        "lon": 145.7734518018467
      },
      {
        "id": 19611,
        "lat": 15.18308477264093,
        "lon": 145.7737371175725
      }
    ],

  },
  {
    "id": 19767,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.2204192652241317,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19824,
        "lat": 15.18035447244,
        "lon": 145.7751489420477
      },
      {
        "id": 19825,
        "lat": 15.18037371787017,
        "lon": 145.7751543728182
      }
    ],

  },
  {
    "id": 19768,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 19.74896388470419,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19825,
        "lat": 15.18037371787017,
        "lon": 145.7751543728182
      },
      {
        "id": 19626,
        "lat": 15.18048870931637,
        "lon": 145.7750143937842
      }
    ],

  },
  {
    "id": 19769,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.221271921281637,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19826,
        "lat": 15.18046999306655,
        "lon": 145.7759405879246
      },
      {
        "id": 19624,
        "lat": 15.18051905867593,
        "lon": 145.7759128645637
      }
    ],

  },
  {
    "id": 19770,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 42.70353562299123,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19827,
        "lat": 15.18032495421913,
        "lon": 145.7755486303179
      },
      {
        "id": 19825,
        "lat": 15.18037371787017,
        "lon": 145.7751543728182
      }
    ],

  },
  {
    "id": 19771,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.834192383719838,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19828,
        "lat": 15.18066458575929,
        "lon": 145.7782165108913
      },
      {
        "id": 19572,
        "lat": 15.18067810897156,
        "lon": 145.7782493335581
      }
    ],

  },
  {
    "id": 19772,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 34.72000735503382,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19572,
        "lat": 15.18067810897156,
        "lon": 145.7782493335581
      },
      {
        "id": 18780,
        "lat": 15.18039071119967,
        "lon": 145.7783748800033
      }
    ],

  },
  {
    "id": 19773,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.99876188313105,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19829,
        "lat": 15.18085618840146,
        "lon": 145.7776781706239
      },
      {
        "id": 19830,
        "lat": 15.18088750241284,
        "lon": 145.7776599334792
      }
    ],

  },
  {
    "id": 19774,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 42.13365399694056,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19830,
        "lat": 15.18088750241284,
        "lon": 145.7776599334792
      },
      {
        "id": 19831,
        "lat": 15.18107472222947,
        "lon": 145.7780007740273
      }
    ],

  },
  {
    "id": 19775,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.992724295735255,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19832,
        "lat": 15.18063555472819,
        "lon": 145.7772763872795
      },
      {
        "id": 18759,
        "lat": 15.18066682142757,
        "lon": 145.7772581776303
      }
    ],

  },
  {
    "id": 19776,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 49.66391127883082,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18759,
        "lat": 15.18066682142757,
        "lon": 145.7772581776303
      },
      {
        "id": 19830,
        "lat": 15.18088750241284,
        "lon": 145.7776599334792
      }
    ],

  },
  {
    "id": 19777,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.416269598265209,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19833,
        "lat": 15.18015704594544,
        "lon": 145.777824848951
      },
      {
        "id": 19574,
        "lat": 15.18010679825183,
        "lon": 145.777854107171
      }
    ],

  },
  {
    "id": 19778,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 85.87415302591334,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19574,
        "lat": 15.18010679825183,
        "lon": 145.777854107171
      },
      {
        "id": 19834,
        "lat": 15.17972527340207,
        "lon": 145.7771593987028
      }
    ],

  },
  {
    "id": 19779,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 17.43147125912973,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19834,
        "lat": 15.17972527340207,
        "lon": 145.7771593987028
      },
      {
        "id": 19835,
        "lat": 15.17964781960734,
        "lon": 145.7770183860579
      }
    ],

  },

  {
    "id": 19780,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.606886358785293,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19836,
        "lat": 15.18011601509086,
        "lon": 145.7784627313617
      },
      {
        "id": 18781,
        "lat": 15.18012913632061,
        "lon": 145.7784934279731
      }
    ],

  },
  {
    "id": 19781,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 60.92128084941526,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18781,
        "lat": 15.18012913632061,
        "lon": 145.7784934279731
      },
      {
        "id": 19089,
        "lat": 15.17962773574265,
        "lon": 145.7787206660986
      }
    ],

  },
  {
    "id": 19782,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.622251113233477,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19837,
        "lat": 15.17969967851509,
        "lon": 145.7769881851465
      },
      {
        "id": 19835,
        "lat": 15.17964781960734,
        "lon": 145.7770183860579
      }
    ],

  },
  {
    "id": 19783,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 82.80060016360596,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19835,
        "lat": 15.17964781960734,
        "lon": 145.7770183860579
      },
      {
        "id": 19090,
        "lat": 15.17927990793605,
        "lon": 145.7763485684196
      }
    ],

  },
  {
    "id": 19784,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.046880404438348,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19838,
        "lat": 15.17939049680067,
        "lon": 145.7781321421415
      },
      {
        "id": 19839,
        "lat": 15.1793196666719,
        "lon": 145.7781734301784
      }
    ],

  },
  {
    "id": 19785,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 29.770770836062034,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19839,
        "lat": 15.1793196666719,
        "lon": 145.7781734301784
      },
      {
        "id": 19840,
        "lat": 15.17945204238124,
        "lon": 145.7784142061321
      }
    ],

  },
  {
    "id": 19786,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 38.27134209344653,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19840,
        "lat": 15.17945204238124,
        "lon": 145.7784142061321
      },
      {
        "id": 18771,
        "lat": 15.17962273507344,
        "lon": 145.7787234249803
      }
    ],

  },
  {
    "id": 19787,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.326124149975236,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19841,
        "lat": 15.17896887375756,
        "lon": 145.7773224052436
      },
      {
        "id": 19842,
        "lat": 15.17888019908225,
        "lon": 145.7773740954944
      }
    ],

  },
  {
    "id": 19788,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 98.83409868934827,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19842,
        "lat": 15.17888019908225,
        "lon": 145.7773740954944
      },
      {
        "id": 19839,
        "lat": 15.1793196666719,
        "lon": 145.7781734301784
      }
    ],

  },
  {
    "id": 19789,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.02144999350228,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19843,
        "lat": 15.17869272231948,
        "lon": 145.7767213290305
      },
      {
        "id": 18770,
        "lat": 15.17871906176022,
        "lon": 145.77672811797
      }
    ],

  },
  {
    "id": 19790,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 26.908321136541353,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18770,
        "lat": 15.17871906176022,
        "lon": 145.77672811797
      },
      {
        "id": 19844,
        "lat": 15.1786600189102,
        "lon": 145.7769709906146
      }
    ],

  },
  {
    "id": 19791,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.406098715650739,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19844,
        "lat": 15.1786600189102,
        "lon": 145.7769709906146
      },
      {
        "id": 19845,
        "lat": 15.17870594723532,
        "lon": 145.7770553524574
      }
    ],

  },
  {
    "id": 19792,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.02849155851561,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19845,
        "lat": 15.17870594723532,
        "lon": 145.7770553524574
      },
      {
        "id": 19846,
        "lat": 15.178772021935,
        "lon": 145.7771773365642
      }
    ],

  },
  {
    "id": 19793,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 24.328410270017944,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19846,
        "lat": 15.178772021935,
        "lon": 145.7771773365642
      },
      {
        "id": 19842,
        "lat": 15.17888019908225,
        "lon": 145.7773740954944
      }
    ],

  },
  {
    "id": 19794,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 1.6007194307820536,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19847,
        "lat": 15.17981540194795,
        "lon": 145.7756797052599
      },
      {
        "id": 19085,
        "lat": 15.17980286689486,
        "lon": 145.7756870057379
      }
    ],

  },
  {
    "id": 19795,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 69.41137177560286,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19085,
        "lat": 15.17980286689486,
        "lon": 145.7756870057379
      },
      {
        "id": 19848,
        "lat": 15.18011129920067,
        "lon": 145.7762485041503
      }
    ],

  },
  {
    "id": 19796,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.106724478691968,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19849,
        "lat": 15.18007913985806,
        "lon": 145.7762672338246
      },
      {
        "id": 19848,
        "lat": 15.18011129920067,
        "lon": 145.7762485041503
      }
    ],

  },
  {
    "id": 19797,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 75.9538424762027,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19848,
        "lat": 15.18011129920067,
        "lon": 145.7762485041503
      },
      {
        "id": 19081,
        "lat": 15.18044880164106,
        "lon": 145.7768629293057
      }
    ],

  },
  {
    "id": 19798,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.52252966449141,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19850,
        "lat": 15.18159577329839,
        "lon": 145.7799942937805
      },
      {
        "id": 19851,
        "lat": 15.1816219114964,
        "lon": 145.7800588634732
      }
    ],

  },
  {
    "id": 19799,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 39.578565740550175,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19851,
        "lat": 15.1816219114964,
        "lon": 145.7800588634732
      },
      {
        "id": 19333,
        "lat": 15.1812934366657,
        "lon": 145.7801998468086
      }
    ],

  },
  {
    "id": 19800,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.022175925418297,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19852,
        "lat": 15.18191471524513,
        "lon": 145.7803239983076
      },
      {
        "id": 18785,
        "lat": 15.18197284477074,
        "lon": 145.7802986132414
      }
    ],

  },
  {
    "id": 19801,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 38.74901134956676,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18785,
        "lat": 15.18197284477074,
        "lon": 145.7802986132414
      },
      {
        "id": 19853,
        "lat": 15.18183621462084,
        "lon": 145.7799668830512
      }
    ],

  },
  {
    "id": 19802,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 25.82180238545624,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19853,
        "lat": 15.18183621462084,
        "lon": 145.7799668830512
      },
      {
        "id": 19851,
        "lat": 15.1816219114964,
        "lon": 145.7800588634732
      }
    ],

  },
  {
    "id": 19803,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 8.622341321698622,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19854,
        "lat": 15.1810894778392,
        "lon": 145.7817465066705
      },
      {
        "id": 19855,
        "lat": 15.18111987992919,
        "lon": 145.7818203224716
      }
    ],

  },
  {
    "id": 19804,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 108.82871429563671,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19855,
        "lat": 15.18111987992919,
        "lon": 145.7818203224716
      },
      {
        "id": 19856,
        "lat": 15.18202076556953,
        "lon": 145.7814269144852
      }
    ],

  },
  {
    "id": 19805,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 33.07935546626379,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19856,
        "lat": 15.18202076556953,
        "lon": 145.7814269144852
      },
      {
        "id": 19857,
        "lat": 15.18220125970104,
        "lon": 145.7811823181427
      }
    ],

  },
  {
    "id": 19806,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 27.790768562648065,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19857,
        "lat": 15.18220125970104,
        "lon": 145.7811823181427
      },
      {
        "id": 19858,
        "lat": 15.18223103443371,
        "lon": 145.7809254873939
      }
    ],

  },
  {
    "id": 19807,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 24.956210404188045,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19858,
        "lat": 15.18223103443371,
        "lon": 145.7809254873939
      },
      {
        "id": 18784,
        "lat": 15.18214303875523,
        "lon": 145.7807118367647
      }
    ],

  },
  {
    "id": 19808,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.956756535464075,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19859,
        "lat": 15.18026606068699,
        "lon": 145.782080073287
      },
      {
        "id": 19570,
        "lat": 15.18034744281291,
        "lon": 145.7820416235359
      }
    ],

  },
  {
    "id": 19809,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 11.491928412213976,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19570,
        "lat": 15.18034744281291,
        "lon": 145.7820416235359
      },
      {
        "id": 19860,
        "lat": 15.1803907174693,
        "lon": 145.7821387379426
      }
    ],

  },
  {
    "id": 19810,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 88.08416421358433,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19860,
        "lat": 15.1803907174693,
        "lon": 145.7821387379426
      },
      {
        "id": 19855,
        "lat": 15.18111987992919,
        "lon": 145.7818203224716
      }
    ],

  },
  {
    "id": 19811,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.145175614660754,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19861,
        "lat": 15.18046133771253,
        "lon": 145.7814033830536
      },
      {
        "id": 19584,
        "lat": 15.18046309959595,
        "lon": 145.7813369012071
      }
    ],

  },
  {
    "id": 19812,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 5.363591573491472,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19862,
        "lat": 15.18059072029035,
        "lon": 145.7805673573129
      },
      {
        "id": 18787,
        "lat": 15.18057153674934,
        "lon": 145.7805215609211
      }
    ],

  },
  {
    "id": 19813,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 80.89696092315219,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18787,
        "lat": 15.18057153674934,
        "lon": 145.7805215609211
      },
      {
        "id": 19715,
        "lat": 15.1799036002829,
        "lon": 145.7808182124913
      }
    ],

  },
  {
    "id": 19814,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 8.149307965472925,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19863,
        "lat": 15.17951915704064,
        "lon": 145.7818253686804
      },
      {
        "id": 19583,
        "lat": 15.17948978537743,
        "lon": 145.7817558886352
      }
    ],

  },
  {
    "id": 19815,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 43.45050926154514,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19583,
        "lat": 15.17948978537743,
        "lon": 145.7817558886352
      },
      {
        "id": 19864,
        "lat": 15.17913154297194,
        "lon": 145.7819164554162
      }
    ],

  },
  {
    "id": 19816,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.712346335453141,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19865,
        "lat": 15.1791593396964,
        "lon": 145.7819822098866
      },
      {
        "id": 19864,
        "lat": 15.17913154297194,
        "lon": 145.7819164554162
      }
    ],

  },
  {
    "id": 19817,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 46.340096121022455,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19864,
        "lat": 15.17913154297194,
        "lon": 145.7819164554162
      },
      {
        "id": 19114,
        "lat": 15.178749476266,
        "lon": 145.7820876997611
      }
    ],

  },
  {
    "id": 19818,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.706119572661798,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19866,
        "lat": 15.17920861897534,
        "lon": 145.7810285814128
      },
      {
        "id": 19716,
        "lat": 15.17924333390877,
        "lon": 145.7811114555195
      }
    ],

  },
  {
    "id": 19819,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 91.77496649755668,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19716,
        "lat": 15.17924333390877,
        "lon": 145.7811114555195
      },
      {
        "id": 19867,
        "lat": 15.17848558084484,
        "lon": 145.7814479926861
      }
    ],

  },
  {
    "id": 19820,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.045544759864191,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19868,
        "lat": 15.17822403169317,
        "lon": 145.7823232782693
      },
      {
        "id": 19582,
        "lat": 15.17822053295954,
        "lon": 145.7822577996934
      }
    ],

  },
  {
    "id": 19821,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 29.528524524884297,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19582,
        "lat": 15.17822053295954,
        "lon": 145.7822577996934
      },
      {
        "id": 19869,
        "lat": 15.17795566931612,
        "lon": 145.7822728048194
      }
    ],

  },
  {
    "id": 19822,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 28.86422531571649,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19869,
        "lat": 15.17795566931612,
        "lon": 145.7822728048194
      },
      {
        "id": 19870,
        "lat": 15.17773635884529,
        "lon": 145.7824161342441
      }
    ],

  },
  {
    "id": 19823,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.9102168569735507,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19870,
        "lat": 15.17773635884529,
        "lon": 145.7824161342441
      },
      {
        "id": 19871,
        "lat": 15.17772184500869,
        "lon": 145.7824256196877
      }
    ],

  },
  {
    "id": 19824,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 24.106626859785035,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19871,
        "lat": 15.17772184500869,
        "lon": 145.7824256196877
      },
      {
        "id": 19112,
        "lat": 15.17753868271079,
        "lon": 145.7825453243346
      }
    ],

  },
  {
    "id": 19825,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.9619055977501163,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19872,
        "lat": 15.17894322367149,
        "lon": 145.780336311319
      },
      {
        "id": 19563,
        "lat": 15.1789289614719,
        "lon": 145.7803025248366
      }
    ],

  },
  {
    "id": 19826,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 80.46541718723326,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19563,
        "lat": 15.1789289614719,
        "lon": 145.7803025248366
      },
      {
        "id": 19712,
        "lat": 15.17959253610998,
        "lon": 145.7800055337505
      }
    ],

  },
  {
    "id": 19827,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.005888082783187,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19873,
        "lat": 15.17908818965712,
        "lon": 145.7795133437049
      },
      {
        "id": 19874,
        "lat": 15.17905643658004,
        "lon": 145.7794362444919
      }
    ],

  },
  {
    "id": 19828,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 31.213944956583344,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19874,
        "lat": 15.17905643658004,
        "lon": 145.7794362444919
      },
      {
        "id": 19709,
        "lat": 15.17931482811165,
        "lon": 145.7793234146433
      }
    ],

  },
  {
    "id": 19829,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 8.79320665937456,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19875,
        "lat": 15.17824844361144,
        "lon": 145.7798778785975
      },
      {
        "id": 19876,
        "lat": 15.17821744052945,
        "lon": 145.7798026003916
      }
    ],

  },
  {
    "id": 19830,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 49.52394616901454,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19877,
        "lat": 15.17864647329335,
        "lon": 145.7796152594398
      },
      {
        "id": 19874,
        "lat": 15.17905643658004,
        "lon": 145.7794362444919
      }
    ],

  },
  {
    "id": 19831,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.145879261815667,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19878,
        "lat": 15.177597541841,
        "lon": 145.7801656610242
      },
      {
        "id": 19879,
        "lat": 15.17756529540414,
        "lon": 145.7800873638039
      }
    ],

  },
  {
    "id": 19832,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 78.77967122505467,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19879,
        "lat": 15.17756529540414,
        "lon": 145.7800873638039
      },
      {
        "id": 19876,
        "lat": 15.17821744052945,
        "lon": 145.7798026003916
      }
    ],

  },
  {
    "id": 19833,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.629730912944257,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19880,
        "lat": 15.17698595610814,
        "lon": 145.7802733712102
      },
      {
        "id": 19881,
        "lat": 15.17700933109466,
        "lon": 145.7803301277261
      }
    ],

  },
  {
    "id": 19834,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 67.16091494324323,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19881,
        "lat": 15.17700933109466,
        "lon": 145.7803301277261
      },
      {
        "id": 19879,
        "lat": 15.17756529540414,
        "lon": 145.7800873638039
      }
    ],

  },
  {
    "id": 19835,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.418652785994563,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19882,
        "lat": 15.17743732802425,
        "lon": 145.7809985359587
      },
      {
        "id": 19883,
        "lat": 15.17742213705937,
        "lon": 145.7809605390565
      }
    ],

  },
  {
    "id": 19836,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 85.30136225241439,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19883,
        "lat": 15.17742213705937,
        "lon": 145.7809605390565
      },
      {
        "id": 19118,
        "lat": 15.17813136030458,
        "lon": 145.780659914762
      }
    ],

  },
  {
    "id": 19837,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.5957203375982125,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19884,
        "lat": 15.17702790645508,
        "lon": 145.7811738604483
      },
      {
        "id": 19666,
        "lat": 15.17701210677667,
        "lon": 145.7811343409696
      }
    ],

  },
  {
    "id": 19838,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 49.316102391088606,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19666,
        "lat": 15.17701210677667,
        "lon": 145.7811343409696
      },
      {
        "id": 19883,
        "lat": 15.17742213705937,
        "lon": 145.7809605390565
      }
    ],

  },
  {
    "id": 19839,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.756165200759126,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19885,
        "lat": 15.17614321794056,
        "lon": 145.7806400765605
      },
      {
        "id": 19669,
        "lat": 15.17616703861408,
        "lon": 145.780697915279
      }
    ],

  },
  {
    "id": 19840,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 101.74951781425875,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19669,
        "lat": 15.17616703861408,
        "lon": 145.780697915279
      },
      {
        "id": 19881,
        "lat": 15.17700933109466,
        "lon": 145.7803301277261
      }
    ],

  },
  {
    "id": 19841,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 5.230389753623961,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19886,
        "lat": 15.17577647884576,
        "lon": 145.7817104072408
      },
      {
        "id": 19887,
        "lat": 15.1757632754593,
        "lon": 145.7816636858384
      }
    ],

  },
  {
    "id": 19842,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 72.73138321541558,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19887,
        "lat": 15.1757632754593,
        "lon": 145.7816636858384
      },
      {
        "id": 19665,
        "lat": 15.17636798863307,
        "lon": 145.7814073655861
      }
    ],

  },
  {
    "id": 19843,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.248809068736593,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19888,
        "lat": 15.17545052258994,
        "lon": 145.7810738951806
      },
      {
        "id": 19889,
        "lat": 15.17542849082513,
        "lon": 145.7810204000191
      }
    ],

  },
  {
    "id": 19844,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 84.83951697593126,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19889,
        "lat": 15.17542849082513,
        "lon": 145.7810204000191
      },
      {
        "id": 19668,
        "lat": 15.1761308011385,
        "lon": 145.7807137383244
      }
    ],

  },
  {
    "id": 19845,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.487958570425395,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19890,
        "lat": 15.17473819348675,
        "lon": 145.7811255210197
      },
      {
        "id": 19092,
        "lat": 15.17476444934959,
        "lon": 145.7812289288285
      }
    ],

  },
  {
    "id": 19846,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 55.92497689747731,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19092,
        "lat": 15.17476444934959,
        "lon": 145.7812289288285
      },
      {
        "id": 19891,
        "lat": 15.17525068939701,
        "lon": 145.7810980361282
      }
    ],

  },
  {
    "id": 19847,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 21.47851372835166,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19891,
        "lat": 15.17525068939701,
        "lon": 145.7810980361282
      },
      {
        "id": 19889,
        "lat": 15.17542849082513,
        "lon": 145.7810204000191
      }
    ],

  },
  {
    "id": 19848,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.017569772961324,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19892,
        "lat": 15.17491832554182,
        "lon": 145.7819585908377
      },
      {
        "id": 19099,
        "lat": 15.17490228917534,
        "lon": 145.7818954221312
      }
    ],

  },
  {
    "id": 19849,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 99.02550152748731,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19099,
        "lat": 15.17490228917534,
        "lon": 145.7818954221312
      },
      {
        "id": 19887,
        "lat": 15.1757632754593,
        "lon": 145.7816636858384
      }
    ],

  },
  {
    "id": 19850,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 5.385786468125727,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19893,
        "lat": 15.17437281293998,
        "lon": 145.7806717019433
      },
      {
        "id": 19095,
        "lat": 15.17432549954584,
        "lon": 145.7806612274809
      }
    ],

  },
  {
    "id": 19851,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 37.201373579185805,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19095,
        "lat": 15.17432549954584,
        "lon": 145.7806612274809
      },
      {
        "id": 19123,
        "lat": 15.17439616752434,
        "lon": 145.7803227994208
      }
    ],

  },
  {
    "id": 19852,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.974097247571104,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19894,
        "lat": 15.17426323052505,
        "lon": 145.7821344915019
      },
      {
        "id": 19097,
        "lat": 15.17424729354904,
        "lon": 145.7820717142952
      }
    ],

  },
  {
    "id": 19853,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 38.027993085529744,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19097,
        "lat": 15.17424729354904,
        "lon": 145.7820717142952
      },
      {
        "id": 19895,
        "lat": 15.17391665555215,
        "lon": 145.7821607051301
      }
    ],

  },
  {
    "id": 19854,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 17.12288888593309,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19896,
        "lat": 15.17379623005738,
        "lon": 145.7820615533086
      },
      {
        "id": 19895,
        "lat": 15.17391665555215,
        "lon": 145.7821607051301
      }
    ],

  },
  {
    "id": 19855,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.797170264264448,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19897,
        "lat": 15.17427183846588,
        "lon": 145.7831069907162
      },
      {
        "id": 18844,
        "lat": 15.1742940653324,
        "lon": 145.7829901264032
      }
    ],

  },
  {
    "id": 19856,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.14762072689074,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19898,
        "lat": 15.17478521136085,
        "lon": 145.7836372004694
      },
      {
        "id": 19122,
        "lat": 15.17476884112379,
        "lon": 145.7835728711581
      }
    ],

  },
  {
    "id": 19857,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.4499043263968,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19122,
        "lat": 15.17476884112379,
        "lon": 145.7835728711581
      },
      {
        "id": 19899,
        "lat": 15.17459975782246,
        "lon": 145.7836184893317
      }
    ],

  },
  {
    "id": 19858,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.47672994320768,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19900,
        "lat": 15.1755155867787,
        "lon": 145.7832808426578
      },
      {
        "id": 19109,
        "lat": 15.17553720724602,
        "lon": 145.7833661574304
      }
    ],

  },
  {
    "id": 19859,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 60.61616337802129,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19109,
        "lat": 15.17553720724602,
        "lon": 145.7833661574304
      },
      {
        "id": 19558,
        "lat": 15.17501011595493,
        "lon": 145.7835077757935
      }
    ],

  },
  {
    "id": 19860,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.725721618160614,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19901,
        "lat": 15.17532105196576,
        "lon": 145.7827510423359
      },
      {
        "id": 19101,
        "lat": 15.17530963529204,
        "lon": 145.7827086771182
      }
    ],

  },
  {
    "id": 19861,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 88.60911987070256,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19101,
        "lat": 15.17530963529204,
        "lon": 145.7827086771182
      },
      {
        "id": 19111,
        "lat": 15.17607698578223,
        "lon": 145.7824894374348
      }
    ],

  },
  {
    "id": 19862,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 5.415454348643251,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19902,
        "lat": 15.17633233480525,
        "lon": 145.7727181428373
      },
      {
        "id": 19703,
        "lat": 15.17632691148176,
        "lon": 145.7726680512708
      }
    ],

  },
  {
    "id": 19863,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 24.80956042973944,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19703,
        "lat": 15.17632691148176,
        "lon": 145.7726680512708
      },
      {
        "id": 19903,
        "lat": 15.17610539861846,
        "lon": 145.7726934783998
      }
    ],

  },
  {
    "id": 19864,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 42.366325380619045,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19903,
        "lat": 15.17610539861846,
        "lon": 145.7726934783998
      },
      {
        "id": 19904,
        "lat": 15.1757280048674,
        "lon": 145.7727444232052
      }
    ],

  },
  {
    "id": 19865,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 31.595686133150515,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19904,
        "lat": 15.1757280048674,
        "lon": 145.7727444232052
      },
      {
        "id": 19698,
        "lat": 15.1757663891192,
        "lon": 145.773035805889
      }
    ],

  },
  {
    "id": 19866,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 16.589334456790972,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19905,
        "lat": 15.17667043105195,
        "lon": 145.7829302055568
      },
      {
        "id": 19906,
        "lat": 15.17675064634686,
        "lon": 145.7830603380427
      }
    ],

  },
  {
    "id": 19867,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.201144044716196,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19906,
        "lat": 15.17675064634686,
        "lon": 145.7830603380427
      },
      {
        "id": 19907,
        "lat": 15.17665794181811,
        "lon": 145.7831209239071
      }
    ],

  },
  {
    "id": 19868,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.183076380133206,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19908,
        "lat": 15.17716961729808,
        "lon": 145.7826854692707
      },
      {
        "id": 19113,
        "lat": 15.17721402080374,
        "lon": 145.78275750461
      }
    ],

  },
  {
    "id": 19869,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 60.986248836974575,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19113,
        "lat": 15.17721402080374,
        "lon": 145.78275750461
      },
      {
        "id": 19906,
        "lat": 15.17675064634686,
        "lon": 145.7830603380427
      }
    ],

  },
  {
    "id": 19870,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.3732741838216445,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19909,
        "lat": 15.17035268068902,
        "lon": 145.7765615263399
      },
      {
        "id": 19730,
        "lat": 15.17033348835255,
        "lon": 145.7765970426856
      }
    ],

  },
  {
    "id": 19871,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.870393268888405,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19730,
        "lat": 15.17033348835255,
        "lon": 145.7765970426856
      },
      {
        "id": 19910,
        "lat": 15.17037177667154,
        "lon": 145.7766189777476
      }
    ],

  },
  {
    "id": 19872,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 23.051396414055258,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19910,
        "lat": 15.17037177667154,
        "lon": 145.7766189777476
      },
      {
        "id": 19911,
        "lat": 15.17057811361483,
        "lon": 145.7766008889354
      }
    ],

  },
  {
    "id": 19873,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.717583971870143,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19911,
        "lat": 15.17057811361483,
        "lon": 145.7766008889354
      },
      {
        "id": 19372,
        "lat": 15.17069195085668,
        "lon": 145.7765909092217
      }
    ],

  },
  {
    "id": 19874,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.12673010951068,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19912,
        "lat": 15.17016485544295,
        "lon": 145.7759005554859
      },
      {
        "id": 19472,
        "lat": 15.17015773294347,
        "lon": 145.7758159296759
      }
    ],

  },
  {
    "id": 19875,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 51.60588360667004,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19472,
        "lat": 15.17015773294347,
        "lon": 145.7758159296759
      },
      {
        "id": 19913,
        "lat": 15.16969585897323,
        "lon": 145.7758571418042
      }
    ],

  },
  {
    "id": 19876,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 8.845020314886426,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19914,
        "lat": 15.16970276161231,
        "lon": 145.7759391553375
      },
      {
        "id": 19913,
        "lat": 15.16969585897323,
        "lon": 145.7758571418042
      }
    ],

  },
  {
    "id": 19877,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 35.040724805273776,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19913,
        "lat": 15.16969585897323,
        "lon": 145.7758571418042
      },
      {
        "id": 18939,
        "lat": 15.16938224359122,
        "lon": 145.7758851250012
      }
    ],

  },
  {
    "id": 19878,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.441176733781113,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19915,
        "lat": 15.16930874244341,
        "lon": 145.776237611212
      },
      {
        "id": 19481,
        "lat": 15.16941114128187,
        "lon": 145.7762284745764
      }
    ],

  },
  {
    "id": 19879,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 43.96592297335802,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19481,
        "lat": 15.16941114128187,
        "lon": 145.7762284745764
      },
      {
        "id": 19916,
        "lat": 15.16944545124993,
        "lon": 145.7766361386299
      }
    ],

  },
  {
    "id": 19880,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 17.553322271738622,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19917,
        "lat": 15.16929879837328,
        "lon": 145.7766961720412
      },
      {
        "id": 19916,
        "lat": 15.16944545124993,
        "lon": 145.7766361386299
      }
    ],

  },
  {
    "id": 19881,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 35.19346498895806,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19916,
        "lat": 15.16944545124993,
        "lon": 145.7766361386299
      },
      {
        "id": 19728,
        "lat": 15.16976047390147,
        "lon": 145.7766085218657
      }
    ],

  },
  {
    "id": 19882,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.494210463390632,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19918,
        "lat": 15.1691165265193,
        "lon": 145.7758668498527
      },
      {
        "id": 18940,
        "lat": 15.16912003379588,
        "lon": 145.7759085213301
      }
    ],

  },
  {
    "id": 19883,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 67.92926173676489,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18940,
        "lat": 15.16912003379588,
        "lon": 145.7759085213301
      },
      {
        "id": 19919,
        "lat": 15.16851206515327,
        "lon": 145.7759627686404
      }
    ],

  },
  {
    "id": 19884,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.649074149846827,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19920,
        "lat": 15.16868208968061,
        "lon": 145.7767428380792
      },
      {
        "id": 19921,
        "lat": 15.16857782251906,
        "lon": 145.7767520483762
      }
    ],

  },
  {
    "id": 19885,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 83.95071650027931,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19921,
        "lat": 15.16857782251906,
        "lon": 145.7767520483762
      },
      {
        "id": 19922,
        "lat": 15.16851295744515,
        "lon": 145.77597357938
      }
    ],

  },
  {
    "id": 19886,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 42.47767116876029,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19922,
        "lat": 15.16851295744515,
        "lon": 145.77597357938
      },
      {
        "id": 19740,
        "lat": 15.16848044394394,
        "lon": 145.7755796597163
      }
    ],

  },
  {
    "id": 19887,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.456855550973485,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19923,
        "lat": 15.16872027686779,
        "lon": 145.7772219526335
      },
      {
        "id": 18992,
        "lat": 15.16861773017484,
        "lon": 145.7772310107243
      }
    ],

  },
  {
    "id": 19888,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 51.6516553615787,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18992,
        "lat": 15.16861773017484,
        "lon": 145.7772310107243
      },
      {
        "id": 19921,
        "lat": 15.16857782251906,
        "lon": 145.7767520483762
      }
    ],

  },
  {
    "id": 19889,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 21.392310039217538,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19924,
        "lat": 15.16919209222346,
        "lon": 145.7752234789539
      },
      {
        "id": 19925,
        "lat": 15.16927936261988,
        "lon": 145.7750460867192
      }
    ],

  },
  {
    "id": 19890,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.345848655388192,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19925,
        "lat": 15.16927936261988,
        "lon": 145.7750460867192
      },
      {
        "id": 19926,
        "lat": 15.16919518377302,
        "lon": 145.7749712736307
      }
    ],

  },
  {
    "id": 19891,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.845349086866502,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19926,
        "lat": 15.16919518377302,
        "lon": 145.7749712736307
      },
      {
        "id": 19736,
        "lat": 15.16918711287468,
        "lon": 145.7748706780644
      }
    ],

  },
  {
    "id": 19892,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.395942434321544,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19927,
        "lat": 15.16951928063796,
        "lon": 145.7751316119041
      },
      {
        "id": 19928,
        "lat": 15.16951058952176,
        "lon": 145.7750259275257
      }
    ],

  },
  {
    "id": 19893,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 25.831026710213504,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19928,
        "lat": 15.16951058952176,
        "lon": 145.7750259275257
      },
      {
        "id": 19925,
        "lat": 15.16927936261988,
        "lon": 145.7750460867192
      }
    ],

  },
  {
    "id": 19894,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 18.23285580241322,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19929,
        "lat": 15.16982798083055,
        "lon": 145.7751577641984
      },
      {
        "id": 19734,
        "lat": 15.16975793738043,
        "lon": 145.7750043628008
      }
    ],

  },
  {
    "id": 19895,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 27.631945686132024,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19734,
        "lat": 15.16975793738043,
        "lon": 145.7750043628008
      },
      {
        "id": 19928,
        "lat": 15.16951058952176,
        "lon": 145.7750259275257
      }
    ],

  },
  {
    "id": 19896,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.261750410026927,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19930,
        "lat": 15.16912236869187,
        "lon": 145.774255716911
      },
      {
        "id": 19738,
        "lat": 15.1691854827162,
        "lon": 145.7743118847612
      }
    ],

  },
  {
    "id": 19897,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 2.7491964289573283,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19738,
        "lat": 15.1691854827162,
        "lon": 145.7743118847612
      },
      {
        "id": 19931,
        "lat": 15.16920168999472,
        "lon": 145.7742925777058
      }
    ],

  },
  {
    "id": 19898,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 37.280212912999055,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19931,
        "lat": 15.16920168999472,
        "lon": 145.7742925777058
      },
      {
        "id": 19932,
        "lat": 15.16953533665087,
        "lon": 145.7742626596625
      }
    ],

  },
  {
    "id": 19899,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.5184434879035695,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19933,
        "lat": 15.16953022463268,
        "lon": 145.7742022211237
      },
      {
        "id": 19932,
        "lat": 15.16953533665087,
        "lon": 145.7742626596625
      }
    ],

  },
  {
    "id": 19900,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 25.939006400980745,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19932,
        "lat": 15.16953533665087,
        "lon": 145.7742626596625
      },
      {
        "id": 19934,
        "lat": 15.16976748292871,
        "lon": 145.7742418430869
      }
    ],

  },
  {
    "id": 19901,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.78373962267924,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19935,
        "lat": 15.16967208993179,
        "lon": 145.7736034247266
      },
      {
        "id": 18990,
        "lat": 15.16959446242607,
        "lon": 145.7736461244334
      }
    ],

  },
  {
    "id": 19902,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 16.235399357233828,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18990,
        "lat": 15.16959446242607,
        "lon": 145.7736461244334
      },
      {
        "id": 19936,
        "lat": 15.16966351958329,
        "lon": 145.7737792218688
      }
    ],

  },
  {
    "id": 19903,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 6.758420537427982,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19936,
        "lat": 15.16966351958329,
        "lon": 145.7737792218688
      },
      {
        "id": 19937,
        "lat": 15.16969015875129,
        "lon": 145.773835746884
      }
    ],

  },
  {
    "id": 19904,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 6.755995990508387,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19937,
        "lat": 15.16969015875129,
        "lon": 145.773835746884
      },
      {
        "id": 19938,
        "lat": 15.16971245364962,
        "lon": 145.7738942314904
      }
    ],

  },
  {
    "id": 19905,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 6.753946369714816,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19938,
        "lat": 15.16971245364962,
        "lon": 145.7738942314904
      },
      {
        "id": 19939,
        "lat": 15.16973026958476,
        "lon": 145.773954322358
      }
    ],

  },
  {
    "id": 19906,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 6.752321446796604,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19939,
        "lat": 15.16973026958476,
        "lon": 145.773954322358
      },
      {
        "id": 19940,
        "lat": 15.16974349892274,
        "lon": 145.7740156564518
      }
    ],

  },
  {
    "id": 19907,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 6.751160757976897,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19940,
        "lat": 15.16974349892274,
        "lon": 145.7740156564518
      },
      {
        "id": 19941,
        "lat": 15.16975206173878,
        "lon": 145.7740778632258
      }
    ],

  },
  {
    "id": 19908,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.10500726730175,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19941,
        "lat": 15.16975206173878,
        "lon": 145.7740778632258
      },
      {
        "id": 19942,
        "lat": 15.16976411380315,
        "lon": 145.7741991968682
      }
    ],

  },
  {
    "id": 19909,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 38.38824181107424,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19942,
        "lat": 15.16976411380315,
        "lon": 145.7741991968682
      },
      {
        "id": 19732,
        "lat": 15.16979224659706,
        "lon": 145.7745553035117
      }
    ],

  },
  {
    "id": 19910,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 5.482328061438181,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19943,
        "lat": 15.16925593166247,
        "lon": 145.7735243890805
      },
      {
        "id": 19944,
        "lat": 15.16923263820215,
        "lon": 145.7734794309217
      }
    ],

  },
  {
    "id": 19911,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 26.9970233477474,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19944,
        "lat": 15.16923263820215,
        "lon": 145.7734794309217
      },
      {
        "id": 18987,
        "lat": 15.16944690863858,
        "lon": 145.7733617371732
      }
    ],

  },
  {
    "id": 19912,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.100117394623474,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19945,
        "lat": 15.16934382889117,
        "lon": 145.7729481420603
      },
      {
        "id": 19946,
        "lat": 15.16925595050759,
        "lon": 145.7729969630012
      }
    ],

  },
  {
    "id": 19913,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 44.58539612634792,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19946,
        "lat": 15.16925595050759,
        "lon": 145.7729969630012
      },
      {
        "id": 18987,
        "lat": 15.16944690863858,
        "lon": 145.7733617371732
      }
    ],

  },
  {
    "id": 19914,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.903206393115955,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19947,
        "lat": 15.16893292794987,
        "lon": 145.7736659399147
      },
      {
        "id": 19421,
        "lat": 15.16892184700137,
        "lon": 145.773621771394
      }
    ],

  },
  {
    "id": 19915,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 7.633660297509614,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19421,
        "lat": 15.16892184700137,
        "lon": 145.773621771394
      },
      {
        "id": 19948,
        "lat": 15.16898754593944,
        "lon": 145.7736014129184
      }
    ],

  },
  {
    "id": 19916,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 7.631346455863743,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19948,
        "lat": 15.16898754593944,
        "lon": 145.7736014129184
      },
      {
        "id": 19949,
        "lat": 15.16905147728216,
        "lon": 145.7735757734217
      }
    ],

  },
  {
    "id": 19917,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 7.62859458792319,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19949,
        "lat": 15.16905147728216,
        "lon": 145.7735757734217
      },
      {
        "id": 19950,
        "lat": 15.16911324131469,
        "lon": 145.7735450132036
      }
    ],

  },
  {
    "id": 19918,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.043442489507816,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19950,
        "lat": 15.16911324131469,
        "lon": 145.7735450132036
      },
      {
        "id": 19944,
        "lat": 15.16923263820215,
        "lon": 145.7734794309217
      }
    ],

  },
  {
    "id": 19919,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.84282153388559,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19951,
        "lat": 15.16838739920994,
        "lon": 145.7747629271908
      },
      {
        "id": 19741,
        "lat": 15.16841284611166,
        "lon": 145.7747607003985
      }
    ],

  },
  {
    "id": 19920,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 81.96003592543545,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19741,
        "lat": 15.16841284611166,
        "lon": 145.7747607003985
      },
      {
        "id": 19743,
        "lat": 15.16835010708687,
        "lon": 145.7740006390867
      }
    ],

  },
  {
    "id": 19921,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.81055121818392,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19952,
        "lat": 15.16826540882446,
        "lon": 145.7732767736606
      },
      {
        "id": 19001,
        "lat": 15.16829056889139,
        "lon": 145.7732745971433
      }
    ],

  },
  {
    "id": 19922,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 43.069864969899044,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19001,
        "lat": 15.16829056889139,
        "lon": 145.7732745971433
      },
      {
        "id": 19953,
        "lat": 15.16825797421938,
        "lon": 145.772875153366
      }
    ],

  },
  {
    "id": 19923,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.895366407657955,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19954,
        "lat": 15.16837341357875,
        "lon": 145.7728651668514
      },
      {
        "id": 19953,
        "lat": 15.16825797421938,
        "lon": 145.772875153366
      }
    ],

  },
  {
    "id": 19924,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 22.396012499702593,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19953,
        "lat": 15.16825797421938,
        "lon": 145.772875153366
      },
      {
        "id": 19955,
        "lat": 15.16824102495047,
        "lon": 145.7726674455932
      }
    ],

  },
  {
    "id": 19925,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 8.529629177137801,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19955,
        "lat": 15.16824102495047,
        "lon": 145.7726674455932
      },
      {
        "id": 19956,
        "lat": 15.16823798948958,
        "lon": 145.7725881191814
      }
    ],

  },
  {
    "id": 19926,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 8.529677232421374,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19956,
        "lat": 15.16823798948958,
        "lon": 145.7725881191814
      },
      {
        "id": 19957,
        "lat": 15.16824180526387,
        "lon": 145.7725088285033
      }
    ],

  },
  {
    "id": 19927,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 8.5305677225324,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19957,
        "lat": 15.16824180526387,
        "lon": 145.7725088285033
      },
      {
        "id": 19958,
        "lat": 15.16825244214365,
        "lon": 145.7724301996301
      }
    ],

  },
  {
    "id": 19928,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 8.532272287950743,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19958,
        "lat": 15.16825244214365,
        "lon": 145.7724301996301
      },
      {
        "id": 19959,
        "lat": 15.16826981614067,
        "lon": 145.7723528534077
      }
    ],

  },
  {
    "id": 19929,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 5.254760801026564,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19960,
        "lat": 15.16822432345854,
        "lon": 145.772339802562
      },
      {
        "id": 19959,
        "lat": 15.16826981614067,
        "lon": 145.7723528534077
      }
    ],

  },
  {
    "id": 19930,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 7.63246908135998,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19959,
        "lat": 15.16826981614067,
        "lon": 145.7723528534077
      },
      {
        "id": 19961,
        "lat": 15.16829094770749,
        "lon": 145.7722852730234
      }
    ],

  },
  {
    "id": 19931,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 7.634931544095379,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19961,
        "lat": 15.16829094770749,
        "lon": 145.7722852730234
      },
      {
        "id": 19962,
        "lat": 15.16831722425766,
        "lon": 145.7722196336626
      }
    ],

  },
  {
    "id": 19932,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 7.637822443882154,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19962,
        "lat": 15.16831722425766,
        "lon": 145.7722196336626
      },
      {
        "id": 19963,
        "lat": 15.1683484798565,
        "lon": 145.7721563498329
      }
    ],

  },
  {
    "id": 19933,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 7.641068522293808,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19963,
        "lat": 15.1683484798565,
        "lon": 145.7721563498329
      },
      {
        "id": 19964,
        "lat": 15.16838451712762,
        "lon": 145.7720958211668
      }
    ],

  },
  {
    "id": 19934,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 7.644587471904226,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19964,
        "lat": 15.16838451712762,
        "lon": 145.7720958211668
      },
      {
        "id": 19965,
        "lat": 15.16842510849825,
        "lon": 145.7720384298988
      }
    ],

  },
  {
    "id": 19935,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 7.648290242784262,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19965,
        "lat": 15.16842510849825,
        "lon": 145.7720384298988
      },
      {
        "id": 19966,
        "lat": 15.1684699976372,
        "lon": 145.7719845384517
      }
    ],

  },
  {
    "id": 19936,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.730156026201392,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19966,
        "lat": 15.1684699976372,
        "lon": 145.7719845384517
      },
      {
        "id": 19967,
        "lat": 15.16856650106428,
        "lon": 145.7718775914063
      }
    ],

  },
  {
    "id": 19937,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.063027645426084,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19967,
        "lat": 15.16856650106428,
        "lon": 145.7718775914063
      },
      {
        "id": 19968,
        "lat": 15.16864616870803,
        "lon": 145.7718333315579
      }
    ],

  },
  {
    "id": 19938,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 14.386396155300927,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19969,
        "lat": 15.1687554738651,
        "lon": 145.7717618924748
      },
      {
        "id": 19968,
        "lat": 15.16864616870803,
        "lon": 145.7718333315579
      }
    ],

  },
  {
    "id": 19939,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 54.3895025137658,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19968,
        "lat": 15.16864616870803,
        "lon": 145.7718333315579
      },
      {
        "id": 19746,
        "lat": 15.16887930238451,
        "lon": 145.7722782126039
      }
    ],

  },
  {
    "id": 19940,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 13.673182516054158,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19970,
        "lat": 15.16929362030076,
        "lon": 145.771643357422
      },
      {
        "id": 19971,
        "lat": 15.16940071340622,
        "lon": 145.771581037372
      }
    ],

  },
  {
    "id": 19941,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 51.75494729689255,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19971,
        "lat": 15.16940071340622,
        "lon": 145.771581037372
      },
      {
        "id": 19972,
        "lat": 15.16917087188439,
        "lon": 145.7711623116807
      }
    ],

  },
  {
    "id": 19942,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.581571198345461,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19973,
        "lat": 15.16907232876305,
        "lon": 145.7712196564853
      },
      {
        "id": 19972,
        "lat": 15.16917087188439,
        "lon": 145.7711623116807
      }
    ],

  },
  {
    "id": 19943,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 40.09831126959876,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19972,
        "lat": 15.16917087188439,
        "lon": 145.7711623116807
      },
      {
        "id": 19191,
        "lat": 15.16899279645248,
        "lon": 145.7708378951476
      }
    ],

  },
  {
    "id": 19944,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 1.3185932158298548,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19974,
        "lat": 15.16955532172758,
        "lon": 145.7718585532071
      },
      {
        "id": 19751,
        "lat": 15.16954473621365,
        "lon": 145.771864060543
      }
    ],

  },
  {
    "id": 19945,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 23.482819679871955,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19751,
        "lat": 15.16954473621365,
        "lon": 145.771864060543
      },
      {
        "id": 19975,
        "lat": 15.1694491249914,
        "lon": 145.7716692339809
      }
    ],

  },
  {
    "id": 19946,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.901181631568354,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19975,
        "lat": 15.1694491249914,
        "lon": 145.7716692339809
      },
      {
        "id": 19971,
        "lat": 15.16940071340622,
        "lon": 145.771581037372
      }
    ],

  },
  {
    "id": 19947,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.4469108619681212,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19976,
        "lat": 15.16854578504701,
        "lon": 145.7708750416456
      },
      {
        "id": 19050,
        "lat": 15.16855036221596,
        "lon": 145.7708973168411
      }
    ],

  },
  {
    "id": 19948,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 4.347778124261116,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19050,
        "lat": 15.16855036221596,
        "lon": 145.7708973168411
      },
      {
        "id": 19977,
        "lat": 15.16851242527827,
        "lon": 145.7709069374325
      }
    ],

  },
  {
    "id": 19949,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.149449251785358,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19977,
        "lat": 15.16851242527827,
        "lon": 145.7709069374325
      },
      {
        "id": 19978,
        "lat": 15.16845160100576,
        "lon": 145.7709283023089
      }
    ],

  },
  {
    "id": 19950,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.146103670906655,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19978,
        "lat": 15.16845160100576,
        "lon": 145.7709283023089
      },
      {
        "id": 19979,
        "lat": 15.16839338324025,
        "lon": 145.7709563273549
      }
    ],

  },
  {
    "id": 19951,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.142085442916854,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19979,
        "lat": 15.16839338324025,
        "lon": 145.7709563273549
      },
      {
        "id": 19980,
        "lat": 15.16833845753412,
        "lon": 145.7709906825524
      }
    ],

  },
  {
    "id": 19952,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.137582377761129,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19980,
        "lat": 15.16833845753412,
        "lon": 145.7709906825524
      },
      {
        "id": 19981,
        "lat": 15.16828747067265,
        "lon": 145.7710309633426
      }
    ],

  },
  {
    "id": 19953,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.132805137283355,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19981,
        "lat": 15.16828747067265,
        "lon": 145.7710309633426
      },
      {
        "id": 19982,
        "lat": 15.16824102305904,
        "lon": 145.7710766953893
      }
    ],

  },
  {
    "id": 19954,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.5433052964958874,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19982,
        "lat": 15.16824102305904,
        "lon": 145.7710766953893
      },
      {
        "id": 19983,
        "lat": 15.1682376727843,
        "lon": 145.7710803725607
      }
    ],

  },
  {
    "id": 19955,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.714704438570731,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19984,
        "lat": 15.16872464365374,
        "lon": 145.7705511006522
      },
      {
        "id": 19192,
        "lat": 15.16880856470094,
        "lon": 145.7705022645497
      }
    ],

  },
  {
    "id": 19956,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 22.181126591760915,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19985,
        "lat": 15.16852124736685,
        "lon": 145.7699788372223
      },
      {
        "id": 19986,
        "lat": 15.16842274075371,
        "lon": 145.769799381218
      }
    ],

  },
  {
    "id": 19957,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.29713294925306,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19987,
        "lat": 15.16822257891366,
        "lon": 145.7710657934456
      },
      {
        "id": 19983,
        "lat": 15.1682376727843,
        "lon": 145.7710803725607
      }
    ],

  },
  {
    "id": 19958,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 41.37849929795256,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19983,
        "lat": 15.1682376727843,
        "lon": 145.7710803725607
      },
      {
        "id": 19988,
        "lat": 15.16798251341718,
        "lon": 145.7713604280834
      }
    ],

  },
  {
    "id": 19959,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.039252800895481,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19989,
        "lat": 15.16796911402672,
        "lon": 145.771347485643
      },
      {
        "id": 19988,
        "lat": 15.16798251341718,
        "lon": 145.7713604280834
      }
    ],

  },
  {
    "id": 19960,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 51.018018691656096,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19988,
        "lat": 15.16798251341718,
        "lon": 145.7713604280834
      },
      {
        "id": 19990,
        "lat": 15.1676679117437,
        "lon": 145.7717057243011
      }
    ],

  },
  {
    "id": 19961,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.34223407781400556,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19990,
        "lat": 15.1676679117437,
        "lon": 145.7717057243011
      },
      {
        "id": 19991,
        "lat": 15.16766580728739,
        "lon": 145.7717080463602
      }
    ],

  },
  {
    "id": 19962,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 1.310662391549802,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19992,
        "lat": 15.16765715326923,
        "lon": 145.7716997749738
      },
      {
        "id": 19991,
        "lat": 15.16766580728739,
        "lon": 145.7717080463602
      }
    ],

  },
  {
    "id": 19963,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.8366665356006875,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19991,
        "lat": 15.16766580728739,
        "lon": 145.7717080463602
      },
      {
        "id": 19993,
        "lat": 15.16762627849916,
        "lon": 145.771756745539
      }
    ],

  },
  {
    "id": 19964,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.832389772634419,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19993,
        "lat": 15.16762627849916,
        "lon": 145.771756745539
      },
      {
        "id": 19994,
        "lat": 15.16759187991605,
        "lon": 145.771809411267
      }
    ],

  },
  {
    "id": 19965,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.828459849807776,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19994,
        "lat": 15.16759187991605,
        "lon": 145.771809411267
      },
      {
        "id": 19995,
        "lat": 15.16756298416783,
        "lon": 145.7718654730306
      }
    ],

  },
  {
    "id": 19966,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.8250472894319385,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19995,
        "lat": 15.16756298416783,
        "lon": 145.7718654730306
      },
      {
        "id": 19996,
        "lat": 15.16753990427374,
        "lon": 145.7719243235284
      }
    ],

  },
  {
    "id": 19967,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.822300478947647,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19996,
        "lat": 15.16753990427374,
        "lon": 145.7719243235284
      },
      {
        "id": 19997,
        "lat": 15.16752289025178,
        "lon": 145.7719853252505
      }
    ],

  },
  {
    "id": 19968,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.820338991341088,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19997,
        "lat": 15.16752289025178,
        "lon": 145.7719853252505
      },
      {
        "id": 19998,
        "lat": 15.16751212640979,
        "lon": 145.7720478173839
      }
    ],

  },
  {
    "id": 19969,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.819248268705065,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19998,
        "lat": 15.16751212640979,
        "lon": 145.7720478173839
      },
      {
        "id": 19999,
        "lat": 15.16750772934981,
        "lon": 145.7721111229705
      }
    ],

  },
  {
    "id": 19970,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.819075916527432,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19999,
        "lat": 15.16750772934981,
        "lon": 145.7721111229705
      },
      {
        "id": 20000,
        "lat": 15.16750974670393,
        "lon": 145.7721745562408
      }
    ],

  },
  {
    "id": 19971,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.2950355766573114,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20000,
        "lat": 15.16750974670393,
        "lon": 145.7721745562408
      },
      {
        "id": 20001,
        "lat": 15.16751008816515,
        "lon": 145.7721866044295
      }
    ],

  },
  {
    "id": 19972,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 24.362707689552476,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20001,
        "lat": 15.16751008816515,
        "lon": 145.7721866044295
      },
      {
        "id": 20002,
        "lat": 15.16752866567823,
        "lon": 145.7724125388834
      }
    ],

  },
  {
    "id": 19973,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.837889411830554,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20003,
        "lat": 15.16750326223218,
        "lon": 145.7724147532834
      },
      {
        "id": 20002,
        "lat": 15.16752866567823,
        "lon": 145.7724125388834
      }
    ],

  },
  {
    "id": 19974,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 49.37353057297365,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20002,
        "lat": 15.16752866567823,
        "lon": 145.7724125388834
      },
      {
        "id": 20004,
        "lat": 15.16756631422293,
        "lon": 145.7728704183928
      }
    ],

  },
  {
    "id": 19975,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.7471499522083285,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20005,
        "lat": 15.16754172302937,
        "lon": 145.7728725619363
      },
      {
        "id": 20004,
        "lat": 15.16756631422293,
        "lon": 145.7728704183928
      }
    ],

  },
  {
    "id": 19976,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 51.86793053026712,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20004,
        "lat": 15.16756631422293,
        "lon": 145.7728704183928
      },
      {
        "id": 20006,
        "lat": 15.1676058638079,
        "lon": 145.7733514306075
      }
    ],

  },
  {
    "id": 19977,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.722700236994756,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20007,
        "lat": 15.16758149147221,
        "lon": 145.7733535550187
      },
      {
        "id": 20006,
        "lat": 15.1676058638079,
        "lon": 145.7733514306075
      }
    ],

  },
  {
    "id": 19978,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 36.13790197215199,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20006,
        "lat": 15.1676058638079,
        "lon": 145.7733514306075
      },
      {
        "id": 18993,
        "lat": 15.16763341855212,
        "lon": 145.7736865659719
      }
    ],

  },
  {
    "id": 19979,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.160787583697461,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20008,
        "lat": 15.1677892461001,
        "lon": 145.7743250369716
      },
      {
        "id": 18994,
        "lat": 15.16768937658091,
        "lon": 145.7743341850594
      }
    ],

  },
  {
    "id": 19980,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 78.92589029958997,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18994,
        "lat": 15.16768937658091,
        "lon": 145.7743341850594
      },
      {
        "id": 19749,
        "lat": 15.16775259461585,
        "lon": 145.7750658526996
      }
    ],

  },
  {
    "id": 19981,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.524891284473849,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20009,
        "lat": 15.17044145697832,
        "lon": 145.7742938685674
      },
      {
        "id": 20010,
        "lat": 15.17049985858921,
        "lon": 145.7742887021378
      }
    ],

  },
  {
    "id": 19982,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 61.88428546367451,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20010,
        "lat": 15.17049985858921,
        "lon": 145.7742887021378
      },
      {
        "id": 20011,
        "lat": 15.17045197400008,
        "lon": 145.7737148545401
      }
    ],

  },
  {
    "id": 19983,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 91.54868739810152,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20011,
        "lat": 15.17045197400008,
        "lon": 145.7737148545401
      },
      {
        "id": 19370,
        "lat": 15.17008005184042,
        "lon": 145.7729548804272
      }
    ],

  },
  {
    "id": 19984,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.560336472619259,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20012,
        "lat": 15.17047812753092,
        "lon": 145.7747371696674
      },
      {
        "id": 19753,
        "lat": 15.17053684640716,
        "lon": 145.7747319752937
      }
    ],

  },
  {
    "id": 19985,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 47.802990854069996,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19753,
        "lat": 15.17053684640716,
        "lon": 145.7747319752937
      },
      {
        "id": 20010,
        "lat": 15.17049985858921,
        "lon": 145.7742887021378
      }
    ],

  },
  {
    "id": 19986,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.399018187415594,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20013,
        "lat": 15.16808633869437,
        "lon": 145.7779873050839
      },
      {
        "id": 18938,
        "lat": 15.16800216181282,
        "lon": 145.7779941113037
      }
    ],

  },
  {
    "id": 19987,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 56.79843276493635,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18938,
        "lat": 15.16800216181282,
        "lon": 145.7779941113037
      },
      {
        "id": 20014,
        "lat": 15.16804235533779,
        "lon": 145.7785211140771
      }
    ],

  },
  {
    "id": 19988,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.725849064258174,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20015,
        "lat": 15.16812945930771,
        "lon": 145.7785140714
      },
      {
        "id": 20014,
        "lat": 15.16804235533779,
        "lon": 145.7785211140771
      }
    ],

  },
  {
    "id": 19989,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 72.31016184809836,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20014,
        "lat": 15.16804235533779,
        "lon": 145.7785211140771
      },
      {
        "id": 20016,
        "lat": 15.16809352398632,
        "lon": 145.7791920423142
      }
    ],

  },
  {
    "id": 19990,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.347570295877773,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20017,
        "lat": 15.16806354339232,
        "lon": 145.7791944662599
      },
      {
        "id": 20016,
        "lat": 15.16809352398632,
        "lon": 145.7791920423142
      }
    ],

  },
  {
    "id": 19991,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 38.159518754744724,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20016,
        "lat": 15.16809352398632,
        "lon": 145.7791920423142
      },
      {
        "id": 20018,
        "lat": 15.16812052590064,
        "lon": 145.7795461046962
      }
    ],

  },
  {
    "id": 19992,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.007329952723502,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20019,
        "lat": 15.16821910675242,
        "lon": 145.7795381345456
      },
      {
        "id": 20018,
        "lat": 15.16812052590064,
        "lon": 145.7795461046962
      }
    ],

  },
  {
    "id": 19993,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 39.852044295114815,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20018,
        "lat": 15.16812052590064,
        "lon": 145.7795461046962
      },
      {
        "id": 20020,
        "lat": 15.16814872486297,
        "lon": 145.7799158712417
      }
    ],

  },
  {
    "id": 19994,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.913394360200316,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20021,
        "lat": 15.16814752568825,
        "lon": 145.7800174390043
      },
      {
        "id": 20020,
        "lat": 15.16814872486297,
        "lon": 145.7799158712417
      }
    ],

  },
  {
    "id": 19995,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.003058329441923722,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20020,
        "lat": 15.16814872486297,
        "lon": 145.7799158712417
      },
      {
        "id": 20022,
        "lat": 15.16814875233154,
        "lon": 145.7799158707057
      }
    ],

  },
  {
    "id": 19996,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 46.02052268676903,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20022,
        "lat": 15.16814875233154,
        "lon": 145.7799158707057
      },
      {
        "id": 20023,
        "lat": 15.16856208842153,
        "lon": 145.7799078051274
      }
    ],

  },
  {
    "id": 19997,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.482623544185524,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20024,
        "lat": 15.16856268493886,
        "lon": 145.7799402134797
      },
      {
        "id": 20023,
        "lat": 15.16856208842153,
        "lon": 145.7799078051274
      }
    ],

  },
  {
    "id": 19998,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 52.52142662889465,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20023,
        "lat": 15.16856208842153,
        "lon": 145.7799078051274
      },
      {
        "id": 20025,
        "lat": 15.16903381277063,
        "lon": 145.7798986001619
      }
    ],

  },
  {
    "id": 19999,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.666135548303255,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20026,
        "lat": 15.16903444072177,
        "lon": 145.7799327163034
      },
      {
        "id": 20025,
        "lat": 15.16903381277063,
        "lon": 145.7798986001619
      }
    ],

  },
  {
    "id": 20000,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 44.380428626682026,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20025,
        "lat": 15.16903381277063,
        "lon": 145.7798986001619
      },
      {
        "id": 20027,
        "lat": 15.16943241825676,
        "lon": 145.7798908219673
      }
    ],

  },
  {
    "id": 20001,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.925707013345765,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20028,
        "lat": 15.16943054682171,
        "lon": 145.779789149877
      },
      {
        "id": 20027,
        "lat": 15.16943241825676,
        "lon": 145.7798908219673
      }
    ],

  },
  {
    "id": 20002,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 40.413569316269545,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20027,
        "lat": 15.16943241825676,
        "lon": 145.7798908219673
      },
      {
        "id": 19210,
        "lat": 15.16979539515746,
        "lon": 145.7798837389879
      }
    ],

  },
  {
    "id": 20003,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.141539582358352,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20029,
        "lat": 15.16912744252838,
        "lon": 145.7725344073326
      },
      {
        "id": 19747,
        "lat": 15.16903923629887,
        "lon": 145.7725834105796
      }
    ],

  },
  {
    "id": 20004,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 50.5591965327662,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19747,
        "lat": 15.16903923629887,
        "lon": 145.7725834105796
      },
      {
        "id": 19946,
        "lat": 15.16925595050759,
        "lon": 145.7729969630012
      }
    ],

  },
  {
    "id": 20005,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 18.734518505005067,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20030,
        "lat": 15.16775542702886,
        "lon": 145.7820487304826
      },
      {
        "id": 20031,
        "lat": 15.16792328348601,
        "lon": 145.7820361500954
      }
    ],

  },
  {
    "id": 20006,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 177.67905964528333,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20031,
        "lat": 15.16792328348601,
        "lon": 145.7820361500954
      },
      {
        "id": 19437,
        "lat": 15.16807038646431,
        "lon": 145.7836828411848
      }
    ],

  },
  {
    "id": 20007,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 31.212630281182655,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19513,
        "lat": 15.17117472730988,
        "lon": 145.7812215354021
      },
      {
        "id": 20032,
        "lat": 15.17145504446852,
        "lon": 145.7812150132602
      }
    ],

  },
  {
    "id": 20008,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.618127427060312,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20033,
        "lat": 15.17563320887502,
        "lon": 145.7796320279742
      },
      {
        "id": 18852,
        "lat": 15.17554717598832,
        "lon": 145.7796402841962
      }
    ],

  },
  {
    "id": 20009,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.816830861786313,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20034,
        "lat": 15.17528764777444,
        "lon": 145.7792059346237
      },
      {
        "id": 18854,
        "lat": 15.1753440868733,
        "lon": 145.7791813158176
      }
    ],

  },
  {
    "id": 20010,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 38.121885347976864,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18854,
        "lat": 15.1753440868733,
        "lon": 145.7791813158176
      },
      {
        "id": 19316,
        "lat": 15.17520979380672,
        "lon": 145.7788549090887
      }
    ],

  },
  {
    "id": 20011,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.46639784747891,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20035,
        "lat": 15.17621651203379,
        "lon": 145.7790985664607
      },
      {
        "id": 18857,
        "lat": 15.17618798071914,
        "lon": 145.7791114917074
      }
    ],

  },
  {
    "id": 20012,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 64.44349739326422,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18857,
        "lat": 15.17618798071914,
        "lon": 145.7791114917074
      },
      {
        "id": 19321,
        "lat": 15.17595362348693,
        "lon": 145.7785630168139
      }
    ],

  },
  {
    "id": 20013,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.8546353052003495,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20036,
        "lat": 15.17491485225521,
        "lon": 145.7780862534645
      },
      {
        "id": 20037,
        "lat": 15.1748973109123,
        "lon": 145.7780154400966
      }
    ],

  },
  {
    "id": 20014,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 11.675368393090492,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20037,
        "lat": 15.1748973109123,
        "lon": 145.7780154400966
      },
      {
        "id": 20038,
        "lat": 15.17479521798242,
        "lon": 145.7780403327969
      }
    ],

  },
  {
    "id": 20015,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 11.676412803409177,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20038,
        "lat": 15.17479521798242,
        "lon": 145.7780403327969
      },
      {
        "id": 20039,
        "lat": 15.174692353168,
        "lon": 145.7780615911488
      }
    ],

  },
  {
    "id": 20016,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 11.677298197298958,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20039,
        "lat": 15.174692353168,
        "lon": 145.7780615911488
      },
      {
        "id": 20040,
        "lat": 15.17458883846065,
        "lon": 145.7780791899462
      }
    ],

  },
  {
    "id": 20017,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 13.65362052045884,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20040,
        "lat": 15.17458883846065,
        "lon": 145.7780791899462
      },
      {
        "id": 19678,
        "lat": 15.17446755920116,
        "lon": 145.7780981539427
      }
    ],

  },
  {
    "id": 20018,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.016661851769569,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20041,
        "lat": 15.17554332117403,
        "lon": 145.7778431935001
      },
      {
        "id": 20042,
        "lat": 15.17551858762788,
        "lon": 145.7777831224125
      }
    ],

  },
  {
    "id": 20019,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 23.126852750998264,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20042,
        "lat": 15.17551858762788,
        "lon": 145.7777831224125
      },
      {
        "id": 20043,
        "lat": 15.17532713351514,
        "lon": 145.7778666980452
      }
    ],

  },
  {
    "id": 20020,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 12.619533756664074,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20043,
        "lat": 15.17532713351514,
        "lon": 145.7778666980452
      },
      {
        "id": 20044,
        "lat": 15.17522177070078,
        "lon": 145.7779100411564
      }
    ],

  },
  {
    "id": 20021,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 12.621470576122094,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20044,
        "lat": 15.17522177070078,
        "lon": 145.7779100411564
      },
      {
        "id": 20045,
        "lat": 15.17511491354561,
        "lon": 145.7779493145587
      }
    ],

  },
  {
    "id": 20022,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 12.623238414449471,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20045,
        "lat": 15.17511491354561,
        "lon": 145.7779493145587
      },
      {
        "id": 20046,
        "lat": 15.17500671025777,
        "lon": 145.7779844637871
      }
    ],

  },
  {
    "id": 20023,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 12.624827522381093,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20046,
        "lat": 15.17500671025777,
        "lon": 145.7779844637871
      },
      {
        "id": 20037,
        "lat": 15.1748973109123,
        "lon": 145.7780154400966
      }
    ],

  },
  {
    "id": 20024,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.199276023877535,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20047,
        "lat": 15.17614157015115,
        "lon": 145.7775737828563
      },
      {
        "id": 19654,
        "lat": 15.1761197178067,
        "lon": 145.7775207094537
      }
    ],

  },
  {
    "id": 20025,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 72.6140251449354,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19654,
        "lat": 15.1761197178067,
        "lon": 145.7775207094537
      },
      {
        "id": 20042,
        "lat": 15.17551858762788,
        "lon": 145.7777831224125
      }
    ],

  },
  {
    "id": 20026,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.079787624503573,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20048,
        "lat": 15.17373070733998,
        "lon": 145.7758347151085
      },
      {
        "id": 19146,
        "lat": 15.17369849215284,
        "lon": 145.7757890192532
      }
    ],

  },
  {
    "id": 20027,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.159486891303418,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19146,
        "lat": 15.17369849215284,
        "lon": 145.7757890192532
      },
      {
        "id": 20049,
        "lat": 15.17374455955783,
        "lon": 145.775757262785
      }
    ],

  },
  {
    "id": 20028,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.162089747009479,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20049,
        "lat": 15.17374455955783,
        "lon": 145.775757262785
      },
      {
        "id": 20050,
        "lat": 15.17379283258372,
        "lon": 145.7757291937892
      }
    ],

  },
  {
    "id": 20029,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.164463424631043,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20050,
        "lat": 15.17379283258372,
        "lon": 145.7757291937892
      },
      {
        "id": 20051,
        "lat": 15.17384303337761,
        "lon": 145.7757049738298
      }
    ],

  },
  {
    "id": 20030,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 50.925879248284154,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20051,
        "lat": 15.17384303337761,
        "lon": 145.7757049738298
      },
      {
        "id": 20052,
        "lat": 15.17426453944075,
        "lon": 145.7755207417875
      }
    ],

  },
  {
    "id": 20031,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 30.891037579605353,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20052,
        "lat": 15.17426453944075,
        "lon": 145.7755207417875
      },
      {
        "id": 19150,
        "lat": 15.17452405699325,
        "lon": 145.7754189254103
      }
    ],

  },
  {
    "id": 20032,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 8.899821888799734,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20053,
        "lat": 15.17825282908587,
        "lon": 145.7763379012092
      },
      {
        "id": 19374,
        "lat": 15.17819925176281,
        "lon": 145.7762764164534
      }
    ],

  },
  {
    "id": 20033,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 47.210689220806245,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19374,
        "lat": 15.17819925176281,
        "lon": 145.7762764164534
      },
      {
        "id": 19800,
        "lat": 15.17788271045435,
        "lon": 145.7765688645041
      }
    ],

  },
  {
    "id": 20034,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 13.390714577616434,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20054,
        "lat": 15.18189308039362,
        "lon": 145.7733292970872
      },
      {
        "id": 18801,
        "lat": 15.18187072952697,
        "lon": 145.7734517675086
      }
    ],

  },
  {
    "id": 20035,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.3189951896179049,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18801,
        "lat": 15.18187072952697,
        "lon": 145.7734517675086
      },
      {
        "id": 20055,
        "lat": 15.18185908215192,
        "lon": 145.7734495137215
      }
    ],

  },
  {
    "id": 20036,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 21.113411584574838,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20055,
        "lat": 15.18185908215192,
        "lon": 145.7734495137215
      },
      {
        "id": 19607,
        "lat": 15.1816748528619,
        "lon": 145.7734962259326
      }
    ],

  },
  {
    "id": 20037,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.185313292077227,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20056,
        "lat": 15.18214324668269,
        "lon": 145.7727973802392
      },
      {
        "id": 19605,
        "lat": 15.18212838328202,
        "lon": 145.7727322965648
      }
    ],

  },
  {
    "id": 20038,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 11.604189637968284,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19605,
        "lat": 15.18212838328202,
        "lon": 145.7727322965648
      },
      {
        "id": 20057,
        "lat": 15.18222989062842,
        "lon": 145.7727077174746
      }
    ],

  },
  {
    "id": 20039,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 18.25494674639144,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20057,
        "lat": 15.18222989062842,
        "lon": 145.7727077174746
      },
      {
        "id": 20058,
        "lat": 15.18238397119079,
        "lon": 145.7726495544788
      }
    ],

  },
  {
    "id": 20040,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 8.178029863180155,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20058,
        "lat": 15.18238397119079,
        "lon": 145.7726495544788
      },
      {
        "id": 19061,
        "lat": 15.18244963313198,
        "lon": 145.7726154153677
      }
    ],

  },
  {
    "id": 20041,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.077929511342492,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20059,
        "lat": 15.18245075603247,
        "lon": 145.7741741608626
      },
      {
        "id": 18792,
        "lat": 15.18248624066339,
        "lon": 145.7741311645027
      }
    ],

  },
  {
    "id": 20042,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 11.73508260700028,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18792,
        "lat": 15.18248624066339,
        "lon": 145.7741311645027
      },
      {
        "id": 20060,
        "lat": 15.18256678075351,
        "lon": 145.7742016409797
      }
    ],

  },
  {
    "id": 20043,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 27.97543814934507,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20060,
        "lat": 15.18256678075351,
        "lon": 145.7742016409797
      },
      {
        "id": 19613,
        "lat": 15.18269253468938,
        "lon": 145.7744270910675
      }
    ],

  },
  {
    "id": 20044,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.412068653988374,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20061,
        "lat": 15.17988638139546,
        "lon": 145.7715321229327
      },
      {
        "id": 20062,
        "lat": 15.17987312281337,
        "lon": 145.7716280590011
      }
    ],

  },
  {
    "id": 20045,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.07086140646299,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20063,
        "lat": 15.1795509192166,
        "lon": 145.771482967693
      },
      {
        "id": 20064,
        "lat": 15.1795368217456,
        "lon": 145.7715849736705
      }
    ],

  },
  {
    "id": 20046,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 37.318316121208184,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20063,
        "lat": 15.1795509192166,
        "lon": 145.771482967693
      },
      {
        "id": 20065,
        "lat": 15.17988285263833,
        "lon": 145.7715316058637
      }
    ],

  },
  {
    "id": 20047,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.39700662339215576,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20065,
        "lat": 15.17988285263833,
        "lon": 145.7715316058637
      },
      {
        "id": 18822,
        "lat": 15.17988638315949,
        "lon": 145.7715321285037
      }
    ],

  },
  {
    "id": 20048,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 57.141397048253125,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19183,
        "lat": 15.17904266638609,
        "lon": 145.7714084936762
      },
      {
        "id": 20063,
        "lat": 15.1795509192166,
        "lon": 145.771482967693
      }
    ],

  },
  {
    "id": 20049,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.745963534073229,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20066,
        "lat": 15.18090671053049,
        "lon": 145.772290362271
      },
      {
        "id": 20067,
        "lat": 15.18083784693367,
        "lon": 145.7723007043084
      }
    ],

  },
  {
    "id": 20050,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 58.62100895381816,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19185,
        "lat": 15.18043755668111,
        "lon": 145.7716653707138
      },
      {
        "id": 20068,
        "lat": 15.18086360759545,
        "lon": 145.7719860603611
      }
    ],

  },
  {
    "id": 20051,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 33.04287016735207,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20068,
        "lat": 15.18086360759545,
        "lon": 145.7719860603611
      },
      {
        "id": 20066,
        "lat": 15.18090671053049,
        "lon": 145.772290362271
      }
    ],

  },
  {
    "id": 20052,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.7465921347874866,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19561,
        "lat": 15.18098672825395,
        "lon": 145.7728552864049
      },
      {
        "id": 20069,
        "lat": 15.18095342007953,
        "lon": 145.7728602885896
      }
    ],

  },
  {
    "id": 20053,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 61.342710459309906,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20066,
        "lat": 15.18090671053049,
        "lon": 145.772290362271
      },
      {
        "id": 19561,
        "lat": 15.18098672825395,
        "lon": 145.7728552864049
      }
    ],

  },
  {
    "id": 20054,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.028994525043406,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18815,
        "lat": 15.18153943709405,
        "lon": 145.7706956828024
      },
      {
        "id": 20070,
        "lat": 15.18150371954405,
        "lon": 145.7707017419259
      }
    ],

  },
  {
    "id": 20055,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 9.958104666371629,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19053,
        "lat": 15.18154902339041,
        "lon": 145.77111465094
      },
      {
        "id": 20071,
        "lat": 15.18159361375811,
        "lon": 145.7710342971371
      }
    ],

  },
  {
    "id": 20056,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 36.87538859220256,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20071,
        "lat": 15.18159361375811,
        "lon": 145.7710342971371
      },
      {
        "id": 18815,
        "lat": 15.18153943709405,
        "lon": 145.7706956828024
      }
    ],

  },
  {
    "id": 20057,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 8.099963542987268,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19603,
        "lat": 15.18193821978061,
        "lon": 145.7727653025769
      },
      {
        "id": 20072,
        "lat": 15.18192968012052,
        "lon": 145.7726904290697
      }
    ],

  },
  {
    "id": 20058,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.116362235926916,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18790,
        "lat": 15.18174421187209,
        "lon": 145.7727834882309
      },
      {
        "id": 20073,
        "lat": 15.18186172220166,
        "lon": 145.7727745533939
      }
    ],

  },
  {
    "id": 20059,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 8.5734713309159,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20073,
        "lat": 15.18186172220166,
        "lon": 145.7727745533939
      },
      {
        "id": 19603,
        "lat": 15.18193821978061,
        "lon": 145.7727653025769
      }
    ],

  },
  {
    "id": 20060,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.851022548374851,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20074,
        "lat": 15.18144829471781,
        "lon": 145.7749512227911
      },
      {
        "id": 20075,
        "lat": 15.18142740396884,
        "lon": 145.7749115962785
      }
    ],

  },
  {
    "id": 20061,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 44.64112191444815,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19073,
        "lat": 15.18196357828395,
        "lon": 145.7748956079576
      },
      {
        "id": 20076,
        "lat": 15.18156264028758,
        "lon": 145.7748873072469
      }
    ],

  },
  {
    "id": 20062,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 14.46294411320872,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20076,
        "lat": 15.18156264028758,
        "lon": 145.7748873072469
      },
      {
        "id": 18809,
        "lat": 15.18144829471769,
        "lon": 145.7749512227911
      }
    ],

  },
  {
    "id": 20063,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.8081259216402925,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19817,
        "lat": 15.18127692657627,
        "lon": 145.7757446190231
      },
      {
        "id": 20077,
        "lat": 15.18129290342722,
        "lon": 145.7757243918021
      }
    ],

  },
  {
    "id": 20064,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 32.97336774032137,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18811,
        "lat": 15.18122739307322,
        "lon": 145.7751311421929
      },
      {
        "id": 20078,
        "lat": 15.18105009758232,
        "lon": 145.7753770059441
      }
    ],

  },
  {
    "id": 20065,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 24.56192145501745,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20078,
        "lat": 15.18105009758232,
        "lon": 145.7753770059441
      },
      {
        "id": 20079,
        "lat": 15.18110299947027,
        "lon": 145.7755989591442
      }
    ],

  },
  {
    "id": 20066,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 24.894894016113128,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20079,
        "lat": 15.18110299947027,
        "lon": 145.7755989591442
      },
      {
        "id": 19817,
        "lat": 15.18127692657627,
        "lon": 145.7757446190231
      }
    ],

  },
  {
    "id": 20067,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.849169450480394,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19068,
        "lat": 15.18073600148674,
        "lon": 145.7763199567728
      },
      {
        "id": 20080,
        "lat": 15.18069775726254,
        "lon": 145.7763415656843
      }
    ],

  },
  {
    "id": 20068,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 35.310198558341106,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19079,
        "lat": 15.1808893279669,
        "lon": 145.7766076745399
      },
      {
        "id": 19068,
        "lat": 15.18073600148674,
        "lon": 145.7763199567728
      }
    ],

  },
  {
    "id": 20069,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.734459629308974,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19827,
        "lat": 15.18032495421913,
        "lon": 145.7755486303179
      },
      {
        "id": 20081,
        "lat": 15.18029141687538,
        "lon": 145.7755494737846
      }
    ],

  },
  {
    "id": 20070,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 44.7008583678644,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19624,
        "lat": 15.18051905867593,
        "lon": 145.7759128645637
      },
      {
        "id": 19827,
        "lat": 15.18032495421913,
        "lon": 145.7755486303179
      }
    ],

  },
  {
    "id": 20071,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.9737965493372505,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19627,
        "lat": 15.18063657034187,
        "lon": 145.774834402266
      },
      {
        "id": 20082,
        "lat": 15.18060924492655,
        "lon": 145.7748106019206
      }
    ],

  },
  {
    "id": 20072,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 25.394100930654634,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19626,
        "lat": 15.18048870931637,
        "lon": 145.7750143937842
      },
      {
        "id": 19627,
        "lat": 15.18063657034187,
        "lon": 145.774834402266
      }
    ],

  },
  {
    "id": 20073,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.235004631615459,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18911,
        "lat": 15.17080659816666,
        "lon": 145.7831878486204
      },
      {
        "id": 20083,
        "lat": 15.17080973112754,
        "lon": 145.7832457901957
      }
    ],

  },
  {
    "id": 20074,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 54.88771227059794,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20084,
        "lat": 15.17129890995188,
        "lon": 145.7831596269867
      },
      {
        "id": 18911,
        "lat": 15.17080659816666,
        "lon": 145.7831878486204
      }
    ],

  },
  {
    "id": 20075,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.9219804616702785,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20084,
        "lat": 15.17129890995188,
        "lon": 145.7831596269867
      },
      {
        "id": 20085,
        "lat": 15.17130238812205,
        "lon": 145.7832239527417
      }
    ],

  },
  {
    "id": 20076,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 17.339528545883887,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18906,
        "lat": 15.17145443572997,
        "lon": 145.7831507114694
      },
      {
        "id": 20084,
        "lat": 15.17129890995188,
        "lon": 145.7831596269867
      }
    ],

  },
  {
    "id": 20077,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.05801159376543,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18905,
        "lat": 15.17145464371956,
        "lon": 145.7824952541685
      },
      {
        "id": 20086,
        "lat": 15.17134632476411,
        "lon": 145.7824952178934
      }
    ],

  },
  {
    "id": 20078,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 2.9996318965322137,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19510,
        "lat": 15.17145479340467,
        "lon": 145.7820197773763
      },
      {
        "id": 20087,
        "lat": 15.17145478464307,
        "lon": 145.7820476965952
      }
    ],

  },
  {
    "id": 20079,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 48.08544168332898,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20087,
        "lat": 15.17145478464307,
        "lon": 145.7820476965952
      },
      {
        "id": 18905,
        "lat": 15.17145464371956,
        "lon": 145.7824952541685
      }
    ],

  },
  {
    "id": 20080,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.477742858492112,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19509,
        "lat": 15.17145487514178,
        "lon": 145.7817587854604
      },
      {
        "id": 20088,
        "lat": 15.17147713308344,
        "lon": 145.7817587928368
      }
    ],

  },
  {
    "id": 20081,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 58.42271010560459,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20032,
        "lat": 15.17145504446852,
        "lon": 145.7812150132602
      },
      {
        "id": 19509,
        "lat": 15.17145487514178,
        "lon": 145.7817587854604
      }
    ],

  },
  {
    "id": 20082,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 0.2458585560896384,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20089,
        "lat": 15.17189297307008,
        "lon": 145.7812048239901
      },
      {
        "id": 20090,
        "lat": 15.17189292286206,
        "lon": 145.7812025362362
      }
    ],

  },
  {
    "id": 20083,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 48.76227902740206,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20032,
        "lat": 15.17145504446852,
        "lon": 145.7812150132602
      },
      {
        "id": 20089,
        "lat": 15.17189297307008,
        "lon": 145.7812048239901
      }
    ],

  },
  {
    "id": 20084,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.73430771743534,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19514,
        "lat": 15.17250525487579,
        "lon": 145.78119057786
      },
      {
        "id": 20091,
        "lat": 15.17254302931282,
        "lon": 145.7811088645566
      }
    ],

  },
  {
    "id": 20085,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 68.1760823802389,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20089,
        "lat": 15.17189297307008,
        "lon": 145.7812048239901
      },
      {
        "id": 19514,
        "lat": 15.17250525487579,
        "lon": 145.78119057786
      }
    ],

  },
  {
    "id": 20086,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.2825950249123412,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18909,
        "lat": 15.17224168264873,
        "lon": 145.7820200391991
      },
      {
        "id": 20092,
        "lat": 15.17224169223131,
        "lon": 145.7819894861734
      }
    ],

  },
  {
    "id": 20087,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 87.59611447617088,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19510,
        "lat": 15.17145479340467,
        "lon": 145.7820197773763
      },
      {
        "id": 18909,
        "lat": 15.17224168264873,
        "lon": 145.7820200391991
      }
    ],

  },
  {
    "id": 20088,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 14.013943286278156,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19511,
        "lat": 15.17068337651094,
        "lon": 145.7824306187732
      },
      {
        "id": 20093,
        "lat": 15.17078945573527,
        "lon": 145.7825008554216
      }
    ],

  },
  {
    "id": 20089,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 6.549582914365583,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18914,
        "lat": 15.17004552702674,
        "lon": 145.7832200411111
      },
      {
        "id": 20094,
        "lat": 15.17004391275856,
        "lon": 145.783159103904
      }
    ],

  },
  {
    "id": 20090,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 74.6371284633598,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20094,
        "lat": 15.17004391275856,
        "lon": 145.783159103904
      },
      {
        "id": 20095,
        "lat": 15.17002075749622,
        "lon": 145.7824648342606
      }
    ],

  },
  {
    "id": 20091,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 73.85395845801439,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20095,
        "lat": 15.17002075749622,
        "lon": 145.7824648342606
      },
      {
        "id": 19511,
        "lat": 15.17068337651094,
        "lon": 145.7824306187732
      }
    ],

  },
  {
    "id": 20092,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 1.3747172003802597,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20096,
        "lat": 15.17020651579832,
        "lon": 145.7812440626816
      },
      {
        "id": 20097,
        "lat": 15.17020623506268,
        "lon": 145.7812312708163
      }
    ],

  },
  {
    "id": 20093,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 22.016546726197326,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20098,
        "lat": 15.17000878764183,
        "lon": 145.7812486631571
      },
      {
        "id": 18917,
        "lat": 15.17020651579846,
        "lon": 145.7812440626816
      }
    ],

  },
  {
    "id": 20094,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.184752253620937,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18941,
        "lat": 15.1699008335846,
        "lon": 145.7812939921305
      },
      {
        "id": 20099,
        "lat": 15.16981846294568,
        "lon": 145.7812989235277
      }
    ],

  },
  {
    "id": 20095,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 90.86052078837271,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20100,
        "lat": 15.16994850718833,
        "lon": 145.7821382309782
      },
      {
        "id": 18941,
        "lat": 15.1699008335846,
        "lon": 145.7812939921305
      }
    ],

  },
  {
    "id": 20096,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.808577310060128,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20100,
        "lat": 15.16994850718833,
        "lon": 145.7821382309782
      },
      {
        "id": 20101,
        "lat": 15.16988744653355,
        "lon": 145.7821418863403
      }
    ],

  },
  {
    "id": 20097,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 31.187760087737892,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19292,
        "lat": 15.16996487036724,
        "lon": 145.7824280149944
      },
      {
        "id": 20100,
        "lat": 15.16994850718833,
        "lon": 145.7821382309782
      }
    ],

  },
  {
    "id": 20098,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 13.086326589109255,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19287,
        "lat": 15.1697335548818,
        "lon": 145.7832431282902
      },
      {
        "id": 20102,
        "lat": 15.16970749987035,
        "lon": 145.7831243569744
      }
    ],

  },
  {
    "id": 20099,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 2.000731671119384,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20103,
        "lat": 15.16934256530312,
        "lon": 145.7833562919062
      },
      {
        "id": 20104,
        "lat": 15.16935936942281,
        "lon": 145.7833496863303
      }
    ],

  },
  {
    "id": 20100,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 14.458924557186798,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20104,
        "lat": 15.16935936942281,
        "lon": 145.7833496863303
      },
      {
        "id": 20105,
        "lat": 15.16948285190923,
        "lon": 145.7833079501045
      }
    ],

  },
  {
    "id": 20101,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 14.461292176791522,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20105,
        "lat": 15.16948285190923,
        "lon": 145.7833079501045
      },
      {
        "id": 20106,
        "lat": 15.16960812042585,
        "lon": 145.7832723002571
      }
    ],

  },
  {
    "id": 20102,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 14.310740105384081,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20106,
        "lat": 15.16960812042585,
        "lon": 145.7832723002571
      },
      {
        "id": 19287,
        "lat": 15.1697335548818,
        "lon": 145.7832431282902
      }
    ],

  },
  {
    "id": 20103,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 13.296875126874248,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20107,
        "lat": 15.16934233785845,
        "lon": 145.7833554428767
      },
      {
        "id": 20108,
        "lat": 15.16930487234018,
        "lon": 145.7832379281466
      }
    ],

  },
  {
    "id": 20104,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 4.824311406290038,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20109,
        "lat": 15.16841803216411,
        "lon": 145.7836513506849
      },
      {
        "id": 20110,
        "lat": 15.16846111900586,
        "lon": 145.7836465280699
      }
    ],

  },
  {
    "id": 20105,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 12.356316083365861,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20110,
        "lat": 15.16846111900586,
        "lon": 145.7836465280699
      },
      {
        "id": 20111,
        "lat": 15.16857073078257,
        "lon": 145.7836284048237
      }
    ],

  },
  {
    "id": 20106,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 12.35490257102502,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20111,
        "lat": 15.16857073078257,
        "lon": 145.7836284048237
      },
      {
        "id": 20112,
        "lat": 15.16867930410506,
        "lon": 145.7836045583422
      }
    ],

  },
  {
    "id": 20107,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 12.353124831488108,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20112,
        "lat": 15.16867930410506,
        "lon": 145.7836045583422
      },
      {
        "id": 20113,
        "lat": 15.16878655728481,
        "lon": 145.7835750504858
      }
    ],

  },
  {
    "id": 20108,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 12.3510012078393,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20113,
        "lat": 15.16878655728481,
        "lon": 145.7835750504858
      },
      {
        "id": 20114,
        "lat": 15.16889221205834,
        "lon": 145.7835399578027
      }
    ],

  },
  {
    "id": 20109,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 12.348553464907704,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20114,
        "lat": 15.16889221205834,
        "lon": 145.7835399578027
      },
      {
        "id": 20115,
        "lat": 15.16899599430815,
        "lon": 145.7834993713317
      }
    ],

  },
  {
    "id": 20110,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 29.07693789311135,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20115,
        "lat": 15.16899599430815,
        "lon": 145.7834993713317
      },
      {
        "id": 20116,
        "lat": 15.16923795173278,
        "lon": 145.7833974147033
      }
    ],

  },
  {
    "id": 20111,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 12.455497627282645,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20116,
        "lat": 15.16923795173278,
        "lon": 145.7833974147033
      },
      {
        "id": 20103,
        "lat": 15.16934256530312,
        "lon": 145.7833562919062
      }
    ],

  },
  {
    "id": 20112,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.373211367622375,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18945,
        "lat": 15.1691268412849,
        "lon": 145.7818172364219
      },
      {
        "id": 20117,
        "lat": 15.16919299669528,
        "lon": 145.7818138798521
      }
    ],

  },
  {
    "id": 20113,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 46.853490789484525,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20118,
        "lat": 15.16910599587056,
        "lon": 145.7813816852595
      },
      {
        "id": 18945,
        "lat": 15.1691268412849,
        "lon": 145.7818172364219
      }
    ],

  },
  {
    "id": 20114,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 5.9484019976949964,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20118,
        "lat": 15.16910599587056,
        "lon": 145.7813816852595
      },
      {
        "id": 20119,
        "lat": 15.16915936731452,
        "lon": 145.7813789772093
      }
    ],

  },
  {
    "id": 20115,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 79.20899979477208,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18947,
        "lat": 15.16907075337847,
        "lon": 145.7806453567132
      },
      {
        "id": 20118,
        "lat": 15.16910599587056,
        "lon": 145.7813816852595
      }
    ],

  },
  {
    "id": 20116,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.272433672005247,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20120,
        "lat": 15.16862014705172,
        "lon": 145.7828330263739
      },
      {
        "id": 20121,
        "lat": 15.16864382606655,
        "lon": 145.7828860012927
      }
    ],

  },
  {
    "id": 20117,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.551878825561031,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18943,
        "lat": 15.16832247156375,
        "lon": 145.7818311292722
      },
      {
        "id": 20122,
        "lat": 15.16840807170165,
        "lon": 145.781824974836
      }
    ],

  },
  {
    "id": 20118,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.967677363260044,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20120,
        "lat": 15.16862014705172,
        "lon": 145.7828330263739
      },
      {
        "id": 20123,
        "lat": 15.16848970265718,
        "lon": 145.7828948399669
      }
    ],

  },
  {
    "id": 20119,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.560845304910448,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20123,
        "lat": 15.16848970265718,
        "lon": 145.7828948399669
      },
      {
        "id": 20124,
        "lat": 15.16839516923861,
        "lon": 145.7829031086675
      }
    ],

  },
  {
    "id": 20120,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 115.45876500029203,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20124,
        "lat": 15.16839516923861,
        "lon": 145.7829031086675
      },
      {
        "id": 18943,
        "lat": 15.16832247156375,
        "lon": 145.7818311292722
      }
    ],

  },
  {
    "id": 20121,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 16.077806045711043,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19218,
        "lat": 15.16916710721033,
        "lon": 145.7826397404938
      },
      {
        "id": 20125,
        "lat": 15.16902784624627,
        "lon": 145.7826794142284
      }
    ],

  },
  {
    "id": 20122,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 16.075593111248185,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20125,
        "lat": 15.16902784624627,
        "lon": 145.7826794142284
      },
      {
        "id": 20126,
        "lat": 15.1688902529116,
        "lon": 145.7827248396038
      }
    ],

  },
  {
    "id": 20123,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 16.07311487988636,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20126,
        "lat": 15.1688902529116,
        "lon": 145.7827248396038
      },
      {
        "id": 20127,
        "lat": 15.16875455117933,
        "lon": 145.7827759426668
      }
    ],

  },
  {
    "id": 20124,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 16.07038732233665,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20127,
        "lat": 15.16875455117933,
        "lon": 145.7827759426668
      },
      {
        "id": 20128,
        "lat": 15.168620961943,
        "lon": 145.7828326402216
      }
    ],

  },
  {
    "id": 20125,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.09395307226949373,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20128,
        "lat": 15.168620961943,
        "lon": 145.7828326402216
      },
      {
        "id": 20129,
        "lat": 15.16862019441427,
        "lon": 145.7828330039301
      }
    ],

  },
  {
    "id": 20126,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.013798044825645,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20109,
        "lat": 15.16841803216411,
        "lon": 145.7836513506849
      },
      {
        "id": 20130,
        "lat": 15.16840629668796,
        "lon": 145.7835401963417
      }
    ],

  },
  {
    "id": 20127,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 31.316265301475482,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19437,
        "lat": 15.16807038646431,
        "lon": 145.7836828411848
      },
      {
        "id": 20131,
        "lat": 15.16835075315693,
        "lon": 145.7836588810701
      }
    ],

  },
  {
    "id": 20128,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 7.533039481569732,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20131,
        "lat": 15.16835075315693,
        "lon": 145.7836588810701
      },
      {
        "id": 20109,
        "lat": 15.16841803216411,
        "lon": 145.7836513506849
      }
    ],

  },
  {
    "id": 20129,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.784760580764921,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19222,
        "lat": 15.16873418341721,
        "lon": 145.7855529337744
      },
      {
        "id": 20132,
        "lat": 15.16869120137969,
        "lon": 145.7855530689779
      }
    ],

  },
  {
    "id": 20130,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 37.42380422990339,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19226,
        "lat": 15.16873521665154,
        "lon": 145.7859012515316
      },
      {
        "id": 19222,
        "lat": 15.16873418341721,
        "lon": 145.7855529337744
      }
    ],

  },
  {
    "id": 20131,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.826961513331609,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20133,
        "lat": 15.16908157495399,
        "lon": 145.7858546878855
      },
      {
        "id": 20134,
        "lat": 15.16907820594313,
        "lon": 145.7858286086676
      }
    ],

  },
  {
    "id": 20132,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 38.16052794794391,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19225,
        "lat": 15.16874172915539,
        "lon": 145.7859012310568
      },
      {
        "id": 20133,
        "lat": 15.16908157495399,
        "lon": 145.7858546878855
      }
    ],

  },
  {
    "id": 20133,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.0064263602673083,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19335,
        "lat": 15.16805101693675,
        "lon": 145.785554325068
      },
      {
        "id": 20135,
        "lat": 15.16807800135857,
        "lon": 145.7855531763775
      }
    ],

  },
  {
    "id": 20134,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 50.51190159566529,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18902,
        "lat": 15.16806987782062,
        "lon": 145.7860240531967
      },
      {
        "id": 19335,
        "lat": 15.16805101693675,
        "lon": 145.785554325068
      }
    ],

  },
  {
    "id": 20135,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.46482860524154,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18901,
        "lat": 15.16772253401658,
        "lon": 145.7860538814461
      },
      {
        "id": 20136,
        "lat": 15.16771467185019,
        "lon": 145.7859568224999
      }
    ],

  },
  {
    "id": 20136,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 16.396705225909013,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20137,
        "lat": 15.16689153855307,
        "lon": 145.7860547997055
      },
      {
        "id": 20138,
        "lat": 15.16703835104295,
        "lon": 145.7860671307997
      }
    ],

  },
  {
    "id": 20137,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 16.397168249135884,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20138,
        "lat": 15.16703835104295,
        "lon": 145.7860671307997
      },
      {
        "id": 20139,
        "lat": 15.16718549872903,
        "lon": 145.7860740298229
      }
    ],

  },
  {
    "id": 20138,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 16.397369659184516,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20139,
        "lat": 15.16718549872903,
        "lon": 145.7860740298229
      },
      {
        "id": 20140,
        "lat": 15.1673327920844,
        "lon": 145.786075487878
      }
    ],

  },
  {
    "id": 20139,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 16.3973084529075,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20140,
        "lat": 15.1673327920844,
        "lon": 145.786075487878
      },
      {
        "id": 20141,
        "lat": 15.16748004139437,
        "lon": 145.7860715030757
      }
    ],

  },
  {
    "id": 20140,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 16.396984971081476,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20141,
        "lat": 15.16748004139437,
        "lon": 145.7860715030757
      },
      {
        "id": 20142,
        "lat": 15.16762705700085,
        "lon": 145.7860620805371
      }
    ],

  },
  {
    "id": 20141,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 10.664897299729668,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20142,
        "lat": 15.16762705700085,
        "lon": 145.7860620805371
      },
      {
        "id": 18901,
        "lat": 15.16772253401658,
        "lon": 145.7860538814461
      }
    ],

  },
  {
    "id": 20142,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.509924002274208,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18928,
        "lat": 15.17052933445935,
        "lon": 145.779186264895
      },
      {
        "id": 20143,
        "lat": 15.17056071919609,
        "lon": 145.7791831306429
      }
    ],

  },
  {
    "id": 20143,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 50.85038869401884,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20144,
        "lat": 15.17048496176491,
        "lon": 145.7787152128047
      },
      {
        "id": 18928,
        "lat": 15.17052933445935,
        "lon": 145.779186264895
      }
    ],

  },
  {
    "id": 20144,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.89420821196398,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20144,
        "lat": 15.17048496176491,
        "lon": 145.7787152128047
      },
      {
        "id": 20145,
        "lat": 15.17051978265404,
        "lon": 145.778711735323
      }
    ],

  },
  {
    "id": 20145,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 50.54545831276287,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20146,
        "lat": 15.17044085418784,
        "lon": 145.7782469856301
      },
      {
        "id": 20144,
        "lat": 15.17048496176491,
        "lon": 145.7787152128047
      }
    ],

  },
  {
    "id": 20146,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.100556703628059,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20146,
        "lat": 15.17044085418784,
        "lon": 145.7782469856301
      },
      {
        "id": 20147,
        "lat": 15.17047752017833,
        "lon": 145.7782433238021
      }
    ],

  },
  {
    "id": 20147,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 52.67369412450371,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20148,
        "lat": 15.17039488841689,
        "lon": 145.7777590437795
      },
      {
        "id": 20146,
        "lat": 15.17044085418784,
        "lon": 145.7782469856301
      }
    ],

  },
  {
    "id": 20148,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 1.557608489555537,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20148,
        "lat": 15.17039488841689,
        "lon": 145.7777590437795
      },
      {
        "id": 20149,
        "lat": 15.17038096073579,
        "lon": 145.7777604347665
      }
    ],

  },
  {
    "id": 20149,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 41.14465957684937,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19248,
        "lat": 15.17035898274414,
        "lon": 145.7773779010878
      },
      {
        "id": 20148,
        "lat": 15.17039488841689,
        "lon": 145.7777590437795
      }
    ],

  },
  {
    "id": 20150,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.9164931992025,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20150,
        "lat": 15.1710430346695,
        "lon": 145.7783163722016
      },
      {
        "id": 18936,
        "lat": 15.17103774093476,
        "lon": 145.7784271496239
      }
    ],

  },
  {
    "id": 20151,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.482273282784926,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18934,
        "lat": 15.17147186028129,
        "lon": 145.7790268565888
      },
      {
        "id": 20151,
        "lat": 15.17147234101667,
        "lon": 145.7790499551007
      }
    ],

  },
  {
    "id": 20152,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 72.54390006743431,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19186,
        "lat": 15.17212338550107,
        "lon": 145.7790124806775
      },
      {
        "id": 18934,
        "lat": 15.17147186028129,
        "lon": 145.7790268565888
      }
    ],

  },
  {
    "id": 20153,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.244598843984875,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19190,
        "lat": 15.17138432798863,
        "lon": 145.777335241952
      },
      {
        "id": 20152,
        "lat": 15.17131644437333,
        "lon": 145.777270860221
      }
    ],

  },
  {
    "id": 20154,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 1.8439471372222163,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20153,
        "lat": 15.1719966717539,
        "lon": 145.7772126588061
      },
      {
        "id": 20154,
        "lat": 15.17198143384721,
        "lon": 145.7772059290468
      }
    ],

  },
  {
    "id": 20155,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.449846739420314,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20154,
        "lat": 15.17198143384721,
        "lon": 145.7772059290468
      },
      {
        "id": 20155,
        "lat": 15.17192679174033,
        "lon": 145.7771859645779
      }
    ],

  },
  {
    "id": 20156,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.452191694489951,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20155,
        "lat": 15.17192679174033,
        "lon": 145.7771859645779
      },
      {
        "id": 20156,
        "lat": 15.17187038213676,
        "lon": 145.7771721629767
      }
    ],

  },
  {
    "id": 20157,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.453707458317927,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20156,
        "lat": 15.17187038213676,
        "lon": 145.7771721629767
      },
      {
        "id": 20157,
        "lat": 15.17181285860149,
        "lon": 145.777164684144
      }
    ],

  },
  {
    "id": 20158,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.454324586431053,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20157,
        "lat": 15.17181285860149,
        "lon": 145.777164684144
      },
      {
        "id": 20158,
        "lat": 15.17175488760493,
        "lon": 145.777163614725
      }
    ],

  },
  {
    "id": 20159,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.45401485223063,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20158,
        "lat": 15.17175488760493,
        "lon": 145.777163614725
      },
      {
        "id": 20159,
        "lat": 15.17169714080101,
        "lon": 145.7771689671046
      }
    ],

  },
  {
    "id": 20160,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.452792394734329,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20159,
        "lat": 15.17169714080101,
        "lon": 145.7771689671046
      },
      {
        "id": 20160,
        "lat": 15.171640287246,
        "lon": 145.7771806792648
      }
    ],

  },
  {
    "id": 20161,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.450713223766458,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20160,
        "lat": 15.171640287246,
        "lon": 145.7771806792648
      },
      {
        "id": 20161,
        "lat": 15.1715849856464,
        "lon": 145.7771986155036
      }
    ],

  },
  {
    "id": 20162,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.447872673129848,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20161,
        "lat": 15.1715849856464,
        "lon": 145.7771986155036
      },
      {
        "id": 20162,
        "lat": 15.17153187672688,
        "lon": 145.7772225680066
      }
    ],

  },
  {
    "id": 20163,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.444401049136297,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20162,
        "lat": 15.17153187672688,
        "lon": 145.7772225680066
      },
      {
        "id": 20163,
        "lat": 15.17148157580788,
        "lon": 145.7772522592559
      }
    ],

  },
  {
    "id": 20164,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.440457946026203,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20163,
        "lat": 15.17148157580788,
        "lon": 145.7772522592559
      },
      {
        "id": 20164,
        "lat": 15.17143466567557,
        "lon": 145.7772873452452
      }
    ],

  },
  {
    "id": 20165,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.7558798659276738,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20164,
        "lat": 15.17143466567557,
        "lon": 145.7772873452452
      },
      {
        "id": 20165,
        "lat": 15.17140908728449,
        "lon": 145.7773101422731
      }
    ],

  },
  {
    "id": 20166,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 3.7544102818737604,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20165,
        "lat": 15.17140908728449,
        "lon": 145.7773101422731
      },
      {
        "id": 20166,
        "lat": 15.17138494916945,
        "lon": 145.7773345475722
      }
    ],

  },
  {
    "id": 20167,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 0.10172221515220775,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20166,
        "lat": 15.17138494916945,
        "lon": 145.7773345475722
      },
      {
        "id": 19190,
        "lat": 15.17138432798863,
        "lon": 145.777335241952
      }
    ],

  },
  {
    "id": 20168,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 5.04692891570003,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20153,
        "lat": 15.1719966717539,
        "lon": 145.7772126588061
      },
      {
        "id": 20167,
        "lat": 15.17201463817941,
        "lon": 145.777169530041
      }
    ],

  },
  {
    "id": 20169,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 44.67251015047585,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20168,
        "lat": 15.17236583388106,
        "lon": 145.7773756980471
      },
      {
        "id": 20153,
        "lat": 15.1719966717539,
        "lon": 145.7772126588061
      }
    ],

  },
  {
    "id": 20170,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 19.76446951801829,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20169,
        "lat": 15.17239603397389,
        "lon": 145.7775569768646
      },
      {
        "id": 20168,
        "lat": 15.17236583388106,
        "lon": 145.7773756980471
      }
    ],

  },
  {
    "id": 20171,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.075335198453686,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19211,
        "lat": 15.17123734935429,
        "lon": 145.7805941009647
      },
      {
        "id": 20170,
        "lat": 15.17123464004062,
        "lon": 145.7805003664119
      }
    ],

  },
  {
    "id": 20172,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 56.59171795379066,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20171,
        "lat": 15.17072919948827,
        "lon": 145.7806096721686
      },
      {
        "id": 19211,
        "lat": 15.17123734935429,
        "lon": 145.7805941009647
      }
    ],

  },
  {
    "id": 20173,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.767503166174539,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20171,
        "lat": 15.17072919948827,
        "lon": 145.7806096721686
      },
      {
        "id": 20172,
        "lat": 15.17072630406984,
        "lon": 145.7805094983626
      }
    ],

  },
  {
    "id": 20174,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 95.49690070465562,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19217,
        "lat": 15.16987171115711,
        "lon": 145.780635947742
      },
      {
        "id": 20171,
        "lat": 15.17072919948827,
        "lon": 145.7806096721686
      }
    ],

  },
  {
    "id": 20175,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 14.540752025056538,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20173,
        "lat": 15.16945182922347,
        "lon": 145.7844546445983
      },
      {
        "id": 18904,
        "lat": 15.16948109195756,
        "lon": 145.7845865422213
      }
    ],

  },
  {
    "id": 20176,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.396355339169851,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19495,
        "lat": 15.16995264741853,
        "lon": 145.7845720168706
      },
      {
        "id": 20174,
        "lat": 15.17003189803432,
        "lon": 145.7846021210385
      }
    ],

  },
  {
    "id": 20177,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.678163714277248,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19219,
        "lat": 15.16978130718376,
        "lon": 145.7848692078838
      },
      {
        "id": 20175,
        "lat": 15.16982641397563,
        "lon": 145.7848151434678
      }
    ],

  },
  {
    "id": 20178,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.674007014939161,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20175,
        "lat": 15.16982641397563,
        "lon": 145.7848151434678
      },
      {
        "id": 20176,
        "lat": 15.16986667114476,
        "lon": 145.7847571620109
      }
    ],

  },
  {
    "id": 20179,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.6700946203973395,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20176,
        "lat": 15.16986667114476,
        "lon": 145.7847571620109
      },
      {
        "id": 20177,
        "lat": 15.16990175951038,
        "lon": 145.7846957232205
      }
    ],

  },
  {
    "id": 20180,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.666550790778958,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20177,
        "lat": 15.16990175951038,
        "lon": 145.7846957232205
      },
      {
        "id": 20178,
        "lat": 15.1699314008724,
        "lon": 145.7846313142165
      }
    ],

  },
  {
    "id": 20181,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 6.795788729549612,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20178,
        "lat": 15.1699314008724,
        "lon": 145.7846313142165
      },
      {
        "id": 19495,
        "lat": 15.16995264741853,
        "lon": 145.7845720168706
      }
    ],

  },
  {
    "id": 20182,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 14.202844536566001,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20179,
        "lat": 15.16982690575338,
        "lon": 145.7856520838834
      },
      {
        "id": 20180,
        "lat": 15.16988508455962,
        "lon": 145.7857697329811
      }
    ],

  },
  {
    "id": 20183,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 20.9963889731978,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20133,
        "lat": 15.16908157495399,
        "lon": 145.7858546878855
      },
      {
        "id": 20181,
        "lat": 15.16926856226043,
        "lon": 145.7858290791814
      }
    ],

  },
  {
    "id": 20184,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.056916379245848,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20181,
        "lat": 15.16926856226043,
        "lon": 145.7858290791814
      },
      {
        "id": 20182,
        "lat": 15.16937550889727,
        "lon": 145.7858113354264
      }
    ],

  },
  {
    "id": 20185,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.055177871324618,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20182,
        "lat": 15.16937550889727,
        "lon": 145.7858113354264
      },
      {
        "id": 20183,
        "lat": 15.16948117660019,
        "lon": 145.7857867769786
      }
    ],

  },
  {
    "id": 20186,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.05291482877777,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20183,
        "lat": 15.16948117660019,
        "lon": 145.7857867769786
      },
      {
        "id": 20184,
        "lat": 15.1695851561836,
        "lon": 145.7857554989279
      }
    ],

  },
  {
    "id": 20187,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.050162000196389,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20184,
        "lat": 15.1695851561836,
        "lon": 145.7857554989279
      },
      {
        "id": 20185,
        "lat": 15.16968704499848,
        "lon": 145.7857176223853
      }
    ],

  },
  {
    "id": 20188,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.046961627789267,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20185,
        "lat": 15.16968704499848,
        "lon": 145.7857176223853
      },
      {
        "id": 20186,
        "lat": 15.16978644849127,
        "lon": 145.7856732940146
      }
    ],

  },
  {
    "id": 20189,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.04739575207953,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20186,
        "lat": 15.16978644849127,
        "lon": 145.7856732940146
      },
      {
        "id": 20179,
        "lat": 15.16982690575338,
        "lon": 145.7856520838834
      }
    ],

  },
  {
    "id": 20190,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.157162813002262,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20187,
        "lat": 15.17030848391872,
        "lon": 145.7852846348247
      },
      {
        "id": 20188,
        "lat": 15.17038569752035,
        "lon": 145.78536465555
      }
    ],

  },
  {
    "id": 20191,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 6.995967172779851,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20179,
        "lat": 15.16982690575338,
        "lon": 145.7856520838834
      },
      {
        "id": 20189,
        "lat": 15.16988298173233,
        "lon": 145.7856226854643
      }
    ],

  },
  {
    "id": 20192,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.0394212298624,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20189,
        "lat": 15.16988298173233,
        "lon": 145.7856226854643
      },
      {
        "id": 20190,
        "lat": 15.16997627090626,
        "lon": 145.7855659927032
      }
    ],

  },
  {
    "id": 20193,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.0351972425176,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20190,
        "lat": 15.16997627090626,
        "lon": 145.7855659927032
      },
      {
        "id": 20191,
        "lat": 15.17006595475946,
        "lon": 145.7855034352611
      }
    ],

  },
  {
    "id": 20194,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.03075605231744,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20191,
        "lat": 15.17006595475946,
        "lon": 145.7855034352611
      },
      {
        "id": 20192,
        "lat": 15.1701516859993,
        "lon": 145.7854352553794
      }
    ],

  },
  {
    "id": 20195,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.026166180469367,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20192,
        "lat": 15.1701516859993,
        "lon": 145.7854352553794
      },
      {
        "id": 20193,
        "lat": 15.17023313263901,
        "lon": 145.785361717073
      }
    ],

  },
  {
    "id": 20196,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 11.787571234053805,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20193,
        "lat": 15.17023313263901,
        "lon": 145.785361717073
      },
      {
        "id": 20187,
        "lat": 15.17030848391872,
        "lon": 145.7852846348247
      }
    ],

  },
  {
    "id": 20197,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 5.636500553471758,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18869,
        "lat": 15.17070452152597,
        "lon": 145.7845913309099
      },
      {
        "id": 20194,
        "lat": 15.1707530549259,
        "lon": 145.7846062833909
      }
    ],

  },
  {
    "id": 20198,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.2339273015330689,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20187,
        "lat": 15.17030848391872,
        "lon": 145.7852846348247
      },
      {
        "id": 20195,
        "lat": 15.17030997928342,
        "lon": 145.7852831051076
      }
    ],

  },
  {
    "id": 20199,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.016825274331568,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20195,
        "lat": 15.17030997928342,
        "lon": 145.7852831051076
      },
      {
        "id": 20196,
        "lat": 15.17038192834983,
        "lon": 145.7851997238972
      }
    ],

  },
  {
    "id": 20200,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.01221874978963,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20196,
        "lat": 15.17038192834983,
        "lon": 145.7851997238972
      },
      {
        "id": 20197,
        "lat": 15.17044870122124,
        "lon": 145.7851118963256
      }
    ],

  },
  {
    "id": 20201,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.007750363258422,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20197,
        "lat": 15.17044870122124,
        "lon": 145.7851118963256
      },
      {
        "id": 20198,
        "lat": 15.17051003932459,
        "lon": 145.7850199624954
      }
    ],

  },
  {
    "id": 20202,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.003489441089458,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20198,
        "lat": 15.17051003932459,
        "lon": 145.7850199624954
      },
      {
        "id": 20199,
        "lat": 15.17056570513267,
        "lon": 145.7849242784116
      }
    ],

  },
  {
    "id": 20203,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 11.999502178230005,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20199,
        "lat": 15.17056570513267,
        "lon": 145.7849242784116
      },
      {
        "id": 20200,
        "lat": 15.17061548308367,
        "lon": 145.7848252146025
      }
    ],

  },
  {
    "id": 20204,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 11.99585055766234,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20200,
        "lat": 15.17061548308367,
        "lon": 145.7848252146025
      },
      {
        "id": 20201,
        "lat": 15.17065918041585,
        "lon": 145.784723154685
      }
    ],

  },
  {
    "id": 20205,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 11.99259141774877,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20201,
        "lat": 15.17065918041585,
        "lon": 145.784723154685
      },
      {
        "id": 20202,
        "lat": 15.17069662791498,
        "lon": 145.7846184938792
      }
    ],

  },
  {
    "id": 20206,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 3.0478093451678157,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20202,
        "lat": 15.17069662791498,
        "lon": 145.7846184938792
      },
      {
        "id": 18869,
        "lat": 15.17070452152597,
        "lon": 145.7845913309099
      }
    ],

  },
  {
    "id": 20207,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.466540223351682,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19755,
        "lat": 15.17135087636088,
        "lon": 145.7845608679109
      },
      {
        "id": 20203,
        "lat": 15.1714529558349,
        "lon": 145.7845751479082
      }
    ],

  },
  {
    "id": 20208,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.040777545593654,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20204,
        "lat": 15.17111953670537,
        "lon": 145.785321286568
      },
      {
        "id": 20205,
        "lat": 15.17116763456521,
        "lon": 145.7852209063861
      }
    ],

  },
  {
    "id": 20209,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.148479765708819,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20205,
        "lat": 15.17116763456521,
        "lon": 145.7852209063861
      },
      {
        "id": 20206,
        "lat": 15.17121435968186,
        "lon": 145.785108509332
      }
    ],

  },
  {
    "id": 20210,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.145428828913095,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20206,
        "lat": 15.17121435968186,
        "lon": 145.785108509332
      },
      {
        "id": 20207,
        "lat": 15.17125513812202,
        "lon": 145.7849936843874
      }
    ],

  },
  {
    "id": 20211,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.142743642288524,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20207,
        "lat": 15.17125513812202,
        "lon": 145.7849936843874
      },
      {
        "id": 20208,
        "lat": 15.17128985152678,
        "lon": 145.7848767648313
      }
    ],

  },
  {
    "id": 20212,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.140455597931357,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20208,
        "lat": 15.17128985152678,
        "lon": 145.7848767648313
      },
      {
        "id": 20209,
        "lat": 15.17131839914101,
        "lon": 145.7847580900227
      }
    ],

  },
  {
    "id": 20213,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.138591454893813,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20209,
        "lat": 15.17131839914101,
        "lon": 145.7847580900227
      },
      {
        "id": 20210,
        "lat": 15.17134069810596,
        "lon": 145.7846380044156
      }
    ],

  },
  {
    "id": 20214,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 8.36461878391862,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20210,
        "lat": 15.17134069810596,
        "lon": 145.7846380044156
      },
      {
        "id": 19755,
        "lat": 15.17135087636088,
        "lon": 145.7845608679109
      }
    ],

  },
  {
    "id": 20215,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.662334810412409,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18954,
        "lat": 15.17209394453005,
        "lon": 145.7846804138058
      },
      {
        "id": 20211,
        "lat": 15.17200835056068,
        "lon": 145.7846654849376
      }
    ],

  },
  {
    "id": 20216,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 17.118141013244273,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19243,
        "lat": 15.17183377404072,
        "lon": 145.7855906892345
      },
      {
        "id": 20212,
        "lat": 15.17186177407363,
        "lon": 145.7854340245148
      }
    ],

  },
  {
    "id": 20217,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.37023554360094,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20212,
        "lat": 15.17186177407363,
        "lon": 145.7854340245148
      },
      {
        "id": 20213,
        "lat": 15.17192066540811,
        "lon": 145.7852944089121
      }
    ],

  },
  {
    "id": 20218,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.36676618226518,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20213,
        "lat": 15.17192066540811,
        "lon": 145.7852944089121
      },
      {
        "id": 20214,
        "lat": 15.17197292928791,
        "lon": 145.7851520237544
      }
    ],

  },
  {
    "id": 20219,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.36365727485356,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20214,
        "lat": 15.17197292928791,
        "lon": 145.7851520237544
      },
      {
        "id": 20215,
        "lat": 15.17201844336908,
        "lon": 145.7850072023502
      }
    ],

  },
  {
    "id": 20220,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.36093813537831,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20215,
        "lat": 15.17201844336908,
        "lon": 145.7850072023502
      },
      {
        "id": 20216,
        "lat": 15.17205710110887,
        "lon": 145.7848602837117
      }
    ],

  },
  {
    "id": 20221,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 19.75360337061994,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20216,
        "lat": 15.17205710110887,
        "lon": 145.7848602837117
      },
      {
        "id": 20217,
        "lat": 15.17209352874431,
        "lon": 145.7846803412865
      }
    ],

  },
  {
    "id": 20222,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.507582088737916,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19761,
        "lat": 15.17245461884422,
        "lon": 145.7858080823462
      },
      {
        "id": 20218,
        "lat": 15.17254097288491,
        "lon": 145.785847572957
      }
    ],

  },
  {
    "id": 20223,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 36.924854998182745,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19230,
        "lat": 15.17212350104627,
        "lon": 145.7857336689799
      },
      {
        "id": 20219,
        "lat": 15.17242297135941,
        "lon": 145.7858814507916
      }
    ],

  },
  {
    "id": 20224,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 8.634089078843989,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20219,
        "lat": 15.17242297135941,
        "lon": 145.7858814507916
      },
      {
        "id": 19761,
        "lat": 15.17245461884422,
        "lon": 145.7858080823462
      }
    ],

  },
  {
    "id": 20225,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.32615049513648,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18949,
        "lat": 15.17336634170736,
        "lon": 145.7843373518404
      },
      {
        "id": 20220,
        "lat": 15.17337307583725,
        "lon": 145.784278885218
      }
    ],

  },
  {
    "id": 20226,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 65.12295998900659,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19237,
        "lat": 15.1727853532054,
        "lon": 145.784266406175
      },
      {
        "id": 18949,
        "lat": 15.17336634170736,
        "lon": 145.7843373518404
      }
    ],

  },
  {
    "id": 20227,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 13.168713502364373,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19516,
        "lat": 15.17261681539328,
        "lon": 145.7825834260663
      },
      {
        "id": 20221,
        "lat": 15.17272445601212,
        "lon": 145.7825325868412
      }
    ],

  },
  {
    "id": 20228,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.28889480969455794,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19247,
        "lat": 15.17252633916553,
        "lon": 145.782019635389
      },
      {
        "id": 20222,
        "lat": 15.17252640752044,
        "lon": 145.7820223233723
      }
    ],

  },
  {
    "id": 20229,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.849102733988442,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20222,
        "lat": 15.17252640752044,
        "lon": 145.7820223233723
      },
      {
        "id": 20223,
        "lat": 15.17252769293647,
        "lon": 145.782123293655
      }
    ],

  },
  {
    "id": 20230,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.849434618937496,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20223,
        "lat": 15.17252769293647,
        "lon": 145.782123293655
      },
      {
        "id": 20224,
        "lat": 15.17253464430227,
        "lon": 145.7822240186325
      }
    ],

  },
  {
    "id": 20231,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.85021841325105,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20224,
        "lat": 15.17253464430227,
        "lon": 145.7822240186325
      },
      {
        "id": 20225,
        "lat": 15.17254723837537,
        "lon": 145.7823241615094
      }
    ],

  },
  {
    "id": 20232,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.851443518432037,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20225,
        "lat": 15.17254723837537,
        "lon": 145.7823241615094
      },
      {
        "id": 20226,
        "lat": 15.17256543304514,
        "lon": 145.7824233874362
      }
    ],

  },
  {
    "id": 20233,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.853093423854355,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20226,
        "lat": 15.17256543304514,
        "lon": 145.7824233874362
      },
      {
        "id": 20227,
        "lat": 15.17258916747439,
        "lon": 145.7825213646292
      }
    ],

  },
  {
    "id": 20234,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 7.343870852377227,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20227,
        "lat": 15.17258916747439,
        "lon": 145.7825213646292
      },
      {
        "id": 19516,
        "lat": 15.17261681539328,
        "lon": 145.7825834260663
      }
    ],

  },
  {
    "id": 20235,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.407669076674647,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20204,
        "lat": 15.17111953670537,
        "lon": 145.785321286568
      },
      {
        "id": 20228,
        "lat": 15.1712034836871,
        "lon": 145.7853639306877
      }
    ],

  },
  {
    "id": 20236,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.16784999306031,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18963,
        "lat": 15.17085013620181,
        "lon": 145.7857353542206
      },
      {
        "id": 20229,
        "lat": 15.17092423000848,
        "lon": 145.7856398165029
      }
    ],

  },
  {
    "id": 20237,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.163573987252496,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20229,
        "lat": 15.17092423000848,
        "lon": 145.7856398165029
      },
      {
        "id": 20230,
        "lat": 15.17099321923623,
        "lon": 145.7855403087876
      }
    ],

  },
  {
    "id": 20238,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.159452215623478,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20230,
        "lat": 15.17099321923623,
        "lon": 145.7855403087876
      },
      {
        "id": 20231,
        "lat": 15.17105690364476,
        "lon": 145.7854371198917
      }
    ],

  },
  {
    "id": 20239,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.155532599685417,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20231,
        "lat": 15.17105690364476,
        "lon": 145.7854371198917
      },
      {
        "id": 20232,
        "lat": 15.17111509839094,
        "lon": 145.7853305493183
      }
    ],

  },
  {
    "id": 20240,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.1110833017406743,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20232,
        "lat": 15.17111509839094,
        "lon": 145.7853305493183
      },
      {
        "id": 20204,
        "lat": 15.17111953670537,
        "lon": 145.785321286568
      }
    ],

  },
  {
    "id": 20241,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.37656909603569,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19465,
        "lat": 15.17143705082886,
        "lon": 145.7861236292495
      },
      {
        "id": 20233,
        "lat": 15.17150884733489,
        "lon": 145.7861852249224
      }
    ],

  },
  {
    "id": 20242,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 11.312929308392693,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20234,
        "lat": 15.1711147337109,
        "lon": 145.7864660098083
      },
      {
        "id": 20235,
        "lat": 15.1711903645379,
        "lon": 145.7863956780327
      }
    ],

  },
  {
    "id": 20243,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.999697570948271,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20235,
        "lat": 15.1711903645379,
        "lon": 145.7863956780327
      },
      {
        "id": 20236,
        "lat": 15.17129268204942,
        "lon": 145.7862910935302
      }
    ],

  },
  {
    "id": 20244,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.994976868240043,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20236,
        "lat": 15.17129268204942,
        "lon": 145.7862910935302
      },
      {
        "id": 20237,
        "lat": 15.171390094246,
        "lon": 145.786181655797
      }
    ],

  },
  {
    "id": 20245,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 8.135761597467313,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20237,
        "lat": 15.171390094246,
        "lon": 145.786181655797
      },
      {
        "id": 19465,
        "lat": 15.17143705082886,
        "lon": 145.7861236292495
      }
    ],

  },
  {
    "id": 20246,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.016768314968697,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20234,
        "lat": 15.1711147337109,
        "lon": 145.7864660098083
      },
      {
        "id": 20238,
        "lat": 15.17118129450173,
        "lon": 145.786541892367
      }
    ],

  },
  {
    "id": 20247,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.0865110019509478,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20239,
        "lat": 15.1707360850982,
        "lon": 145.7867614156887
      },
      {
        "id": 20240,
        "lat": 15.17073675044634,
        "lon": 145.7867609996157
      }
    ],

  },
  {
    "id": 20248,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.018116959041148,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20240,
        "lat": 15.17073675044634,
        "lon": 145.7867609996157
      },
      {
        "id": 20241,
        "lat": 15.17085630970253,
        "lon": 145.7866780408104
      }
    ],

  },
  {
    "id": 20249,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.01366436434984,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20241,
        "lat": 15.17085630970253,
        "lon": 145.7866780408104
      },
      {
        "id": 20242,
        "lat": 15.17097193520356,
        "lon": 145.7865893672853
      }
    ],

  },
  {
    "id": 20250,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.009083060310246,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20242,
        "lat": 15.17097193520356,
        "lon": 145.7865893672853
      },
      {
        "id": 20243,
        "lat": 15.17108336951619,
        "lon": 145.7864951764582
      }
    ],

  },
  {
    "id": 20251,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 4.691484323005176,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20243,
        "lat": 15.17108336951619,
        "lon": 145.7864951764582
      },
      {
        "id": 20234,
        "lat": 15.1711147337109,
        "lon": 145.7864660098083
      }
    ],

  },
  {
    "id": 20252,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.366877250646036,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20239,
        "lat": 15.1707360850982,
        "lon": 145.7867614156887
      },
      {
        "id": 20244,
        "lat": 15.17079401785153,
        "lon": 145.7868596307284
      }
    ],

  },
  {
    "id": 20253,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 16.02647916688612,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19334,
        "lat": 15.17048690360153,
        "lon": 145.7869090474255
      },
      {
        "id": 20245,
        "lat": 15.17061352362711,
        "lon": 145.7868380590066
      }
    ],

  },
  {
    "id": 20254,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.93589017157368,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20245,
        "lat": 15.17061352362711,
        "lon": 145.7868380590066
      },
      {
        "id": 20239,
        "lat": 15.1707360850982,
        "lon": 145.7867614156887
      }
    ],

  },
  {
    "id": 20255,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.268483994167305,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20246,
        "lat": 15.17131501153206,
        "lon": 145.7872718205931
      },
      {
        "id": 18840,
        "lat": 15.17127528985002,
        "lon": 145.7873131754156
      }
    ],

  },
  {
    "id": 20256,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.138704240370947,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18959,
        "lat": 15.17057436591408,
        "lon": 145.7860165992892
      },
      {
        "id": 20247,
        "lat": 15.17063149544447,
        "lon": 145.7860900923481
      }
    ],

  },
  {
    "id": 20257,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.5767895485563497,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20248,
        "lat": 15.16947125651318,
        "lon": 145.7865190810409
      },
      {
        "id": 20249,
        "lat": 15.16948532417749,
        "lon": 145.7865173675347
      }
    ],

  },
  {
    "id": 20258,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.667335021222467,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20249,
        "lat": 15.16948532417749,
        "lon": 145.7865173675347
      },
      {
        "id": 20250,
        "lat": 15.16960627962478,
        "lon": 145.7864955436975
      }
    ],

  },
  {
    "id": 20259,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.66547876095823,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20250,
        "lat": 15.16960627962478,
        "lon": 145.7864955436975
      },
      {
        "id": 20251,
        "lat": 15.16972586686969,
        "lon": 145.7864668175967
      }
    ],

  },
  {
    "id": 20260,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.663149048323934,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20251,
        "lat": 15.16972586686969,
        "lon": 145.7864668175967
      },
      {
        "id": 20252,
        "lat": 15.1698437146878,
        "lon": 145.7864312783926
      }
    ],

  },
  {
    "id": 20261,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.660374503077044,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20252,
        "lat": 15.1698437146878,
        "lon": 145.7864312783926
      },
      {
        "id": 20253,
        "lat": 15.1699594572534,
        "lon": 145.7863890363961
      }
    ],

  },
  {
    "id": 20262,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.657189341950195,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20253,
        "lat": 15.1699594572534,
        "lon": 145.7863890363961
      },
      {
        "id": 20254,
        "lat": 15.17007273527575,
        "lon": 145.7863402227251
      }
    ],

  },
  {
    "id": 20263,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.653632763698079,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20254,
        "lat": 15.17007273527575,
        "lon": 145.7863402227251
      },
      {
        "id": 20255,
        "lat": 15.17018319711383,
        "lon": 145.7862849888987
      }
    ],

  },
  {
    "id": 20264,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.649748658587818,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20255,
        "lat": 15.17018319711383,
        "lon": 145.7862849888987
      },
      {
        "id": 20256,
        "lat": 15.17029049986844,
        "lon": 145.786223506366
      }
    ],

  },
  {
    "id": 20265,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.645584928201417,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20256,
        "lat": 15.17029049986844,
        "lon": 145.786223506366
      },
      {
        "id": 20257,
        "lat": 15.17039431044621,
        "lon": 145.7861559659746
      }
    ],

  },
  {
    "id": 20266,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 13.641193007137922,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20257,
        "lat": 15.17039431044621,
        "lon": 145.7861559659746
      },
      {
        "id": 20258,
        "lat": 15.17049430659418,
        "lon": 145.7860825773782
      }
    ],

  },
  {
    "id": 20267,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 11.387547734539233,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20258,
        "lat": 15.17049430659418,
        "lon": 145.7860825773782
      },
      {
        "id": 18959,
        "lat": 15.17057436591408,
        "lon": 145.7860165992892
      }
    ],

  },
  {
    "id": 20268,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.77222645845452,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20259,
        "lat": 15.16988459897952,
        "lon": 145.7864163570594
      },
      {
        "id": 20260,
        "lat": 15.16992314450252,
        "lon": 145.7865283250137
      }
    ],

  },
  {
    "id": 20269,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 13.072302433294992,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20248,
        "lat": 15.16947125651318,
        "lon": 145.7865190810409
      },
      {
        "id": 20261,
        "lat": 15.16949160565361,
        "lon": 145.7866389103051
      }
    ],

  },
  {
    "id": 20270,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 69.20671607968583,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19224,
        "lat": 15.16874714951238,
        "lon": 145.7866174652485
      },
      {
        "id": 20262,
        "lat": 15.16936337599889,
        "lon": 145.7865322213739
      }
    ],

  },
  {
    "id": 20271,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.091905426868568,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20262,
        "lat": 15.16936337599889,
        "lon": 145.7865322213739
      },
      {
        "id": 20248,
        "lat": 15.16947125651318,
        "lon": 145.7865190810409
      }
    ],

  },
  {
    "id": 20272,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.67263024281481,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19461,
        "lat": 15.16997076587246,
        "lon": 145.7871236570347
      },
      {
        "id": 20263,
        "lat": 15.17000862633371,
        "lon": 145.7872348932103
      }
    ],

  },
  {
    "id": 20273,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.8952172347100267,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20264,
        "lat": 15.1695555177308,
        "lon": 145.7872203710574
      },
      {
        "id": 20265,
        "lat": 15.16956348949051,
        "lon": 145.7872192731935
      }
    ],

  },
  {
    "id": 20274,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.508177899741655,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20265,
        "lat": 15.16956348949051,
        "lon": 145.7872192731935
      },
      {
        "id": 20266,
        "lat": 15.16970061342757,
        "lon": 145.7871937894522
      }
    ],

  },
  {
    "id": 20275,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.506453269000469,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20266,
        "lat": 15.16970061342757,
        "lon": 145.7871937894522
      },
      {
        "id": 20267,
        "lat": 15.16983646639586,
        "lon": 145.7871618952941
      }
    ],

  },
  {
    "id": 20276,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 15.504366871963938,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20267,
        "lat": 15.16983646639586,
        "lon": 145.7871618952941
      },
      {
        "id": 19461,
        "lat": 15.16997076587246,
        "lon": 145.7871236570347
      }
    ],

  },
  {
    "id": 20277,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.4740584346830903,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20264,
        "lat": 15.1695555177308,
        "lon": 145.7872203710574
      },
      {
        "id": 20268,
        "lat": 15.16955255311803,
        "lon": 145.7871975496303
      }
    ],

  },
  {
    "id": 20278,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 78.34795505203402,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19363,
        "lat": 15.1687318940286,
        "lon": 145.7873627480707
      },
      {
        "id": 20269,
        "lat": 15.16942537975019,
        "lon": 145.7872382935335
      }
    ],

  },
  {
    "id": 20279,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 14.61430930471768,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20269,
        "lat": 15.16942537975019,
        "lon": 145.7872382935335
      },
      {
        "id": 20264,
        "lat": 15.1695555177308,
        "lon": 145.7872203710574
      }
    ],

  },
  {
    "id": 20280,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.127492340426222,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18836,
        "lat": 15.169122918609,
        "lon": 145.7879810395282
      },
      {
        "id": 20270,
        "lat": 15.16912078317384,
        "lon": 145.7879613620045
      }
    ],

  },
  {
    "id": 20281,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.723279073261045,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20271,
        "lat": 15.16959895666456,
        "lon": 145.7879239096314
      },
      {
        "id": 20272,
        "lat": 15.16945884297002,
        "lon": 145.7879423916442
      }
    ],

  },
  {
    "id": 20282,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 37.62476288656785,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20272,
        "lat": 15.16945884297002,
        "lon": 145.7879423916442
      },
      {
        "id": 18836,
        "lat": 15.169122918609,
        "lon": 145.7879810395282
      }
    ],

  },
  {
    "id": 20283,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.730220027913747,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20271,
        "lat": 15.16959895666456,
        "lon": 145.7879239096314
      },
      {
        "id": 20273,
        "lat": 15.16961357799823,
        "lon": 145.7880414232883
      }
    ],

  },
  {
    "id": 20284,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 9.74518769766904,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20274,
        "lat": 15.17006433864802,
        "lon": 145.7878328259578
      },
      {
        "id": 20275,
        "lat": 15.1699791962799,
        "lon": 145.7878539194872
      }
    ],

  },
  {
    "id": 20285,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.57373219459507,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20275,
        "lat": 15.1699791962799,
        "lon": 145.7878539194872
      },
      {
        "id": 20276,
        "lat": 15.16980682123968,
        "lon": 145.7878898766317
      }
    ],

  },
  {
    "id": 20286,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.575301638405854,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20276,
        "lat": 15.16980682123968,
        "lon": 145.7878898766317
      },
      {
        "id": 20277,
        "lat": 15.16963329419508,
        "lon": 145.7879193802573
      }
    ],

  },
  {
    "id": 20287,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 3.8532891605815256,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20277,
        "lat": 15.16963329419508,
        "lon": 145.7879193802573
      },
      {
        "id": 20271,
        "lat": 15.16959895666456,
        "lon": 145.7879239096314
      }
    ],

  },
  {
    "id": 20288,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.804398291278192,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20274,
        "lat": 15.17006433864802,
        "lon": 145.7878328259578
      },
      {
        "id": 20278,
        "lat": 15.17009140643339,
        "lon": 145.7879486559225
      }
    ],

  },
  {
    "id": 20289,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.561680737546602,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19559,
        "lat": 15.17081593998499,
        "lon": 145.7875792755214
      },
      {
        "id": 20279,
        "lat": 15.17065267905991,
        "lon": 145.7876466252997
      }
    ],

  },
  {
    "id": 20290,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.5646119909437,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20279,
        "lat": 15.17065267905991,
        "lon": 145.7876466252997
      },
      {
        "id": 20280,
        "lat": 15.1704871555951,
        "lon": 145.7877078408532
      }
    ],

  },
  {
    "id": 20291,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.56729607709979,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20280,
        "lat": 15.1704871555951,
        "lon": 145.7877078408532
      },
      {
        "id": 20281,
        "lat": 15.17031958690863,
        "lon": 145.7877628418245
      }
    ],

  },
  {
    "id": 20292,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.56971897578761,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20281,
        "lat": 15.17031958690863,
        "lon": 145.7877628418245
      },
      {
        "id": 20282,
        "lat": 15.1701501930039,
        "lon": 145.7878115560168
      }
    ],

  },
  {
    "id": 20293,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 9.826680382627023,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20282,
        "lat": 15.1701501930039,
        "lon": 145.7878115560168
      },
      {
        "id": 20274,
        "lat": 15.17006433864802,
        "lon": 145.7878328259578
      }
    ],

  },
  {
    "id": 20294,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.265654050410548,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18834,
        "lat": 15.17024222991939,
        "lon": 145.7883938303796
      },
      {
        "id": 20283,
        "lat": 15.17027010726619,
        "lon": 145.7884946286881
      }
    ],

  },
  {
    "id": 20295,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 59.08614516909545,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20284,
        "lat": 15.17075295370442,
        "lon": 145.7882440833974
      },
      {
        "id": 18834,
        "lat": 15.17024222991939,
        "lon": 145.7883938303796
      }
    ],

  },
  {
    "id": 20296,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 8.470666423654096,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20284,
        "lat": 15.17075295370442,
        "lon": 145.7882440833974
      },
      {
        "id": 20285,
        "lat": 15.1707739148011,
        "lon": 145.7883198739967
      }
    ],

  },
  {
    "id": 20297,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 64.78813807281989,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19559,
        "lat": 15.17081593998499,
        "lon": 145.7875792755214
      },
      {
        "id": 20286,
        "lat": 15.17108113065381,
        "lon": 145.7881160559882
      }
    ],

  },
  {
    "id": 20298,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 17.206251579507896,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20286,
        "lat": 15.17108113065381,
        "lon": 145.7881160559882
      },
      {
        "id": 20287,
        "lat": 15.17094318764929,
        "lon": 145.7881883055541
      }
    ],

  },
  {
    "id": 20299,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 22.00835893915096,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20287,
        "lat": 15.17094318764929,
        "lon": 145.7881883055541
      },
      {
        "id": 20284,
        "lat": 15.17075295370442,
        "lon": 145.7882440833974
      }
    ],

  },
  {
    "id": 20300,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.712046849546716,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20288,
        "lat": 15.16936644968364,
        "lon": 145.7892412642503
      },
      {
        "id": 20289,
        "lat": 15.16947142369705,
        "lon": 145.7892485783888
      }
    ],

  },
  {
    "id": 20301,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 20.194412943854033,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18835,
        "lat": 15.1695476763782,
        "lon": 145.7885974758645
      },
      {
        "id": 20290,
        "lat": 15.16937312156013,
        "lon": 145.788648655744
      }
    ],

  },
  {
    "id": 20302,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.53857566392986,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20290,
        "lat": 15.16937312156013,
        "lon": 145.788648655744
      },
      {
        "id": 20291,
        "lat": 15.1693991996011,
        "lon": 145.7887429482388
      }
    ],

  },
  {
    "id": 20303,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 53.66341543823171,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20291,
        "lat": 15.1693991996011,
        "lon": 145.7887429482388
      },
      {
        "id": 20288,
        "lat": 15.16936644968364,
        "lon": 145.7892412642503
      }
    ],

  },
  {
    "id": 20304,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.745250661903777,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20292,
        "lat": 15.16920468122951,
        "lon": 145.7894939831236
      },
      {
        "id": 20293,
        "lat": 15.16919081627034,
        "lon": 145.7895357477517
      }
    ],

  },
  {
    "id": 20305,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 30.722616229524697,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20288,
        "lat": 15.16936644968364,
        "lon": 145.7892412642503
      },
      {
        "id": 20294,
        "lat": 15.16934769966763,
        "lon": 145.7895265529839
      }
    ],

  },
  {
    "id": 20306,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 7.021885516655256,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20294,
        "lat": 15.16934769966763,
        "lon": 145.7895265529839
      },
      {
        "id": 20295,
        "lat": 15.16928476315049,
        "lon": 145.7895221677511
      }
    ],

  },
  {
    "id": 20307,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 9.414954203788692,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20295,
        "lat": 15.16928476315049,
        "lon": 145.7895221677511
      },
      {
        "id": 20292,
        "lat": 15.16920468122951,
        "lon": 145.7894939831236
      }
    ],

  },
  {
    "id": 20308,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.36738887969304,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19798,
        "lat": 15.16871725275211,
        "lon": 145.7889225488746
      },
      {
        "id": 20296,
        "lat": 15.16881037698648,
        "lon": 145.7889237819555
      }
    ],

  },
  {
    "id": 20309,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 32.35203618366155,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20292,
        "lat": 15.16920468122951,
        "lon": 145.7894939831236
      },
      {
        "id": 20297,
        "lat": 15.16892950055979,
        "lon": 145.7893971341429
      }
    ],

  },
  {
    "id": 20310,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.857142686752368,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20297,
        "lat": 15.16892950055979,
        "lon": 145.7893971341429
      },
      {
        "id": 20298,
        "lat": 15.16888924681011,
        "lon": 145.7893796911203
      }
    ],

  },
  {
    "id": 20311,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.8537930412885455,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20298,
        "lat": 15.16888924681011,
        "lon": 145.7893796911203
      },
      {
        "id": 20299,
        "lat": 15.16885170566026,
        "lon": 145.7893567133453
      }
    ],

  },
  {
    "id": 20312,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.849893180639843,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20299,
        "lat": 15.16885170566026,
        "lon": 145.7893567133453
      },
      {
        "id": 20300,
        "lat": 15.16881759066416,
        "lon": 145.7893286375652
      }
    ],

  },
  {
    "id": 20313,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.845737239644281,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20300,
        "lat": 15.16881759066416,
        "lon": 145.7893286375652
      },
      {
        "id": 20301,
        "lat": 15.16878755025374,
        "lon": 145.7892959974255
      }
    ],

  },
  {
    "id": 20314,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.84163947838038,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20301,
        "lat": 15.16878755025374,
        "lon": 145.7892959974255
      },
      {
        "id": 20302,
        "lat": 15.16876215541359,
        "lon": 145.7892594133267
      }
    ],

  },
  {
    "id": 20315,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.837910464219291,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20302,
        "lat": 15.16876215541359,
        "lon": 145.7892594133267
      },
      {
        "id": 20303,
        "lat": 15.16874188882914,
        "lon": 145.7892195806321
      }
    ],

  },
  {
    "id": 20316,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.834833528014873,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20303,
        "lat": 15.16874188882914,
        "lon": 145.7892195806321
      },
      {
        "id": 20304,
        "lat": 15.16872713571124,
        "lon": 145.7891772564512
      }
    ],

  },
  {
    "id": 20317,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.832642889070459,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20304,
        "lat": 15.16872713571124,
        "lon": 145.7891772564512
      },
      {
        "id": 20305,
        "lat": 15.16871817647541,
        "lon": 145.7891332452492
      }
    ],

  },
  {
    "id": 20318,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.831505630131445,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20305,
        "lat": 15.16871817647541,
        "lon": 145.7891332452492
      },
      {
        "id": 20306,
        "lat": 15.16871518141124,
        "lon": 145.789088383556
      }
    ],

  },
  {
    "id": 20319,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 17.818946702828708,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20306,
        "lat": 15.16871518141124,
        "lon": 145.789088383556
      },
      {
        "id": 19798,
        "lat": 15.16871725275211,
        "lon": 145.7889225488746
      }
    ],

  },
  {
    "id": 20320,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.675228870304197,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20307,
        "lat": 15.1677089813657,
        "lon": 145.7866844499136
      },
      {
        "id": 20308,
        "lat": 15.16771459115832,
        "lon": 145.7868022798704
      }
    ],

  },
  {
    "id": 20321,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 9.650087247096373,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18916,
        "lat": 15.16809594221736,
        "lon": 145.786668442845
      },
      {
        "id": 20309,
        "lat": 15.16800925790272,
        "lon": 145.7866692941583
      }
    ],

  },
  {
    "id": 20322,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 33.46626988604597,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20309,
        "lat": 15.16800925790272,
        "lon": 145.7866692941583
      },
      {
        "id": 20307,
        "lat": 15.1677089813657,
        "lon": 145.7866844499136
      }
    ],

  },
  {
    "id": 20323,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.624542229470084,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18886,
        "lat": 15.16693102262969,
        "lon": 145.7866511244463
      },
      {
        "id": 20310,
        "lat": 15.16691444608886,
        "lon": 145.7867673634998
      }
    ],

  },
  {
    "id": 20324,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 7.602374620660449,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20307,
        "lat": 15.1677089813657,
        "lon": 145.7866844499136
      },
      {
        "id": 20311,
        "lat": 15.16764076896127,
        "lon": 145.7866878927644
      }
    ],

  },
  {
    "id": 20325,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 16.792811803492608,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20311,
        "lat": 15.16764076896127,
        "lon": 145.7866878927644
      },
      {
        "id": 20312,
        "lat": 15.16749000539305,
        "lon": 145.7866932556412
      }
    ],

  },
  {
    "id": 20326,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 16.792924928203213,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20312,
        "lat": 15.16749000539305,
        "lon": 145.7866932556412
      },
      {
        "id": 20313,
        "lat": 15.16733916026772,
        "lon": 145.7866916174825
      }
    ],

  },
  {
    "id": 20327,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 16.792613867961474,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20313,
        "lat": 15.16733916026772,
        "lon": 145.7866916174825
      },
      {
        "id": 20314,
        "lat": 15.16718854009672,
        "lon": 145.7866829816321
      }
    ],

  },
  {
    "id": 20328,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 16.79188112648761,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20314,
        "lat": 15.16718854009672,
        "lon": 145.7866829816321
      },
      {
        "id": 20315,
        "lat": 15.1670384509338,
        "lon": 145.7866673656521
      }
    ],

  },
  {
    "id": 20329,
    "diameter": "DIAM_250",
    "diameterMm": 250,
    "length": 12.085504107714858,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20315,
        "lat": 15.1670384509338,
        "lon": 145.7866673656521
      },
      {
        "id": 18886,
        "lat": 15.16693102262969,
        "lon": 145.7866511244463
      }
    ],

  },
  {
    "id": 20330,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 13.670049676846542,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20316,
        "lat": 15.16677067470983,
        "lon": 145.7860773047199
      },
      {
        "id": 20137,
        "lat": 15.16689153855307,
        "lon": 145.7860547997055
      }
    ],

  },
  {
    "id": 20331,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.899240869633589,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19356,
        "lat": 15.16720223958831,
        "lon": 145.7853242627633
      },
      {
        "id": 20317,
        "lat": 15.16720982417038,
        "lon": 145.7854160628471
      }
    ],

  },
  {
    "id": 20332,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 9.91085385293923,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19336,
        "lat": 15.1680387148605,
        "lon": 145.7852479564218
      },
      {
        "id": 20318,
        "lat": 15.16795029471681,
        "lon": 145.7852587410867
      }
    ],

  },
  {
    "id": 20333,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 83.57015029768212,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20318,
        "lat": 15.16795029471681,
        "lon": 145.7852587410867
      },
      {
        "id": 19356,
        "lat": 15.16720223958831,
        "lon": 145.7853242627633
      }
    ],

  },
  {
    "id": 20334,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 16.73367702084288,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19725,
        "lat": 15.16824264783799,
        "lon": 145.7806541582349
      },
      {
        "id": 20319,
        "lat": 15.16811497191288,
        "lon": 145.7805719512863
      }
    ],

  },
  {
    "id": 20335,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 30.903643018314895,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18944,
        "lat": 15.16826210806103,
        "lon": 145.7809410834857
      },
      {
        "id": 19725,
        "lat": 15.16824264783799,
        "lon": 145.7806541582349
      }
    ],

  },
  {
    "id": 20336,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.847286686842287,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18899,
        "lat": 15.16682940588117,
        "lon": 145.7844844824263
      },
      {
        "id": 20320,
        "lat": 15.16675893685772,
        "lon": 145.7844864020589
      }
    ],

  },
  {
    "id": 20337,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 69.99710844173504,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19360,
        "lat": 15.16681267038132,
        "lon": 145.7838332259928
      },
      {
        "id": 18899,
        "lat": 15.16682940588117,
        "lon": 145.7844844824263
      }
    ],

  },
  {
    "id": 20338,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 1.9964155534004118,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19293,
        "lat": 15.1661046470433,
        "lon": 145.7860877614076
      },
      {
        "id": 20321,
        "lat": 15.16612095821094,
        "lon": 145.78609548549
      }
    ],

  },
  {
    "id": 20339,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 31.300429975061544,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18866,
        "lat": 15.16613290337299,
        "lon": 145.7854250676562
      },
      {
        "id": 20322,
        "lat": 15.16615917006482,
        "lon": 145.7857151166822
      }
    ],

  },
  {
    "id": 20340,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.82512478594227,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20322,
        "lat": 15.16615917006482,
        "lon": 145.7857151166822
      },
      {
        "id": 20323,
        "lat": 15.16616340300507,
        "lon": 145.7857878154218
      }
    ],

  },
  {
    "id": 20341,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.825020782927405,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20323,
        "lat": 15.16616340300507,
        "lon": 145.7857878154218
      },
      {
        "id": 20324,
        "lat": 15.16616069371669,
        "lon": 145.7858605912453
      }
    ],

  },
  {
    "id": 20342,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.825861197211353,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20324,
        "lat": 15.16616069371669,
        "lon": 145.7858605912453
      },
      {
        "id": 20325,
        "lat": 15.16615106829988,
        "lon": 145.7859327430525
      }
    ],

  },
  {
    "id": 20343,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.8276133982874505,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20325,
        "lat": 15.16615106829988,
        "lon": 145.7859327430525
      },
      {
        "id": 20326,
        "lat": 15.16613461948205,
        "lon": 145.7860035757545
      }
    ],

  },
  {
    "id": 20344,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.830209457545068,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20326,
        "lat": 15.16613461948205,
        "lon": 145.7860035757545
      },
      {
        "id": 20327,
        "lat": 15.1661115057261,
        "lon": 145.7860724069707
      }
    ],

  },
  {
    "id": 20345,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.8178304455411518,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20327,
        "lat": 15.1661115057261,
        "lon": 145.7860724069707
      },
      {
        "id": 19293,
        "lat": 15.1661046470433,
        "lon": 145.7860877614076
      }
    ],

  },
  {
    "id": 20346,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.5474808101286635,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18865,
        "lat": 15.16609584490688,
        "lon": 145.7849577162225
      },
      {
        "id": 20328,
        "lat": 15.16612760809356,
        "lon": 145.7849550461156
      }
    ],

  },
  {
    "id": 20347,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 85.50808460363098,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20329,
        "lat": 15.16603294791557,
        "lon": 145.7841645383556
      },
      {
        "id": 18865,
        "lat": 15.16609584490688,
        "lon": 145.7849577162225
      }
    ],

  },
  {
    "id": 20348,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.285190377367025,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20329,
        "lat": 15.16603294791557,
        "lon": 145.7841645383556
      },
      {
        "id": 20330,
        "lat": 15.16606236261589,
        "lon": 145.7841620655603
      }
    ],

  },
  {
    "id": 20349,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 28.350825171243425,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19358,
        "lat": 15.16601209334991,
        "lon": 145.7839015545895
      },
      {
        "id": 20329,
        "lat": 15.16603294791557,
        "lon": 145.7841645383556
      }
    ],

  },
  {
    "id": 20350,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.855806087324666,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19518,
        "lat": 15.16522088133972,
        "lon": 145.7844719561525
      },
      {
        "id": 20331,
        "lat": 15.16531822905207,
        "lon": 145.7844659639195
      }
    ],

  },
  {
    "id": 20351,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 53.616361483695115,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19361,
        "lat": 15.16519195756576,
        "lon": 145.7839738346185
      },
      {
        "id": 19518,
        "lat": 15.16522088133972,
        "lon": 145.7844719561525
      }
    ],

  },
  {
    "id": 20352,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.677314003945623,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18892,
        "lat": 15.16524910389124,
        "lon": 145.7854580655437
      },
      {
        "id": 20332,
        "lat": 15.165353805455,
        "lon": 145.7854647322255
      }
    ],

  },
  {
    "id": 20353,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 18.410718994644245,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19519,
        "lat": 15.16523880506419,
        "lon": 145.7847806457813
      },
      {
        "id": 20333,
        "lat": 15.16524873638594,
        "lon": 145.7849516901898
      }
    ],

  },
  {
    "id": 20354,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.133758339320364,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20333,
        "lat": 15.16524873638594,
        "lon": 145.7849516901898
      },
      {
        "id": 20334,
        "lat": 15.16525622754939,
        "lon": 145.7850830078072
      }
    ],

  },
  {
    "id": 20355,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.133483514902622,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20334,
        "lat": 15.16525622754939,
        "lon": 145.7850830078072
      },
      {
        "id": 20335,
        "lat": 15.16525859411856,
        "lon": 145.785214529184
      }
    ],

  },
  {
    "id": 20356,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.13349520066335,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20335,
        "lat": 15.16525859411856,
        "lon": 145.785214529184
      },
      {
        "id": 20336,
        "lat": 15.16525583227961,
        "lon": 145.7853460423967
      }
    ],

  },
  {
    "id": 20357,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.059365939839587,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20336,
        "lat": 15.16525583227961,
        "lon": 145.7853460423967
      },
      {
        "id": 18892,
        "lat": 15.16524910389124,
        "lon": 145.7854580655437
      }
    ],

  },
  {
    "id": 20358,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.987706128947868,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20337,
        "lat": 15.16523685250294,
        "lon": 145.7867525936098
      },
      {
        "id": 20338,
        "lat": 15.16521957034427,
        "lon": 145.7867851033693
      }
    ],

  },
  {
    "id": 20359,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 77.18329834272588,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19337,
        "lat": 15.165943230839,
        "lon": 145.7863301741927
      },
      {
        "id": 20339,
        "lat": 15.16557200872199,
        "lon": 145.7869369048973
      }
    ],

  },
  {
    "id": 20360,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 7.143096021830744,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20339,
        "lat": 15.16557200872199,
        "lon": 145.7869369048973
      },
      {
        "id": 20340,
        "lat": 15.1655183073737,
        "lon": 145.7869005144033
      }
    ],

  },
  {
    "id": 20361,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.35154104111553697,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20340,
        "lat": 15.1655183073737,
        "lon": 145.7869005144033
      },
      {
        "id": 20341,
        "lat": 15.16551979274312,
        "lon": 145.7868976270389
      }
    ],

  },
  {
    "id": 20362,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.3512677800647971,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20341,
        "lat": 15.16551979274312,
        "lon": 145.7868976270389
      },
      {
        "id": 20342,
        "lat": 15.1655207727916,
        "lon": 145.7868945193724
      }
    ],

  },
  {
    "id": 20363,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.35110052403518394,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20342,
        "lat": 15.1655207727916,
        "lon": 145.7868945193724
      },
      {
        "id": 20343,
        "lat": 15.16552121821353,
        "lon": 145.7868912843302
      }
    ],

  },
  {
    "id": 20364,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.35105928579185697,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20343,
        "lat": 15.16552121821353,
        "lon": 145.7868912843302
      },
      {
        "id": 20344,
        "lat": 15.16552111568976,
        "lon": 145.7868880186476
      }
    ],

  },
  {
    "id": 20365,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.3511489831126048,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20344,
        "lat": 15.16552111568976,
        "lon": 145.7868880186476
      },
      {
        "id": 20345,
        "lat": 15.1655204682857,
        "lon": 145.7868848199763
      }
    ],

  },
  {
    "id": 20366,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.35135888740483645,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20345,
        "lat": 15.1655204682857,
        "lon": 145.7868848199763
      },
      {
        "id": 20346,
        "lat": 15.16551929536048,
        "lon": 145.7868817839641
      }
    ],

  },
  {
    "id": 20367,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.3516638813770809,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20346,
        "lat": 15.16551929536048,
        "lon": 145.7868817839641
      },
      {
        "id": 20347,
        "lat": 15.16551763198751,
        "lon": 145.7868790013949
      }
    ],

  },
  {
    "id": 20368,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.352027600644391,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20347,
        "lat": 15.16551763198751,
        "lon": 145.7868790013949
      },
      {
        "id": 20348,
        "lat": 15.16551552790522,
        "lon": 145.786876555474
      }
    ],

  },
  {
    "id": 20369,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.35240672390643774,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20348,
        "lat": 15.16551552790522,
        "lon": 145.786876555474
      },
      {
        "id": 19459,
        "lat": 15.16551304603081,
        "lon": 145.7868745193401
      }
    ],

  },
  {
    "id": 20370,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.3234052549775963,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19459,
        "lat": 15.16551304603081,
        "lon": 145.7868745193401
      },
      {
        "id": 20349,
        "lat": 15.16551050236876,
        "lon": 145.7868730651425
      }
    ],

  },
  {
    "id": 20371,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.3236457490464547,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20349,
        "lat": 15.16551050236876,
        "lon": 145.7868730651425
      },
      {
        "id": 20350,
        "lat": 15.16550776746118,
        "lon": 145.7868720431333
      }
    ],

  },
  {
    "id": 20372,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.3238088507992717,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20350,
        "lat": 15.16550776746118,
        "lon": 145.7868720431333
      },
      {
        "id": 20351,
        "lat": 15.16550491005073,
        "lon": 145.786871479001
      }
    ],

  },
  {
    "id": 20373,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.32387839001184837,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20351,
        "lat": 15.16550491005073,
        "lon": 145.786871479001
      },
      {
        "id": 20352,
        "lat": 15.16550200195922,
        "lon": 145.7868713869253
      }
    ],

  },
  {
    "id": 20374,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.3238474966187707,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20352,
        "lat": 15.16550200195922,
        "lon": 145.7868713869253
      },
      {
        "id": 20353,
        "lat": 15.16549911628218,
        "lon": 145.7868717692203
      }
    ],

  },
  {
    "id": 20375,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.3237191835286749,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20353,
        "lat": 15.16549911628218,
        "lon": 145.7868717692203
      },
      {
        "id": 20354,
        "lat": 15.16549632555216,
        "lon": 145.786872616277
      }
    ],

  },
  {
    "id": 20376,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.32350622722763356,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20354,
        "lat": 15.16549632555216,
        "lon": 145.786872616277
      },
      {
        "id": 20355,
        "lat": 15.16549369991462,
        "lon": 145.7868739068044
      }
    ],

  },
  {
    "id": 20377,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.3232297127866825,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20355,
        "lat": 15.16549369991462,
        "lon": 145.7868739068044
      },
      {
        "id": 20356,
        "lat": 15.1654913053659,
        "lon": 145.7868756083648
      }
    ],

  },
  {
    "id": 20378,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.32291716398262327,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20356,
        "lat": 15.1654913053659,
        "lon": 145.7868756083648
      },
      {
        "id": 20357,
        "lat": 15.16548920209355,
        "lon": 145.7868776781889
      }
    ],

  },
  {
    "id": 20379,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 0.32259976535726675,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20357,
        "lat": 15.16548920209355,
        "lon": 145.7868776781889
      },
      {
        "id": 20358,
        "lat": 15.16548744296375,
        "lon": 145.7868800642512
      }
    ],

  },
  {
    "id": 20380,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 3.350951650624719,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20358,
        "lat": 15.16548744296375,
        "lon": 145.7868800642512
      },
      {
        "id": 20359,
        "lat": 15.16546197364816,
        "lon": 145.7868634400199
      }
    ],

  },
  {
    "id": 20381,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.633060174263662,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20359,
        "lat": 15.16546197364816,
        "lon": 145.7868634400199
      },
      {
        "id": 20360,
        "lat": 15.16542035416294,
        "lon": 145.7868634252304
      }
    ],

  },
  {
    "id": 20382,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.541662476307234,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20360,
        "lat": 15.16542035416294,
        "lon": 145.7868634252304
      },
      {
        "id": 20361,
        "lat": 15.16526924895133,
        "lon": 145.7867708507578
      }
    ],

  },
  {
    "id": 20383,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.105323060964268,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20361,
        "lat": 15.16526924895133,
        "lon": 145.7867708507578
      },
      {
        "id": 20337,
        "lat": 15.16523685250294,
        "lon": 145.7867525936098
      }
    ],

  },
  {
    "id": 20384,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.56843459933706,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20362,
        "lat": 15.16491268851562,
        "lon": 145.7865815146701
      },
      {
        "id": 20363,
        "lat": 15.16495612979586,
        "lon": 145.7864837028659
      }
    ],

  },
  {
    "id": 20385,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.440113246683879,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20337,
        "lat": 15.16523685250294,
        "lon": 145.7867525936098
      },
      {
        "id": 20364,
        "lat": 15.16511500950241,
        "lon": 145.7866839285537
      }
    ],

  },
  {
    "id": 20386,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.54903968749937,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20364,
        "lat": 15.16511500950241,
        "lon": 145.7866839285537
      },
      {
        "id": 20365,
        "lat": 15.164957835169,
        "lon": 145.7866027709514
      }
    ],

  },
  {
    "id": 20387,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 5.520290108069996,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20365,
        "lat": 15.164957835169,
        "lon": 145.7866027709514
      },
      {
        "id": 20362,
        "lat": 15.16491268851562,
        "lon": 145.7865815146701
      }
    ],

  },
  {
    "id": 20388,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.343802747628095,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20366,
        "lat": 15.16454366697357,
        "lon": 145.7864228970334
      },
      {
        "id": 20367,
        "lat": 15.16457947356211,
        "lon": 145.7863240499282
      }
    ],

  },
  {
    "id": 20389,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.03216398562821,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20362,
        "lat": 15.16491268851562,
        "lon": 145.7865815146701
      },
      {
        "id": 20368,
        "lat": 15.16479792909675,
        "lon": 145.7865274828326
      }
    ],

  },
  {
    "id": 20390,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.55566200208149,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20368,
        "lat": 15.16479792909675,
        "lon": 145.7865274828326
      },
      {
        "id": 20369,
        "lat": 15.16463549796159,
        "lon": 145.7864581614917
      }
    ],

  },
  {
    "id": 20391,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 10.902158957622468,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20369,
        "lat": 15.16463549796159,
        "lon": 145.7864581614917
      },
      {
        "id": 20366,
        "lat": 15.16454366697357,
        "lon": 145.7864228970334
      }
    ],

  },
  {
    "id": 20392,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 8.306237123060816,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19422,
        "lat": 15.16471554597385,
        "lon": 145.7856836421142
      },
      {
        "id": 20370,
        "lat": 15.16474138820353,
        "lon": 145.7856111184155
      }
    ],

  },
  {
    "id": 20393,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 9.841825759139526,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20371,
        "lat": 15.16390088411778,
        "lon": 145.7854653558596
      },
      {
        "id": 20372,
        "lat": 15.16398802421083,
        "lon": 145.7854808292402
      }
    ],

  },
  {
    "id": 20394,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 20.245064541238907,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20372,
        "lat": 15.16398802421083,
        "lon": 145.7854808292402
      },
      {
        "id": 20373,
        "lat": 15.1641660547899,
        "lon": 145.7855193151204
      }
    ],

  },
  {
    "id": 20395,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 20.243082480279988,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20373,
        "lat": 15.1641660547899,
        "lon": 145.7855193151204
      },
      {
        "id": 20374,
        "lat": 15.16434261721107,
        "lon": 145.7855644045033
      }
    ],

  },
  {
    "id": 20396,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 20.24080890801867,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20374,
        "lat": 15.16434261721107,
        "lon": 145.7855644045033
      },
      {
        "id": 20375,
        "lat": 15.16451748050452,
        "lon": 145.7856160384221
      }
    ],

  },
  {
    "id": 20397,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 20.238255603239562,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20375,
        "lat": 15.16451748050452,
        "lon": 145.7856160384221
      },
      {
        "id": 20376,
        "lat": 15.16469041592243,
        "lon": 145.7856741493481
      }
    ],

  },
  {
    "id": 20398,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 2.977594601192315,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20376,
        "lat": 15.16469041592243,
        "lon": 145.7856741493481
      },
      {
        "id": 19422,
        "lat": 15.16471554597385,
        "lon": 145.7856836421142
      }
    ],

  },
  {
    "id": 20399,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.724830516459146,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20377,
        "lat": 15.16414911290949,
        "lon": 145.7862905075202
      },
      {
        "id": 20378,
        "lat": 15.16417300735759,
        "lon": 145.7861938077867
      }
    ],

  },
  {
    "id": 20400,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 8.656487970969405,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20366,
        "lat": 15.16454366697357,
        "lon": 145.7864228970334
      },
      {
        "id": 20379,
        "lat": 15.16447075170238,
        "lon": 145.786394896511
      }
    ],

  },
  {
    "id": 20401,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.56139355477565,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20379,
        "lat": 15.16447075170238,
        "lon": 145.786394896511
      },
      {
        "id": 20380,
        "lat": 15.16430390324967,
        "lon": 145.7863377696446
      }
    ],

  },
  {
    "id": 20402,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 17.963946999056322,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20380,
        "lat": 15.16430390324967,
        "lon": 145.7863377696446
      },
      {
        "id": 20381,
        "lat": 15.16414896745133,
        "lon": 145.7862910185485
      }
    ],

  },
  {
    "id": 20403,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.489735832272563,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19440,
        "lat": 15.16365827896023,
        "lon": 145.786179088092
      },
      {
        "id": 20382,
        "lat": 15.16365431192558,
        "lon": 145.7862018931511
      }
    ],

  },
  {
    "id": 20404,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 1.599940764060075,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20381,
        "lat": 15.16414896745133,
        "lon": 145.7862910185485
      },
      {
        "id": 20383,
        "lat": 15.16413516825087,
        "lon": 145.7862868547123
      }
    ],

  },
  {
    "id": 20405,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.56611679780365,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20383,
        "lat": 15.16413516825087,
        "lon": 145.7862868547123
      },
      {
        "id": 20384,
        "lat": 15.16396476479067,
        "lon": 145.7862422175052
      }
    ],

  },
  {
    "id": 20406,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 19.568069190757363,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20384,
        "lat": 15.16396476479067,
        "lon": 145.7862422175052
      },
      {
        "id": 20385,
        "lat": 15.16379291311017,
        "lon": 145.7862039156996
      }
    ],

  },
  {
    "id": 20407,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 15.222950628906439,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20385,
        "lat": 15.16379291311017,
        "lon": 145.7862039156996
      },
      {
        "id": 19440,
        "lat": 15.16365827896023,
        "lon": 145.786179088092
      }
    ],

  },
  {
    "id": 20408,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.373576952671405,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20371,
        "lat": 15.16390088411778,
        "lon": 145.7854653558596
      },
      {
        "id": 20386,
        "lat": 15.16391681814652,
        "lon": 145.7853702286182
      }
    ],

  },
  {
    "id": 20409,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 50.98543862985254,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19281,
        "lat": 15.1631784928065,
        "lon": 145.7853354957475
      },
      {
        "id": 20387,
        "lat": 15.16362849175307,
        "lon": 145.7854238605962
      }
    ],

  },
  {
    "id": 20410,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 20.248114584914717,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20387,
        "lat": 15.16362849175307,
        "lon": 145.7854238605962
      },
      {
        "id": 20388,
        "lat": 15.1638087583635,
        "lon": 145.7854489971909
      }
    ],

  },
  {
    "id": 20411,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.404919062686151,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20388,
        "lat": 15.1638087583635,
        "lon": 145.7854489971909
      },
      {
        "id": 20371,
        "lat": 15.16390088411778,
        "lon": 145.7854653558596
      }
    ],

  },
  {
    "id": 20412,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 13.33661557824868,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18897,
        "lat": 15.16478411752564,
        "lon": 145.7847645427169
      },
      {
        "id": 20389,
        "lat": 15.16477627705074,
        "lon": 145.7848884039014
      }
    ],

  },
  {
    "id": 20413,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 10.454335653882431,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19519,
        "lat": 15.16523880506419,
        "lon": 145.7847806457813
      },
      {
        "id": 20390,
        "lat": 15.16514522046485,
        "lon": 145.7847887745355
      }
    ],

  },
  {
    "id": 20414,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 40.28202032671542,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20390,
        "lat": 15.16514522046485,
        "lon": 145.7847887745355
      },
      {
        "id": 18897,
        "lat": 15.16478411752564,
        "lon": 145.7847645427169
      }
    ],

  },
  {
    "id": 20415,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.5645955204182176,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19547,
        "lat": 15.16332693995913,
        "lon": 145.7847177390792
      },
      {
        "id": 20391,
        "lat": 15.16329505084229,
        "lon": 145.7847147276394
      }
    ],

  },
  {
    "id": 20416,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 9.698408397874616,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19280,
        "lat": 15.16317157439443,
        "lon": 145.7853349759078
      },
      {
        "id": 20392,
        "lat": 15.16318290172234,
        "lon": 145.7852454772157
      }
    ],

  },
  {
    "id": 20417,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 7.956829401150341,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20392,
        "lat": 15.16318290172234,
        "lon": 145.7852454772157
      },
      {
        "id": 20393,
        "lat": 15.16320848669987,
        "lon": 145.7851763282608
      }
    ],

  },
  {
    "id": 20418,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 18.889737654251178,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20393,
        "lat": 15.16320848669987,
        "lon": 145.7851763282608
      },
      {
        "id": 20394,
        "lat": 15.16326852756854,
        "lon": 145.7850118910227
      }
    ],

  },
  {
    "id": 20419,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.76767088759443,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20394,
        "lat": 15.16326852756854,
        "lon": 145.7850118910227
      },
      {
        "id": 20395,
        "lat": 15.16329313332892,
        "lon": 145.7849149710216
      }
    ],

  },
  {
    "id": 20420,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.766055582380316,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20395,
        "lat": 15.16329313332892,
        "lon": 145.7849149710216
      },
      {
        "id": 20396,
        "lat": 15.16331262306097,
        "lon": 145.7848168250187
      }
    ],

  },
  {
    "id": 20421,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 10.764803195748508,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20396,
        "lat": 15.16331262306097,
        "lon": 145.7848168250187
      },
      {
        "id": 19547,
        "lat": 15.16332693995913,
        "lon": 145.7847177390792
      }
    ],

  },
  {
    "id": 20422,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.115926048143642,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19428,
        "lat": 15.16271848069986,
        "lon": 145.7853009311892
      },
      {
        "id": 20397,
        "lat": 15.16272513610148,
        "lon": 145.7852070334496
      }
    ],

  },
  {
    "id": 20423,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 28.4644811751711,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19427,
        "lat": 15.1624634497046,
        "lon": 145.7852817686088
      },
      {
        "id": 19428,
        "lat": 15.16271848069986,
        "lon": 145.7853009311892
      }
    ],

  },
  {
    "id": 20424,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.792180120580472,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18884,
        "lat": 15.16252218789026,
        "lon": 145.7847516639886
      },
      {
        "id": 20398,
        "lat": 15.16262744456252,
        "lon": 145.7847640275612
      }
    ],

  },
  {
    "id": 20425,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 57.33077930643987,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19427,
        "lat": 15.1624634497046,
        "lon": 145.7852817686088
      },
      {
        "id": 18884,
        "lat": 15.16252218789026,
        "lon": 145.7847516639886
      }
    ],

  },
  {
    "id": 20426,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.182082375279917,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19425,
        "lat": 15.1621024491058,
        "lon": 145.7852407227361
      },
      {
        "id": 20399,
        "lat": 15.16211415059015,
        "lon": 145.7851373581073
      }
    ],

  },
  {
    "id": 20427,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 13.213881098154173,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18984,
        "lat": 15.16051879840328,
        "lon": 145.7847651210505
      },
      {
        "id": 20400,
        "lat": 15.16061830215302,
        "lon": 145.7848321792589
      }
    ],

  },
  {
    "id": 20428,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 13.21760817751947,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20400,
        "lat": 15.16061830215302,
        "lon": 145.7848321792589
      },
      {
        "id": 20401,
        "lat": 15.16072096671555,
        "lon": 145.7848939806312
      }
    ],

  },
  {
    "id": 20429,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 13.221128109147967,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20401,
        "lat": 15.16072096671555,
        "lon": 145.7848939806312
      },
      {
        "id": 20402,
        "lat": 15.16082653033474,
        "lon": 145.7849503675886
      }
    ],

  },
  {
    "id": 20430,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 13.224405141537545,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20402,
        "lat": 15.16082653033474,
        "lon": 145.7849503675886
      },
      {
        "id": 20403,
        "lat": 15.16093472386167,
        "lon": 145.7850011963569
      }
    ],

  },
  {
    "id": 20431,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 13.227406113857478,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20403,
        "lat": 15.16093472386167,
        "lon": 145.7850011963569
      },
      {
        "id": 20404,
        "lat": 15.16104527144246,
        "lon": 145.7850463373319
      }
    ],

  },
  {
    "id": 20432,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 13.230100616248917,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20404,
        "lat": 15.16104527144246,
        "lon": 145.7850463373319
      },
      {
        "id": 20405,
        "lat": 15.16115789122027,
        "lon": 145.7850856754114
      }
    ],

  },
  {
    "id": 20433,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 13.23246139127607,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20405,
        "lat": 15.16115789122027,
        "lon": 145.7850856754114
      },
      {
        "id": 20406,
        "lat": 15.16127229605472,
        "lon": 145.7851191102875
      }
    ],

  },
  {
    "id": 20434,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 13.234464582676845,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20406,
        "lat": 15.16127229605472,
        "lon": 145.7851191102875
      },
      {
        "id": 20407,
        "lat": 15.1613881942537,
        "lon": 145.7851465567034
      }
    ],

  },
  {
    "id": 20435,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 13.23608989278581,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20407,
        "lat": 15.1613881942537,
        "lon": 145.7851465567034
      },
      {
        "id": 20408,
        "lat": 15.16150529031673,
        "lon": 145.78516794467
      }
    ],

  },
  {
    "id": 20436,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 13.237320929932382,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20408,
        "lat": 15.16150529031673,
        "lon": 145.78516794467
      },
      {
        "id": 20409,
        "lat": 15.1616232856889,
        "lon": 145.7851832196452
      }
    ],

  },
  {
    "id": 20437,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 53.69685675728333,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20409,
        "lat": 15.1616232856889,
        "lon": 145.7851832196452
      },
      {
        "id": 19425,
        "lat": 15.1621024491058,
        "lon": 145.7852407227361
      }
    ],

  },
  {
    "id": 20438,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 14.80749820991862,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20410,
        "lat": 15.16186057359593,
        "lon": 145.7844733798692
      },
      {
        "id": 20411,
        "lat": 15.16181059106837,
        "lon": 145.7843456640049
      }
    ],

  },
  {
    "id": 20439,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 8.911150912487674,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20412,
        "lat": 15.1619605486636,
        "lon": 145.7844389803867
      },
      {
        "id": 20413,
        "lat": 15.16188411114392,
        "lon": 145.7844636148855
      }
    ],

  },
  {
    "id": 20440,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.8224444911098145,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20413,
        "lat": 15.16188411114392,
        "lon": 145.7844636148855
      },
      {
        "id": 20410,
        "lat": 15.16186057359593,
        "lon": 145.7844733798692
      }
    ],

  },
  {
    "id": 20441,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.53962738108769,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18979,
        "lat": 15.16136039829074,
        "lon": 145.7849071256721
      },
      {
        "id": 20414,
        "lat": 15.16127955892817,
        "lon": 145.7848560621504
      }
    ],

  },
  {
    "id": 20442,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 6.0859069963046455,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20410,
        "lat": 15.16186057359593,
        "lon": 145.7844733798692
      },
      {
        "id": 20415,
        "lat": 15.16180982066409,
        "lon": 145.7844944356454
      }
    ],

  },
  {
    "id": 20443,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 8.905044162528604,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20415,
        "lat": 15.16180982066409,
        "lon": 145.7844944356454
      },
      {
        "id": 20416,
        "lat": 15.16173814867359,
        "lon": 145.7845312470707
      }
    ],

  },
  {
    "id": 20444,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 8.901312239466327,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20416,
        "lat": 15.16173814867359,
        "lon": 145.7845312470707
      },
      {
        "id": 20417,
        "lat": 15.1616695500045,
        "lon": 145.7845738155495
      }
    ],

  },
  {
    "id": 20445,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 8.897249854985976,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20417,
        "lat": 15.1616695500045,
        "lon": 145.7845738155495
      },
      {
        "id": 20418,
        "lat": 15.16160445998518,
        "lon": 145.7846218709367
      }
    ],

  },
  {
    "id": 20446,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 8.89295955210176,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20418,
        "lat": 15.16160445998518,
        "lon": 145.7846218709367
      },
      {
        "id": 20419,
        "lat": 15.16154329167788,
        "lon": 145.7846751082676
      }
    ],

  },
  {
    "id": 20447,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 8.888549845797165,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20419,
        "lat": 15.16154329167788,
        "lon": 145.7846751082676
      },
      {
        "id": 20420,
        "lat": 15.16148643325705,
        "lon": 145.7847331896938
      }
    ],

  },
  {
    "id": 20448,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 8.884132371120433,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20420,
        "lat": 15.16148643325705,
        "lon": 145.7847331896938
      },
      {
        "id": 20421,
        "lat": 15.16143424554677,
        "lon": 145.7847957466271
      }
    ],

  },
  {
    "id": 20449,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 8.87981922692683,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20421,
        "lat": 15.16143424554677,
        "lon": 145.7847957466271
      },
      {
        "id": 20422,
        "lat": 15.16138705973001,
        "lon": 145.7848623820789
      }
    ],

  },
  {
    "id": 20450,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 5.649813011993968,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20422,
        "lat": 15.16138705973001,
        "lon": 145.7848623820789
      },
      {
        "id": 18979,
        "lat": 15.16136039829074,
        "lon": 145.7849071256721
      }
    ],

  },
  {
    "id": 20451,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 8.503692439212188,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18973,
        "lat": 15.16085988366889,
        "lon": 145.7844118814602
      },
      {
        "id": 20423,
        "lat": 15.16080638518075,
        "lon": 145.7843553868607
      }
    ],

  },
  {
    "id": 20452,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 49.88196989657539,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20424,
        "lat": 15.16118169947388,
        "lon": 145.7840888268597
      },
      {
        "id": 18973,
        "lat": 15.16085988366889,
        "lon": 145.7844118814602
      }
    ],

  },
  {
    "id": 20453,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 7.9450559786416175,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20424,
        "lat": 15.16118169947388,
        "lon": 145.7840888268597
      },
      {
        "id": 20425,
        "lat": 15.16113171540321,
        "lon": 145.7840360435831
      }
    ],

  },
  {
    "id": 20454,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 79.61761525061156,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19593,
        "lat": 15.16169535511829,
        "lon": 145.7835731907916
      },
      {
        "id": 20424,
        "lat": 15.16118169947388,
        "lon": 145.7840888268597
      }
    ],

  },
  {
    "id": 20455,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.923758053655427,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18971,
        "lat": 15.16030853827835,
        "lon": 145.7838652858246
      },
      {
        "id": 20426,
        "lat": 15.16027842479617,
        "lon": 145.7838317209686
      }
    ],

  },
  {
    "id": 20456,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 53.612778432946385,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20427,
        "lat": 15.16066333164505,
        "lon": 145.7835278559656
      },
      {
        "id": 18971,
        "lat": 15.16030853827835,
        "lon": 145.7838652858246
      }
    ],

  },
  {
    "id": 20457,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.406952059264999,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20427,
        "lat": 15.16066333164505,
        "lon": 145.7835278559656
      },
      {
        "id": 20428,
        "lat": 15.16063637887724,
        "lon": 145.7834978141292
      }
    ],

  },
  {
    "id": 20458,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 82.24085133617379,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19591,
        "lat": 15.1612075759924,
        "lon": 145.7830102435061
      },
      {
        "id": 20427,
        "lat": 15.16066333164505,
        "lon": 145.7835278559656
      }
    ],

  },
  {
    "id": 20459,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 18.484086842713886,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18977,
        "lat": 15.15959728859315,
        "lon": 145.7834232500982
      },
      {
        "id": 20429,
        "lat": 15.15971017075381,
        "lon": 145.7835494135641
      }
    ],

  },
  {
    "id": 20460,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 19.510316611889884,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20430,
        "lat": 15.16011290012651,
        "lon": 145.7829342103764
      },
      {
        "id": 20431,
        "lat": 15.16023204977049,
        "lon": 145.7830673784239
      }
    ],

  },
  {
    "id": 20461,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 4.144425684579778,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19286,
        "lat": 15.16068925489221,
        "lon": 145.7823876565439
      },
      {
        "id": 20432,
        "lat": 15.16066174476486,
        "lon": 145.7824136462693
      }
    ],

  },
  {
    "id": 20462,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 82.83274395395424,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20432,
        "lat": 15.16066174476486,
        "lon": 145.7824136462693
      },
      {
        "id": 20430,
        "lat": 15.16011290012651,
        "lon": 145.7829342103764
      }
    ],

  },
  {
    "id": 20463,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 77.81695765892954,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20430,
        "lat": 15.16011290012651,
        "lon": 145.7829342103764
      },
      {
        "id": 18977,
        "lat": 15.15959728859315,
        "lon": 145.7834232500982
      }
    ],

  },
  {
    "id": 20464,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.415629215726101,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19344,
        "lat": 15.16171714929233,
        "lon": 145.7824285687044
      },
      {
        "id": 20433,
        "lat": 15.16165400106266,
        "lon": 145.7824868690135
      }
    ],

  },
  {
    "id": 20465,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 4.848979083178516,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20434,
        "lat": 15.16241597341473,
        "lon": 145.7819948705474
      },
      {
        "id": 20435,
        "lat": 15.16237543368695,
        "lon": 145.7820113803822
      }
    ],

  },
  {
    "id": 20466,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.378702602710474,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20435,
        "lat": 15.16237543368695,
        "lon": 145.7820113803822
      },
      {
        "id": 20436,
        "lat": 15.16225772291846,
        "lon": 145.7820664778266
      }
    ],

  },
  {
    "id": 20467,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.375182307912114,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20436,
        "lat": 15.16225772291846,
        "lon": 145.7820664778266
      },
      {
        "id": 20437,
        "lat": 15.16214283556457,
        "lon": 145.7821275671298
      }
    ],

  },
  {
    "id": 20468,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.371401491107354,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20437,
        "lat": 15.16214283556457,
        "lon": 145.7821275671298
      },
      {
        "id": 20438,
        "lat": 15.16203105912322,
        "lon": 145.782194495411
      }
    ],

  },
  {
    "id": 20469,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.367397850266483,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20438,
        "lat": 15.16203105912322,
        "lon": 145.782194495411
      },
      {
        "id": 20439,
        "lat": 15.16192267330665,
        "lon": 145.7822670951788
      }
    ],

  },
  {
    "id": 20470,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.363211259802673,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20439,
        "lat": 15.16192267330665,
        "lon": 145.7822670951788
      },
      {
        "id": 20440,
        "lat": 15.16181794934187,
        "lon": 145.7823451847499
      }
    ],

  },
  {
    "id": 20471,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.358883466196042,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20440,
        "lat": 15.16181794934187,
        "lon": 145.7823451847499
      },
      {
        "id": 19344,
        "lat": 15.16171714929233,
        "lon": 145.7824285687044
      }
    ],

  },
  {
    "id": 20472,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 19.698922968129413,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19435,
        "lat": 15.16110666432138,
        "lon": 145.7819933149069
      },
      {
        "id": 20441,
        "lat": 15.16122671030646,
        "lon": 145.782128015807
      }
    ],

  },
  {
    "id": 20473,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 11.526358181444422,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20442,
        "lat": 15.16156936036744,
        "lon": 145.7816448973443
      },
      {
        "id": 20443,
        "lat": 15.16147941494039,
        "lon": 145.7816980402093
      }
    ],

  },
  {
    "id": 20474,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 11.523219340862463,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20443,
        "lat": 15.16147941494039,
        "lon": 145.7816980402093
      },
      {
        "id": 20444,
        "lat": 15.16139211772716,
        "lon": 145.7817556747068
      }
    ],

  },
  {
    "id": 20475,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 11.51993430518258,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20444,
        "lat": 15.16139211772716,
        "lon": 145.7817556747068
      },
      {
        "id": 20445,
        "lat": 15.16130768014287,
        "lon": 145.7818176612535
      }
    ],

  },
  {
    "id": 20476,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 11.516534803777798,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20445,
        "lat": 15.16130768014287,
        "lon": 145.7818176612535
      },
      {
        "id": 20446,
        "lat": 15.16122630667675,
        "lon": 145.7818838497271
      }
    ],

  },
  {
    "id": 20477,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 11.513053646694546,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20446,
        "lat": 15.16122630667675,
        "lon": 145.7818838497271
      },
      {
        "id": 20447,
        "lat": 15.16114819439722,
        "lon": 145.7819540798294
      }
    ],

  },
  {
    "id": 20478,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 6.256555257281516,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20447,
        "lat": 15.16114819439722,
        "lon": 145.7819540798294
      },
      {
        "id": 19435,
        "lat": 15.16110666432138,
        "lon": 145.7819933149069
      }
    ],

  },
  {
    "id": 20479,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 17.98857503228851,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20442,
        "lat": 15.16156936036744,
        "lon": 145.7816448973443
      },
      {
        "id": 20448,
        "lat": 15.16166987116474,
        "lon": 145.7817759920743
      }
    ],

  },
  {
    "id": 20480,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 57.19235851737725,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20449,
        "lat": 15.16212553270996,
        "lon": 145.7813673833554
      },
      {
        "id": 20450,
        "lat": 15.16166173617994,
        "lon": 145.7815963748177
      }
    ],

  },
  {
    "id": 20481,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 11.529320609652023,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20450,
        "lat": 15.16166173617994,
        "lon": 145.7815963748177
      },
      {
        "id": 20442,
        "lat": 15.16156936036744,
        "lon": 145.7816448973443
      }
    ],

  },
  {
    "id": 20482,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 17.966459999138976,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20449,
        "lat": 15.16212553270996,
        "lon": 145.7813673833554
      },
      {
        "id": 20451,
        "lat": 15.16219567454078,
        "lon": 145.781517982662
      }
    ],

  },
  {
    "id": 20483,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 4.0075827287411885,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20452,
        "lat": 15.16260563561167,
        "lon": 145.7811314712465
      },
      {
        "id": 20453,
        "lat": 15.1625727245104,
        "lon": 145.7811465890337
      }
    ],

  },
  {
    "id": 20484,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 55.14480315440105,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20453,
        "lat": 15.1625727245104,
        "lon": 145.7811465890337
      },
      {
        "id": 20449,
        "lat": 15.16212553270996,
        "lon": 145.7813673833554
      }
    ],

  },
  {
    "id": 20485,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 18.03577081144147,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20452,
        "lat": 15.16260563561167,
        "lon": 145.7811314712465
      },
      {
        "id": 20454,
        "lat": 15.1626719924514,
        "lon": 145.7812846084271
      }
    ],

  },
  {
    "id": 20486,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 12.051446390478018,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19796,
        "lat": 15.16287602044711,
        "lon": 145.7810273916169
      },
      {
        "id": 20455,
        "lat": 15.16277284908063,
        "lon": 145.7810613755341
      }
    ],

  },
  {
    "id": 20487,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 12.048870541793926,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20455,
        "lat": 15.16277284908063,
        "lon": 145.7810613755341
      },
      {
        "id": 20456,
        "lat": 15.16267164839598,
        "lon": 145.781101148111
      }
    ],

  },
  {
    "id": 20488,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 8.038373017411415,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20456,
        "lat": 15.16267164839598,
        "lon": 145.781101148111
      },
      {
        "id": 20452,
        "lat": 15.16260563561167,
        "lon": 145.7811314712465
      }
    ],

  },
  {
    "id": 20489,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.246214241587774,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20434,
        "lat": 15.16241597341473,
        "lon": 145.7819948705474
      },
      {
        "id": 20457,
        "lat": 15.16240518934608,
        "lon": 145.7819667994008
      }
    ],

  },
  {
    "id": 20490,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.392617681490892,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19350,
        "lat": 15.16312409399507,
        "lon": 145.781813256658
      },
      {
        "id": 20458,
        "lat": 15.16299582343979,
        "lon": 145.781830054078
      }
    ],

  },
  {
    "id": 20491,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.391281616929508,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20458,
        "lat": 15.16299582343979,
        "lon": 145.781830054078
      },
      {
        "id": 20459,
        "lat": 15.16286852924508,
        "lon": 145.7818534350573
      }
    ],

  },
  {
    "id": 20492,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.389525165859492,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20459,
        "lat": 15.16286852924508,
        "lon": 145.7818534350573
      },
      {
        "id": 20460,
        "lat": 15.1627425299586,
        "lon": 145.7818833410747
      }
    ],

  },
  {
    "id": 20493,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.387365727556203,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20460,
        "lat": 15.1627425299586,
        "lon": 145.7818833410747
      },
      {
        "id": 20461,
        "lat": 15.1626181408871,
        "lon": 145.7819196972802
      }
    ],

  },
  {
    "id": 20494,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 14.384824756312309,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20461,
        "lat": 15.1626181408871,
        "lon": 145.7819196972802
      },
      {
        "id": 20462,
        "lat": 15.16249567330729,
        "lon": 145.7819624126838
      }
    ],

  },
  {
    "id": 20495,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 9.53294838567184,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20462,
        "lat": 15.16249567330729,
        "lon": 145.7819624126838
      },
      {
        "id": 20434,
        "lat": 15.16241597341473,
        "lon": 145.7819948705474
      }
    ],

  },
  {
    "id": 20496,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 9.743462234623582,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18883,
        "lat": 15.16263871611519,
        "lon": 145.7832941276996
      },
      {
        "id": 20463,
        "lat": 15.16255226103974,
        "lon": 145.7833082766696
      }
    ],

  },
  {
    "id": 20497,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.212362267282682,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20464,
        "lat": 15.16193822535719,
        "lon": 145.7838149710191
      },
      {
        "id": 20465,
        "lat": 15.16201087069317,
        "lon": 145.7837297994354
      }
    ],

  },
  {
    "id": 20498,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 27.791364166897804,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19284,
        "lat": 15.16170518635576,
        "lon": 145.783573932973
      },
      {
        "id": 20466,
        "lat": 15.16187804616454,
        "lon": 145.7837605587205
      }
    ],

  },
  {
    "id": 20499,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 8.891424820162426,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20466,
        "lat": 15.16187804616454,
        "lon": 145.7837605587205
      },
      {
        "id": 20464,
        "lat": 15.16193822535719,
        "lon": 145.7838149710191
      }
    ],

  },
  {
    "id": 20500,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 1.201158367928441,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20467,
        "lat": 15.16246354553762,
        "lon": 145.7840914725963
      },
      {
        "id": 20468,
        "lat": 15.16246619448147,
        "lon": 145.7840806353458
      }
    ],

  },
  {
    "id": 20501,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 1.2042384390378378,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20464,
        "lat": 15.16193822535719,
        "lon": 145.7838149710191
      },
      {
        "id": 20469,
        "lat": 15.16194637591693,
        "lon": 145.7838223405243
      }
    ],

  },
  {
    "id": 20502,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 10.099852310312864,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20469,
        "lat": 15.16194637591693,
        "lon": 145.7838223405243
      },
      {
        "id": 20470,
        "lat": 15.16201860984328,
        "lon": 145.7838792196874
      }
    ],

  },
  {
    "id": 20503,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 10.103888247540455,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20470,
        "lat": 15.16201860984328,
        "lon": 145.7838792196874
      },
      {
        "id": 20471,
        "lat": 15.16209441675037,
        "lon": 145.7839309354123
      }
    ],

  },
  {
    "id": 20504,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 10.1076974284944,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20471,
        "lat": 15.16209441675037,
        "lon": 145.7839309354123
      },
      {
        "id": 20472,
        "lat": 15.1621734490624,
        "lon": 145.7839772505761
      }
    ],

  },
  {
    "id": 20505,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 10.111210279489736,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20472,
        "lat": 15.1621734490624,
        "lon": 145.7839772505761
      },
      {
        "id": 20473,
        "lat": 15.16225534441439,
        "lon": 145.7840179528157
      }
    ],

  },
  {
    "id": 20506,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 10.114362839416472,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20473,
        "lat": 15.16225534441439,
        "lon": 145.7840179528157
      },
      {
        "id": 20474,
        "lat": 15.1623397273138,
        "lon": 145.7840528555036
      }
    ],

  },
  {
    "id": 20507,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 10.117097730006156,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20474,
        "lat": 15.1623397273138,
        "lon": 145.7840528555036
      },
      {
        "id": 20475,
        "lat": 15.16242621086233,
        "lon": 145.7840817986027
      }
    ],

  },
  {
    "id": 20508,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 4.284082158633569,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20475,
        "lat": 15.16242621086233,
        "lon": 145.7840817986027
      },
      {
        "id": 20467,
        "lat": 15.16246354553762,
        "lon": 145.7840914725963
      }
    ],

  },
  {
    "id": 20509,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.963868564026315,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19282,
        "lat": 15.1629970445161,
        "lon": 145.784132586497
      },
      {
        "id": 20476,
        "lat": 15.16299634801054,
        "lon": 145.78403054639
      }
    ],

  },
  {
    "id": 20510,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 5.835283028315026,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20467,
        "lat": 15.16246354553762,
        "lon": 145.7840914725963
      },
      {
        "id": 20477,
        "lat": 15.16251439852947,
        "lon": 145.7841046494002
      }
    ],

  },
  {
    "id": 20511,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 10.121124003435439,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20477,
        "lat": 15.16251439852947,
        "lon": 145.7841046494002
      },
      {
        "id": 20478,
        "lat": 15.16260388597079,
        "lon": 145.7841213031163
      }
    ],

  },
  {
    "id": 20512,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 10.122342229738777,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20478,
        "lat": 15.16260388597079,
        "lon": 145.7841213031163
      },
      {
        "id": 20479,
        "lat": 15.16269426288176,
        "lon": 145.7841316833849
      }
    ],

  },
  {
    "id": 20513,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 10.122997749477804,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20479,
        "lat": 15.16269426288176,
        "lon": 145.7841316833849
      },
      {
        "id": 20480,
        "lat": 15.16278511487907,
        "lon": 145.7841357426039
      }
    ],

  },
  {
    "id": 20514,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 10.123078683248336,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20480,
        "lat": 15.16278511487907,
        "lon": 145.7841357426039
      },
      {
        "id": 20481,
        "lat": 15.16287602540077,
        "lon": 145.7841334621532
      }
    ],

  },
  {
    "id": 20515,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 13.472114821805102,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20481,
        "lat": 15.16287602540077,
        "lon": 145.7841334621532
      },
      {
        "id": 19282,
        "lat": 15.1629970445161,
        "lon": 145.784132586497
      }
    ],

  },
  {
    "id": 20516,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.0877074654759853,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19438,
        "lat": 15.16424222271667,
        "lon": 145.7840498396232
      },
      {
        "id": 20482,
        "lat": 15.16424457972087,
        "lon": 145.7840784736857
      }
    ],

  },
  {
    "id": 20517,
    "diameter": "DIAM_300",
    "diameterMm": 300,
    "length": 102.38191744559632,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18874,
        "lat": 15.16332575505837,
        "lon": 145.7841298118733
      },
      {
        "id": 19438,
        "lat": 15.16424222271667,
        "lon": 145.7840498396232
      }
    ],

  },
  {
    "id": 20518,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 46.121542507198185,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19723,
        "lat": 15.16978410678657,
        "lon": 145.7794548580621
      },
      {
        "id": 19215,
        "lat": 15.16981990778363,
        "lon": 145.7798825275907
      }
    ],

  },
  {
    "id": 20519,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 43.66129175689305,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20483,
        "lat": 15.16818932701966,
        "lon": 145.7701640384562
      },
      {
        "id": 20484,
        "lat": 15.16784376366891,
        "lon": 145.7703562595991
      }
    ],

  },
  {
    "id": 20520,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 2.8263539897131267,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19985,
        "lat": 15.16852124736685,
        "lon": 145.7699788372223
      },
      {
        "id": 20485,
        "lat": 15.16849911047143,
        "lon": 145.7699917193779
      }
    ],

  },
  {
    "id": 20521,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 64.69656477799762,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19192,
        "lat": 15.16880856470094,
        "lon": 145.7705022645497
      },
      {
        "id": 19985,
        "lat": 15.16852124736685,
        "lon": 145.7699788372223
      }
    ],

  },
  {
    "id": 20522,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 5.668300849747259,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20483,
        "lat": 15.16818932701966,
        "lon": 145.7701640384562
      },
      {
        "id": 20486,
        "lat": 15.16821364716712,
        "lon": 145.7702103890802
      }
    ],

  },
  {
    "id": 20523,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 21.135342189658047,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20484,
        "lat": 15.16784376366891,
        "lon": 145.7703562595991
      },
      {
        "id": 20487,
        "lat": 15.16774508132831,
        "lon": 145.7705243157084
      }
    ],

  },
  {
    "id": 20524,
    "diameter": "DIAM_100",
    "diameterMm": 100,
    "length": 39.140587630164525,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20485,
        "lat": 15.16849911047143,
        "lon": 145.7699917193779
      },
      {
        "id": 20483,
        "lat": 15.16818932701966,
        "lon": 145.7701640384562
      }
    ],

  },
  {
    "id": 20525,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.184133145825659,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18762,
        "lat": 15.17692236575757,
        "lon": 145.7787927022406
      },
      {
        "id": 20488,
        "lat": 15.17687086144569,
        "lon": 145.7788142739116
      }
    ],

  },
  {
    "id": 20526,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 65.3409694794041,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19325,
        "lat": 15.1767000152582,
        "lon": 145.7782298479743
      },
      {
        "id": 18762,
        "lat": 15.17692236575757,
        "lon": 145.7787927022406
      }
    ],

  },
  {
    "id": 20527,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 8.098640363567952,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19326,
        "lat": 15.17768574377244,
        "lon": 145.7784643194926
      },
      {
        "id": 20489,
        "lat": 15.17761880886669,
        "lon": 145.7784938536031
      }
    ],

  },
  {
    "id": 20528,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 1.0437666039044926,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19160,
        "lat": 15.17744407538486,
        "lon": 145.777882698516
      },
      {
        "id": 20490,
        "lat": 15.17744746131599,
        "lon": 145.7778917581308
      }
    ],

  },
  {
    "id": 20529,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 66.98937614209005,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20490,
        "lat": 15.17744746131599,
        "lon": 145.7778917581308
      },
      {
        "id": 19326,
        "lat": 15.17768574377244,
        "lon": 145.7784643194926
      }
    ],

  },
  {
    "id": 20530,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.966624652271004,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19801,
        "lat": 15.17767648700737,
        "lon": 145.7767593907901
      },
      {
        "id": 20491,
        "lat": 15.1776586278296,
        "lon": 145.7767388957736
      }
    ],

  },
  {
    "id": 20531,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 30.75725495872837,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19800,
        "lat": 15.17788271045435,
        "lon": 145.7765688645041
      },
      {
        "id": 19801,
        "lat": 15.17767648700737,
        "lon": 145.7767593907901
      }
    ],

  },
  {
    "id": 20532,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.913315978028521,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19632,
        "lat": 15.17851253944728,
        "lon": 145.7751259590939
      },
      {
        "id": 20492,
        "lat": 15.17855640542869,
        "lon": 145.7751310199534
      }
    ],

  },
  {
    "id": 20533,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 32.591655019843685,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19376,
        "lat": 15.17854534144747,
        "lon": 145.7748245104813
      },
      {
        "id": 19632,
        "lat": 15.17851253944728,
        "lon": 145.7751259590939
      }
    ],

  },
  {
    "id": 20534,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.97298146566157,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19634,
        "lat": 15.17871563730722,
        "lon": 145.7737625290044
      },
      {
        "id": 20493,
        "lat": 15.17860030208231,
        "lon": 145.7737452233186
      }
    ],

  },
  {
    "id": 20535,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 48.50979576860341,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20494,
        "lat": 15.17877886052131,
        "lon": 145.7733157835072
      },
      {
        "id": 19634,
        "lat": 15.17871563730722,
        "lon": 145.7737625290044
      }
    ],

  },
  {
    "id": 20536,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 11.14096742358605,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20494,
        "lat": 15.17877886052131,
        "lon": 145.7733157835072
      },
      {
        "id": 20495,
        "lat": 15.17867981263718,
        "lon": 145.7733009218952
      }
    ],

  },
  {
    "id": 20537,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 33.87407105833254,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19180,
        "lat": 15.17882300834417,
        "lon": 145.7730038239073
      },
      {
        "id": 20494,
        "lat": 15.17877886052131,
        "lon": 145.7733157835072
      }
    ],

  },
  {
    "id": 20538,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 2.8984536019524545,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19600,
        "lat": 15.18176265146203,
        "lon": 145.771891979422
      },
      {
        "id": 20496,
        "lat": 15.18175991421777,
        "lon": 145.7718651501049
      }
    ],

  },
  {
    "id": 20539,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 12.497706987761916,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18831,
        "lat": 15.18145238256055,
        "lon": 145.771871871406
      },
      {
        "id": 20497,
        "lat": 15.18155694330903,
        "lon": 145.7719142317118
      }
    ],

  },
  {
    "id": 20540,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 23.023779893031172,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20497,
        "lat": 15.18155694330903,
        "lon": 145.7719142317118
      },
      {
        "id": 19600,
        "lat": 15.18176265146203,
        "lon": 145.771891979422
      }
    ],

  },
  {
    "id": 20541,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 8.191225631147315,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18774,
        "lat": 15.18036657804751,
        "lon": 145.7788783092216
      },
      {
        "id": 20498,
        "lat": 15.1803942245459,
        "lon": 145.778948966614
      }
    ],

  },
  {
    "id": 20542,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 67.12256532248517,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20499,
        "lat": 15.17980680556153,
        "lon": 145.7791105332904
      },
      {
        "id": 18774,
        "lat": 15.18036657804751,
        "lon": 145.7788783092216
      }
    ],

  },
  {
    "id": 20543,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.145901630810099,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19713,
        "lat": 15.18023094872101,
        "lon": 145.7797198024227
      },
      {
        "id": 20500,
        "lat": 15.18025307308044,
        "lon": 145.7797722139272
      }
    ],

  },
  {
    "id": 20544,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 77.41429627846924,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19712,
        "lat": 15.17959253610998,
        "lon": 145.7800055337505
      },
      {
        "id": 19713,
        "lat": 15.18023094872101,
        "lon": 145.7797198024227
      }
    ],

  },
  {
    "id": 20545,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 8.55993675844202,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19877,
        "lat": 15.17864647329335,
        "lon": 145.7796152594398
      },
      {
        "id": 20501,
        "lat": 15.17867665398453,
        "lon": 145.7796885407505
      }
    ],

  },
  {
    "id": 20546,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 51.82753506903482,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19876,
        "lat": 15.17821744052945,
        "lon": 145.7798026003916
      },
      {
        "id": 19877,
        "lat": 15.17864647329335,
        "lon": 145.7796152594398
      }
    ],

  },
  {
    "id": 20547,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 5.660618442974942,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19102,
        "lat": 15.17695983576546,
        "lon": 145.7821062037875
      },
      {
        "id": 20502,
        "lat": 15.17697979486291,
        "lon": 145.7821546633765
      }
    ],

  },
  {
    "id": 20548,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 53.69838317114044,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20503,
        "lat": 15.17651531929047,
        "lon": 145.7823003139209
      },
      {
        "id": 19102,
        "lat": 15.17695983576546,
        "lon": 145.7821062037875
      }
    ],

  },
  {
    "id": 20549,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.099430856692125,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20503,
        "lat": 15.17651531929047,
        "lon": 145.7823003139209
      },
      {
        "id": 20504,
        "lat": 15.17653682556882,
        "lon": 145.7823525300218
      }
    ],

  },
  {
    "id": 20550,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 51.00568649458699,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19366,
        "lat": 15.17609309283932,
        "lon": 145.7824846896066
      },
      {
        "id": 20503,
        "lat": 15.17651531929047,
        "lon": 145.7823003139209
      }
    ],

  },
  {
    "id": 20551,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.499878511805536,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19660,
        "lat": 15.1762221531556,
        "lon": 145.7801949994656
      },
      {
        "id": 20505,
        "lat": 15.17620635108068,
        "lon": 145.7801564485456
      }
    ],

  },
  {
    "id": 20552,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 88.84272524802937,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19390,
        "lat": 15.17695812510623,
        "lon": 145.7798751546099
      },
      {
        "id": 19660,
        "lat": 15.1762221531556,
        "lon": 145.7801949994656
      }
    ],

  },
  {
    "id": 20553,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.202705629605695,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19671,
        "lat": 15.17497698722466,
        "lon": 145.7804369980799
      },
      {
        "id": 20506,
        "lat": 15.17498495687148,
        "lon": 145.7803987620452
      }
    ],

  },
  {
    "id": 20554,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 12.064747806248363,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19663,
        "lat": 15.17568187578903,
        "lon": 145.7804313211497
      },
      {
        "id": 20507,
        "lat": 15.17558252526342,
        "lon": 145.7804761939638
      }
    ],

  },
  {
    "id": 20555,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 30.67766628662936,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20507,
        "lat": 15.17558252526342,
        "lon": 145.7804761939638
      },
      {
        "id": 20508,
        "lat": 15.17530706292009,
        "lon": 145.7804846132617
      }
    ],

  },
  {
    "id": 20556,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 33.08669826459633,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20508,
        "lat": 15.17530706292009,
        "lon": 145.7804846132617
      },
      {
        "id": 20509,
        "lat": 15.17501233318588,
        "lon": 145.7804448089271
      }
    ],

  },
  {
    "id": 20557,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 4.015584155575925,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20509,
        "lat": 15.17501233318588,
        "lon": 145.7804448089271
      },
      {
        "id": 20510,
        "lat": 15.17497705403172,
        "lon": 145.7804370128432
      }
    ],

  },
  {
    "id": 20558,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.590131040626373,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19679,
        "lat": 15.1740270441835,
        "lon": 145.778180618864
      },
      {
        "id": 20511,
        "lat": 15.17400988971919,
        "lon": 145.7780836652785
      }
    ],

  },
  {
    "id": 20559,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 0.6122228328425716,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19678,
        "lat": 15.17446755920116,
        "lon": 145.7780981539427
      },
      {
        "id": 20512,
        "lat": 15.17446212108809,
        "lon": 145.7780990042802
      }
    ],

  },
  {
    "id": 20560,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 49.2198940455782,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20512,
        "lat": 15.17446212108809,
        "lon": 145.7780990042802
      },
      {
        "id": 19679,
        "lat": 15.1740270441835,
        "lon": 145.778180618864
      }
    ],

  },
  {
    "id": 20561,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 4.260642686686549,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 18846,
        "lat": 15.1748481625669,
        "lon": 145.77615949242
      },
      {
        "id": 20513,
        "lat": 15.17483315454065,
        "lon": 145.7761230116045
      }
    ],

  },
  {
    "id": 20562,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 24.0226505750109,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20514,
        "lat": 15.17565886232308,
        "lon": 145.7758060050823
      },
      {
        "id": 20515,
        "lat": 15.17545992859936,
        "lon": 145.7758926609059
      }
    ],

  },
  {
    "id": 20563,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 73.88947229318674,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20515,
        "lat": 15.17545992859936,
        "lon": 145.7758926609059
      },
      {
        "id": 18846,
        "lat": 15.1748481625669,
        "lon": 145.77615949242
      }
    ],

  },
  {
    "id": 20564,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 3.969314502466239,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20514,
        "lat": 15.17565886232308,
        "lon": 145.7758060050823
      },
      {
        "id": 20516,
        "lat": 15.175644895804,
        "lon": 145.7757720118125
      }
    ],

  },
  {
    "id": 20565,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 95.40897026981061,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19394,
        "lat": 15.17644895217386,
        "lon": 145.7754618388461
      },
      {
        "id": 20514,
        "lat": 15.17565886232308,
        "lon": 145.7758060050823
      }
    ],

  },
  {
    "id": 20566,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 6.112197060171584,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20517,
        "lat": 15.17428507328794,
        "lon": 145.77484360812
      },
      {
        "id": 20518,
        "lat": 15.17432759350462,
        "lon": 145.7748076143058
      }
    ],

  },
  {
    "id": 20567,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 62.69724858046604,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19151,
        "lat": 15.17452619513532,
        "lon": 145.7754113027224
      },
      {
        "id": 20519,
        "lat": 15.17430241973101,
        "lon": 145.7748757746765
      }
    ],

  },
  {
    "id": 20568,
    "diameter": "DIAM_150",
    "diameterMm": 150,
    "length": 3.957636630875209,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20519,
        "lat": 15.17430241973101,
        "lon": 145.7748757746765
      },
      {
        "id": 19403,
        "lat": 15.17428414336611,
        "lon": 145.7748441784016
      }
    ],

  },
  {
    "id": 20569,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 10.729137244522951,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 19156,
        "lat": 15.17677419598897,
        "lon": 145.7744574822434
      },
      {
        "id": 20520,
        "lat": 15.17673652683896,
        "lon": 145.7743655608672
      }
    ],

  },
  {
    "id": 20570,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 75.7424419421708,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 19387,
        "lat": 15.176146722618,
        "lon": 145.7747301050062
      },
      {
        "id": 19156,
        "lat": 15.17677419598897,
        "lon": 145.7744574822434
      }
    ],

  },
  {
    "id": 20571,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 13.004684567934994,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20521,
        "lat": 15.16973537361283,
        "lon": 145.778872719778
      },
      {
        "id": 20522,
        "lat": 15.16961897679025,
        "lon": 145.7788830501536
      }
    ],

  },
  {
    "id": 20572,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 12.981826082098292,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20523,
        "lat": 15.16969366725039,
        "lon": 145.7783745340985
      },
      {
        "id": 20524,
        "lat": 15.16957747504224,
        "lon": 145.7783848465849
      }
    ],

  },
  {
    "id": 20573,
    "diameter": "DIAM_25",
    "diameterMm": 25,
    "length": 13.13142676788064,
    "material": "UPVC",
    "soundVelocity": 503.0,
    "nodes": [
      {
        "id": 20525,
        "lat": 15.16965072579582,
        "lon": 145.7778616090099
      },
      {
        "id": 20526,
        "lat": 15.16953319462875,
        "lon": 145.7778720406153
      }
    ],

  },
  {
    "id": 20574,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 45.688405269622386,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 18933,
        "lat": 15.16961525724311,
        "lon": 145.7774379564947
      },
      {
        "id": 20525,
        "lat": 15.16965072579582,
        "lon": 145.7778616090099
      }
    ],

  },
  {
    "id": 20575,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 55.315901086868294,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20525,
        "lat": 15.16965072579582,
        "lon": 145.7778616090099
      },
      {
        "id": 20523,
        "lat": 15.16969366725039,
        "lon": 145.7783745340985
      }
    ],

  },
  {
    "id": 20576,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 53.726322505805484,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20523,
        "lat": 15.16969366725039,
        "lon": 145.7783745340985
      },
      {
        "id": 20521,
        "lat": 15.16973537361283,
        "lon": 145.778872719778
      }
    ],

  },
  {
    "id": 20577,
    "diameter": "DIAM_200",
    "diameterMm": 200,
    "length": 62.78007798219621,
    "material": "UPVC",
    "soundVelocity": 483.0,
    "nodes": [
      {
        "id": 20521,
        "lat": 15.16973537361283,
        "lon": 145.778872719778
      },
      {
        "id": 19723,
        "lat": 15.16978410678657,
        "lon": 145.7794548580621
      }
    ],

  }
]
